// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/material-icons-outlined.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/material-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/active-menu.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/banner2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/golf-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Plus+Jakarta+Sans:300,400,500,700,900);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Patua+One&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Author       : Dreamguys
Template Name: Pathivu - Bootstrap Template
Version      : 1.0
*/


/*============================
 [Table of CSS]

1. General
2. Table
3. Bootstrap Classes
4. Avatar
5. Select2
6. Nav Tabs
7. Components
8. Focus Label
9. Login
10. Header
11. Home
12. Footer
13. Mobile Menu
14. Search
15. advisors Profile
16. Booking
17. Checkout
18. Booking Success
19. Invoice View
20. Schedule Timings
21. advisors Dashboard
22. Customer Profile
23. Chat
24. advisors Profile Settings
25. Calendar
26. Customer Dashboard
27. Profile Settings
28. Appoitment List
29. Reviews
30. Voice call
31. Video Call
32. Outgoing Call
33. Incoming Call
34. Terms and Conditions
35. Blog
36. Blog Details
37. Blog Grid
38. Map List & Grid
39. Responsive
40. Custom

========================================*/


/*-----------------
	1. General
-----------------------*/
/* Material Symbols Outlined */
@font-face {
    font-family: 'Material Symbols Outlined';
    font-style: normal;
    font-weight: 100 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
    font-display: block;
}
.material-symbols-outlined {
    font-family: 'Material Symbols Outlined';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -moz-font-feature-settings: 'liga';
    -moz-osx-font-smoothing: grayscale;
}

/* Material Icons Outlined */
@font-face {
    font-family: 'Material Icons Outlined';
    font-style: normal;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
    font-display: block;
}
.material-icons-outlined {
    font-family: 'Material Icons Outlined';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -moz-font-feature-settings: 'liga';
    -moz-osx-font-smoothing: grayscale;
}

@font-face {
    font-family: 'Material Icons';
    font-style: normal;
    font-weight: 100 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
    font-display: block;
}

.material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -moz-font-feature-settings: 'liga';
    -moz-osx-font-smoothing: grayscale;
} 

html {
	height: 100%;
}

body {
	background-color: #fff;
	color: #505050;
	font-family: "Plus Jakarta Sans", sans-serif;
	/* font-size: 0.9375rem; */
	height: 100%;
	overflow-x: hidden;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	color: #505050;
	font-weight: 500;
}

.h1,
h1 {
	font-size: 2.25rem;
}

.h2,
h2 {
	font-size: 1.875rem;
}

.h3,
h3 {
	font-size: 1.5rem;
}

.h4,
h4 {
	font-size: 1.125rem;
}

.h5,
h5 {
	font-size: 1rem;
}

.h6,
h6 {
	font-size: 0.875rem;
}

a {
	color: #2E3842;
}

a:hover {
	color: #e5bd54;
}
a,
a:hover,
a:active,
a:focus {
	outline: none;
	text-decoration: none;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
	-webkit-box-shadow: 0 0 0px 1000px white inset !important;
}

input,
button,
a {
	transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-ms-transition: all 0.4s ease;
	-webkit-transition: all 0.4s ease;
}

ul {
	padding: 0;
	margin-bottom: 0;
}

p:last-child {
	margin-bottom: 0;
}

button:focus {
	outline: 0;
}

input[type=text],
input[type=password] {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
}

.container-fluid {
    padding-left: 30px;
    padding-right: 30px;
}

.btn, .btn * {
    cursor: pointer;
}

.btn.focus,
.btn:focus {
	box-shadow: inherit;
}

.btn.disabled, .btn.disabled *
.btn:disabled, .btn:disabled * {
	cursor: default;
}

.form-control {
	border-color: #dcdcdc;
	color: #333;
	font-size: 15px;
	min-height: 46px;
	padding: 6px 15px;
}

.table .form-control {
	font-size: 14px;
	min-height: 38px;
}

.form-control::-webkit-input-placeholder {
	color: #858585;
	font-size: 14px;
}

.form-control::-moz-placeholder {
	color: #858585;
	font-size: 14px;
}

.form-control:-ms-input-placeholder {
	color: #858585;
	font-size: 14px;
}

.form-control::-ms-input-placeholder {
	color: #858585;
	font-size: 14px;
}

.form-control::placeholder {
	color: #858585;
	font-size: 14px;
}

.list-group-item {
	border: 1px solid #f0f0f0;
}

.content {
	min-height: 70vh;
	padding: 40px 0 0;
    margin-top: 6rem;
}

figure {
	margin: 0;
}


/*-----------------
	2. Table
-----------------------*/

.table {
	color: #272b41;
	max-width: 100%;
	margin-bottom: 0;
	width: 100%;
}

.table-striped > tbody > tr:nth-of-type(2n+1) {
	background-color: #f8f9fa;
}

.table.no-border > tbody > tr > td,
.table > tbody > tr > th,
.table.no-border > tfoot > tr > td,
.table.no-border > tfoot > tr > th,
.table.no-border > thead > tr > td,
.table.no-border > thead > tr > th {
	border-top: 0;
	padding: 10px 8px;
}

.table-nowrap td,
.table-nowrap th {
	white-space: nowrap
}

.table.dataTable {
	border-collapse: collapse !important;
}

table.table td h2 {
	display: inline-block;
	font-size: inherit;
	font-weight: 400;
	margin: 0;
	padding: 0;
	vertical-align: middle;
}

table.table td h2.table-avatar {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	font-size: inherit;
	font-weight: 400;
	margin: 0;
	padding: 0;
	vertical-align: middle;
	white-space: nowrap;
}

table.table td h2 a {
	color: #272b41;
}

table.table td h2 a:hover {
	color: #e5bd54;
}

table.table td h2 span {
	color: #888;
	display: block;
	font-size: 12px;
	margin-top: 3px;
}

.table thead {
	border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}

.table thead tr th {
	border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.table tbody tr {
	border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.table tbody tr:last-child {
	border-color: transparent;
}

.table.table-center td,
.table.table-center th {
	vertical-align: middle;
}

.table-hover tbody tr:hover {
	background-color: #f7f7f7;
}

.table-hover tbody tr:hover td {
	color: #474648;
}

.table-striped thead tr {
	border-color: transparent;
}

.table-striped tbody tr {
	border-color: transparent;
}

.table-striped tbody tr:nth-of-type(even) {
	background-color: rgba(255, 255, 255, 0.3);
}

.table-striped tbody tr:nth-of-type(odd) {
	background-color: rgba(235, 235, 235, 0.4);
}

.table-bordered {
	border: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.table-bordered th,
.table-bordered td {
	border-color: rgba(0, 0, 0, 0.05);
}

.card-table .card-body {
	padding: 0;
}

.card-table .card-body .table > thead > tr > th {
	border-top: 0;
}

.card-table .table tr td:first-child,
.card-table .table tr th:first-child {
	padding-left: 1.5rem;
}

.card-table .table tr td:last-child,
.card-table .table tr th:last-child {
	padding-right: 1.5rem;
}

.card-table .table td,
.card-table .table th {
	border-top: 1px solid #e2e5e8;
	padding: 1rem 0.75rem;
	white-space: nowrap;
}


/*-----------------
	3. Bootstrap Classes
-----------------------*/

.btn.focus,
.btn:focus {
	box-shadow: unset;
}

.btn-white {
	background-color: #fff;
	border: 1px solid #ccc;
	color: #272b41;
}

.btn.btn-rounded {
	border-radius: 50px;
}

.bg-primary,
.badge-primary {
	background-color: #e5bd54 !important;
}

a.bg-primary:focus,
a.bg-primary:hover,
button.bg-primary:focus,
button.bg-primary:hover {
	background-color: #e5bd54 !important;
}

.bg-success,
.badge-success {
	background-color: #00e65b !important;
}

a.bg-success:focus,
a.bg-success:hover,
button.bg-success:focus,
button.bg-success:hover {
	background-color: #00cc52 !important;
}

.bg-info,
.badge-info {
	background-color: #009efb !important;
}

a.bg-info:focus,
a.bg-info:hover,
button.bg-info:focus,
button.bg-info:hover {
	background-color: #028ee1 !important;
}

.bg-warning,
.badge-warning {
	background-color: #ffbc34 !important;
}

a.bg-warning:focus,
a.bg-warning:hover,
button.bg-warning:focus,
button.bg-warning:hover {
	background-color: #e9ab2e !important;
}

.bg-danger,
.badge-danger {
	background-color: #ff0100 !important;
}

a.bg-danger:focus,
a.bg-danger:hover,
button.bg-danger:focus,
button.bg-danger:hover {
	background-color: #e63333 !important;
}

.bg-white {
	background-color: #fff;
}

.bg-purple,
.badge-purple {
	background-color: #9368e9 !important;
}

.text-primary,
.dropdown-menu > li > a.text-primary {
	color: #e5bd54 !important;
}

.text-success,
.dropdown-menu > li > a.text-success {
	color: #00cc52 !important;
}

.text-danger,
.dropdown-menu > li > a.text-danger {
	color: #ff0100 !important;
}

.text-info,
.dropdown-menu > li > a.text-info {
	color: #009efb !important;
}

.text-warning,
.dropdown-menu > li > a.text-warning {
	color: #ffbc34 !important;
}

.text-purple,
.dropdown-menu > li > a.text-purple {
	color: #7460ee !important;
}

.text-muted {
	color: #757575 !important;
}

.text-light {
    color: #edeeef
}

a.text-light:focus,a.text-light:hover{color:#cbd3da}

.btn-primary {
	background-color: #e5bd54;
	border: 1px solid #e5bd54;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary.active,
.btn-primary:active,
.open > .dropdown-toggle.btn-primary {
	background-color: #e6b230;
	border: 1px solid #e6b230;
}

.btn-primary.active.focus,
.btn-primary.active:focus,
.btn-primary.active:hover,
.btn-primary.focus:active,
.btn-primary:active:focus,
.btn-primary:active:hover,
.open > .dropdown-toggle.btn-primary.focus,
.open > .dropdown-toggle.btn-primary:focus,
.open > .dropdown-toggle.btn-primary:hover {
	background-color: #e5bd54;
	border: 1px solid #e5bd54;
}

.btn-primary.active:not(:disabled):not(.disabled),
.btn-primary:active:not(:disabled):not(.disabled),
.show > .btn-primary.dropdown-toggle {
	background-color: #e5bd54;
	border-color: #e5bd54;
	color: #fff;
}

.btn-primary.active:focus:not(:disabled):not(.disabled),
.btn-primary:active:focus:not(:disabled):not(.disabled),
.show > .btn-primary.dropdown-toggle:focus {
	box-shadow: unset;
}

.btn-primary.disabled,
.btn-primary:disabled {
	background-color: #e5bd54;
	border-color: #e5bd54;
	color: #fff;
}

/* .btn-secondary:hover {
	color: #fff;
	background-color: #e5bd54;
	border-color: #e5bd54;
}

.btn-secondary.active:focus:not(:disabled):not(.disabled),
.btn-secondary:active:focus:not(:disabled):not(.disabled),
.show > .btn-secondary.dropdown-toggle:focus {
	box-shadow: unset;
} */

/* .btn-success {
	background-color: #00e65b;
	border: 1px solid #00e65b
}

.btn-success:hover,
.btn-success:focus,
.btn-success.active,
.btn-success:active,
.open > .dropdown-toggle.btn-success {
	background-color: #00cc52;
	border: 1px solid #00cc52;
	color: #fff;
}

.btn-success.active.focus,
.btn-success.active:focus,
.btn-success.active:hover,
.btn-success.focus:active,
.btn-success:active:focus,
.btn-success:active:hover,
.open > .dropdown-toggle.btn-success.focus,
.open > .dropdown-toggle.btn-success:focus,
.open > .dropdown-toggle.btn-success:hover {
	background-color: #00cc52;
	border: 1px solid #00cc52
}

.btn-success.active:not(:disabled):not(.disabled),
.btn-success:active:not(:disabled):not(.disabled),
.show > .btn-success.dropdown-toggle {
	background-color: #00cc52;
	border-color: #00cc52;
	color: #fff;
}

.btn-success.active:focus:not(:disabled):not(.disabled),
.btn-success:active:focus:not(:disabled):not(.disabled),
.show > .btn-success.dropdown-toggle:focus {
	box-shadow: unset;
}

.btn-success.disabled,
.btn-success:disabled {
	background-color: #00e65b;
	border-color: #00e65b;
	color: #fff;
}

.btn-info {
	background-color: #009efb;
	border: 1px solid #009efb
}

.btn-info:hover,
.btn-info:focus,
.btn-info.active,
.btn-info:active,
.open > .dropdown-toggle.btn-info {
	background-color: #028ee1;
	border: 1px solid #028ee1
}

.btn-info.active.focus,
.btn-info.active:focus,
.btn-info.active:hover,
.btn-info.focus:active,
.btn-info:active:focus,
.btn-info:active:hover,
.open > .dropdown-toggle.btn-info.focus,
.open > .dropdown-toggle.btn-info:focus,
.open > .dropdown-toggle.btn-info:hover {
	background-color: #028ee1;
	border: 1px solid #028ee1
}

.btn-info.active:not(:disabled):not(.disabled),
.btn-info:active:not(:disabled):not(.disabled),
.show > .btn-info.dropdown-toggle {
	background-color: #028ee1;
	border-color: #028ee1;
	color: #fff;
}

.btn-info.active:focus:not(:disabled):not(.disabled),
.btn-info:active:focus:not(:disabled):not(.disabled),
.show > .btn-info.dropdown-toggle:focus {
	box-shadow: unset;
}

.btn-info.disabled,
.btn-info:disabled {
	background-color: #e5bd54;
	border-color: #e5bd54;
	color: #fff;
}

.btn-warning {
	background-color: #ffbc34;
	border: 1px solid #ffbc34
}

.btn-warning:hover,
.btn-warning:focus,
.btn-warning.active,
.btn-warning:active,
.open > .dropdown-toggle.btn-warning {
	background-color: #e9ab2e;
	border: 1px solid #e9ab2e
}

.btn-warning.active.focus,
.btn-warning.active:focus,
.btn-warning.active:hover,
.btn-warning.focus:active,
.btn-warning:active:focus,
.btn-warning:active:hover,
.open > .dropdown-toggle.btn-warning.focus,
.open > .dropdown-toggle.btn-warning:focus,
.open > .dropdown-toggle.btn-warning:hover {
	background-color: #e9ab2e;
	border: 1px solid #e9ab2e
}

.btn-warning.active:not(:disabled):not(.disabled),
.btn-warning:active:not(:disabled):not(.disabled),
.show > .btn-warning.dropdown-toggle {
	background-color: #e9ab2e;
	border-color: #e9ab2e;
	color: #fff;
}

.btn-warning.active:focus:not(:disabled):not(.disabled),
.btn-warning:active:focus:not(:disabled):not(.disabled),
.show > .btn-warning.dropdown-toggle:focus {
	box-shadow: unset;
}

.btn-warning.disabled,
.btn-warning:disabled {
	background-color: #ffbc34;
	border-color: #ffbc34;
	color: #fff;
}

.btn-danger {
	background-color: #ff0100;
	border: 1px solid #ff0100;
}

.btn-danger:hover,
.btn-danger:focus,
.btn-danger.active,
.btn-danger:active,
.open > .dropdown-toggle.btn-danger {
	background-color: #e63333;
	border: 1px solid #e63333;
}

.btn-danger.active.focus,
.btn-danger.active:focus,
.btn-danger.active:hover,
.btn-danger.focus:active,
.btn-danger:active:focus,
.btn-danger:active:hover,
.open > .dropdown-toggle.btn-danger.focus,
.open > .dropdown-toggle.btn-danger:focus,
.open > .dropdown-toggle.btn-danger:hover {
	background-color: #e63333;
	border: 1px solid #e63333;
}

.btn-danger.active:not(:disabled):not(.disabled),
.btn-danger:active:not(:disabled):not(.disabled),
.show > .btn-danger.dropdown-toggle {
	background-color: #e63333;
	border-color: #e63333;
	color: #fff;
}

.btn-danger.active:focus:not(:disabled):not(.disabled),
.btn-danger:active:focus:not(:disabled):not(.disabled),
.show > .btn-danger.dropdown-toggle:focus {
	box-shadow: unset;
}

.btn-danger.disabled,
.btn-danger:disabled {
	background-color: #f62d51;
	border-color: #f62d51;
	color: #fff;
}

.btn-light.active:focus:not(:disabled):not(.disabled),
.btn-light:active:focus:not(:disabled):not(.disabled),
.show > .btn-light.dropdown-toggle:focus {
	box-shadow: unset;
}

.btn-dark.active:focus:not(:disabled):not(.disabled),
.btn-dark:active:focus:not(:disabled):not(.disabled),
.show > .btn-dark.dropdown-toggle:focus {
	box-shadow: unset;
}
*/

.btn-outline-primary {
	color: #e5bd54;
	border-color: #e5bd54;
}

.btn-outline-primary:hover {
	background-color: #e5bd54;
	border-color: #e5bd54;
}

.btn-outline-primary:focus,
.btn-outline-primary.focus {
	box-shadow: none;
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
	color: #e5bd54;
	background-color: transparent;
}

.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle {
	background-color: #e5bd54;
	border-color: #e5bd54;
}

.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus {
	box-shadow: none;
}

/*
.btn-outline-success {
	color: #00e65b;
	border-color: #00e65b;
}

.btn-outline-success:hover {
	background-color: #00e65b;
	border-color: #00e65b;
}

.btn-outline-success:focus,
.btn-outline-success.focus {
	box-shadow: none;
}

.btn-outline-success.disabled,
.btn-outline-success:disabled {
	color: #00e65b;
	background-color: transparent;
}

.btn-outline-success:not(:disabled):not(.disabled):active,
.btn-outline-success:not(:disabled):not(.disabled).active,
.show > .btn-outline-success.dropdown-toggle {
	background-color: #00e65b;
	border-color: #00e65b;
}

.btn-outline-success:not(:disabled):not(.disabled):active:focus,
.btn-outline-success:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-success.dropdown-toggle:focus {
	box-shadow: none;
}

.btn-outline-info {
	color: #009efb;
	border-color: #009efb;
}

.btn-outline-info:hover {
	color: #fff;
	background-color: #009efb;
	border-color: #009efb;
}

.btn-outline-info:focus,
.btn-outline-info.focus {
	box-shadow: none;
}

.btn-outline-info.disabled,
.btn-outline-info:disabled {
	background-color: transparent;
	color: #009efb;
}

.btn-outline-info:not(:disabled):not(.disabled):active,
.btn-outline-info:not(:disabled):not(.disabled).active,
.show > .btn-outline-info.dropdown-toggle {
	background-color: #009efb;
	border-color: #009efb;
}

.btn-outline-info:not(:disabled):not(.disabled):active:focus,
.btn-outline-info:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-info.dropdown-toggle:focus {
	box-shadow: none;
}

.btn-outline-warning {
	color: #ffbc34;
	border-color: #ffbc34;
}

.btn-outline-warning:hover {
	color: #212529;
	background-color: #ffbc34;
	border-color: #ffbc34;
}

.btn-outline-warning:focus,
.btn-outline-warning.focus {
	box-shadow: none;
}

.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
	background-color: transparent;
	color: #ffbc34;
}

.btn-outline-warning:not(:disabled):not(.disabled):active,
.btn-outline-warning:not(:disabled):not(.disabled).active,
.show > .btn-outline-warning.dropdown-toggle {
	color: #212529;
	background-color: #ffbc34;
	border-color: #ffbc34;
}

.btn-outline-warning:not(:disabled):not(.disabled):active:focus,
.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-warning.dropdown-toggle:focus {
	box-shadow: none;
}

.btn-outline-danger {
	color: #ff0100;
	border-color: #ff0100;
}

.btn-outline-danger:hover {
	color: #fff;
	background-color: #ff0100;
	border-color: #ff0100;
}

.btn-outline-danger:focus,
.btn-outline-danger.focus {
	box-shadow: none;
}

.btn-outline-danger.disabled,
.btn-outline-danger:disabled {
	background-color: transparent;
	color: #ff0100;
}

.btn-outline-danger:not(:disabled):not(.disabled):active,
.btn-outline-danger:not(:disabled):not(.disabled).active,
.show > .btn-outline-danger.dropdown-toggle {
	background-color: #ff0100;
	border-color: #ff0100;
}

.btn-outline-danger:not(:disabled):not(.disabled):active:focus,
.btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-danger.dropdown-toggle:focus {
	box-shadow: none;
}

.btn-outline-light {
	color: #ababab;
	border-color: #e6e6e6;
}

.btn-outline-light.disabled,
.btn-outline-light:disabled {
	color: #ababab;
} */

.pagination > .active > a,
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
	background-color: #e5bd54;
	border-color: #e5bd54;
}

.pagination > li > a,
.pagination > li > span {
	color: #e5bd54;
}

.page-link:hover {
	color: #e5bd54;
}

.page-link:focus {
	box-shadow: unset;
}

.page-item.active .page-link {
	background-color: #e5bd54;
	border-color: #e5bd54;
}

.dropdown-menu {
	background-color: #fff;
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: 3px;
	box-shadow: inherit;
	font-size: 14px;
	transform-origin: left top 0;
}

.dropdown-item.active,
.dropdown-item:active {
	background-color: #e8ba3f;
}

.dropdown-menu.show {
    display: block;
    z-index: 99999;
}

.navbar-nav .open .dropdown-menu {
	border: 0;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	background-color: #fff;
}

.card {
	box-shadow: 0px 2px 8px rgb(183 183 183 / 25%);
	margin-bottom: 1.875rem;
	border: 0;
}

.card-body {
	padding: 1.5rem;
}

.card-title {
	margin-bottom: 15px;
}

.card-header {
	border-bottom: 1px solid #f0f0f0;
	padding: 1rem 1.5rem;
}

.card-footer {
	background-color: #fff;
	border-top: 1px solid #f0f0f0;
	padding: 1rem 1.5rem;
}

.card .card-header {
	background-color: #fff;
	border-bottom: 1px solid #f0f0f0;
}

.card .card-header .card-title {
	margin-bottom: 0;
}

.btn-light {
	border-color: #e6e6e6;
	color: #a6a6a6;
}

.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td.active:hover {
	background-color: #e5bd54;
	text-shadow: unset;
}

.bootstrap-datetimepicker-widget table td.today::before {
	border-bottom-color: #e5bd54;
}

.bg-secondary-light {
	background-color: rgba(129, 129, 129, 0.12) !important;
	color: #474747 !important;
}

.bg-info-light {
	background-color: rgba(2, 182, 179, 0.12) !important;
	color: #1db9aa !important;
}

.bg-primary-light {
	background-color: rgba(17, 148, 247, 0.12) !important;
	color: #2196f3 !important;
}

.bg-danger-light {
	background-color: rgba(242, 17, 54, 0.12) !important;
	color: #e63c3c !important;
}

.bg-warning-light {
	background-color: rgba(255, 152, 0, 0.12) !important;
	color: #f39c12 !important;
}

.bg-success-light {
	background-color: rgba(15, 183, 107, 0.12) !important;
	color: #26af48 !important;
}

.bg-purple-light {
	background-color: rgba(197, 128, 255, 0.12) !important;
	color: #c580ff !important;
}

.bg-default-light {
	background-color: rgba(40, 52, 71, 0.12) !important;
	color: #283447 !important;
}

.text-xs {
	font-size: .75rem !important;
}

.text-sm {
	font-size: .875rem !important;
}

.text-md {
    font-size: 1rem !important;
}

.text-lg {
	font-size: 1.25rem !important;
}

.text-xl {
	font-size: 1.5rem !important;
}

.form-control:focus {
	border-color: #bbb;
	box-shadow: none;
	outline: 0 none;
}

.form-group {
	margin-bottom: 1.25rem;
}

.custom-control-input:checked ~ .custom-control-label.custom-control-primary::before {
    color: #fff;
    border-color: #e6b230;
    background-color: #e6b230;
}

.custom-control-input:focus ~ .custom-control-label.custom-control-primary::before {
    box-shadow: 0 0 0 .2rem rgba(230,178,48,.25);
}

.custom-control-input:focus:not(:checked) ~ .custom-control-label.custom-control-primary::before {
    border-color: #e5bd54;
}

.custom-control-input:not(:disabled):active ~ .custom-control-label.custom-control-primary::before {
    color: #fff;
    background-color: #ebd295;
    border-color: #ebd295;
}

#alertModal {
    z-index: 1060; /* higher so it stacks above */
}

.modal-backdrop + .modal-backdrop {
    z-index: 1055; /* adjust backdrop layering */
}

/*-----------------
	4. Avatar
-----------------------*/

.avatar {
	position: relative;
	display: inline-block;
	width: 3rem;
	height: 3rem
}

.avatar > img {
	width: 100%;
	height: 100%;
	-o-object-fit: cover;
	object-fit: cover;
}

.avatar-title {
	width: 100%;
	height: 100%;
	background-color: #e5bd54;
	color: #fff;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
}

.avatar-away::before,
.avatar-offline::before,
.avatar-online::before {
	position: absolute;
	right: 0;
	bottom: 0;
	width: 25%;
	height: 25%;
	border-radius: 50%;
	content: '';
	border: 2px solid #fff;
}

.avatar-online::before {
	background-color: #00e65b;
}

.avatar-offline::before {
	background-color: #ff0100;
}

.avatar-away::before {
	background-color: #ffbc34;
}

.avatar .border {
	border-width: 3px !important;
}

.avatar .rounded {
	border-radius: 6px !important;
}

.avatar .avatar-title {
	font-size: 18px;
}

.avatar-xs {
	width: 1.65rem;
	height: 1.65rem;
}

.avatar-xs .border {
	border-width: 2px !important;
}

.avatar-xs .rounded {
	border-radius: 4px !important;
}

.avatar-xs .avatar-title {
	font-size: 12px;
}

.avatar-xs.avatar-away::before,
.avatar-xs.avatar-offline::before,
.avatar-xs.avatar-online::before {
	border-width: 1px;
}

.avatar-sm {
	width: 2.5rem;
	height: 2.5rem;
}

.avatar-sm .border {
	border-width: 3px !important;
}

.avatar-sm .rounded {
	border-radius: 4px !important;
}

.avatar-sm .avatar-title {
	font-size: 15px;
}

.avatar-sm.avatar-away::before,
.avatar-sm.avatar-offline::before,
.avatar-sm.avatar-online::before {
	border-width: 2px;
}

.avatar-lg {
	width: 3.75rem;
	height: 3.75rem;
}

.avatar-lg .border {
	border-width: 3px !important;
}

.avatar-lg .rounded {
	border-radius: 8px !important;
}

.avatar-lg .avatar-title {
	font-size: 24px;
}

.avatar-lg.avatar-away::before,
.avatar-lg.avatar-offline::before,
.avatar-lg.avatar-online::before {
	border-width: 3px;
}

.avatar-xl {
	width: 5rem;
	height: 5rem;
}

.avatar-xl .border {
	border-width: 4px !important;
}

.avatar-xl .rounded {
	border-radius: 8px !important;
}

.avatar-xl .avatar-title {
	font-size: 28px;
}

.avatar-xl.avatar-away::before,
.avatar-xl.avatar-offline::before,
.avatar-xl.avatar-online::before {
	border-width: 4px;
}

.avatar-xxl {
	width: 5.125rem;
	height: 5.125rem;
}

.avatar-xxl .border {
	border-width: 6px !important;
}

.avatar-xxl .rounded {
	border-radius: 8px !important;
}

.avatar-xxl .avatar-title {
	font-size: 30px;
}

.avatar-xxl.avatar-away::before,
.avatar-xxl.avatar-offline::before,
.avatar-xxl.avatar-online::before {
	border-width: 4px;
}

.avatar-group {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
}

.avatar-group .avatar+.avatar {
	margin-left: -.75rem;
}

.avatar-group .avatar-xs+.avatar-xs {
	margin-left: -.40625rem;
}

.avatar-group .avatar-sm+.avatar-sm {
	margin-left: -.625rem;
}

.avatar-group .avatar-lg+.avatar-lg {
	margin-left: -1rem;
}

.avatar-group .avatar-xl+.avatar-xl {
	margin-left: -1.28125rem;
}

.avatar-group .avatar:hover {
	z-index: 1;
}


/*-----------------
	5. Select2
-----------------------*/

.select2-results__option {
	padding: 6px 15px;
}

.select2-container .select2-selection--single {
	border: 1px solid #dcdcdc;
	height: 46px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
	height: 44px;
	right: 7px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow b {
	border-color: #dcdcdc transparent transparent;
	border-style: solid;
	border-width: 6px 6px 0;
	height: 0;
	left: 50%;
	margin-left: -10px;
	margin-top: -2px;
	position: absolute;
	top: 50%;
	width: 0;
}

.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
	border-color: transparent transparent #dcdcdc;
	border-width: 0 6px 6px;
}

.select2-container .select2-selection--single .select2-selection__rendered {
	padding-right: 30px;
	padding-left: 15px;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
	color: #272b41;
	font-size: 15px;
	font-weight: normal;
	line-height: 44px;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
	background-color: #e5bd54;
}

.select2-container--default .select2-selection--multiple {
	border: 1px solid #dcdcdc;
	min-height: 46px;
}

.select2-dropdown {
	border-color: #dcdcdc;
}


/*-----------------
	6. Nav Tabs
-----------------------*/

.nav-tabs {
	border-bottom: none;
}

.card-header-tabs {
	border-bottom: 0;
}

.nav-tabs > li > a {
	margin-right: 0;
	color: #888;
	border-radius: 0;
}

.nav-tabs > li > a:hover,
.nav-tabs > li > a:focus {
	border-color: transparent;
	color: #272b41;
}

.nav-tabs.nav-tabs-solid > li > a {
	color: #272b41;
}

.nav-tabs.nav-tabs-solid > .active > a,
.nav-tabs.nav-tabs-solid > .active > a:hover,
.nav-tabs.nav-tabs-solid > .active > a:focus {
	background-color: #e5bd54;
	border-color: #e5bd54;
	color: #fff;
}

.tab-content {
	padding-top: 20px;
}

.nav-tabs .nav-link {
	border-radius: 0;
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
	border-color: transparent;
    border-bottom: 2px solid #b8b8b8;
	color: #272b41;
}

.nav-tabs.nav-justified > li > a {
	border-radius: 0;
	margin-bottom: 0;
}

.nav-tabs.nav-justified > li > a:hover,
.nav-tabs.nav-justified > li > a:focus {
	border-bottom-color: #b8b8b8;
}

.nav-tabs.nav-justified.nav-tabs-solid > li > a {
	border-color: transparent;
}

.nav-tabs.nav-tabs-solid > li > a {
	color: #272b41;
}

.nav-tabs.nav-tabs-solid > li > a.active,
.nav-tabs.nav-tabs-solid > li > a.active:hover,
.nav-tabs.nav-tabs-solid > li > a.active:focus {
	background-color: #e5bd54;
	border-color: #e5bd54;
	color: #fff;
}

.nav-tabs.nav-tabs-solid.nav-tabs-rounded {
	border-radius: 50px;
}

.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a {
	border-radius: 50px;
}

.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {
	border-radius: 5px;
}

.nav-tabs-justified > li > a {
	border-radius: 0;
	margin-bottom: 0;
}

.nav-tabs-justified > li > a:hover,
.nav-tabs-justified > li > a:focus {
	border-bottom-color: #ddd;
}

.nav-tabs-justified.nav-tabs-solid > li > a {
	border-color: transparent;
}

.nav-tabs.nav-justified.nav-tabs-top {
	border-bottom: 1px solid #ddd;
}

.nav-tabs.nav-justified.nav-tabs-top > li > a,
.nav-tabs.nav-justified.nav-tabs-top > li > a:hover,
.nav-tabs.nav-justified.nav-tabs-top > li > a:focus {
	border-width: 2px 0 0 0;
}

.nav-tabs.nav-tabs-top > li {
	margin-bottom: 0;
}

.nav-tabs.nav-tabs-top > li > a,
.nav-tabs.nav-tabs-top > li > a:hover,
.nav-tabs.nav-tabs-top > li > a:focus {
	border-width: 2px 0 0 0;
}

.nav-tabs.nav-tabs-top > li.open > a,
.nav-tabs.nav-tabs-top > li > a:hover,
.nav-tabs.nav-tabs-top > li > a:focus {
	border-top-color: #ddd;
}

.nav-tabs.nav-tabs-top > li+li > a {
	margin-left: 1px;
}

.nav-tabs.nav-tabs-top > li > a.active,
.nav-tabs.nav-tabs-top > li > a.active:hover,
.nav-tabs.nav-tabs-top > li > a.active:focus {
	border-top-color: #e5bd54;
}

.nav-tabs.nav-tabs-bottom > li > a.active,
.nav-tabs.nav-tabs-bottom > li > a.active:hover,
.nav-tabs.nav-tabs-bottom > li > a.active:focus {
	border-bottom-width: 2px;
	border-color: transparent;
	border-bottom-color: #e5bd54;
	background-color: transparent;
	transition: none 0s ease 0s;
	-moz-transition: none 0s ease 0s;
	-o-transition: none 0s ease 0s;
	-ms-transition: none 0s ease 0s;
	-webkit-transition: none 0s ease 0s;
}

.nav-tabs.nav-tabs-solid {
	background-color: #fafafa;
	border: 0;
}

.nav-tabs.nav-tabs-solid > li {
	margin-bottom: 0;
}

.nav-tabs.nav-tabs-solid > li > a {
	border-color: transparent;
}

.nav-tabs.nav-tabs-solid > li > a:hover,
.nav-tabs.nav-tabs-solid > li > a:focus {
	background-color: #f5f5f5;
}

.nav-tabs.nav-tabs-solid > .open:not(.active) > a {
	background-color: #f5f5f5;
	border-color: transparent;
}

.nav-tabs-justified.nav-tabs-top {
	border-bottom: 1px solid #ddd;
}

.nav-tabs-justified.nav-tabs-top > li > a,
.nav-tabs-justified.nav-tabs-top > li > a:hover,
.nav-tabs-justified.nav-tabs-top > li > a:focus {
	border-width: 2px 0 0 0;
}


/*-----------------
	7. Components
-----------------------*/

.comp-header {
	margin-bottom: 1.875rem;
}

.comp-header .comp-title {
	color: #272b41;
}

.line {
	background-color: #e5bd54;
	height: 2px;
	margin: 0;
	width: 60px;
}

.comp-buttons .btn {
	margin-bottom: 5px;
}

.pagination-box .pagination {
	margin-top: 0;
}

.comp-dropdowns .btn-group {
	margin-bottom: 5px;
}

.progress-example .progress {
	margin-bottom: 1.5rem;
}

.progress-xs {
	height: 4px;
}

.progress-sm {
	height: 15px;
}

.progress.progress-sm {
	height: 6px;
}

.progress.progress-md {
	height: 8px;
}

.progress.progress-lg {
	height: 18px;
}


/*-----------------
	8. Focus Label
-----------------------*/

.form-focus {
	height: 50px;
	position: relative;
}

.form-focus .focus-label {
	font-size: 14px;
	font-weight: 400;
	pointer-events: none;
	position: absolute;
	-webkit-transform: translate3d(0, 22px, 0) scale(1);
	-ms-transform: translate3d(0, 22px, 0) scale(1);
	-o-transform: translate3d(0, 22px, 0) scale(1);
	transform: translate3d(0, 22px, 0) scale(1);
	transform-origin: left top;
	transition: 240ms;
	left: 12px;
	top: -8px;
	z-index: 1;
	color: #b8b8b8;
	margin-bottom: 0;
}

.form-focus.focused .focus-label {
	opacity: 1;
	top: -18px;
	font-size: 12px;
	z-index: 1;
}

.form-focus .form-control:focus~.focus-label,
.form-focus .form-control:-webkit-autofill~.focus-label {
	opacity: 1;
	font-weight: 400;
	top: -18px;
	font-size: 12px;
	z-index: 1;
}

.form-focus .form-control {
	height: 50px;
	padding: 21px 12px 6px;
}

.form-focus .form-control::-webkit-input-placeholder {
	color: transparent;
	transition: 240ms;
}

.form-focus .form-control:focus::-webkit-input-placeholder {
	transition: none;
}

.form-focus.focused .form-control::-webkit-input-placeholder {
	color: #bbb;
}

.form-focus.select-focus .focus-label {
	opacity: 1;
	font-weight: 300;
	top: -20px;
	font-size: 12px;
	z-index: 1;
}

.form-focus .select2-container .select2-selection--single {
	border: 1px solid #e3e3e3;
	height: 50px;
}

.form-focus .select2-container--default .select2-selection--single .select2-selection__arrow {
	height: 48px;
	right: 7px;
}

.form-focus .select2-container--default .select2-selection--single .select2-selection__arrow b {
	border-color: #ccc transparent transparent;
	border-style: solid;
	border-width: 6px 6px 0;
	height: 0;
	left: 50%;
	margin-left: -10px;
	margin-top: -2px;
	position: absolute;
	top: 50%;
	width: 0;
}

.form-focus .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
	border-color: transparent transparent #ccc;
	border-width: 0 6px 6px;
}

.form-focus .select2-container .select2-selection--single .select2-selection__rendered {
	padding-right: 30px;
	padding-left: 12px;
	padding-top: 10px;
}

.form-focus .select2-container--default .select2-selection--single .select2-selection__rendered {
	color: #676767;
	font-size: 14px;
	font-weight: normal;
	line-height: 38px;
}

.form-focus .select2-container--default .select2-results__option--highlighted[aria-selected] {
	background-color: #fc6075;
}


/*-----------------
	9. Login
-----------------------*/

.account-page {
	background-color: #fff;
}

.account-page .content {
	padding: 50px 0;
}

.login-right {
	background-color: #fff;
	border: 1px solid #f0f0f0;
	border-radius: 4px;
	padding: 25px;
}

.login-header {
	margin-bottom: 20px;
}

.login-header p {
	margin-bottom: 0;
}

.login-header h3 {
	font-size: 18px;
	margin-bottom: 3px;
}

.login-header h3 a {
	color: #e8ba3f;
	float: right;
	font-size: 15px;
	margin-top: 2px;
}

.login-right .dont-have {
	color: #3d3d3d;
	margin-top: 20px;
	font-size: 13px;
}

.login-right .dont-have a {
	color: #e5bd54;
}

.login-btn {
	font-size: 18px;
	font-weight: 500;
}

.login-or {
	color: #c8c8c8;
	margin-bottom: 20px;
	margin-top: 20px;
	padding-bottom: 10px;
	padding-top: 10px;
	position: relative;
}

.or-line {
	background-color: #ddd;
	height: 1px;
	margin-bottom: 0;
	margin-top: 0;
	display: block;
}

.span-or {
	background-color: #fff;
	display: block;
	left: 50%;
	margin-left: -20px;
	position: absolute;
	text-align: center;
	top: -3px;
	width: 42px;
}

.forgot-link {
	color: #3d3d3d;
	display: inline-block;
	font-size: 13px;
	margin-bottom: 10px;
	font-weight: 400;
}

.btn-facebook {
	background-color: #3a559f;
	color: #fff;
	font-size: 13px;
	padding: 8px 12px;
}

.btn-google {
	background-color: #dd4b39;
	color: #fff;
	font-size: 13px;
	padding: 8px 12px;
}

.social-login .btn:hover,
.social-login .btn:focus {
	color: #fff;
}


/*-----------------
	10. Header
-----------------------*/

.header-nav {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	background-color: #13563A;
	border: 0;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	justify-content: space-between;
	-webkit-justify-content: space-between;
	-ms-flex-pack: space-between;
	position: relative;
	padding: 10px 30px;
	margin-bottom: 0;
}

.home .header-trans {
	position: fixed !important;
}

.header-trans {
	display: block;
	width: 100%;
    position: relative;
	z-index: 9999;
	height: 75px;
	transition: all 0.5s ease;
	-webkit-transition: all 0.5s ease;
	-ms-transition: all 0.5s ease;
}

.header-trans .header-nav {
	background: #13563A;
}
.home .header-trans .header-nav {
	background: transparent;
}

.main-nav {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	list-style: none;
	margin: 0;
	padding: 0;
}

.main-nav > li.active > a {
	color: #E5BD54 !important;
}

.main-nav > li.active > a:before {
    content: '';
    position: absolute;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    bottom: 0;
    top: 0;
    left: 35%;
    right: 0;
    background-repeat: no-repeat;
}

.main-nav > li .submenu li a {
	display: block;
	padding: 10px 15px;
	clear: both;
	white-space: nowrap;
	font-size: 14px;
	color: #2d3b48;
	-webkit-transition: all .35s ease;
	transition: all .35s ease;
	width: 100%;
	border-top: 1px solid #f0f0f0;
}

.main-nav > li .submenu > li.has-submenu > a::after {
	content: "\\f054";
	font-family: "Font Awesome 5 Free";
	font-weight: 900;
	position: absolute;
	right: 15px;
	top: 12px;
	font-size: 13px;
}

.vibrate {
    display: inline-block;
    animation: vibrate 0.5s ease infinite;
}

/* Vibration effect */
@keyframes vibrate {
    0% { transform: translateX(0); }
    25% { transform: translateX(-1px); }
    50% { transform: translateX(1px); }
    75% { transform: translateX(-1px); }
    100% { transform: translateX(1px); }
}

.main-nav > li .submenu li {
	position: relative;
}

.main-nav li a {
	display: block;
	font-size: 14px;
	font-weight: 500;
}

.main-nav li .submenu::before {
    display: none !important;
}

.main-nav.bg-trans li a {
	display: block;
	font-size: 14px;
	font-weight: 500;
	color: #ffffff;
}

.main-nav li.login-link {
	display: none;
}

.logo {
	display: inline-block;
	margin-right: 30px;
	max-width: 75px;
}

.main-menu-wrapper {
	margin-left: auto;
}

.header-contact-img {
	display: inline-block;
}

.header-contact-img i {
	color: rgba(0, 0, 0, 0.5);
	font-size: 30px;
}

.header-contact-detail {
	display: inline-block;
	padding-left: 10px;
}

.header-contact-detail p.contact-header {
	color: #484848;
	font-size: 13px;
	font-weight: 400;
	margin-bottom: 2px;
	text-align: left;
}

.header-contact-detail p.contact-info-header {
	color: #000;
	font-weight: 500;
	font-size: 14px;
	margin-bottom: 0;
}

.header-navbar-rht {
	margin: 0;
	padding: 0;
}

.header-navbar-rht li {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	justify-content: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	margin-left: 15px;
}

.header-navbar-rht li:last-child {
	padding-right: 0px;
}

.header-navbar-rht li .dropdown-menu {
	border: 0;
	box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
}

.header-navbar-rht .dropdown-toggle::after {
	display: none;
}

.header-navbar-rht li .dropdown-menu::before {
	content: "";
	position: absolute;
	top: 2px;
	right: 0;
	border: 7px solid #fff;
	border-color: transparent transparent #ffffff #ffffff;
	-webkit-transform-origin: 0 0;
	transform-origin: 0 0;
	-webkit-transform: rotate(135deg);
	transform: rotate(135deg);
	box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
}

.header-navbar-rht li .dropdown-menu .dropdown-item {
	border-top: 1px solid #f0f0f0;
	padding: 10px 15px;
}

.header-navbar-rht li .dropdown-menu .dropdown-item:first-child {
	border-top: 0;
	border-radius: 5px 5px 0 0;
}

.header-navbar-rht li .dropdown-menu .dropdown-item:last-child {
	border-radius: 0 0 5px 5px;
}

.header-navbar-rht li a.header-login:hover {
	background-color: #e5bd54;
	border-color: #e5bd54;
	color: #fff;
}

.header-navbar-rht li .dropdown-menu a:hover {
	color: #e5bd54;
	letter-spacing: 0.5px;
	padding-left: 20px;
	background-color: #fff;
}

.header-navbar-rht li a.header-login {
	border: 2px solid #e5bd54;
	border-radius: 4px;
	padding: 10px 15px !important;
	text-align: center;
	font-size: 15px;
	color: #e5bd54;
	text-transform: uppercase;
	font-weight: 500;
}

.header .has-arrow .dropdown-toggle:after {
	border-top: 0;
	border-left: 0;
	border-bottom: 2px solid #757575;
	border-right: 2px solid #757575;
	content: '';
	height: 8px;
	display: inline-block;
	pointer-events: none;
	-webkit-transform-origin: 66% 66%;
	-ms-transform-origin: 66% 66%;
	transform-origin: 66% 66%;
	-webkit-transform: rotate(45deg);
	-ms-transform: rotate(45deg);
	transform: rotate(45deg);
	-webkit-transition: all 0.15s ease-in-out;
	transition: all 0.15s ease-in-out;
	width: 8px;
	vertical-align: 2px;
	margin-left: 10px;
}

.header .has-arrow .dropdown-toggle[aria-expanded="true"]:after {
	-webkit-transform: rotate(-135deg);
	-ms-transform: rotate(-135deg);
	transform: rotate(-135deg);
}

.user-menu {
	float: right;
	margin: 0;
	position: relative;
	z-index: 99;
}

.user-menu.nav > li > a {
	color: #fff;
	font-size: 14px;
	line-height: 58px;
	padding: 0 15px;
	height: 60px;
}

.user-menu.nav > li > a:hover,
.user-menu.nav > li > a:focus {
	background-color: rgba(0, 0, 0, 0.2);
}

.user-menu.nav > li > a:hover i,
.user-menu.nav > li > a:focus i {
	color: #fff;
}

.user-img {
	display: inline-block;
	position: relative;
}

.user-img > img {
	height: 31px;
	object-fit: cover;
	width: 31px;
}

.user-menu.nav > li > a.mobile_btn {
	border: 0;
	position: relative;
	padding: 0;
	margin: 0;
	cursor: pointer
}

.header-navbar-rht .dropdown-menu {
	min-width: 200px;
	padding: 0;
}

.header-navbar-rht .dropdown-menu .dropdown-item {
	padding: 7px 15px;
}

.header-navbar-rht .dropdown-menu .dropdown-item {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	border-top: 1px solid #e3e3e3;
	padding: 10px 15px;
}

.header-navbar-rht .dropdown-menu .dropdown-item:hover {
	color: #e5bd54;
}

.user-header {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	padding: 10px 15px;
}

.user-header .user-text {
	margin-left: 10px;
}

.user-header .user-text h6 {
	font-size: 15px;
	margin-bottom: 2px;
}

.header-navbar-rht .logged-item .nav-link {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	font-size: 14px;
	line-height: 60px;
	padding: 0 10px;
}

.togglesearch {
	position: absolute;
	top: 74px;
	right: 8%;
	width: 280px;
	border-top: 4px solid #e5bd54;
	display: none;
	z-index: 999;
	background: #fff;
	padding: 0 10px;
	border-radius: 5px;
	box-shadow: 0px 2px 8px rgb(183 183 183 / 25%);
}

.togglesearch:before {
	content: "";
	position: absolute;
	top: -30px;
	right: 13px;
	border-left: 12px solid transparent;
	border-right: 12px solid transparent;
	border-top: 14px solid transparent;
	border-bottom: 14px solid #e5bd54;
}

.togglesearch input[type="text"] {
	width: 182px;
	padding: 5px 10px;
	border: 1px solid #e5bd54;
	outline: none;
	height: 40px;
	border-radius: 5px 0 0 5px;
}

.togglesearch button {
	width: 80px;
	padding: 5px 0;
	background: #e5bd54;
	color: #fff;
	margin-left: -6px;
	border: 1px solid #e5bd54;
	outline: none;
	cursor: pointer;
	height: 41px;
	border-radius: 0 5px 5px 0;
}

.dropdown-item img {
	margin-right: 5px;
}

.nav-item > a {
	color: #fff;
}

.nav-book-content span {
	font-weight: 500;
	color: #fff;
	font-size: 14px;
}

.nav-book-content p {
	color: #e5bd54;
	font-weight: 500;
	font-size: 14px;
}

.nav-booking {
	width: 30px;
	height: 30px;
	border-radius: 50%;
	background: #e5bd54;
	text-align: center;
	padding: 3px;
}

.nav-item i {
	color: #fff;
}

.contact-item {
	background: #E5BD54;
	padding: 0 15px !important;
	box-shadow: -2px 2px 4px rgba(5, 90, 190, 0.1);
	border-radius: 5px;
	font-size: 12px;
	height: 45px;
}

.cart-item img {
	padding: 10px 9px 8px 2px;
}

.cart-item {
	width: 35px;
    height: 35px;
    background: #e5bd54;
    border-radius: 50%;
    margin: auto;
    padding: 5px;
}

.header-top {
	display: flex;
	display: -webkit-flex;
	background: #E5BD54;
	color: #fff;
	padding: 8px 30px;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 999;
	height: 32px;
}

.header-top a:hover {
	color: #000;
}

.header-top ul {
	display: flex;
	margin: 0;
	list-style: none;
}

.header-top .left-top ul li {
	font-size: 12px;
}

.header-top .left-top ul li:last-child {
	padding-right: 0;
}

.header-top .right-top ul li {
	padding-left: 25px;
	font-size: 13px;
}

.header-top .right-top ul li a {
	color: #fff;
}

.header-top .right-top {
	float: right;
}

.top-icon {
	margin-right: 5px;
}

.header-top .nav-link {
	padding: 0;
}


/*-----------------
	11. Home
-----------------------*/

.banner-section {
	position: relative;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
	background-position: 50% 0;
	background-size: cover;
	background-repeat: no-repeat;
	z-index: 1;
}

.banner-top:after {
	content: "";
	position: absolute;
	background: rgba(0, 0, 0, 0.6);
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	z-index: -1;
}

.banner-content img {
	margin-bottom: 25px;
	width: 135px;
}

.banner-content {
	max-width: 740px;
	margin: auto;
	padding: 185px 0 160px;
	text-align: center;
}

.banner-content h4 {
	font-size: 26px;
	font-weight: 600;
	color: #fff;
}

.banner-content p {
	font-size: 15px;
	color: #fff;
	margin-bottom: 2rem;
	line-height: 30px;
}

.banner-content h2 {
	font-size: 44px;
	font-weight: 400;
	color: #FFCF53;
	font-family: 'Patua One', cursive;
}

.banner-primary:hover {
	background: #13563A;
	color: #fff;
	border: 1px solid #13563A;
}

.banner-primary {
	padding: 15px 30px;
	background: #E5BD54;
	border: 1px solid #E5BD54;
	border-radius: 0;
	color: #fff;
	font-weight: 400;
	font-size: 15px;
}

/* .btn-secondary {
	padding: 15px 30px;
	background: #13563A;
	border: 1px solid #13563A;
	border-radius: 0;
	color: #fff;
	font-weight: 400;
	font-size: 15px;
}

.btn-secondary:hover {
	background: #fff;
	border: 1px solid #13563A;
	color: #13563A
}

.btn-secondary-outline {
	background: #F8F8F8;
	border: 2px solid #D9B03E;
	padding: 5px 10px;
	color: #13563A;
	border-radius: 0;
	width: 100%;
	font-size: 16px;
	font-family: 'Patua One', cursive;
} */

.banner-white-outline {
	padding: 15px 30px;
	border: 1px solid #FFFFFF;
	border-radius: 0;
	color: #fff;
	font-weight: 400;
	font-size: 15px;
}

.banner-white-outline:hover {
	padding: 15px 30px;
	border: 1px solid #FFFFFF;
	background: #FFFFFF;
	border-radius: 0;
	color: #212529;
	font-weight: 400;
	font-size: 15px;
}

.features-box {
	position: relative;
}

.features-img {
	position: relative;
}

.features-img:after, .feature-video:after {
	content: '';
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background: rgba(25, 25, 25, 0.7);
}

.features-img:after {
    background: rgba(0, 0, 0, 0.45)
}

.features-border {
	position: absolute;
	border: 1px solid #CC9400;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: 20px;
}

.features-text {
	bottom: 30px;
	left: 10px;
	position: absolute;
}

.features-text h2 {
	font-size: 20px;
	font-weight: 400;
	color: #FFCF53;
	font-family: 'Patua One', cursive;
	margin-bottom: 0;
}

.features-text p {
	font-size: 17px;
	color: #fff;
}

.features-arrow {
	bottom: 45px;
	right: 10px;
	position: absolute;
	display: none;
}

.features-border:hover .features-arrow {
	display: block;
}

.features-arrow i {
	border: 1px solid #ffffff;
	background: #ffffff;
	border-radius: 50%;
	width: 25px;
	color: #e5bd54;
	height: 25px;
	line-height: 23px;
	font-size: 12px;
	text-align: center;
}

.features-border:hover {
	background: #cc9400;
}

.features-border:hover h2 {
	color: #fff;
}

.section-heading {
	position: relative;
	padding-bottom: 50px;
	width: 575px;
	margin: auto;
}

.fields-section .section-heading {
	padding-bottom: 8px;
}

.section-heading img {
	width: 22px;
	margin-bottom: 5px;
}

.section-heading h2 {
	color: #13563A;
	font-family: 'Patua One', cursive;
	font-size: 32px;
	font-weight: 400;
}

.section-heading p {
	color: #545454;
	font-size: 13px;
}

.coaching-section {
	padding: 175px 0 50px;
}

.coaching-text h2 {
	color: #13563A;
	font-family: 'Patua One', cursive;
	font-size: 22px;
	font-weight: 400;
	margin-bottom: 10px;
}

.coaching-text img {
	width: 55px;
}

.coaching-text p {
	color: #232323;
	font-size: 13px;
	font-weight: 500;
}

.golf-img-1 {
	margin-top: -50px;
}

.feature-card {
	box-shadow: 0px 2px 8px rgba(39, 39, 39, 0.25);
	border-radius: 10px;
	padding: 20px;
	background: #fff;
}

.feature-head p {
	color: rgba(19, 74, 86, 0.1);
	font-family: 'Patua One', cursive;
	font-size: 46px;
}

.feature-head img {
	width: auto;
	height: 55px;
}

.feature-head {
	margin-bottom: 20px;
}

.feature-body h2 {
	font-size: 20px;
	color: #000;
	margin: 0;
}

.features-section {
	position: relative;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
	background-position: 50% 0;
	background-size: cover;
	background-repeat: no-repeat;
	padding: 50px 0;
	background-blend-mode: multiply;
	z-index: 1;
}

.features-section:after {
	content: "";
	position: absolute;
	background: rgba(224, 181, 65, 0.95);
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	z-index: -1;
}

.field-body h2 {
	color: #CC9400;
	font-size: 18px;
}

.field-body span {
	color: #13563A;
	font-size: 16px;
	font-family: 'Patua One', cursive;
}

.fields-section {
	padding: 50px 0;
	background: rgba(255, 250, 236, 0.6)
}

.field-row {
	-ms-flex: 0 0 20%;
	flex: 0 0 20%;
	max-width: 20%;
	padding: 0 15px;
}

.text-view {
	text-decoration: underline;
	font-weight: 500;
}

.golf-img img {
	border-radius: 10px;
}

.golf-img-1 img {
	border-radius: 10px;
}

.golf-bg {
	background: rgba(196, 196, 196, 0.1);
	border: 1px solid #E5BD54;
	padding: 40px;
}

.golf-bg h2 {
	color: #fff;
	font-size: 38px;
	font-family: 'Patua One', cursive;
}

.golf-bg p {
	color: #fff;
}

.golf-section {
	position: relative;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
	background-position: bottom;
	background-size: cover;
	background-repeat: no-repeat;
	padding: 50px 0;
	background-blend-mode: multiply;
	z-index: 1;
}

.golf-section:after {
	content: "";
	position: absolute;
	background: rgba(172, 209, 23, 0.3);
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	z-index: -1;
}

.review-section {
	padding: 50px 0;
	background: rgba(255, 250, 236, 0.6);
}

.clients {
	width: 80px !important;
	border-radius: 50%;
}

.review-card h6 {
	color: #13563A;
	font-size: 18px;
}

.review-card span {
    color: #4F4F4F;
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 500;
}

.review-rating li .checked {
	color: #FFAA00;
}

.review-rating li .not-checked {
	color: #C4C4C4;
}

.review-rating li {
	list-style-type: none;
	display: inline-block;
	font-size: 10px;
}

.owl-nav-left {
	border: 1px solid #13563A;
	background: #13563A;
	border-radius: 50%;
	width: 25px;
	color: #FFFFFF;
	height: 25px;
	line-height: 23px;
	font-size: 12px;
}

.owl-nav-right {
	border: 1px solid #13563A;
	background: #13563A;
	border-radius: 50%;
	width: 25px;
	color: #FFFFFF;
	height: 25px;
	line-height: 23px;
	font-size: 12px;
}

.testimonial-slider {
	background: #fff;
	padding: 25px;
}

.blog-text h5 a {
	color: #13563A;
	font-weight: 600;
}

.blog-text p {
	font-size: 12px;
	margin-bottom: 0.75rem;
}

.blog-text a {
	color: #E5BD54;
	font-size: 13px;
	font-weight: 600;
}

.blogs-date {
	background: #D9B03E;
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
	border-radius: 4px;
	text-align: center;
	padding: 1px 10px;
	width: 150px;
	position: absolute;
	right: 10px;
	top: 20px;
}

.blogs-date p {
	color: #fff;
	font-size: 12px;
}

.our-blogs,
.blog-img {
	position: relative;
}

.blog-img img{
	width: 100%;
}

.blog-section {
	padding: 50px 0;
}

.banner-overlay {
	position: absolute;
	bottom: -125px;
}

.vector-shapes {
	position: absolute;
	width: 100%;
}

.shape-1 {
	position: absolute;
    top: -270px;
    right: 0;
}

.shape-3 {
	position: absolute;
    bottom: -520px;
    left: -140px;
}

.shape-4 {
	position: absolute;
    top: -45px;
    right: 15%;
}

.shape-5 {
    position: absolute;
    bottom: 0;
}

.shape-6 {
    position: absolute;
    top: 0;
    left: 130px;
}

.shape-7 {
    position: absolute;
    right: 110px;
    top: 0;
}

.shape-8 {
    position: absolute;
    right: 0;
    bottom: 0;
}

/*-----------------
	12. Footer
-----------------------*/

.footer {
	position: relative;
	background: #13563A;
}

.footer .footer-top {
	padding-top: 40px;
	position: relative;
	z-index: 9;
}

.footer .footer-top .footer-about-content {
	max-width: 315px;
}

.footer .footer-bottom {
	position: relative;
	z-index: 9;
}

.footer-title {
	color: #fff;
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 20px;
	text-transform: capitalize;
	position: relative;
}

h2.footer-title:after {
	content: "";
	width: 39px;
	height: 2px;
	background: #FF3115;
	top: 32px;
	left: 0;
	right: 0;
	bottom: 0;
	position: absolute;
}

.footer .footer-widget.footer-menu ul {
	list-style: none;
	margin: 0;
	padding: 0;
	outline: none;
}

.footer .footer-widget .footer-logo {
	margin-bottom: 15px;
}

.footer .footer-widget .footer-logo img {
	max-height: 50px;
	max-width: 100%;
}

.footer .footer-widget p {
	color: #fff;
	font-size: 12px;
}

.footer .footer-widget h5 {
	color: #fff;
	font-size: 14px;
	font-weight: 500;
}

.footer .footer-widget .footer-about-content p:last-child {
	margin-bottom: 0;
}

.footer .footer-menu ul li {
	margin-bottom: 10px;
	position: relative;
}

.footer .footer-menu ul li:last-child {
	margin-bottom: 0;
}

.footer .footer-menu ul li a {
	color: #fff;
	transition: all 0.4s ease 0s;
	font-size: 13px;
}

.footer .footer-menu ul li a i {
	margin-right: 15px;
	font-size: 13px;
	color: #e5bd54;
}

.footer .footer-widget.footer-menu ul li a:hover {
	color: #fff;
}

.footer-contact-info {
	color: #fff;
}

.footer-contact-info .footer-address {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.footer-contact-info .footer-address span {
	margin-right: 20px;
}

.footer-contact-info .footer-address span i.fa-map-marker-alt {
	font-size: 20px;
}

.footer-contact-info p i {
	margin-right: 15px;
}

.footer .footer-bottom .copyright {
	padding: 40px 0;
}

.home-page .footer .footer-bottom .copyright {
	border-top: 1px solid #eceff0;
}

.footer .footer-bottom .copyright-text p {
	color: #e5bd54;
}

.footer .footer-bottom .copyright-text p a {
	color: #09e5ab;
	-webkit-transition: all 0.4s ease 0s;
	-o-transition: all 0.4s ease 0s;
	transition: all 0.4s ease 0s;
}

.footer .footer-bottom .copyright-text p a:hover {
	color: #fff;
}

.footer .footer-bottom .copyright-text p.title {
	font-weight: 400;
	margin: 10px 0 0;
}

.footer .social-icon ul {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	list-style: none;
	padding: 0;
	margin: 0;
}

.footer .social-icon ul li {
	margin-right: 15px;
}

.footer .social-icon ul li:last-child {
	margin-right: 0;
}

.footer .social-icon ul li a {
	color: #fff;
	display: block;
	font-size: 14px;
	transition: all 0.4s ease 0s;
	height: 26px;
	width: 26px;
	background: rgba(255, 255, 255, 0.1);
	border-radius: 50%;
	text-align: center;
	padding: 4px;
}

.footer .social-icon ul li a:hover {
	color: #ff3115;
}

.footer-newsletter input {
	box-shadow: 0px 4px 4px rgb(194 194 194 / 25%);
	border-radius: 200px !important;
	height: 43px;
	width: 100%;
	padding: 6px 15px;
}

.footer-newsletter input:focus {
	outline: none;
}

.btn-newsletter {
	background: #FF3115;
	border-radius: 200px;
	position: absolute;
	height: 43px;
	right: 0;
	width: 83px;
}

.subsccribe-item {
	margin-bottom: 40px;
}

.subscribe-item .section-title h2 {
	color: #E5BD54;
}

.subscribe-item .section-title p {
	color: #fff;
}

.subscribe-item .newsletter-form {
	position: relative;
}

.subscribe-item .newsletter-form .form-control {
	height: 50px;
	padding: 10px 15px 10px 30px;
	background-color: #fff;
	border-radius: 0;
	font-size: 16px;
	box-shadow: 0px 4px 4px rgb(194 194 194 / 25%);
	border: 0;
}

.subscribe-item .newsletter-form .cmn-btn {
	opacity: 1;
	position: absolute;
	right: 0;
	top: 0;
	padding: 12px 18px;
	background: #E5BD54;
	border-radius: 0;
	height: 50px;
	color: #fff;
}

.footer-about {
	max-width: 320px;
	margin: auto;
}

.footer-about ul li {
	display: inline-block;
}


/*-----------------
	13. Mobile Menu
-----------------------*/

.sidebar-overlay {
	background-color: rgba(0, 0, 0, 0.6);
	display: none;
	height: 100%;
	left: 0;
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 1029;
}

.menu-opened .main-menu-wrapper {
	transform: translateX(0);
}

.menu-header {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	background-color: #13563A;
	height: 60px;
	padding: 0 20px;
	justify-content: space-between;
	-webkit-justify-content: space-between;
	-ms-flex-pack: space-between;
	border-bottom: 1px solid #f0f0f0;
	display: none;
}

.menu-logo img {
	height: 40px;
}

.menu-close {
	font-size: 18px;
	color: #fff;
}

.bar-icon {
	display: inline-block;
	width: 31px;
}

.bar-icon span {
	background-color: #e8ba3f;
	display: block;
	float: left;
	height: 3px;
	margin-bottom: 7px;
	width: 31px;
	border-radius: 2px;
}

.bar-icon span:nth-child(2) {
	width: 16px;
}

.bar-icon span:nth-child(3) {
	margin-bottom: 0;
}

#mobile_btn {
	display: none;
	margin-right: 30px;
}

html.menu-opened body {
	overflow: hidden;
}


/*-----------------
	14. Search
-----------------------*/

.breadcrumb-bar {
    display: none;
	background-color: #f1f1f1;
	padding: 15px 0;
}

.breadcrumb-bar .breadcrumb-title {
	color: #2d3952;
	font-size: 22px;
	font-weight: 700;
	margin: 5px 0 0;
}

.page-breadcrumb ol {
	background-color: transparent;
	font-size: 12px;
	margin-bottom: 0;
	padding: 0;
}

.page-breadcrumb ol li a {
	color: #2d3952;
}

.page-breadcrumb ol li.active {
	color: #2d3952;
}

.page-breadcrumb .breadcrumb-item+.breadcrumb-item:before {
	color: #2d3952;
	font-size: 10px;
}

.sort-by {
	float: right;
}

.sort-title {
	color: #2d3952;
	font-size: 14px;
	margin-right: 10px;
}

.sortby-fliter {
	display: inline-block;
	width: 120px;
}

.cal-icon {
	position: relative;
	width: 100%;
}

.cal-icon:after {
	color: #979797;
	content: '\\f073';
	display: block;
	font-family: "Font Awesome 5 Free";
	font-size: 16px;
	font-weight: 400;
	margin: auto;
	position: absolute;
	right: 15px;
	top: 10px;
}

.custom_check {
	color: #666;
	display: inline-block;
	position: relative;
	font-size: 14px;
	font-size: .9375rem;
	padding-left: 30px;
	margin-bottom: 10px;
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none
}

.custom_check input {
	position: absolute;
	opacity: 0;
	cursor: pointer
}

.custom_check input:checked~.checkmark {
	background-color: #fff;
}

.custom_check .checkmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 20px;
	width: 20px;
	border: 1px solid #dcdcdc;
	background-color: #fff;
	border-radius: 3px;
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out
}

.custom_check .checkmark::after {
	content: "\\f00c";
	font-family: "Font Awesome 5 Free";
	font-weight: 900;
	position: absolute;
	display: none;
	left: 4px;
	top: 0;
	color: #f1c85f;
	font-size: 11px;
}

.custom_check input:checked~.checkmark:after {
	display: block
}

.custom_radio {
	color: #555;
	display: inline-block;
	position: relative;
	font-size: 14px;
	font-size: 0.9375rem;
	padding-left: 30px;
	margin-bottom: 10px;
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none
}

.radio_input .custom_radio+.custom_radio {
	margin-left: 15px;
}

.custom_radio input {
	position: absolute;
	opacity: 0
}

.custom_radio input:checked~.checkmark:after {
	opacity: 1
}

.custom_radio .checkmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #fff;
	border: 1px solid #ccc;
	border-radius: 50%
}

.custom_radio .checkmark:after {
	display: block;
	content: "";
	position: absolute;
	opacity: 0;
	top: 3px;
	left: 3px;
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background: #ff9b44;
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out
}

.filter-widget {
	margin-bottom: 20px;
}

.filter-widget h4 {
	font-size: 1rem;
	margin-bottom: 15px;
}

.filter-widget .custom_check {
	line-height: 18px;
}

.btn-search .btn {
	background-color: #f1c85f;
	border: 1px solid #f1c85f;
	color: #fff;
	height: 46px;
	font-weight: 500;
	font-size: 16px;
}

.sender-widget {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.doc-info-left {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.doc-info-right {
	margin-left: auto;
	-ms-flex: 0 0 25%;
	flex: 0 0 25%;
	max-width: 200px;
}

.sender-img {
	-ms-flex: 0 0 150px;
	flex: 0 0 150px;
	margin-right: 20px;
	width: 150px;
}

.sender-img img {
	/* border-radius: 5px; */
}

.doc-department {
	color: #e5bd54;
	font-size: 14px;
	margin-bottom: 8px;
}

.doc-department img {
	width: 19px;
	display: inline-block;
	margin-right: 10px;
}

.doc-location {
	color: #757575;
	font-size: 14px;
	margin-bottom: 25px;
}

.doc-location a {
	color: #13563A;
	font-weight: 500;
}

.sender-widget .doc-name {
	font-size: 20px;
	font-weight: 500;
	margin-bottom: 3px;
}

.doc-speciality {
	font-size: 14px;
	color: #757575;
	margin-bottom: 15px;
}

.sender-widget .rating i {
	font-size: 14px;
}

.sender-widget .average-rating {
	font-size: 14px;
	font-weight: 500;
}

.shop-details {
	margin-bottom: 15px;
}

.shop-details h5 {
	font-weight: normal;
	color: #757575;
	margin-bottom: 25px;
}

.shop-details ul {
	list-style: none;
	margin: 0;
	padding: 0;
}

.shop-details ul li {
	display: inline-block;
	padding-right: 9px;
}

.shop-details ul li:last-child {
	padding-right: 0;
}

.shop-details ul li a {
	display: inline-block;
}

.shop-details ul li a img {
	border-radius: 5px;
	width: 40px;
}

.shop-services {
	color: #272b41;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	font-size: 13px;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
}

.shop-services span {
	border: 1px solid #ccc;
	border-radius: 4px;
	display: inline-block;
	font-size: 12px;
	padding: 3px 10px;
}

.shop-services span+span {
	margin-left: 5px;
}

.clini-infos {
	margin-bottom: 15px;
}

.clini-infos ul {
	font-size: 14px;
	list-style: none;
	margin: 0;
	padding: 0;
}

.clini-infos ul li {
	display: block;
	line-height: 30px;
	color: #4E4852;
}

.clini-infos ul li i {
	font-size: 15px;
	min-width: 30px;
}

.shop-booking a+a {
	margin-top: 15px;
}

.shop-booking a {
	background-color: #fff;
	border: 2px solid #e5bd54;
	border-radius: 4px;
	color: #e5bd54;
	display: block;
	font-size: 14px;
	font-weight: 500;
	letter-spacing: 1px;
	padding: 10px 15px;
	text-align: center;
	text-transform: uppercase;
	width: 100%;
}

.shop-booking a.view-pro-btn:hover,
.shop-booking a.view-pro-btn:focus {
	background: #e5bd54;
	color: #fff;
}

.shop-booking a.apt-btn {
	background-color: #e5bd54;
	color: #fff;
}

.shop-booking a.apt-btn:hover,
.shop-booking a.apt-btn:focus {
	background-color: #e2b745;
	border-color: #e2b745;
	color: #fff;
}

.load-more {
	margin-bottom: 30px;
}


/*-----------------
	15. advisors Profile
-----------------------*/

.shop-direction {
	color: #757575;
	font-size: 14px;
	margin-bottom: 25px;
}

.shop-direction a {
	color: #09e5ab;
	font-weight: 500;
}

.sender-action {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	margin-bottom: 15px;
}

.sender-action a+a {
	margin-left: 8px;
}

.sender-action .fav-btn:hover {
	background-color: #fb1612;
	border-color: #fb1612;
	color: #fff;
}

.msg-btn:hover,
.msg-btn:focus {
	background-color: #efc75e;
	border-color: #efc75e;
	color: #fff;
}

.call-btn:hover,
.call-btn:focus {
	background-color: #efc75e;
	border-color: #efc75e;
	color: #fff;
}

.user-tabs .nav-tabs > li > a {
	border: 0;
	border-bottom: 3px solid transparent;
	color: #3e3e3e;
	font-weight: 600;
	padding: 20px;
}

.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active,
.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:hover,
.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:focus {
	border-bottom-width: 3px;
	color: #e5bd54;
}

.user-tabs .med-records {
	display: inline-block;
	min-width: 130px;
}

.user-tabs .nav-tabs > li > a:hover {
	background-color: unset;
	color: #e5bd54;
}

.widget {
	margin-bottom: 30px;
}

.widget-title {
	margin-bottom: 15px;
}

.experience-box {
	position: relative;
}

.experience-list {
	list-style: none;
	margin: 0;
	padding: 0;
	position: relative;
}

.experience-list::before {
	background: #ddd;
	bottom: 0;
	content: "";
	left: 8px;
	position: absolute;
	top: 8px;
	width: 2px;
}

.experience-list > li {
	position: relative;
}

.experience-list > li:last-child .experience-content {
	margin-bottom: 0;
}

.experience-user .avatar {
	height: 32px;
	line-height: 32px;
	margin: 0;
	width: 32px;
}

.experience-list > li .experience-user {
	background: #fff;
	height: 10px;
	left: 4px;
	margin: 0;
	padding: 0;
	position: absolute;
	top: 4px;
	width: 10px;
}

.experience-list > li .experience-content {
	background-color: #fff;
	margin: 0 0 20px 40px;
	padding: 0;
	position: relative;
}

.experience-list > li .experience-content .timeline-content {
	color: #757575;
}

.experience-list > li .experience-content .timeline-content a.name {
	font-weight: 500;
}

.experience-list > li .time {
	color: #757575;
	display: block;
	font-size: 13px;
}

.before-circle {
	background-color: rgb(229 189 84 / 25%);
	border-radius: 50%;
	height: 12px;
	width: 12px;
	border: 2px solid #e5bd54;
}

.exp-year {
	color: #e5bd54;
	margin-bottom: 2px;
}

.exp-title {
	font-size: 16px;
}

.awards-widget .experience-list > li:last-child p {
	margin-bottom: 0;
}

.service-list {
	margin-bottom: 30px;
}

.service-list:last-child {
	border-bottom: 0;
	margin-bottom: 0;
	padding-bottom: 0;
}

.service-list ul {
	list-style: none;
	margin: 0;
	padding: 0;
}

.service-list ul li {
	float: left;
	margin: 6px 0;
	padding-left: 25px;
	position: relative;
	width: 33%;
}

.service-list ul li::before {
	color: #ccc;
	content: '\\f30b';
	font-family: "Font Awesome 5 Free";
	font-weight: 900;
	left: 0;
	position: absolute;
}

.location-list {
	border: 1px solid #f0f0f0;
	border-radius: 4px;
	padding: 20px;
}

.location-list+.location-list {
	margin-top: 20px;
}

.shop-content .shop-name {
	font-size: 18px;
	font-weight: 500;
	margin-bottom: 3px;
}

.shop-content .shop-direction a {
	display: inline-block;
	margin-top: 8px;
}

.timings-days {
	font-weight: bold;
	color: #272b41;
	margin-bottom: 5px;
}

.timings-times span {
	display: block;
}

.location-list .consult-price {
	font-size: 20px;
	font-weight: 500;
	color: #272b41;
}

.review-listing {
	border-bottom: 1px solid #f5f7fc;
	margin-top: 20px;
	padding-bottom: 30px;
}

.review-listing > ul {
	padding: 0;
	margin: 0;
	list-style: none;
}

.review-listing > ul li+li {
	margin-top: 20px;
	border-top: 1px dashed #f0f0f0;
	padding-top: 20px;
}

.review-listing > ul li .comment {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	margin-bottom: 30px;
}

.review-listing > ul li .comment:last-child {
	margin-bottom: 0;
}

.review-listing > ul li .comment .comment-body {
	margin-left: 16px;
}

.review-listing > ul li .comment .comment-body .meta-data {
	position: relative;
	margin-bottom: 10px;
}

.review-listing > ul li .comment .comment-body .meta-data span {
	display: block;
	font-size: 16px;
	color: #757575;
}

.review-listing > ul li .comment .comment-body .meta-data span.comment-author {
	font-weight: 600;
	color: #272b41;
	text-transform: capitalize;
}

.review-listing > ul li .comment .comment-body .meta-data span.comment-date {
	font-size: 14px;
}

.review-listing > ul li .comment .comment-body .meta-data .review-count {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	position: absolute;
	top: 3px;
	right: 0;
	width: auto;
}

.review-listing > ul li .comment .comment-body .comment-content {
	color: #757575;
	margin-top: 15px;
	margin-bottom: 15px;
	font-size: 14px;
}

.review-listing > ul li .comment .comment-body .comment-reply .comment-btn {
	color: #e5bd54;
	display: inline-block;
	font-weight: 500;
	font-size: 15px;
}

.review-listing .recommend-btn {
	float: right;
	color: #757575;
	font-size: 14px;
	padding: 5px 0;
	margin-bottom: 0;
}

.review-listing .recommend-btn a {
	border: 1px solid rgba(128, 137, 150, 0.4);
	border-radius: 4px;
	display: inline-block;
	padding: 4px 12px;
	color: #757575;
	margin-left: 3px;
	margin-right: 3px;
	transition: all .3s;
}

.review-listing .recommend-btn a.like-btn:hover {
	background-color: #28a745;
	border: 1px solid #28a745;
	color: #fff;
}

.review-listing .recommend-btn a.dislike-btn:hover {
	background-color: #dc3545;
	border: 1px solid #dc3545;
	color: #fff;
}

.review-listing .recommend-btn a i {
	font-size: 16px;
}

.review-listing > ul li .comments-reply {
	list-style: none;
	margin-left: 65px;
	padding: 0;
}

.recommended {
	color: #28a745;
	font-size: 15px;
	font-weight: 500;
	margin: 0;
}

.all-feedback {
	margin-top: 20px;
}

.star-rating {
	direction: rtl;
}

.star-rating input[type=radio] {
	display: none
}

.star-rating label {
	color: #dedfe0;
	cursor: pointer;
	font-size: 18px;
	padding: 0;
	-webkit-transition: all .3s ease-in-out;
	transition: all .3s ease-in-out;
    direction: ltr;
    line-height: 1;
    margin-bottom: 0;
}

.star-rating label i {
    min-width: auto !important;
}

.star-rating label:hover,
.star-rating label:hover~label,
.star-rating input[type=radio]:checked~label {
	color: #f2b600
}

.terms-accept a {
	color: #e5bd54;
	font-weight: 500;
}

.business-widget {
	background-color: #fcfcfc;
	border: 1px solid #f0f0f0;
	padding: 20px;
	margin-bottom: 0;
}

.listing-day {
	-webkit-box-align: flex-start;
	-ms-flex-align: flex-start;
	align-items: flex-start;
	color: #000;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	justify-content: space-between;
	-webkit-justify-content: space-between;
	-ms-flex-pack: space-between;
	margin-bottom: 10px;
}

.listing-day:last-child {
	margin-bottom: 0;
}

.listing-day.current {
	border-bottom: 1px solid #ddd;
	padding-bottom: 13px;
	margin-bottom: 13px;
}

.listing-day .day {
	font-weight: 500;
}

.listing-day.current .day {
	font-weight: bold;
}

.listing-day.current .day span {
	display: block;
	font-weight: normal;
}

.time-items {
	color: #757575;
}

.time-items > span {
	display: block;
	text-align: right;
}

.time-items > span.open-status {
	margin-bottom: 3px;
}

.dropzone .dz-preview.dz-error:hover .dz-error-message {
	display: none;
}


/*-----------------
	16. Booking
-----------------------*/

.booking-doc-info {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.booking-doc-info .booking-doc-img {
	width: 80px;
	margin-right: 15px;
}

.booking-doc-info .booking-doc-img img {
	border-radius: 4px;
	height: 80px;
	width: 80px;
	object-fit: cover;
}

.schedule-widget {
	border-radius: 4px;
	min-height: 100px;
}

.schedule-header h4 {
	font-size: 18px;
	font-weight: 600;
	margin: 3px 0 0;
}

.schedule-header {
	border-bottom: 1px solid #f0f0f0;
	border-radius: 4px 4px 0 0;
	padding: 10px 20px;
}

.day-slot ul {
	float: left;
	list-style: none;
	margin-bottom: 0;
	margin-left: -5px;
	margin-right: -5px;
	padding: 0;
	position: relative;
	width: 100%;
}

.day-slot li {
	float: left;
	padding-left: 5px;
	padding-right: 5px;
	text-align: center;
	width: 14.28%;
}

.day-slot li span {
	display: block;
	font-size: 18px;
	text-transform: uppercase;
}

.day-slot li span.slot-date {
	display: block;
	color: #757575;
	font-size: 14px;
}

.day-slot li small.slot-year {
	color: #757575;
	font-size: 14px;
}

.day-slot li.left-arrow {
	left: 0;
	padding: 0;
	position: absolute;
	text-align: center;
	top: 50%;
	width: 20px !important;
	transform: translateY(-50%);
}

.day-slot li.right-arrow {
	right: -11px;
	padding: 0;
	position: absolute;
	text-align: center;
	top: 50%;
	width: 20px !important;
	transform: translateY(-50%);
}

.schedule-cont {
	padding: 20px;
}

.time-slot ul {
	list-style: none;
	margin-right: -5px;
	margin-left: -5px;
	margin-bottom: 0;
	padding: 0;
}

.time-slot li {
	float: left;
	padding-left: 5px;
	padding-right: 5px;
	width: 14.28%;
}

.time-slot li .timing {
	background-color: #e9e9e9;
	border: 1px solid #e9e9e9;
	border-radius: 3px;
	color: #757575;
	display: block;
	font-size: 14px;
	margin-bottom: 10px;
	padding: 5px 5px;
	text-align: center;
	position: relative;
}

.time-slot li .timing:hover {
	background-color: #fff;
}

.time-slot li .timing:last-child {
	margin-bottom: 0;
}

.time-slot li .timing.selected {
	background-color: #13563A;
	border: 1px solid #13563A;
	color: #fff;
}

.time-slot li .timing.selected::before {
	color: #fff;
	content: "\\f00c";
	font-family: "Font Awesome 5 Free";
	font-size: 12px;
	font-weight: 900;
	position: absolute;
	right: 6px;
	top: 6px;
}

.schedule-list {
	border-bottom: 1px solid #cfcfcf;
	margin-bottom: 50px;
	padding-bottom: 50px;
}

.schedule-list:last-child {
	border-bottom: 0;
	margin-bottom: 0;
	padding-bottom: 0;
}

.submit-section.proceed-btn {
	margin: 0 0 30px;
}


/*-----------------
	17. Checkout
-----------------------*/

.info-widget {
	border-bottom: 1px solid #f0f0f0;
	padding-bottom: 30px;
	margin-bottom: 30px;
}

.card-label > label {
    position: relative;
    z-index: 900;
	background-color: #fff;
	color: #959595;
	display: inline-block;
	font-size: 14px;
	font-weight: 500;
	margin: 6px auto auto 8px;
	padding: 0 7px;
    border-radius: 4px;
}

.card-label > input, .card-label > .input, .card-label > select, .card-label > textarea {
	background-color: #fff;
	border: 1px solid #ebebeb;
	border-radius: 4px;
	box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .05);
	display: block;
	height: 50px;
	margin-top: -11px;
	padding: 0 15px;
	transition: border-color .3s;
	width: 100%;
}

.card-label > textarea {
    height: inherit;
    padding-top: 8px;
}

.card-label > span.input {
    padding-top: 13px;
    border: none;
    box-shadow: none;
}

.exist-customer a {
	color: #e5bd54;
	font-weight: 500;
}

.payment-widget .payment-list+.payment-list {
	margin-bottom: 15px;
}

.payment-radio {
	display: block;
	position: relative;
	padding-left: 35px;
	margin-bottom: 12px;
	cursor: pointer;
	font-size: 16px;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	font-weight: 600;
	color: #272b41;
	text-transform: capitalize;
}

.payment-radio input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
	height: 0;
	width: 0;
}

.payment-radio .checkmark {
	position: absolute;
	top: 0;
	left: 0;
	width: 19px;
	height: 19px;
	margin: 3px 0 0 0;
	border: 2px solid #ddd;
	border-top-color: rgb(221, 221, 221);
	border-right-color: rgb(221, 221, 221);
	border-bottom-color: rgb(221, 221, 221);
	border-left-color: rgb(221, 221, 221);
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-transition: all .3s;
	-moz-transition: all .3s;
	-ms-transition: all .3s;
	-o-transition: all .3s;
	transition: all .3s;
}

.payment-radio input:checked~.checkmark {
	border-color: #e5bd54;
}

.payment-radio .checkmark::after {
	position: absolute;
	left: 3px;
	top: 3px;
	content: '';
	width: 9px;
	height: 9px;
	background-color: #e5bd54;
	opacity: 0;
	visibility: hidden;
	-webkit-transform: scale(0.1);
	-moz-transform: scale(0.1);
	-ms-transform: scale(0.1);
	-o-transform: scale(0.1);
	transform: scale(0.1);
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-transition: all .3s;
	-moz-transition: all .3s;
	-ms-transition: all .3s;
	-o-transition: all .3s;
	transition: all .3s;
}

.payment-radio input:checked~.checkmark::after {
	-webkit-transform: scale(1);
	-moz-transform: scale(1);
	-ms-transform: scale(1);
	-o-transform: scale(1);
	transform: scale(1);
	opacity: 1;
	visibility: visible;
}

.booking-date {
	padding: 0;
	list-style: none;
}

.booking-date li {
	position: relative;
	font-size: 14px;
	font-weight: 500;
	color: #272b41;
	text-transform: capitalize;
	margin-bottom: 15px;
}

.booking-date li span {
	float: right;
	color: #757575;
	font-weight: 400;
	font-size: 15px;
}

.booking-fee {
	padding: 0;
	list-style: none;
}

.booking-fee li {
	position: relative;
	font-size: 14px;
	font-weight: 500;
	color: #272b41;
	text-transform: capitalize;
	margin-bottom: 15px;
}

.booking-fee li span {
	float: right;
	color: #757575;
	font-weight: 400;
	font-size: 15px;
}

.booking-total {
	border-top: 1px solid #e4e4e4;
	margin-top: 20px;
	padding-top: 20px;
}

.booking-total ul {
	padding: 0;
	list-style: none;
	margin: 0;
}

.booking-total ul li span {
	font-size: 18px;
	font-weight: 600;
	color: #272b41;
}

.booking-total ul li .total-cost {
	color: #e5bd54;
	font-size: 16px;
	float: right;
}


/*-----------------
	18. Booking Success
-----------------------*/

.success-page-cont {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	display: flex;
}

.success-card .card-body {
	padding: 50px 20px;
}

.success-cont {
	text-align: center;
}

.success-cont i {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	color: #fff;
	width: 60px;
	height: 60px;
	border: 2px solid #e5bd54;
	border-radius: 50%;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	justify-content: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	font-size: 30px;
	margin-bottom: 30px;
	background-color: #e5bd54;
}

.success-cont h3 {
	font-size: 24px;
}

.success-cont p {
	margin-bottom: 30px;
}

.success-cont strong {
	font-weight: 600;
}

.view-inv-btn {
	font-size: 16px;
	font-weight: 600;
	padding: 12px 30px;
}


/*-----------------
	19. Invoice View
-----------------------*/

.invoice-content {
	background-color: #fff;
	border: 1px solid #f0f0f0;
	border-radius: 4px;
	margin-bottom: 30px;
	padding: 30px;
}

.invoice-item .invoice-logo {
	margin-bottom: 30px;
}

.invoice-item .invoice-logo img {
	width: auto;
	max-height: 52px;
}

.invoice-item .invoice-text h2 {
	color: #272b41;
	font-size: 36px;
	font-weight: 600;
}

.invoice-item .invoice-details {
	text-align: right;
	color: #757575;
	font-weight: 500
}

.invoice-item .invoice-details strong {
	color: #272b41
}

.invoice-item .invoice-details-two {
	text-align: left
}

.invoice-item .invoice-text {
	padding-top: 42px;
	padding-bottom: 36px
}

.invoice-item .invoice-text h2 {
	font-weight: 400
}

.invoice-info {
	margin-bottom: 30px;
}

.invoice-info p {
	margin-bottom: 0;
}

.invoice-info.invoice-info2 {
	text-align: right;
}

.invoice-item .customer-text {
	font-size: 18px;
	color: #272b41;
	font-weight: 600;
	margin-bottom: 8px;
	display: block
}

.invoice-table tr th,
.invoice-table tr td,
.invoice-table-two tr th,
.invoice-table-two tr td {
	color: #272b41;
	font-weight: 600;
	padding: 10px 20px;
	line-height: inherit
}

.invoice-table tr td,
.invoice-table-two tr td {
	color: #757575;
	font-weight: 500;
}

.invoice-table-two {
	margin-bottom: 0
}

.invoice-table-two tr th,
.invoice-table-two tr td {
	border-top: 0;
}

.invoice-table-two tr td {
	text-align: right
}

.invoice-info h5 {
	font-size: 16px;
	font-weight: 500;
}

.other-info {
	margin-top: 10px;
}


/*-----------------
	20. Schedule Timings
-----------------------*/

.tab-content.schedule-cont .card-title {
	margin-bottom: 10px;
}

.doc-times {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
}

.doc-slot-list {
	background-color: #d9534f;
	border: 1px solid #d43f3a;
	border-radius: 4px;
	color: #fff;
	font-size: 14px;
	margin: 10px 10px 0 0;
	padding: 6px 15px;
}

.doc-slot-list a {
	color: #e48784;
	display: inline-block;
	margin-left: 5px;
}

.doc-slot-list a:hover {
	color: #fff;
}

.schedule-nav .nav-tabs {
	border: 0 !important;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
}

.schedule-nav .nav-tabs li {
	margin: 5px 15px 5px 0;
	display: inline-block;
}

.schedule-nav .nav-tabs li:last-child {
	margin-right: 0;
}

.schedule-nav .nav-tabs > li > a {
	border: 1px solid #dcddea;
	border-radius: 4px;
	padding: 6px 15px;
	text-transform: uppercase;
}

.schedule-nav .nav-tabs li a.active {
	background: #ff4877;
	border: 1px solid #ff4877 !important;
	color: #fff;
}

.hours-info .form-control {
	min-height: auto;
}

.hours-info .btn.btn-danger.trash {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	height: 38px;
	width: 100%;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	justify-content: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
}

.edit-link {
	color: #e5bd54;
	font-size: 16px;
	margin-top: 4px;
}


/*-----------------
	21. advisors Dashboard
-----------------------*/

.dash-widget {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.circle-bar {
	margin-right: 15px;
}

.dct-border-rht {
	border-right: 1px solid #f0f0f0;
}

.dash-widget h6 {
	font-size: 16px;
	font-weight: 400;
}

.dash-widget h3 {
	font-size: 24px;
	margin-bottom: 5px;
}

.dash-widget p {
	color: #757575;
	font-size: 14px;
	margin-bottom: 0;
}

.circle-bar > div {
	display: inline-block;
    position: relative;
    text-align: center;
    padding: 10px;
    background: #e5bd54;
    border-radius: 50px;
    border: 1px dashed;
}

.circle-bar > div img {
	position: relative;
	text-align: center;
	margin: 0 auto;

}

.circle-bar > div canvas {
	width: 90px !important;
	height: 90px !important;
}

.dash-card .row {
	margin-left: -10px;
	margin-right: -10px;
}

.dash-card .row > div {
	padding-left: 10px;
	padding-right: 10px;
}

.appointment-tab {
	margin-bottom: 30px;
}

.appointment-tab .nav-tabs {
	background-color: #fff;
	padding: 1.5rem;
	border: 1px solid #f0f0f0;
	border-radius: .25rem 0.25rem 0 0 !important;
	border-bottom: 0;
}

.appointment-tab .tab-content {
	padding-top: 0;
}

.appointment-tab .card {
	border-radius: 0;
}

.submit-btn-bottom {
	margin-bottom: 30px;
}


/*-----------------
	22. Customer Profile
-----------------------*/

.add-new-btn {
	background-color: #e8ba3f;
	border-radius: 30px;
	color: #fff;
	display: inline-block;
	font-weight: 500;
	margin-bottom: 20px;
	padding: 10px 20px;
}

.add-new-btn:focus,
.add-new-btn:hover,
.add-new-btn:active {
	background-color: #e8ba3f;
	color: #fff;
}

.receiver-info {
	margin-top: 15px;
}

.receiver-info ul {
	padding: 0;
	list-style: none;
	font-size: .875rem;
	margin: 0;
}

.receiver-info ul li {
	position: relative;
	font-size: .875rem;
	font-weight: 500;
	color: #272b41;
	text-transform: capitalize;
}

.receiver-info ul li+li {
	margin-top: 15px;
}

.receiver-info ul li i {
	width: 18px;
}

.receiver-info ul li span {
	color: #757575;
	float: right;
	font-weight: 400;
}

.dependent {
	margin: auto;
}

.dependent h2 {
	font-size: 32px;
	font-weight: 500;
}


/*-----------------
	23. Chat
-----------------------*/

.chat-page .footer {
	display: none;
}

.chat-window {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	position: relative;
}

.chat-cont-left {
	border-right: 1px solid #f0f0f0;
	-ms-flex: 0 0 35%;
	flex: 0 0 35%;
	left: 0;
	max-width: 35%;
	position: relative;
	z-index: 4;
}

.chat-page .content {
    padding: 0;
}

.chat-page .content > .container-fluid {
    padding: 0;
}

.chat-cont-left .chat-header {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	background-color: #fff;
	border-bottom: 1px solid #f0f0f0;
	color: #272b41;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	height: 72px;
	justify-content: space-between;
	-webkit-justify-content: space-between;
	-ms-flex-pack: space-between;
	padding: 0 15px;
}

.chat-cont-left .chat-header span {
	font-size: 20px;
	font-weight: 500;
	text-transform: capitalize;
}

.chat-cont-left .chat-header .chat-compose {
	color: #8a8a8a;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
}

.chat-cont-left .chat-search {
	background-color: #f5f5f6;
	border-bottom: 1px solid #e5e5e5;
	padding: 10px 15px;
	width: 100%;
}

.chat-cont-left .chat-search .input-group {
	width: 100%;
}

.chat-cont-left .chat-search .input-group .form-control {
	background-color: #fff;
	border-radius: 50px !important;
	padding-left: 36px;
}

.chat-cont-left .chat-search .input-group .form-control:focus {
	border-color: #ccc;
	box-shadow: none;
}

.chat-cont-left .chat-search .input-group .input-group-prepend {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	bottom: 0;
	color: #666;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	left: 15px;
	pointer-events: none;
	position: absolute;
	top: 0;
	z-index: 4;
}

.chat-window .chat-scroll {
	min-height: 300px;
	max-height: calc(100vh - 260px);
	overflow-y: auto;
}

.chat-cont-left .chat-users-list {
	background-color: #fff;
}

.chat-cont-left .chat-users-list a.media {
	border-bottom: 1px solid #f0f0f0;
	padding: 10px 15px;
	transition: all 0.2s ease 0s;
}

.chat-cont-left .chat-users-list a.media:last-child {
	border-bottom: 0;
}

.chat-cont-left .chat-users-list a.media .media-img-wrap {
	margin-right: 15px;
	position: relative;
}

.chat-cont-left .chat-users-list a.media .media-img-wrap .avatar {
	height: 45px;
	width: 45px;
}

.chat-cont-left .chat-users-list a.media .media-img-wrap .status {
	bottom: 7px;
	height: 10px;
	right: 4px;
	position: absolute;
	width: 10px;
	border: 2px solid #fff;
}

.chat-cont-left .chat-users-list a.media .media-body {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	justify-content: space-between;
	-webkit-justify-content: space-between;
	-ms-flex-pack: space-between;
}

.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name,
.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {
	max-width: 250px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {
	color: #272b41;
	text-transform: capitalize;
}

.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {
	color: #8a8a8a;
	font-size: 14px;
	line-height: 24px;
}

.chat-cont-left .chat-users-list a.media .media-body > div:last-child {
	text-align: right;
}

.chat-cont-left .chat-users-list a.media .media-body > div:last-child .last-chat-time {
	color: #8a8a8a;
	font-size: 13px;
}

.chat-cont-left .chat-users-list a.media:hover {
	background-color: #f5f5f6;
}

.chat-cont-left .chat-users-list a.media.read-chat .media-body > div:last-child .last-chat-time {
	color: #8a8a8a;
}

.chat-cont-left .chat-users-list a.media.active {
	background-color: #f5f5f6;
}

.chat-cont-right {
	-ms-flex: 0 0 65%;
	flex: 0 0 65%;
	max-width: 65%;
}

.chat-cont-right .chat-header {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	background-color: #fff;
	border-bottom: 1px solid #f0f0f0;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	height: 72px;
	justify-content: space-between;
	-webkit-justify-content: space-between;
	-ms-flex-pack: space-between;
	padding: 0 15px;
}

.chat-cont-right .chat-header .back-user-list {
	display: none;
	margin-right: 5px;
	margin-left: -7px;
}

.chat-cont-right .chat-header .media {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
}

.chat-cont-right .chat-header .media .media-img-wrap {
	position: relative;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	margin-right: 15px;
}

.chat-cont-right .chat-header .media .media-img-wrap .avatar {
	height: 50px;
	width: 50px;
}

.chat-cont-right .chat-header .media .media-img-wrap .status {
	border: 2px solid #fff;
	bottom: 0;
	height: 10px;
	position: absolute;
	right: 3px;
	width: 10px;
}

.chat-cont-right .chat-header .media .media-body .user-name {
	color: #272b41;
	font-size: 16px;
	font-weight: 500;
	text-transform: capitalize;
}

.chat-cont-right .chat-header .media .media-body .user-status {
	color: #666;
	font-size: 14px;
}

.chat-cont-right .chat-header .chat-options {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.chat-cont-right .chat-header .chat-options > a {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	border-radius: 50%;
	color: #8a8a8a;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	height: 30px;
	justify-content: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	margin-left: 10px;
	width: 30px;
}

.chat-cont-right .chat-body {
	background-color: #f5f5f6;
}

.chat-cont-right .chat-body ul.list-unstyled {
	margin: 0 auto;
	padding: 15px;
	width: 100%;
}

.chat-cont-right .chat-body .media .avatar {
	height: 30px;
	width: 30px;
}

.chat-cont-right .chat-body .media .media-body {
	margin-left: 20px;
}

.chat-cont-right .chat-body .media .media-body .msg-box > div {
	padding: 10px 15px;
	border-radius: .25rem;
	display: inline-block;
	position: relative;
}

.chat-cont-right .chat-body .media .media-body .msg-box > div p {
	color: #272b41;
	margin-bottom: 0;
}

.chat-cont-right .chat-body .media .media-body .msg-box+.msg-box {
	margin-top: 5px;
}

.chat-cont-right .chat-body .media.received {
	margin-bottom: 20px;
}

.chat-cont-right .chat-body .media:last-child {
	margin-bottom: 0;
}

.chat-cont-right .chat-body .media.received .media-body .msg-box > div {
	background-color: #fff;
}

.chat-cont-right .chat-body .media.sent {
	margin-bottom: 20px;
}

.chat-cont-right .chat-body .media.sent .media-body {
	-webkit-box-align: flex-end;
	-ms-flex-align: flex-end;
	align-items: flex-end;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	justify-content: flex-end;
	-webkit-justify-content: flex-end;
	-ms-flex-pack: flex-end;
	margin-left: 0;
}

.chat-cont-right .chat-body .media.sent .media-body .msg-box > div {
	background-color: #e3e3e3;
}

.chat-cont-right .chat-body .media.sent .media-body .msg-box > div p {
	color: #272b41;
}

.chat-cont-right .chat-body .chat-date {
	font-size: 14px;
	margin: 1.875rem 0;
	overflow: hidden;
	position: relative;
	text-align: center;
	text-transform: capitalize;
}

.chat-cont-right .chat-body .chat-date:before {
	background-color: #e0e3e4;
	content: "";
	height: 1px;
	margin-right: 28px;
	position: absolute;
	right: 50%;
	top: 50%;
	width: 100%;
}

.chat-cont-right .chat-body .chat-date:after {
	background-color: #e0e3e4;
	content: "";
	height: 1px;
	left: 50%;
	margin-left: 28px;
	position: absolute;
	top: 50%;
	width: 100%;
}

.chat-cont-right .chat-footer {
	background-color: #fff;
	border-top: 1px solid #f0f0f0;
	padding: 10px 15px;
	position: relative;
}

.chat-cont-right .chat-footer .input-group {
	width: 100%;
}

.chat-cont-right .chat-footer .input-group .form-control {
	background-color: #f5f5f6;
	border: none;
	border-radius: 50px;
}

.chat-cont-right .chat-footer .input-group .form-control:focus {
	background-color: #f5f5f6;
	border: none;
	box-shadow: none;
}

.chat-cont-right .chat-footer .input-group .input-group-prepend .btn,
.chat-cont-right .chat-footer .input-group .input-group-append .btn {
	background-color: transparent;
	border: none;
	color: #9f9f9f;
}

.chat-cont-right .chat-footer .input-group .input-group-append .btn.msg-send-btn {
	background-color: #e8ba3f;
	border-color: #e8ba3f;
	border-radius: 50%;
	color: #fff;
	margin-left: 10px;
	min-width: 46px;
	font-size: 20px;
}

.msg-typing {
	width: auto;
	height: 24px;
	padding-top: 8px
}

.msg-typing span {
	height: 8px;
	width: 8px;
	float: left;
	margin: 0 1px;
	background-color: #a0a0a0;
	display: block;
	border-radius: 50%;
	opacity: .4
}

.msg-typing span:nth-of-type(1) {
	animation: 1s blink infinite .33333s
}

.msg-typing span:nth-of-type(2) {
	animation: 1s blink infinite .66666s
}

.msg-typing span:nth-of-type(3) {
	animation: 1s blink infinite .99999s
}

.chat-cont-right .chat-body .media.received .media-body .msg-box {
	position: relative;
}

.chat-cont-right .chat-body .media.received .media-body .msg-box:first-child:before {
	border-bottom: 6px solid transparent;
	border-right: 6px solid #fff;
	border-top: 6px solid transparent;
	content: "";
	height: 0;
	left: -6px;
	position: absolute;
	right: auto;
	top: 8px;
	width: 0;
}

.chat-cont-right .chat-body .media.sent .media-body .msg-box {
	padding-left: 50px;
	position: relative;
}

.chat-cont-right .chat-body .media.sent .media-body .msg-box:first-child:before {
	border-bottom: 6px solid transparent;
	border-left: 6px solid #e3e3e3;
	border-top: 6px solid transparent;
	content: "";
	height: 0;
	left: auto;
	position: absolute;
	right: -6px;
	top: 8px;
	width: 0;
}

.chat-msg-info {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	clear: both;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	list-style: none;
	padding: 0;
	margin: 5px 0 0;
}

.chat-msg-info li {
	font-size: 13px;
	padding-right: 16px;
	position: relative;
}

.chat-msg-info li:not(:last-child):after {
	position: absolute;
	right: 8px;
	top: 50%;
	content: '';
	height: 4px;
	width: 4px;
	background: #d2dde9;
	border-radius: 50%;
	transform: translate(50%, -50%)
}

.chat-cont-right .chat-body .media.sent .media-body .msg-box .chat-msg-info li:not(:last-child)::after {
	right: auto;
	left: 8px;
	transform: translate(-50%, -50%);
	background: #aaa;
}

.chat-cont-right .chat-body .media.received .media-body .msg-box > div .chat-time {
	color: rgba(50, 65, 72, 0.4);
}

.chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-time {
	color: rgba(50, 65, 72, 0.4);
}

.chat-msg-info li a {
	color: #777;
}

.chat-msg-info li a:hover {
	color: #2c80ff
}

.chat-seen i {
	color: #00d285;
	font-size: 16px;
}

.chat-msg-attachments {
	padding: 4px 0;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	width: 100%;
	margin: 0 -1px
}

.chat-msg-attachments > div {
	margin: 0 1px
}

.chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info {
	flex-direction: row-reverse;
}

.chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-attachments {
	flex-direction: row-reverse
}

.chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info li {
	padding-left: 16px;
	padding-right: 0;
	position: relative;
}

.chat-attachment img {
	max-width: 100%;
}

.chat-attachment {
	position: relative;
	max-width: 130px;
	overflow: hidden;
}

.chat-attachment {
	border-radius: .25rem;
}

.chat-attachment:before {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: #000;
	content: "";
	opacity: 0.4;
	transition: all .4s;
}

.chat-attachment:hover:before {
	opacity: 0.6;
}

.chat-attach-caption {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	color: #fff;
	padding: 7px 15px;
	font-size: 13px;
	opacity: 1;
	transition: all .4s;
}

.chat-attach-download {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	opacity: 0;
	transition: all .4s;
	color: #fff;
	width: 32px;
	line-height: 32px;
	background: rgba(255, 255, 255, 0.2);
	text-align: center;
}

.chat-attach-download:hover {
	color: #495463;
	background: #fff;
}

.chat-attachment:hover .chat-attach-caption {
	opacity: 0;
}

.chat-attachment:hover .chat-attach-download {
	opacity: 1;
}

.chat-attachment-list {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	margin: -5px;
}

.chat-attachment-list li {
	width: 33.33%;
	padding: 5px;
}

.chat-attachment-item {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	border: 5px solid rgba(230, 239, 251, 0.5);
	height: 100%;
	min-height: 60px;
	text-align: center;
	font-size: 30px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	justify-content: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
}

.chat-cont-right .chat-body .media.sent .media-body .msg-box > div:hover .chat-msg-actions {
	opacity: 1;
}

.chat-msg-actions {
	position: absolute;
	left: -30px;
	top: 50%;
	transform: translateY(-50%);
	opacity: 0;
	transition: all .4s;
	z-index: 2;
}

.chat-msg-actions > a {
	padding: 0 10px;
	color: #495463;
	font-size: 24px;
}

.chat-msg-actions > a:hover {
	color: #2c80ff;
}

@keyframes blink {
	50% {
		opacity: 1
	}
}

.btn-file {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	font-size: 20px;
	justify-content: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	overflow: hidden;
	padding: 0 0.75rem;
	position: relative;
	vertical-align: middle;
}

.btn-file input {
	cursor: pointer;
	filter: alpha(opacity=0);
	font-size: 23px;
	height: 100%;
	margin: 0;
	opacity: 0;
	position: absolute;
	right: 0;
	top: 0;
	width: 100%;
}


/*-----------------
	24. advisors Profile Settings
-----------------------*/

.profile-image img {
	margin-bottom: 1.5rem;
}

.change-photo-btn {
	background-color: #e8b145;
	border-radius: 50px;
	color: #fff;
	cursor: pointer;
	display: block;
	font-size: 13px;
	font-weight: 600;
	margin: 0 auto;
	padding: 10px 15px;
	position: relative;
	transition: .3s;
	text-align: center;
	width: 220px;
}

.change-photo-btn input.upload {
	bottom: 0;
	cursor: pointer;
	filter: alpha(opacity=0);
	left: 0;
	margin: 0;
	opacity: 0;
	padding: 0;
	position: absolute;
	right: 0;
	top: 0;
	width: 220px;
}

.dropzone {
	background-color: #fbfbfb;
	border: 2px dashed rgba(0, 0, 0, 0.1);
}

.btn-icon {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	text-align: center;
	position: absolute;
	padding: 0;
	font-size: 10px;
	width: 20px;
	height: 20px;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	right: 3px;
	top: 3px;
	justify-content: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
}

.upload-images {
	position: relative;
	width: 80px;
}

.upload-images img {
	border-radius: 4px;
	height: 80px;
	width: auto;
}

.upload-wrap {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.upload-wrap .upload-images+.upload-images {
	margin-left: 20px;
}

.contact-card .card-body {
	padding-bottom: 0.625rem;
}

.custom_price_cont {
	margin-top: 20px;
}

.btn.btn-danger.trash {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	height: 46px;
	width: 46px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	justify-content: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
}

.add-more a {
	color: #e5bd54;
}

.bootstrap-tagsinput {
	border-color: #dcdcdc;
	box-shadow: inherit;
	min-height: 46px;
	width: 100%;
	border-radius: 0;
}

.bootstrap-tagsinput.focus {
	border-color: #bbb;
}

.bootstrap-tagsinput .tag {
	background-color: #e5bd54 !important;
	color: #fff;
	display: inline-block;
	font-size: 14px;
	font-weight: normal;
	margin-right: 2px;
	padding: 11px 15px;
	border-radius: 0;
}

.services-card .bootstrap-tagsinput input {
	width: 160px;
}

.submit-section .submit-btn {
	padding: 12px 30px;
	font-weight: 600;
	font-size: 16px;
	min-width: 120px;
}

.submit-section .submit-btn+.submit-btn {
	margin-left: 15px;
}


/*-----------------
	25. Calendar
-----------------------*/

#calendar-events {
	background-color: #fcfcfc;
}

.calendar-events {
	border: 1px solid transparent;
	cursor: move;
	padding: 10px 15px;
}

.calendar-events:hover {
	border-color: #e9e9e9;
	background-color: #fff;
}

.calendar-events i {
	margin-right: 8px;
}

.calendar {
	float: left;
	margin-bottom: 0;
}

.fc-toolbar.fc-header-toolbar {
	margin-bottom: 1.5rem;
}

.none-border .modal-footer {
	border-top: none;
}

.fc-toolbar h2 {
	font-size: 18px;
	font-weight: 600;
	font-family: 'Roboto', sans-serif;
	line-height: 30px;
	text-transform: uppercase;
}

.fc-day-grid-event .fc-time {
	font-family: 'Roboto', sans-serif;
}

.fc-day {
	background: #fff;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar button:focus,
.fc-toolbar button:hover,
.fc-toolbar .ui-state-hover {
	z-index: 0;
}

.fc th.fc-widget-header {
	background: #eeeeee;
	font-size: 14px;
	line-height: 20px;
	padding: 10px 0;
	text-transform: uppercase;
}

.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
	border-color: #f3f3f3;
}

.fc-basic-view .fc-day-number,
.fc-basic-view .fc-week-number {
	padding: 2px 5px;
}

.fc-button {
	background: #f1f1f1;
	border: none;
	color: #797979;
	text-transform: capitalize;
	box-shadow: none !important;
	border-radius: 3px !important;
	margin: 0 3px !important;
	padding: 6px 12px !important;
	height: auto !important;
}

.fc-text-arrow {
	font-family: inherit;
	font-size: 16px;
}

.fc-state-hover {
	background: #f3f3f3;
}

.fc-state-highlight {
	background: #f0f0f0;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
	background-color: #e5bd54 !important;
	color: #fff !important;
	text-shadow: none !important;
}

.fc-cell-overlay {
	background: #f0f0f0;
}

.fc-unthemed .fc-today {
	background: #fff;
}

.fc-event {
	border-radius: 2px;
	border: none;
	color: #fff !important;
	cursor: move;
	font-size: 13px;
	margin: 1px 7px;
	padding: 5px 5px;
	text-align: center;
}

.fc-basic-view td.fc-week-number span {
	padding-right: 8px;
	font-weight: 700;
	font-family: 'Roboto', sans-serif;
}

.fc-basic-view td.fc-day-number {
	padding-right: 8px;
	font-weight: 700;
	font-family: 'Roboto', sans-serif;
}

.event-form .input-group .form-control {
	height: 40px;
}


/*-----------------
	26. Customer Dashboard
-----------------------*/

.profile-sidebar {
	background-color: #fff;
	border-radius: 10px;
	margin-bottom: 30px;
	overflow: hidden;
	box-shadow: 0px 2px 8px rgb(183 183 183 / 25%);
}

.pro-widget-content {
	border-bottom: 1px solid #f0f0f0;
	padding: 20px;
	text-align: center;
}

.profile-info-widget {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	text-align: left;
}

.profile-info-widget .booking-doc-img {
	margin-right: 15px;
}

.profile-info-widget .booking-doc-img img {
	border-radius: 4px;
	height: 90px;
	width: 90px;
	object-fit: cover;
}

.profile-det-info {
	overflow: hidden;
}

.profile-det-info h3 {
	font-size: 17px;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.receiver-details h5 {
	color: #757575;
	font-size: 13px;
	font-weight: normal;
	margin-bottom: 8px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.receiver-details h5 i {
	width: 18px;
}

.dashboard-menu ul {
	color: #757575;
	font-size: 14px;
	line-height: 17px;
	list-style: none;
	margin: 0;
	padding: 0;
	text-transform: capitalize;
}

.dashboard-menu ul li {
	line-height: inherit;
}

.dashboard-menu > ul > li {
	border-bottom: 1px solid #f0f0f0;
	position: relative;
}
.media {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: start;
    align-items: flex-start;
}
.media-img-wrap {
    flex-shrink: 0!important;
}
.media-body {
    flex-grow: 1!important;
}

.dashboard-menu > ul > li:last-child {
	border-bottom: 0;
}

.dashboard-menu ul li a span,
.dashboard-menu ul li a i {
	display: inline-block;
	vertical-align: middle;
}

.dashboard-menu > ul > li > a {
	color: #757575;
	display: block;
	padding: 16px 20px;
	font-weight: 500;
}

.dashboard-menu > ul > li:hover > a,
.dashboard-menu > ul > li.active > a {
	color: #e5bd54;
}

.dashboard-menu ul li a i {
	font-size: 16px;
	margin-right: 10px;
	width: 16px;
}

.unread-msg {
	background-color: #e5bd54;
	border-radius: 2px;
	color: #ffffff;
	font-size: 10px;
	font-style: normal;
	padding: 0 5px;
	position: absolute;
	right: 20px;
	text-align: center;
	top: 50%;
	transform: translateY(-50%);
}


/*-----------------
	27. Profile Settings
-----------------------*/

.change-avatar {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.change-avatar .profile-img {
	margin-right: 15px;
}

.change-avatar .profile-img img {
	border-radius: 4px;
	height: 100px;
	width: 100px;
	object-fit: cover;
}

.change-avatar .change-photo-btn {
	margin: 0 0 10px;
	width: 150px;
}

.widget-profile.pat-widget-profile .profile-info-widget .booking-doc-img {
	padding: 0;
}

.widget-profile.pat-widget-profile .profile-info-widget .booking-doc-img img {
	border-radius: 50%;
	height: 100px;
	width: 100px;
}


/*-----------------
	28. Appoitment List
-----------------------*/

.widget-profile {
	background-color: #fff;
	border-bottom: 1px solid #f0f0f0;
}

.widget-profile .profile-info-widget {
	display: block;
	text-align: center;
}

.widget-profile .profile-info-widget .booking-doc-img {
	display: inline-block;
	margin: 0 0 15px;
	width: auto;
	padding: 8px;
	background-color: #f7f7f7;
	border-radius: 50%;
}

.widget-profile .profile-info-widget .booking-doc-img img {
	border-radius: 50%;
	height: 120px;
	width: 120px;
}

.appointment-list .profile-info-widget {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	margin-right: auto;
	text-align: left;
}

.appointment-list .profile-info-widget .booking-doc-img img {
	border-radius: 4px;
	height: 120px;
	object-fit: cover;
	width: 120px;
}

.batch .appointment-list {
	background-color: #fff;
	border: 1px solid #f0f0f0;
	border-radius: 4px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	margin-bottom: 20px;
	padding: 20px;
}

.batch .appointment-list:last-child {
	margin-bottom: 30px;
}

.batch .appointment-action {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
}

.appointment-action a+a {
	margin-left: 5px;
}

.appointment-action a {
	font-size: 13px;
}

.info-details {
	list-style: none;
	margin: 0;
	padding: 0;
}

.info-details li .title {
	color: #272b41;
	font-weight: 500;
}

.info-details li .text {
	color: #757575;
	display: block;
	font-size: 16px;
	overflow: hidden;
}

.info-details li {
	margin-bottom: 10px;
}

.info-details li:last-child {
	margin-bottom: 0;
}


/*-----------------
	29. Reviews
-----------------------*/

.doc-review.review-listing {
	margin: 0;
}

.review-listing.doc-review > ul > li {
	background-color: #fff;
	border: 1px solid #f0f0f0;
	padding: 20px;
}


/*-----------------
	30. Voice call
-----------------------*/

.modal-open .main-wrapper {
	-webkit-filter: blur(1px);
	-moz-filter: blur(1px);
	-o-filter: blur(1px);
	-ms-filter: blur(1px);
	filter: blur(1px);
}

.call-main-row {
	bottom: 0;
	left: 0;
	overflow: auto;
	padding-bottom: inherit;
	padding-top: inherit;
	position: absolute;
	right: 0;
	top: 0;
}

.call-main-wrapper {
	display: table;
	height: 100%;
	table-layout: fixed;
	width: 100%;
}

.call-view {
	display: table-cell;
	height: 100%;
	float: none;
	padding: 0;
	position: static;
	vertical-align: top;
	width: 75%;
}

.call-window {
	display: table;
	height: 100%;
	table-layout: fixed;
	width: 100%;
	background-color: #fff;
	border: 1px solid #f0f0f0;
}

.fixed-header {
	background-color: #fff;
	border-bottom: 1px solid #f0f0f0;
	padding: 10px 15px;
}

.fixed-header .navbar {
	border: 0 none;
	margin: 0;
	min-height: auto;
	padding: 0;
}

.fixed-header .user-info a {
	color: #272b41;
	font-weight: 500;
}

.typing-text {
	color: #e5bd54;
	font-size: 12px;
	text-transform: lowercase;
}

.last-seen {
	color: #888;
	display: block;
	font-size: 12px;
}

.custom-menu {
	margin-top: 6px;
}

.fixed-header .custom-menu {
	margin: 0 0 1px;
}

.custom-menu.nav > li > a {
	color: #bbb;
	font-size: 26px;
	line-height: 32px;
	margin-left: 15px;
	padding: 0;
}

.custom-menu.navbar-nav > li > a:hover,
.custom-menu.navbar-nav > li > a:focus {
	background-color: transparent;
}

.custom-menu .dropdown-menu {
	left: auto;
	right: 0;
}

.call-contents {
	display: table-row;
	height: 100%;
}

.call-content-wrap {
	height: 100%;
	position: relative;
	width: 100%;
}

.voice-call-avatar {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	-ms-flex-direction: column;
	flex-direction: column;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	justify-content: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	-ms-flex: 2;
	flex: 2;
}

.voice-call-avatar .call-avatar {
	margin: 15px;
	width: 150px;
	height: 150px;
	border-radius: 100%;
	border: 1px solid rgba(0, 0, 0, 0.1);
	padding: 3px;
	background-color: #fff;
}

.call-duration {
	display: inline-block;
	font-size: 30px;
	margin-top: 4px;
	position: absolute;
	left: 0;
}

.voice-call-avatar .call-timing-count {
	padding: 5px;
}

.voice-call-avatar .username {
	font-size: 20px;
	font-weight: 500;
}

.call-footer {
	background-color: #fff;
	border-top: 1px solid #f0f0f0;
	padding: 15px;
}

.call-icons {
	text-align: center;
	position: relative;
}

.call-icons .call-items {
	border-radius: 5px;
	padding: 0;
	margin: 0;
	list-style: none;
	display: inline-block;
}

.call-icons .call-items .call-item {
	display: inline-block;
	text-align: center;
	margin-right: 5px;
}

.call-icons .call-items .call-item:last-child {
	margin-right: 0;
}

.call-icons .call-items .call-item a {
	color: #777;
	border: 1px solid #ddd;
	width: 50px;
	height: 50px;
	line-height: 50px;
	border-radius: 50px;
	display: inline-block;
	font-size: 20px;
}

.call-icons .call-items .call-item a i {
	width: 18px;
	height: 18px;
}

.user-video {
	bottom: 0;
	left: 0;
	overflow: auto;
	position: absolute;
	right: 0;
	top: 0;
	z-index: 10;
}

.user-video img {
	width: auto;
	max-width: 100%;
	height: auto;
	max-height: 100%;
	display: block;
	margin: 0 auto;
}

.user-video video {
	width: auto;
	max-width: 100%;
	height: auto;
	max-height: 100%;
	display: block;
	margin: 0 auto;
}

.my-video {
	position: absolute;
	z-index: 99;
	bottom: 20px;
	right: 20px;
}

.my-video ul {
	margin: 0;
	padding: 0;
	list-style: none;
}

.my-video ul li {
	float: left;
	width: 120px;
	margin-right: 10px;
}

.my-video ul li img {
	border: 3px solid #fff;
	border-radius: 6px;
}

.end-call {
	position: absolute;
	top: 7px;
	right: 0;
}

.end-call a {
	background-color: #f06060;
	border-radius: 50px;
	color: #fff;
	display: inline-block;
	line-height: 10px;
	padding: 8px 25px;
	text-transform: uppercase;
}

.call-users {
	position: absolute;
	z-index: 99;
	bottom: 20px;
	right: 20px;
}

.call-users ul {
	margin: 0;
	padding: 0;
	list-style: none;
}

.call-users ul li {
	float: left;
	width: 80px;
	margin-left: 10px;
}

.call-users ul li img {
	border-radius: 6px;
	padding: 2px;
	background-color: #fff;
	border: 1px solid rgba(0, 0, 0, 0.1);
}

.call-mute {
	width: 80px;
	height: 80px;
	background-color: rgba(0, 0, 0, 0.5);
	position: absolute;
	text-align: center;
	line-height: 80px;
	border-radius: 6px;
	font-size: 30px;
	color: #fff;
	display: none;
	top: 0;
	border: 3px solid transparent;
}

.call-users ul li a:hover .call-mute {
	display: block;
}

.call-details {
	margin: 10px 0 0;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.call-info {
	margin-left: 10px;
	width: 100%;
}

.call-user-details,
.call-timing {
	display: block;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.call-description {
	white-space: nowrap;
	vertical-align: bottom;
}

.call-timing {
	color: #727272;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	font-size: 14px;
	margin-top: 1px;
	overflow: hidden;
	white-space: pre;
}


/*-----------------
	31. Video Call
-----------------------*/

.content-full {
	height: 100%;
	position: relative;
	width: 100%;
}

.video-window .fixed-header {
	padding: 0;
	border: 0;
}

.video-window .fixed-header .nav > li > a {
	padding: 18px 15px;
}


/*-----------------
	32. Outgoing Call
-----------------------*/

.call-box .call-wrapper {
	height: auto;
	text-align: center;
}

.call-box .call-wrapper .call-avatar {
	margin-bottom: 30px;
	cursor: pointer;
	animation: ripple 2s infinite;
}

.call-box .call-wrapper .call-user {
	margin-bottom: 30px;
}

.call-box .call-wrapper .call-user span {
	display: block;
	font-weight: 500;
	text-align: center;
}

.call-box .call-wrapper .call-items {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	justify-content: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
}

.call-box .call-wrapper .call-items .call-item {
	background-color: rgba(255, 255, 255, 0.2);
	border: 1px solid transparent;
	border-radius: 100%;
	color: #fff;
	line-height: 0;
	margin: 0 5px;
	padding: 15px;
}

.call-box .call-wrapper .call-items .call-item:hover {
	opacity: 0.9;
}

.call-box .call-wrapper .call-items .call-item:first-child {
	margin-top: -30px;
}

.call-box .call-wrapper .call-items .call-item:last-child {
	margin-top: -30px;
}

.call-box .call-wrapper .call-items .call-item.call-end {
	padding: 20px;
	margin: 30px 20px 0;
	background: #f06060;
	border: 1px solid #f06060;
	color: #fff;
	line-height: 0;
	border-radius: 100%;
}

.call-box .call-wrapper .call-items .call-item.call-start {
	padding: 20px;
	margin: 30px 20px 0;
	background: #55ce63;
	border: 1px solid #55ce63;
	color: #fff;
	line-height: 0;
	border-radius: 100%;
}

.call-box.incoming-box .call-wrapper .call-items .call-item.call-start {
	margin: 0 10px;
}

.call-box.incoming-box .call-wrapper .call-items .call-item.call-end {
	margin: 0 10px;
}

.call-box .call-avatar {
	border-radius: 100%;
	height: 140px;
	max-width: 140px;
	min-width: 140px;
	position: relative;
	width: 100%;
	border: 10px solid #fafafa;
}

.call-box .btn {
	background: rgba(0, 0, 0, 0);
	transition: all 0.3s ease 0s;
}

@-webkit-keyframes ripple {
	0% {
		-webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
	}
	100% {
		-webkit-box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);
	}
}

@keyframes ripple {
	0% {
		-moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
		box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);
	}
	100% {
		-moz-box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);
		box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);
	}
}


/*-----------------
	33. Incoming Call
-----------------------*/

.incoming-btns {
	margin-top: 20px;
}

.call-wrapper {
	position: relative;
	height: calc(100vh - 145px);
}

.call-page .footer {
	display: none;
}

.dropdown-action .dropdown-toggle::after {
	display: none;
}

.call-modal .modal-body {
	padding: 40px;
}

.call-modal .modal-content {
	border: 0;
	border-radius: 10px;
}

.call-box .call-wrapper .call-user h4 {
	font-size: 24px;
}


/*-----------------
	34. Terms and Conditions
-----------------------*/

.terms-text {
	margin-bottom: 20px;
}

.terms-text h4 {
	font-size: 24px;
	font-weight: 500;
	margin-bottom: 20px;
}

.terms-text p {
	color: #666;
	display: inline-block;
	font-size: 16px;
}


/*-----------------
	35. Blog
-----------------------*/

.blog {
	border: 1px solid #f0f0f0;
	background-color: #fff;
	border-radius: 4px;
	margin-bottom: 30px;
	padding: 1.5rem;
	position: relative;
}

.blog-image {
	overflow: hidden;
}

.blog-image,
.blog-image > a,
.blog-image img {
	display: block;
	position: relative;
	width: 100%;
	height: auto;
}

.blog-image img {
	-webkit-transform: translateZ(0);
	-moz-transform: translateZ(0);
	transform: translateZ(0);
	-moz-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
	-ms-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
	-o-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
	-webkit-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
	transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
}

.blog-image a:hover img {
	-webkit-transform: scale(1.15);
	-moz-transform: scale(1.15);
	transform: scale(1.15);
}

.blog-image {
	margin-bottom: 30px;
}

.blog-content {
	position: relative;
}

.blog-title {
	font-size: 22px;
	margin: 0 0 10px;
}

.blog-title a {
	color: #272b41;
}

.blog-title a:hover {
	color: #e5bd54;
}

.blog-content p {
	color: #666;
	font-size: 14px;
	margin: 0 0 30px;
}

.read-more {
	display: inline-block;
	font-size: 16px;
	padding: 0;
	color: #e5bd54;
	text-decoration: underline;
	font-weight: bold;
}

.blog-info {
	color: #757575;
	font-size: 14px;
	margin-bottom: 15px;
}

.blog-info a {
	color: #757575;
}

.blog-info a:hover {
	color: #757575;
}

.blog-info i {
	color: #e5bd54;
	font-size: 14px;
	margin-right: 5px;
}

.entry-meta {
	color: #757575;
	font-size: 14px;
	list-style: none;
	margin-bottom: 15px;
	padding: 0;
}

.entry-meta li {
	display: inline-block;
	margin-right: 15px;
}

.entry-meta li:last-child {
	margin-right: 0;
}

.blog-pagination .pagination {
	margin-bottom: 30px;
}

.blog-pagination .pagination li a {
	padding: 12px 20px;
	font-weight: 600;
	color: #2E3842;
	margin-right: 10px;
	border-radius: inherit !important;
	border-color: #f0f0f0;
}

.blog-pagination .pagination li.disabled a {
	border-color: #f0f0f0;
}

.blog-pagination .pagination li.active a {
	background: #e5bd54;
	border-color: transparent;
	color: #ffffff;
}

.post-left ul {
	margin: 0;
	padding-left: 0;
	list-style: none;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
}

.post-left ul li {
	margin-bottom: 5px;
	margin-right: 20px;
}

.post-left ul li:last-child {
	margin-right: 0;
}

.post-author a {
	display: flex;
	align-items: center;
}

.video {
	position: relative;
	padding-bottom: 56%;
	height: 0;
	overflow: hidden;
}

.video iframe,
.video object,
.video embed {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border: none;
}

.latest-posts {
	margin: 0;
	padding: 0;
}

.latest-posts li {
	display: table;
	width: 100%;
	margin-bottom: 20px;
}

.latest-posts li:last-child {
	padding-bottom: 0px;
	margin-bottom: 0px;
	border-bottom: none;
}

.post-thumb {
	border-radius: 4px;
	width: 80px;
	float: left;
	overflow: hidden;
}

.post-thumb a img {
	border-radius: 4px;
	-webkit-transform: translateZ(0);
	-moz-transform: translateZ(0);
	transform: translateZ(0);
	-moz-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
	-ms-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
	-o-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
	-webkit-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
	transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
}

.post-thumb a:hover img {
	-webkit-transform: scale(1.15);
	-moz-transform: scale(1.15);
	transform: scale(1.15);
}

.post-info {
	margin-left: 95px;
}

.post-info h4 {
	font-size: 15px;
	margin: 0 0 5px;
}

.post-info h4 a {
	color: #272b41;
}

.post-info h4 a:hover {
	color: #e5bd54;
}

.post-info p {
	color: #757575;
	font-size: 12px;
	margin: 0;
}

.post-info p i {
	color: #e5bd54;
	font-size: 14px;
	margin-right: 4px;
}

.category-widget .categories {
	list-style: none;
	margin: 0;
	padding: 0;
}

.category-widget .categories li {
	margin-bottom: 20px;
}

.category-widget .categories li:last-child {
	border-bottom: none;
	margin-bottom: 0;
	padding-bottom: 0;
}

.category-widget .categories li a {
	color: #2E3842;
	font-size: 15px;
	font-weight: 500;
}

.category-widget .categories li a span {
	float: right;
	color: #757575;
}

.category-widget .categories li a:hover {
	color: #e5bd54;
}

.category-widget .categories > li > a > i {
	color: #e5bd54;
	font-size: 18px;
	margin-right: 10px;
}

.tags-widget .card-body {
	padding-bottom: 1rem;
}

.tags {
	list-style: none;
	margin: 0;
	overflow: hidden;
	padding: 0;
}

.tags li {
	float: left;
}

.tag {
	background-color: #fff;
	border-radius: 4px;
	color: #272b41;
	padding: 5px 10px;
	position: relative;
	margin: 0 .5rem .5rem 0;
	font-size: 14px;
	border: 1px solid #ccc;
	display: inline-block;
}

.tag:hover {
	background-color: #e5bd54;
	border-color: #e5bd54;
	color: #fff;
}

.comment-by {
	display: block;
	font-size: 14px;
	line-height: 21px;
	margin: 0 0 10px;
}

.comments-list .comment-block p {
	font-size: 14px;
	margin-bottom: 5px;
}


/*-----------------
	36. Blog Details
-----------------------*/

.blog-view .blog-title {
	font-size: 24px;
}

.blog-content p:last-child {
	margin-bottom: 0;
}

.blog-view .blog-info {
	border: 0;
	margin-bottom: 20px;
	padding: 0;
}

.social-share {
	float: left;
	list-style: none;
	margin: 0;
	padding: 0;
}

.social-share > li {
	display: inline-block;
	float: left;
	margin-left: 10px;
	text-align: center;
}

.social-share > li:first-child {
	margin-left: 0;
}

.social-share > li > a {
	border: 1px solid #dfdfdf;
	color: #666;
	display: inline-block;
	font-size: 22px;
	height: 40px;
	line-height: 40px;
	width: 40px;
}

.social-share > li > a:hover {
	background-color: #e5bd54;
	color: #fff;
	border-color: #e5bd54;
}

.blog-reply > a {
	color: #999;
	font-size: 12px;
	font-weight: 500;
}

.blog-date {
	color: #999;
	font-size: 12px;
}

.blog-comments .comments-list {
	list-style: none;
	margin: 0;
	padding: 0;
	position: relative;
}

.blog-comments .comments-list li {
	clear: both;
	padding-left: 80px;
}

.blog-comments .comments-list li .comment {
	margin-bottom: 20px;
}

.blog-comments .comments-list li .comment-author {
	left: 0;
	position: absolute;
}

.blog-comments .comments-list li img.avatar {
	height: 58px;
	width: 58px;
	border-radius: 58px;
}

.blog-comments .comment-btn {
	color: #e5bd54;
	display: inline-block;
	font-weight: 500;
	font-size: 15px;
}

.blog-author-name {
	color: #272b41;
	font-size: 16px;
	font-weight: 600;
}

.new-comment label {
	font-weight: 500;
}

.comment-submit .btn {
	background-color: #e5bd54;
	border-color: #e5bd54;
	border-radius: 0;
	font-size: 18px;
	padding: 8px 26px;
	color: #fff;
}

.about-author-img {
	background-color: #fff;
	height: 100px;
	overflow: hidden;
	position: absolute;
	width: 100px;
}

.author-details {
	margin-left: 120px;
}

.about-author {
	min-height: 100px;
}

.author-details .blog-author-name {
	display: inline-block;
	margin-bottom: 10px;
}

.post-author img {
	border-radius: 100%;
	width: 28px;
	margin-right: 5px;
}


/*-----------------
	37. Blog Grid
-----------------------*/

.grid-blog .blog-title {
	font-size: 18px;
	margin: 0 0 5px;
	min-height: 43px;
}

.grid-blog .blog-content p {
	margin: 0 0 15px;
}

.grid-blog .blog-info {
	margin-bottom: 15px;
}

.grid-blog .blog-image {
	margin-bottom: 20px;
}

.blog.grid-blog {
	padding: 20px;
}

.grid-blog .entry-meta {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	margin-bottom: 0;
}

.grid-blog .entry-meta li {
	margin-bottom: 10px;
}

.grid-blog .entry-meta li:last-child {
	flex: 0 0 100px;
	max-width: 100px;
}

.grid-blog .post-author {
	width: 189px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.grid-blog .post-author a:hover {
	color: #e5bd54
}


/*-----------------
	38. Map List & Grid
-----------------------*/

.map-page .footer {
	display: none;
}

.map-page .map-header {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	z-index: 1030;
}

.map-page .bootstrap-datetimepicker-widget {
  z-index: 1030 !important;
}

.fixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
}

.map-page .content {
	padding-top: 140px;
}

.map-right {
	bottom: 0;
	height: 100%;
	min-height: 100%;
	padding-right: 30px;
	position: fixed;
	right: 0;
	top: 140px;
	z-index: 1029;
}

body.map-up .map-right {
	top: 80px;
	transition: ease all 0.5s;
    -webkit-transition: ease all 0.5s;
    -ms-transition: ease all 0.5s;
}

.map-listing {
	height: calc(100vh - 145px);
	width: 100%;
}

.map-listing .profile-widget {
	width: 200px !important;
	padding: 0;
	border: 0;
	margin-bottom: 0;
}

.map-right .available-info {
	margin-bottom: 0;
}

.blank-page .content {
	min-height: 200px !important;
}

.view-icons {
	display: inline-flex;
	float: right;
}

.view-icons a {
	align-items: center;
	background-color: #fff;
	border: 1px solid #ddd;
	border-radius: 4px;
	color: #212529;
	display: flex;
	font-size: 20px;
	justify-content: center;
	padding: 4px 10px;
	text-align: center;
	margin-left: 10px;
	width: 44px;
	height: 44px;
}

.view-icons a:hover {
	border-color: #e5bd54;
	color: #e5bd54;
}

.view-icons a.active {
	background-color: #e5bd54;
	border-color: #e5bd54;
	color: #fff;
}

.profile-widget {
	background-color: #fff;
	border: 1px solid #f0f0f0;
	border-radius: 4px;
	margin-bottom: 30px;
	position: relative;
	-webkit-transition: all .3s ease 0s;
	-moz-transition: all .3s ease 0s;
	-o-transition: all .3s ease 0s;
	transition: all .3s ease 0s;
	padding: 15px;
}

.doc-img {
	position: relative;
	overflow: hidden;
	z-index: 1;
	border-radius: 4px;
}

.doc-img img {
	border-radius: 4px;
	-webkit-transform: translateZ(0);
	-moz-transform: translateZ(0);
	transform: translateZ(0);
	-moz-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
	-ms-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
	-o-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
	-webkit-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
	transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;
	width: 100%;
}

.doc-img:hover img {
	-webkit-transform: scale(1.15);
	-moz-transform: scale(1.15);
	transform: scale(1.15);
}

.profile-widget .fav-btn {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	position: absolute;
	top: 5px;
	right: 5px;
	background-color: #fff;
	width: 30px;
	height: 30px;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	justify-content: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	border-radius: 3px;
	color: #2E3842;
	-webkit-transform: translate3d(100%, 0, 0);
	-ms-transform: translate3d(100%, 0, 0);
	transform: translate3d(100%, 0, 0);
	opacity: 0;
	visibility: hidden;
	z-index: 99;
}

.profile-widget:hover .fav-btn {
	opacity: 1;
	visibility: visible;
	-webkit-transform: translate3d(0, 0, 0);
	-ms-transform: translate3d(0, 0, 0);
	transform: translate3d(0, 0, 0);
}

.profile-widget .fav-btn:hover {
	background-color: #fb1612;
	color: #fff;
}

.pro-content {
	padding: 15px 0 0;
}

.pro-content .title {
	font-size: 17px;
	font-weight: 500;
	margin-bottom: 5px;
}

.profile-widget .pro-content .title a {
	display: inline-block;
}

.profile-widget .verified {
	color: #28a745;
	margin-left: 3px;
}

.profile-widget p.speciality {
	font-size: 13px;
	color: #757575;
	margin-bottom: 10px;
}

.rating {
	list-style: none;
	margin: 0 0 7px;
	padding: 0;
	width: 100%;
}

.rating i {
	color: #dedfe0;
}

.rating i.filled {
	color: #f4c150;
}

.profile-widget .rating {
	color: #757575;
	font-size: 14px;
	margin-bottom: 15px;
}

.profile-widget .rating i {
	font-size: 14px;
}

.available-info {
	font-size: 13px;
	color: #757575;
	font-weight: 400;
	list-style: none;
	padding: 0;
	margin-bottom: 15px;
}

.available-info li+li {
	margin-top: 5px;
}

.available-info li i {
	width: 22px;
}

.row.row-sm {
	margin-left: -3px;
	margin-right: -3px;
}

.row.row-sm > div {
	padding-left: 3px;
	padding-right: 3px;
}

.view-btn {
	color: #f1c144;
	font-size: 13px;
	border: 2px solid #f1c144;
	text-align: center;
	display: block;
	font-weight: 500;
	padding: 6px;
}

.view-btn:hover,
.view-btn:focus {
	background-color: #f1c144;
	color: #fff;
}

.book-btn {
	background-color: #f1c144;
	border: 2px solid #f1c144;
	color: #fff;
	font-size: 13px;
	text-align: center;
	display: block;
	font-weight: 500;
	padding: 6px;
}

.book-btn:hover,
.book-btn:focus {
	background-color: #ecba37;
	border-color: #ecba37;
	color: #fff;
}

.section-sender .profile-widget {
	box-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);
	margin-bottom: 0;
}


/*-----------------
	Carousel
-----------------------*/

.carousel {
    height: 95px;
    width: 560px;
    position: relative;
    overflow-x: scroll;
    margin: auto 0;
    padding: 0;
    list-style: none;
    /* width: 100%; */
    display: flex;
    left: 0;
    transition: all 1s ease;
}

@media (max-width: 768px) {
    .carousel {
        width: 320px;
    }
}

.carousel-card {
    min-width: 70px;
    height: 80px;
    margin: 0 5px;
    background-color: #f2f2f2;
}

.carousel-card a {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
}

.carousel-card a:hover {
    background-color: #d0d0d0;
    border-color: #d0d0d0;
}

.carousel-card a.active-card, .carousel-card a.active-card:hover {
    background-color: #e5bd54;
    border-color: #e5bd54;
}

.carousel-card a.active-card * {
    color: #fff;
}
  
.carousel-arrow {
    height: fit-content;
    align-self: center;
    cursor: pointer;
}  


/*-----------------
	39. Responsive
-----------------------*/

@media only screen and (min-width:768px) {
	.avatar-xxl {
		width: 8rem;
		height: 8rem;
	}
	.avatar-xxl .border {
		border-width: 4px !important;
	}
	.avatar-xxl .rounded {
		border-radius: 12px !important;
	}
	.avatar-xxl .avatar-title {
		font-size: 42px;
	}
	.avatar-xxl.avatar-away:before,
	.avatar-xxl.avatar-offline:before,
	.avatar-xxl.avatar-online:before {
		border-width: 4px;
	}
}

@media (min-width: 992px) {

	.container {
		max-width: 1440px;
	}
	.main-nav > li {
		margin-right: 30px;
	}
	.main-nav > li:last-child {
		margin-right: 0;
	}
	.main-nav li {
		display: block;
		position: relative;
	}
	.main-nav > li > a {
		line-height: 60px;
		padding: 0 !important;
		color: #fff;
	}
	.main-nav > li > i {
		width: 30px;
		height: 30px;
		background: #FFFFFF;
		border: 1px solid #F8F8F8;
		padding: 8px;
		border-radius: 50%;
		font-size: 12px;
	}
	.main-nav > li > i:hover {
		cursor: pointer;
	}
	.main-nav > li > a > i {
		font-size: initial;
		margin-left: 3px;
	}
	.main-nav li > ul {
		background-color: #fff;
		border-radius: 5px;
		box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
		display: block;
		font-size: 14px;
		left: 0;
		margin: 0;
		min-width: 200px;
		opacity: 0;
		padding: 0;
		position: absolute;
		-webkit-transition: all .2s ease;
		transition: all .2s ease;
		-webkit-transform: translateY(20px);
		-ms-transform: translateY(20px);
		transform: translateY(20px);
		top: 100%;
		visibility: hidden;
		z-index: 1000;
	}
	.main-nav li .submenu::before {
		border: 7px solid #fff;
		border-color: transparent transparent #fff #fff;
		box-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);
		content: "";
		left: 45px;
		position: absolute;
		top: 2px;
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		-webkit-transform: rotate(135deg);
		transform: rotate(135deg);
	}
	.main-nav li.has-submenu:hover > .submenu {
		visibility: visible;
		opacity: 1;
		margin-top: 0;
		-webkit-transform: translateY(0);
		-ms-transform: translateY(0);
		transform: translateY(0);
	}
	.main-nav .has-submenu.active > a {
		color: #e5bd54;
	}
	.main-nav .has-submenu.active .submenu li.active > a {
		color: #e5bd54;
	}
	.main-nav > li .submenu li:first-child a {
		border-top: 0;
	}
	.main-nav > li.has-submenu:hover > .submenu > li.has-submenu:hover > .submenu {
		visibility: visible;
		opacity: 1;
		margin-top: -1px;
		margin-right: 0;
	}
	.main-nav > li .submenu > li .submenu {
		left: 100%;
		top: 0;
		margin-top: 10px;
	}
	.main-nav li .submenu a:hover {
		color: #e5bd54;
		letter-spacing: 0.5px;
		padding-left: 20px;
	}
	.main-nav > .has-submenu > .submenu > .has-submenu > .submenu::before {
		top: 20px;
		margin-left: -35px;
		box-shadow: 1px 1px 0 0 rgba(0, 0, 0, .15);
		border-color: transparent #fff #fff transparent;
	}
	.header-navbar-rht li.show > .dropdown-menu {
		visibility: visible;
		opacity: 1;
		margin-top: 0;
		-webkit-transform: translateY(0);
		-ms-transform: translateY(0);
		transform: translateY(0);
	}
	.header-navbar-rht li .dropdown-menu {
		border-radius: 5px;
		padding: 0;
		margin: 0;
		min-width: 200px;
		visibility: hidden;
		opacity: 0;
		-webkit-transition: all .2s ease;
		transition: all .2s ease;
		display: block;
		-webkit-transform: translateY(20px);
		-ms-transform: translateY(20px);
		transform: translateY(20px);
	}
	.searchbar {
		line-height: 60px;
	}
	.banner-section .container-fluid {
		padding-left: 60px;
		padding-right: 60px;
	}
	.banner-white-outline {
		margin-right: 1.5rem;
	}
}

@media (min-width: 1200px) {
    body.map-up .map-right .map-listing {
        height: calc(100vh - 80px);
    }
}

@media only screen and (max-width: 1399px) {
	.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name,
	.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {
		max-width: 180px;
	}
	.row.row-grid {
		margin-left: -8px;
		margin-right: -8px;
	}
	.row.row-grid > div {
		padding-right: 8px;
		padding-left: 8px;
		-ms-flex: 0 0 33.333333%;
		flex: 0 0 33.333333%;
		max-width: 33.333333%;
	}
}

@media only screen and (max-width: 1199px) {
	.header-nav {
		padding-left: 20px;
		padding-right: 20px;
	}
	.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name,
	.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {
		max-width: 150px;
	}
	.chat-cont-left {
		-ms-flex: 0 0 40%;
		flex: 0 0 40%;
		max-width: 40%;
	}
	.chat-cont-right {
		-ms-flex: 0 0 60%;
		flex: 0 0 60%;
		max-width: 60%;
	}
	.row.row-grid > div {
		-ms-flex: 0 0 50%;
		flex: 0 0 50%;
		max-width: 50%;
	}
	.dash-widget {
		-ms-flex-direction: column;
		flex-direction: column;
		text-align: center;
	}
	.circle-bar {
		margin: 0 0 15px;
	}
	.header-navbar-rht li.contact-item {
		display: none;
	}
	.map-right {
		height: 450px;
		position: static;
		min-height: inherit;
		margin-bottom: 30px;
		padding-right: 15px;
	}
	.map-listing {
		height: 450px;
	}
	.map-page .content {
		padding-top: 100px;
	}
	.banner-overlay {
		position: absolute;
		bottom: -100px;
	}
	.coaching-section {
		padding: 150px 0 40px;
	}
	.golf-img-1 {
		margin-top: -25px;
	}
}

@media only screen and (max-width: 991.98px) {
	.main-nav {
		padding: 0;
		-ms-flex-direction: column;
		flex-direction: column;
		padding-left: 0;
		margin-bottom: 0;
		list-style: none;
	}
	.main-nav ul {
		background-color: #25525c;
		display: none;
		list-style: none;
		margin: 0;
		padding-left: 0;
	}
	.main-nav > li {
		border-bottom: 1px solid #4b8997;
		margin-left: 0;
	}
	.main-nav li+li {
		margin-left: 0;
	}
	.main-nav > li > a {
		line-height: 1.5;
		padding: 15px 20px !important;
		color: #fff;
		font-size: 14px;
		font-weight: 500;
	}
	.main-nav > li > a > i {
		float: right;
		margin-top: 5px;
	}
	.main-nav > li .submenu li a {
		border-top: 0;
		color: #fff;
		padding: 10px 15px 10px 35px;
	}
	.main-nav > li .submenu ul li a {
		padding: 10px 15px 10px 45px;
	}
	.main-nav > li .submenu > li.has-submenu > a::after {
		content: "\\f078";
	}
	.main-nav .has-submenu.active > a {
		color: #e5bd54;
	}
	.main-nav .has-submenu.active .submenu li.active > a {
		color: #e5bd54;
	}
	.login-left {
		display: none;
	}
	.main-menu-wrapper {
		order: 3;
		width: 260px;
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		overflow-x: hidden;
		overflow-y: auto;
		z-index: 1060;
		transform: translateX(-260px);
		transition: all 0.4s;
		background-color: #13563A;
	}
	.menu-header {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
	}
	.navbar-header {
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		display: -webkit-inline-box;
		display: -ms-inline-flexbox;
		display: inline-flex;
	}
	#mobile_btn {
		display: inline-block;
	}
	.searchbar {
		display: none;
	}
	.libraries-row {
		-ms-flex: 0 0 33.3%;
		flex: 0 0 33.3%;
		max-width: 33.3%;
		padding: 0 15px;
		margin-bottom: 20px;
	}
	.advisors-row {
		-ms-flex: 0 0 33.3%;
		flex: 0 0 33.3%;
		max-width: 33.3%;
		padding: 0 15px;
		margin-bottom: 20px;
	}
	.collection-row {
		-ms-flex: 0 0 33.3%;
		flex: 0 0 33.3%;
		max-width: 33.3%;
		padding: 0 15px;
		margin-bottom: 20px;
	}
	.counter {
		text-align: center;
		margin-bottom: 20px;
	}
	.top-books {
		margin-bottom: 20px;
	}
	.course-section {
		margin-bottom: 20px;
	}
	.reviews {
		margin-bottom: 50px;
	}
	.sc-btn {
		margin-top: 0;
	}
	.review-bot:after {
		bottom: 15px;
	}
	.counter-overlay {
		display: none;
	}
	.counter-section {
		padding: 40px 0 20px;
	}
	.reviews-section {
		padding: 60px 0 30px;
	}
	.popular-course-section {
		padding: 60px 0 40px;
	}
	.advisors-section {
		padding: 60px 0 30px;
	}
	.top-books-section {
		padding: 60px 0 30px;
	}
	.libraries-section {
		padding: 30px 0;
	}
	.ourblog-section {
		padding: 60px 0 30px;
	}
	.footer .footer-bottom .copyright {
		padding: 15px 0;
	}
	.footer .footer-top {
		padding: 30px 0 10px;
	}
	.section-search {
		min-height: 330px;
	}
	.section-specialities {
		padding: 50px 0;
	}
	.footer-widget {
		margin: 0 0 20px;;
	}
	.chat-cont-left,
	.chat-cont-right {
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
		transition: left 0.3s ease-in-out 0s, right 0.3s ease-in-out 0s;
		width: 100%;
	}
	.chat-cont-left {
		border-right: 0;
	}
	.chat-cont-right {
		position: absolute;
		right: -100%;
		top: 0;
		opacity: 0;
		visibility: hidden;
	}
	.chat-cont-right .chat-header {
		justify-content: start;
		-webkit-justify-content: start;
		-ms-flex-pack: start;
	}
	.chat-cont-right .chat-header .back-user-list {
		display: block;
	}
	.chat-cont-right .chat-header .chat-options {
		margin-left: auto;
	}
	.chat-window.chat-slide .chat-cont-left {
		left: -100%;
	}
	.chat-window.chat-slide .chat-cont-right {
		right: 0;
		opacity: 1;
		visibility: visible;
	}
	.day-slot li.left-arrow {
		left: -10px;
	}
	.container {
		max-width: 100%;
	}
	.batch .appointment-action {
		margin-top: 10px;
	}
	.batch .appointment-list {
		display: block;
	}
	.banner-wrapper {
		max-width: 720px;
	}
	.search-box .search-info {
		-ms-flex: 0 0 410px;
		flex: 0 0 410px;
		width: 410px;
	}
	.banner-wrapper .banner-header h1 {
		font-size: 2.125rem;
	}
	.dct-border-rht {
		border-bottom: 1px solid #f0f0f0;
		border-right: 0;
		margin-bottom: 20px;
		padding-bottom: 15px;
	}
	.card-label > label {
		font-size: 12px;
	}
	.footer .footer-top {
		padding-bottom: 0;
	}
	.time-slot li .timing.selected::before {
		display: none;
	}
	.review-listing .recommend-btn {
		float: none;
	}
	.dash-widget {
		flex-direction: unset;
		text-align: left;
	}
	.circle-bar {
		margin: 0 15px 0 0;
	}
	.call-wrapper {
		height: calc(100vh - 140px);
	}
	.sidebar-overlay.opened {
		display: block;
	}
	.about-content {
		margin-bottom: 30px;
	}
	.header-top {
		display: none;
	}
	.banner-overlay {
		position: relative;
		bottom: 0;
	}
	.banner-btns {
		display: block;
	}
	.banner-white-outline {
		font-size: 12px;
	}
	.features-box {
		margin-bottom: 15px;
	}
	.section-heading {
		width: auto;
	}
	.coaching-section {
		padding: 30px 0 10px;
	}
	.banner-content {
		padding: 120px 0 60px;
	}
	.coaching-text {
		margin-bottom: 20px;
	}
	.golf-img-1 {
		margin-top: 0;
	}
	.coaching-info {
		margin-bottom: 20px;
	}
	.feature-card {
		margin-bottom: 20px;
	}
	.features-section {
		padding: 30px 0 20px;
	}
	.field-row {
		-ms-flex: 0 0 33%;
		flex: 0 0 33%;
		max-width: 33%;
		padding: 0 15px;
		margin-bottom: 20px;
	}
	.field-body h2 {
		font-size: 15px;
	}
	.fields-section {
		padding: 30px 0 10px;
	}
	.golf-bg h2 {
		font-size: 28px;
	}
	.golf-section, .review-section {
		padding: 30px 0;
	}
	.banner-primary {
		font-size: 12px;
	}
	.blog-section {
		padding: 30px 0 10px;
	}
	.our-blogs {
		margin-bottom: 20px;
	}
	.subscribe-item .newsletter-form .cmn-btn {
		padding: 5px 8px;
	}
	.subscribe-item .newsletter-form .form-control {
		padding: 5px;
	}
	.subscribe-item .section-title p {
		margin-bottom: 15px;
	}
	.subsccribe-item {
		margin-bottom: 20px;
	}
	.vector-shapes {
		display: none;
	}
	.main-nav > li.active > a:before {
		display: none;
	}
}

@media only screen and (max-width: 849.98px) {
	.row.row-grid > div {
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
	}
}

@media only screen and (max-width: 767.98px) {
	h1,
	.h1 {
		font-size: 2rem;
	}
	h2,
	.h2 {
		font-size: 1.75rem;
	}
	h3,
	.h3 {
		font-size: 1.375rem;
	}
	h4,
	.h4 {
		font-size: 1rem;
	}
	h5,
	.h5 {
		font-size: 0.875rem;
	}
	h6,
	.h6 {
		font-size: 0.75rem;
	}
	.content {
		padding: 15px 0 0;
	}
	.account-page .content {
		padding: 15px 0;
	}
	.container-fluid {
		padding-left: 15px;
		padding-right: 15px;
	}
	.card {
		margin-bottom: 20px;
	}
	.profile-sidebar {
		margin-bottom: 20px;
	}
	.appointment-tab {
		margin-bottom: 20px;
	}
	.features-slider .slick-dots,
	.features-img img {
		text-align: center;
		margin: 0 auto;
	}
	.sender-slider {
		margin-top: 25px;
	}
	.breadcrumb-bar {
		height: auto;
	}
	.login-right {
		margin: 0 15px;
		padding: 15px;
	}
	.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name,
	.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {
		max-width: 250px;
	}
	.chat-window .chat-cont-right .chat-header .media .media-body {
		display: none;
	}
	.banner-wrapper .banner-header h1 {
		font-size: 2rem;
	}
	.banner-wrapper .banner-header p {
		font-size: 1rem;
	}
	.section-header h2 {
		font-size: 1.875rem;
	}
	.section-header .sub-title {
		font-size: 0.875rem;
	}
	.speicality-item p {
		font-size: 0.875rem;
	}
	.section-header p {
		font-size: 0.9375rem;
	}
	.footer-title {
		font-size: 1.125rem;
	}
	.search-box {
		max-width: 535px;
		margin: 0 auto;
	}
	.search-box form {
		-ms-flex-direction: column;
		flex-direction: column;
		word-wrap: break-word;
		background-clip: border-box;
	}
	.search-box .search-location {
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		width: 100%;
	}
	.search-box .search-info {
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		width: 100%;
	}
	.search-box .search-btn {
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		min-height: 46px;
		width: 100%;
	}
	.search-box .search-btn span {
		display: inline-block;
		margin-left: 5px;
		text-transform: uppercase;
	}
	.section-search {
		background: #f9f9f9;
	}
	.day-slot li span {
		font-size: 16px;
		text-transform: unset;
	}
	.time-slot li .timing span {
		display: block;
	}
	.submit-section.proceed-btn {
		margin-bottom: 20px;
	}
	.day-slot li small.slot-year {
		display: none;
	}
	.success-cont h3 {
		font-size: 22px;
	}
	.view-inv-btn {
		font-size: 14px;
		padding: 10px 30px;
	}
	.invoice-info.invoice-info2 {
		text-align: left;
	}
	.invoice-item .invoice-details {
		text-align: left;
	}
	.section-search,
	.section-sender,
	.section-features {
		padding: 50px 0;
	}
	.slick-next {
		right: -10px;
	}
	.slick-prev {
		left: -10px;
	}
	.specialities-slider .slick-slide {
		margin-right: 15px;
	}
	.about-content a {
		padding: 12px 20px;
	}
	.submit-section .submit-btn {
		padding: 10px 20px;
		font-size: 15px;
		min-width: 105px;
	}
	.policy-menu {
		margin-top: 10px;
		text-align: left;
	}
	.booking-doc-info .booking-doc-img {
		width: 75px;
	}
	.booking-doc-info .booking-doc-img img {
		height: 75px;
		width: 75px;
	}
	.btn.btn-danger.trash {
		margin-bottom: 20px;
	}
	.libraries-row {
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
		padding: 0 15px;
		margin-bottom: 20px;
	}
	.advisors-row {
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
		padding: 0 15px;
		margin-bottom: 20px;
	}
	.collection-row {
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
		padding: 0 15px;
		margin-bottom: 20px;
	}
	.banner-content h2 {
		font-size: 32px;
	}
	.banner-content p {
		font-size: 16px;
	}
	body {
		font-size: .75rem;
	}
	.section-heading {
		padding-bottom: 15px;
	}
	.section-heading h2 {
		font-size: 20px;
	}
	.section-heading.section-bg h2 {
		font-size: 20px;
	}
	.advisors-author h2 {
		font-size: 22px;
	}
	.advisors-author span {
		font-size: .75rem;
	}
	.advisors-author p {
		font-size: .75rem;
	}
	.course-bot h2 {
		font-size: 22px;
	}
	.course-content h2 {
		font-size: 22px;
	}
	.review-listing > ul li .comment .comment-body .meta-data span.comment-date {
		margin-bottom: 5px;
	}
	.review-listing > ul li .comment .comment-body .meta-data .review-count {
		position: unset;
	}
	.my-video ul li {
		width: 50px;
	}
	.call-users ul li {
		width: 50px;
	}
	.call-mute {
		font-size: 20px;
		height: 50px;
		line-height: 50px;
		width: 50px;
	}
	.call-duration {
		font-size: 24px;
	}
	.voice-call-avatar .call-avatar {
		height: 100px;
		width: 100px;
	}
	.user-tabs {
		margin-top: 1.5rem;
	}
	.user-tabs .nav-tabs > li > a {
		border-left: 2px solid transparent;
		border-bottom: 0;
		padding: .5rem 1rem;
	}
	.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active,
	.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:hover,
	.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:focus {
		border-left-width: 2px;
		color: #20c0f3;
	}
	.sender-widget {
		-ms-flex-direction: column;
		flex-direction: column;
		text-align: center;
	}
	.doc-info-right {
		margin-left: 0;
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
	}
	.doc-info-left {
		-ms-flex-direction: column;
		flex-direction: column;
	}
	.shop-services {
		display: none;
	}
	.sender-img {
		margin: 0 auto 20px;
	}
	.sender-action {
		justify-content: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
	}
	.row.row-grid > div {
		-ms-flex: 0 0 50%;
		flex: 0 0 50%;
		max-width: 50%;
	}
	.breadcrumb-bar .breadcrumb-title {
		font-size: 18px;
	}
	.dash-widget h6 {
		font-size: 15px;
	}
	.dash-widget h3 {
		font-size: 20px;
	}
	.dash-widget p {
		font-size: 13px;
	}
	.sender-widget .doc-name {
		font-size: 18px;
	}
	.exp-title,
	.booking-total ul li span,
	.booking-total ul li .total-cost {
		font-size: 14px;
	}
	.invoice-item .customer-text {
		font-size: 16px;
	}
	.call-wrapper {
		height: calc(100vh - 115px);
	}
	.appointment-tab .nav-tabs {
		padding: 1.5rem;
	}
	.submit-btn-bottom {
		margin-bottom: 20px;
	}
	.service-list ul li {
		width: 50%;
	}
	.grid-blog .blog-title {
		min-height: inherit;
	}
	.blog-title {
		font-size: 20px;
	}
	.blog-view .blog-title {
		font-size: 22px;
	}
	.field-row {
		-ms-flex: 0 0 50%;
		flex: 0 0 50%;
		max-width: 50%;
		padding: 0 15px;
		margin-bottom: 20px;
	}
	.golf-bg {
		padding: 20px;
	}
}

@media only screen and (max-width: 575.98px) {
	body {
		font-size: 0.8125rem;
	}
	h1,
	.h1 {
		font-size: 1.75rem;
	}
	h2,
	.h2 {
		font-size: 1.5rem;
	}
	h3,
	.h3 {
		font-size: 1.25rem;
	}
	h4,
	.h4 {
		font-size: 1rem;
	}
	h5,
	.h5 {
		font-size: 0.875rem;
	}
	h6,
	.h6 {
		font-size: 0.75rem;
	}
	.card {
		margin-bottom: 0.9375rem;
	}
	.card-body {
		padding: 1.25rem;
	}
	.card-header {
		padding: .75rem 1.25rem;
	}
	.card-footer {
		padding: .75rem 1.25rem;
	}
	.header-nav {
		padding-left: 15px;
		padding-right: 15px;
	}
	.header-navbar-rht {
		display: none;
	}
	.main-nav li.login-link {
		display: block;
	}
	.navbar-header {
		width: 100%;
	}
	#mobile_btn {
		left: 0;
		margin-right: 0;
		padding: 0 15px;
		position: absolute;
		z-index: 99;
	}
	.navbar-brand.logo {
		width: 100%;
		text-align: center;
		margin-right: 0;
	}
	.navbar-brand.logo img {
		height: 40px;
	}
	.search-box form {
		display: block;
	}
	.search-box .search-location {
		width: 100%;
		-ms-flex: none;
		flex: none;
	}
	.search-box .search-info {
		width: 100%;
		-ms-flex: none;
		flex: none;
	}
	.banner-wrapper .banner-header h1 {
		font-size: 28px;
	}
	.slick-next {
		right: 0px;
	}
	.section-header h2 {
		font-size: 1.5rem;
	}
	.section-header .sub-title {
		font-size: 0.875rem;
	}
	.speicality-item p {
		font-size: 0.875rem;
	}
	.section-header p {
		font-size: 0.9375rem;
	}
	.footer-title {
		font-size: 1.125rem;
	}
	.booking-schedule.schedule-widget {
		overflow-x: auto;
	}
	.booking-schedule.schedule-widget > div {
		width: 730px;
	}
	.booking-schedule .day-slot ul {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
	}
	.booking-schedule .day-slot li {
		-ms-flex: 0 0 100px;
		flex: 0 0 100px;
		width: 100px;
	}
	.booking-schedule .time-slot ul {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
	}
	.booking-schedule .time-slot li {
		-ms-flex: 0 0 100px;
		flex: 0 0 100px;
		width: 100px;
	}
	.booking-schedule .time-slot li .timing span {
		display: inline-block;
	}
	.booking-schedule .day-slot li.right-arrow {
		right: -20px;
	}
	.booking-doc-info .booking-doc-img {
		width: 70px;
	}
	.booking-doc-info .booking-doc-img img {
		height: 70px;
		width: 70px;
	}
	.voice-call-avatar .call-avatar {
		height: 80px;
		width: 80px;
	}
	.call-duration {
		display: block;
		margin-top: 0;
		margin-bottom: 10px;
		position: inherit;
	}
	.end-call {
		margin-top: 10px;
		position: inherit;
	}
	.user-tabs .med-records {
		min-width: 110px;
	}
	.pagination-lg .page-link {
		font-size: 1rem;
		padding: 0.5rem 0.625rem;
	}
	.row.row-grid > div {
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
	}
	.edit-link {
		font-size: 14px;
		margin-top: 2px;
	}
	.invoice-content {
		padding: 1.25rem;
	}
	.change-avatar .profile-img img {
		height: 80px;
		width: 80px;
	}
	.submit-btn-bottom {
		margin-bottom: 0.9375rem;
	}
	.service-list ul li {
		width: 100%;
	}
	.blog {
		padding: 1.25rem;
	}
	.blog-title {
		font-size: 18px;
	}
	.blog-view .blog-title {
		font-size: 20px;
	}
	.blog-info i {
		font-size: 14px;
	}
	.post-left ul li {
		margin-right: 10px;
	}
	.post-left ul li:last-child {
		margin-right: 10px;
	}
	.about-author-img {
		height: 60px;
		width: 60px;
	}
	.author-details {
		margin-left: 80px;
	}
	.blog-comments .comments-list li img.avatar {
		border-radius: 40px;
		height: 40px;
		width: 40px;
	}
	.blog-comments .comments-list li {
		padding: 10px 0 0 50px;
	}
	.read-more {
		font-size: 14px;
	}
	.field-row {
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		max-width: 100%;
		padding: 0 15px;
		margin-bottom: 20px;
	}
}

@media only screen and (max-width:479px) {
	.section-search {
		min-height: 410px;
		padding: 30px 15px;
	}
	.specialities-slider .slick-slide {
		margin-right: 10px;
	}
	.speicality-img {
		width: 120px;
		height: 120px;
	}
	.speicality-img img {
		width: 50px;
	}
	.shop-booking a.view-pro-btn {
		width: 100%;
		margin-bottom: 15px;
	}
	.shop-booking a.apt-btn {
		width: 100%;
	}
	.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name,
	.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {
		max-width: 160px;
	}
	.section-features,
	.section-features,
	.section-specialities {
		background-color: #fff;
		padding: 30px 0;
	}	
	.banner-btns {
		max-width: 200px;
		margin:0 auto;
	}
	.banner-btns button {
		margin-bottom: 10px;
		width: 100%;
		padding: 10px;
	}
	.login-header h3 a {
		color: #0de0fe;
		float: none;
		font-size: 15px;
		margin-top: 10px;
		text-align: center;
		display: block;
	}
	.login-header h3 {
		text-align: center;
	}
	.batch .appointment-list {
		text-align: center;
	}
	.appointment-list .profile-info-widget {
		-ms-flex-direction: column;
		flex-direction: column;
	}
	.appointment-list .profile-info-widget {
		text-align: center;
	}
	.appointment-list .profile-info-widget .booking-doc-img {
		margin: 0 0 15px;
	}
	.appointment-list .profile-info-widget .booking-doc-img img {
		border-radius: 50%;
		height: 100px;
		width: 100px;
	}
	.appointment-list .profile-det-info {
		margin-bottom: 15px;
	}
	.batch .appointment-action {
		margin-top: 0;
	}
	.user-tabs .nav-tabs .nav-item {
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
	}
	.review-listing .recommend-btn span {
		display: block;
		margin-bottom: 10px;
	}
	.review-listing > ul li .comments-reply {
		margin-left: 0;
	}
	.schedule-nav .nav-tabs li {
		display: block;
		-ms-flex: 0 0 100%;
		flex: 0 0 100%;
		margin-right: 0;
	}
	.fc-header-toolbar .fc-left {
		margin-bottom: 10px;
	}
	.fc-header-toolbar .fc-right {
		margin-bottom: 10px;
	}
}



.stickyside {
	position: sticky;
	top: 0;
	padding-bottom: 1px;
}
.mapgridrating1 i:not(:last-child) {
    margin-right: 4px;
}
.fancystyle {
	display: unset !important;
}

/*-----------------
	40. Custom Elements
-----------------------*/

.form-control:disabled, .form-control[readonly] {
    background-color: transparent;
    border: none;
    box-shadow: none;
}

input:focus:not(.form-control) {
    outline: none;
    border: none;
}

.min-h-40 {
    min-height: 40rem;
}

.inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.inset-top-left {
    top: 5px;
    left: 5px;
}

.object-contain {
    object-fit: cover;
}

.object-cover {
    object-fit: cover;
}

.bg-cover {
    background-size: cover;
}

.bg-contain {
    background-size: contain;
}

.bg-no-repeat {
    background-repeat: no-repeat;
}

.bg-light {
    background-color: var(--light);
}

.bgc-gray {
    background-color: #fafafa !important;
}

.bg-light-hover:hover {
    background-color: var(--gray);
}

.bg-white-hover:hover {
    background-color: var(--light);
}

.display-1 {
    font-size: 13vmin;
}

.display-2 {
    font-size: 11vmin;
}

.display-3 {
    font-size: 7.5vmin;
}

.font-weight-200 {
    font-weight: 200;
}

.font-weight-300 {
    font-weight: 300;
}

.font-weight-500 {
    font-weight: 500;
}

.font-weight-600 {
    font-weight: 600;
}

@media (min-width: 40rem) {
    .min-vh-md-100 {
        min-height: 100vh;
    }
}`, "",{"version":3,"sources":["webpack://./assets/css/style.css"],"names":[],"mappings":"AAAA;;;;CAIC;;;AAGD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;yCA4CyC;;;AAGzC;;wBAEwB;AAIxB,8BAA8B;AAC9B;IACI,wCAAwC;IACxC,kBAAkB;IAClB,oBAAoB;IACpB,4DAAkE;IAClE,mBAAmB;AACvB;AACA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA,4BAA4B;AAC5B;IACI,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,4DAAkE;IAClE,mBAAmB;AACvB;AACA;IACI,sCAAsC;IACtC,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,oBAAoB;IACpB,4DAAyD;IACzD,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,4CAA4C;CAC5C,0BAA0B;CAC1B,YAAY;CACZ,kBAAkB;AACnB;;AAEA;;;;;;CAMC,cAAc;CACd,gBAAgB;AACjB;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;AACA;;;;CAIC,aAAa;CACb,qBAAqB;AACtB;;AAEA;;;CAGC,yDAAyD;AAC1D;;AAEA;;;CAGC,yBAAyB;CACzB,8BAA8B;CAC9B,4BAA4B;CAC5B,6BAA6B;CAC7B,iCAAiC;AAClC;;AAEA;CACC,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX;;AAEA;;CAEC,wBAAwB;CACxB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;IACd,gBAAgB;AACpB;;AAEA;CACC,SAAS;AACV;;;AAGA;;wBAEwB;;AAExB;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;;;;;CAMC,aAAa;CACb,iBAAiB;AAClB;;AAEA;;CAEC;AACD;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,kBAAkB;CAClB,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;CACX,cAAc;CACd,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,4CAA4C;AAC7C;;AAEA;CACC,4CAA4C;AAC7C;;AAEA;CACC,4CAA4C;AAC7C;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,gDAAgD;AACjD;;AAEA;;CAEC,iCAAiC;AAClC;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC,oBAAoB;AACrB;;AAEA;;CAEC,qBAAqB;AACtB;;AAEA;;CAEC,6BAA6B;CAC7B,qBAAqB;CACrB,mBAAmB;AACpB;;;AAGA;;wBAEwB;;AAExB;;CAEC,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;CACtB,sBAAsB;CACtB,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;;;CAIC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;;;CAIC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;;;CAIC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;;;CAIC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;;;CAIC,oCAAoC;AACrC;;AAEA;CACC,sBAAsB;AACvB;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;IACI;AACJ;;AAEA,sCAAsC,aAAa;;AAEnD;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;;;;;CAKC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;;;;;;;;;CASC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;;;CAGC,iBAAiB;AAClB;;AAEA;;CAEC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;;;;;;;;;;GAUG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4MC;;AAED;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;;CAEC,cAAc;CACd,6BAA6B;AAC9B;;AAEA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;;CAGC,gBAAgB;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAqJG;;AAEH;;;;;;CAMC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;CACtB,oCAAoC;CACpC,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,4BAA4B;AAC7B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;CACC,SAAS;CACT,uCAAuC;CACvC,sBAAsB;AACvB;;AAEA;CACC,8CAA8C;CAC9C,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gCAAgC;CAChC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,6BAA6B;CAC7B,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;;CAEC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,sDAAsD;CACtD,yBAAyB;AAC1B;;AAEA;CACC,oDAAoD;CACpD,yBAAyB;AAC1B;;AAEA;CACC,qDAAqD;CACrD,yBAAyB;AAC1B;;AAEA;CACC,oDAAoD;CACpD,yBAAyB;AAC1B;;AAEA;CACC,oDAAoD;CACpD,yBAAyB;AAC1B;;AAEA;CACC,qDAAqD;CACrD,yBAAyB;AAC1B;;AAEA;CACC,sDAAsD;CACtD,yBAAyB;AAC1B;;AAEA;CACC,mDAAmD;CACnD,yBAAyB;AAC1B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa,EAAE,8BAA8B;AACjD;;AAEA;IACI,aAAa,EAAE,6BAA6B;AAChD;;AAEA;;wBAEwB;;AAExB;CACC,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX;AACD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,oBAAoB;CACpB,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,WAAW;CACX,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,+BAA+B;CAC/B,qBAAqB;AACtB;;AAEA;;;CAGC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,eAAe;AAChB;;AAEA;;;CAGC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,cAAc;AACf;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,eAAe;AAChB;;AAEA;;;CAGC,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,eAAe;AAChB;;AAEA;;;CAGC,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,eAAe;AAChB;;AAEA;;;CAGC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,eAAe;AAChB;;AAEA;;;CAGC,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,UAAU;AACX;;;AAGA;;wBAEwB;;AAExB;CACC,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,6CAA6C;CAC7C,mBAAmB;CACnB,uBAAuB;CACvB,SAAS;CACT,SAAS;CACT,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,QAAQ;CACR,QAAQ;AACT;;AAEA;CACC,6CAA6C;CAC7C,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;;AAGA;;wBAEwB;;AAExB;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,gBAAgB;AACjB;;AAEA;;CAEC,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,yBAAyB;IACtB,gCAAgC;CACnC,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;;CAEC,4BAA4B;AAC7B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;;CAGC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;;;CAGC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;CAGC,uBAAuB;AACxB;;AAEA;;;CAGC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;;;CAGC,wBAAwB;CACxB,yBAAyB;CACzB,4BAA4B;CAC5B,6BAA6B;CAC7B,2BAA2B;CAC3B,gCAAgC;CAChC,8BAA8B;CAC9B,+BAA+B;CAC/B,mCAAmC;AACpC;;AAEA;CACC,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;;;CAGC,uBAAuB;AACxB;;;AAGA;;wBAEwB;;AAExB;CACC,uBAAuB;AACxB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;;AAGA;;wBAEwB;;AAExB;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,oBAAoB;CACpB,kBAAkB;CAClB,mDAAmD;CACnD,+CAA+C;CAC/C,8CAA8C;CAC9C,2CAA2C;CAC3C,0BAA0B;CAC1B,iBAAiB;CACjB,UAAU;CACV,SAAS;CACT,UAAU;CACV,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,UAAU;CACV,eAAe;CACf,UAAU;AACX;;AAEA;;CAEC,UAAU;CACV,gBAAgB;CAChB,UAAU;CACV,eAAe;CACf,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,UAAU;CACV,eAAe;CACf,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,0CAA0C;CAC1C,mBAAmB;CACnB,uBAAuB;CACvB,SAAS;CACT,SAAS;CACT,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,QAAQ;CACR,QAAQ;AACT;;AAEA;CACC,0CAA0C;CAC1C,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;AAC1B;;;AAGA;;wBAEwB;;AAExB;CACC,sBAAsB;AACvB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB,gBAAgB;CAChB,oBAAoB;CACpB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,WAAW;CACX,gBAAgB;CAChB,aAAa;CACb,cAAc;AACf;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,SAAS;CACT,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,eAAe;CACf,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,eAAe;CACf,iBAAiB;AAClB;;AAEA;;CAEC,WAAW;AACZ;;;AAGA;;wBAEwB;;AAExB;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,yBAAyB;CACzB,SAAS;CACT,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,8BAA8B;CAC9B,sCAAsC;CACtC,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,cAAc;CACd,WAAW;IACR,kBAAkB;CACrB,aAAa;CACb,YAAY;CACZ,yBAAyB;CACzB,iCAAiC;CACjC,6BAA6B;AAC9B;;AAEA;CACC,mBAAmB;AACpB;AACA;CACC,uBAAuB;AACxB;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mDAAuC;IACvC,SAAS;IACT,MAAM;IACN,SAAS;IACT,QAAQ;IACR,4BAA4B;AAChC;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,mBAAmB;CACnB,eAAe;CACf,cAAc;CACd,iCAAiC;CACjC,yBAAyB;CACzB,WAAW;CACX,6BAA6B;AAC9B;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,eAAe;AAChB;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA,qBAAqB;AACrB;IACI,KAAK,wBAAwB,EAAE;IAC/B,MAAM,2BAA2B,EAAE;IACnC,MAAM,0BAA0B,EAAE;IAClC,MAAM,2BAA2B,EAAE;IACnC,OAAO,0BAA0B,EAAE;AACvC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,SAAS;CACT,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,uBAAuB;CACvB,+BAA+B;CAC/B,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,sCAAsC;AACvC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,QAAQ;CACR,sBAAsB;CACtB,qDAAqD;CACrD,6BAA6B;CAC7B,qBAAqB;CACrB,iCAAiC;CACjC,yBAAyB;CACzB,gDAAgD;AACjD;;AAEA;CACC,6BAA6B;CAC7B,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,6BAA6B;CAC7B,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,cAAc;CACd,gCAAgC;CAChC,+BAA+B;CAC/B,WAAW;CACX,WAAW;CACX,qBAAqB;CACrB,oBAAoB;CACpB,iCAAiC;CACjC,6BAA6B;CAC7B,yBAAyB;CACzB,gCAAgC;CAChC,4BAA4B;CAC5B,wBAAwB;CACxB,yCAAyC;CACzC,iCAAiC;CACjC,UAAU;CACV,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,kCAAkC;CAClC,8BAA8B;CAC9B,0BAA0B;AAC3B;;AAEA;CACC,YAAY;CACZ,SAAS;CACT,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,YAAY;AACb;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;;CAEC,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT;AACD;;AAEA;CACC,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,6BAA6B;CAC7B,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,eAAe;CACf,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,YAAY;CACZ,6BAA6B;CAC7B,aAAa;CACb,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,mCAAmC;CACnC,oCAAoC;CACpC,kCAAkC;CAClC,iCAAiC;AAClC;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,yBAAyB;CACzB,aAAa;CACb,YAAY;CACZ,0BAA0B;AAC3B;;AAEA;CACC,WAAW;CACX,cAAc;CACd,mBAAmB;CACnB,WAAW;CACX,iBAAiB;CACjB,yBAAyB;CACzB,aAAa;CACb,eAAe;CACf,YAAY;CACZ,0BAA0B;AAC3B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,0BAA0B;CAC1B,8CAA8C;CAC9C,kBAAkB;CAClB,eAAe;CACf,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;IACR,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;;AAEA;CACC,aAAa;CACb,qBAAqB;CACrB,mBAAmB;CACnB,WAAW;CACX,iBAAiB;CACjB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,UAAU;AACX;;;AAGA;;wBAEwB;;AAExB;CACC,kBAAkB;CAClB,mDAAmC;CACnC,0BAA0B;CAC1B,sBAAsB;CACtB,4BAA4B;CAC5B,UAAU;AACX;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,8BAA8B;CAC9B,MAAM;CACN,QAAQ;CACR,OAAO;CACP,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,iCAAiC;AAClC;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;CAChB,eAAe;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;GAyBG;;AAEH;CACC,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,QAAQ;CACR,SAAS;CACT,iCAAiC;AAClC;;AAEA;IACI;AACJ;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,MAAM;CACN,SAAS;CACT,OAAO;CACP,QAAQ;CACR,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,iCAAiC;CACjC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,cAAc;CACd,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,iCAAiC;CACjC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,iCAAiC;CACjC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,8CAA8C;CAC9C,mBAAmB;CACnB,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;CAC5B,iCAAiC;CACjC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,mDAA8B;CAC9B,0BAA0B;CAC1B,sBAAsB;CACtB,4BAA4B;CAC5B,eAAe;CACf,+BAA+B;CAC/B,UAAU;AACX;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,oCAAoC;CACpC,MAAM;CACN,QAAQ;CACR,OAAO;CACP,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iCAAiC;AAClC;;AAEA;CACC,eAAe;CACf;AACD;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oCAAoC;CACpC,yBAAyB;CACzB,aAAa;AACd;;AAEA;CACC,WAAW;CACX,eAAe;CACf,iCAAiC;AAClC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,mDAAmC;CACnC,2BAA2B;CAC3B,sBAAsB;CACtB,4BAA4B;CAC5B,eAAe;CACf,+BAA+B;CAC/B,UAAU;AACX;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,mCAAmC;CACnC,MAAM;CACN,QAAQ;CACR,OAAO;CACP,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,oCAAoC;AACrC;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,cAAc;CACd,YAAY;CACZ,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,cAAc;CACd,YAAY;CACZ,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,2CAA2C;CAC3C,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,SAAS;AACV;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,kBAAkB;IACf,WAAW;IACX,QAAQ;AACZ;;AAEA;CACC,kBAAkB;IACf,cAAc;IACd,YAAY;AAChB;;AAEA;CACC,kBAAkB;IACf,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;;wBAEwB;;AAExB;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,0BAA0B;CAC1B,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,WAAW;CACX,WAAW;CACX,mBAAmB;CACnB,SAAS;CACT,OAAO;CACP,QAAQ;CACR,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,4BAA4B;CAC5B,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,oCAAoC;CACpC,+BAA+B;CAC/B,4BAA4B;AAC7B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,gBAAgB;CAChB,UAAU;CACV,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,cAAc;CACd,eAAe;CACf,4BAA4B;CAC5B,YAAY;CACZ,WAAW;CACX,oCAAoC;CACpC,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,8CAA8C;CAC9C,+BAA+B;CAC/B,YAAY;CACZ,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;CACnB,oBAAoB;CACpB,kBAAkB;CAClB,YAAY;CACZ,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,4BAA4B;CAC5B,sBAAsB;CACtB,gBAAgB;CAChB,eAAe;CACf,8CAA8C;CAC9C,SAAS;AACV;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,qBAAqB;AACtB;;;AAGA;;wBAEwB;;AAExB;CACC,oCAAoC;CACpC,aAAa;CACb,YAAY;CACZ,OAAO;CACP,eAAe;CACf,MAAM;CACN,WAAW;CACX,aAAa;AACd;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,yBAAyB;CACzB,YAAY;CACZ,eAAe;CACf,8BAA8B;CAC9B,sCAAsC;CACtC,4BAA4B;CAC5B,gCAAgC;CAChC,aAAa;AACd;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;;AAGA;;wBAEwB;;AAExB;IACI,aAAa;CAChB,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,6BAA6B;CAC7B,eAAe;CACf,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,cAAc;CACd,kCAAkC;CAClC,eAAe;CACf,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,SAAS;AACV;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;CACf,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,yBAAyB;CACzB,sBAAsB;CACtB,qBAAqB;CACrB;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,sBAAsB;CACtB,kBAAkB;CAClB,qCAAqC;CACrC,mCAAmC;CACnC,wCAAwC;CACxC,oCAAoC;CACpC;AACD;;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,SAAS;CACT,MAAM;CACN,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;CACf,oBAAoB;CACpB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,yBAAyB;CACzB,sBAAsB;CACtB,qBAAqB;CACrB;AACD;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,YAAY;CACZ,WAAW;CACX,sBAAsB;CACtB,sBAAsB;CACtB;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,SAAS;CACT,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,qCAAqC;CACrC,mCAAmC;CACnC,wCAAwC;CACxC,oCAAoC;CACpC;AACD;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;AACd;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,eAAe;CACf,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;CACzB,WAAW;AACZ;;AAEA;;CAEC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;;CAEC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;;AAGA;;wBAEwB;;AAExB;CACC,cAAc;CACd,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;;CAEC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;;CAEC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,oCAAoC;CACpC,cAAc;CACd,gBAAgB;CAChB,aAAa;AACd;;AAEA;;;CAGC,wBAAwB;CACxB,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,WAAW;CACX,SAAS;CACT,kBAAkB;CAClB,QAAQ;CACR,UAAU;AACX;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,SAAS;CACT,SAAS;CACT,UAAU;CACV,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;CACrB,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,WAAW;CACX,aAAa;CACb,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kCAAkC;CAClC,gBAAgB;CAChB,OAAO;CACP,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,UAAU;CACV,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,8BAA8B;CAC9B,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,0BAA0B;AAC3B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,kBAAkB;CAClB,QAAQ;CACR,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,0CAA0C;CAC1C,kBAAkB;CAClB,qBAAqB;CACrB,iBAAiB;CACjB,cAAc;CACd,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,UAAU;AACX;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,eAAe;CACf,eAAe;CACf,UAAU;CACV,uCAAuC;CACvC,+BAA+B;IAC5B,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;;CAGC;AACD;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;CAC7B,0BAA0B;CAC1B,uBAAuB;CACvB,WAAW;CACX,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,8BAA8B;CAC9B,sCAAsC;CACtC,4BAA4B;CAC5B,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;CAC7B,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;;AAGA;;wBAEwB;;AAExB;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;AACd;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,gCAAgC;CAChC,0BAA0B;CAC1B,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;CACV,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,cAAc;CACd,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,OAAO;CACP,UAAU;CACV,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,cAAc;CACd,eAAe;CACf,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kCAAkC;CAClC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;CACV,QAAQ;AACT;;AAEA;CACC,gCAAgC;CAChC,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;;AAGA;;wBAEwB;;AAExB;CACC,gCAAgC;CAChC,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;CACf,sBAAsB;CACtB,cAAc;CACd,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,cAAc;IACX,kBAAkB;AACtB;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,0CAA0C;CAC1C,cAAc;CACd,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,4BAA4B;CAC5B,WAAW;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,eAAe;CACf,yBAAyB;CACzB,sBAAsB;CACtB,qBAAqB;CACrB,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,eAAe;CACf,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,sBAAsB;CACtB,oCAAoC;CACpC,sCAAsC;CACtC,uCAAuC;CACvC,qCAAqC;CACrC,0BAA0B;CAC1B,uBAAuB;CACvB,kBAAkB;CAClB,2BAA2B;CAC3B,wBAAwB;CACxB,uBAAuB;CACvB,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,WAAW;CACX,UAAU;CACV,WAAW;CACX,yBAAyB;CACzB,UAAU;CACV,kBAAkB;CAClB,6BAA6B;CAC7B,0BAA0B;CAC1B,yBAAyB;CACzB,wBAAwB;CACxB,qBAAqB;CACrB,0BAA0B;CAC1B,uBAAuB;CACvB,kBAAkB;CAClB,2BAA2B;CAC3B,wBAAwB;CACxB,uBAAuB;CACvB,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;CAC3B,wBAAwB;CACxB,uBAAuB;CACvB,sBAAsB;CACtB,mBAAmB;CACnB,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,0BAA0B;CAC1B,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,0BAA0B;CAC1B,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,6BAA6B;CAC7B,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;CACf,YAAY;AACb;;;AAGA;;wBAEwB;;AAExB;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,uBAAuB;CACvB,+BAA+B;CAC/B,qBAAqB;CACrB,eAAe;CACf,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;;;AAGA;;wBAEwB;;AAExB;CACC,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC;AACD;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB;AACD;;AAEA;;;;CAIC,cAAc;CACd,gBAAgB;CAChB,kBAAkB;CAClB;AACD;;AAEA;;CAEC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC;AACD;;AAEA;;CAEC,aAAa;AACd;;AAEA;CACC;AACD;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;;AAGA;;wBAEwB;;AAExB;CACC,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,oCAAoC;CACpC,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,YAAY;CACZ,WAAW;CACX,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,uBAAuB;CACvB,+BAA+B;CAC/B,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,eAAe;AAChB;;;AAGA;;wBAEwB;;AAExB;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;;AAEf;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,eAAe;CACf,yBAAyB;CACzB,4CAA4C;CAC5C,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;;AAGA;;wBAEwB;;AAExB;CACC,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;;;CAGC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CACd,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;;AAGA;;wBAEwB;;AAExB;CACC,aAAa;AACd;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,+BAA+B;CAC/B,iBAAiB;CACjB,aAAa;CACb,OAAO;CACP,cAAc;CACd,kBAAkB;CAClB,UAAU;AACX;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,sBAAsB;CACtB,gCAAgC;CAChC,cAAc;CACd,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,YAAY;CACZ,8BAA8B;CAC9B,sCAAsC;CACtC,4BAA4B;CAC5B,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,0BAA0B;AAC3B;;AAEA;CACC,cAAc;CACd,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;CACzB,gCAAgC;CAChC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,8BAA8B;CAC9B,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,SAAS;CACT,WAAW;CACX,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,UAAU;CACV,oBAAoB;CACpB,kBAAkB;CAClB,MAAM;CACN,UAAU;AACX;;AAEA;CACC,iBAAiB;CACjB,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,gCAAgC;CAChC,kBAAkB;CAClB,4BAA4B;AAC7B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,8BAA8B;CAC9B,sCAAsC;CACtC,4BAA4B;AAC7B;;AAEA;;CAEC,gBAAgB;CAChB,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,0BAA0B;AAC3B;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,sBAAsB;CACtB,gCAAgC;CAChC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,YAAY;CACZ,8BAA8B;CAC9B,sCAAsC;CACtC,4BAA4B;CAC5B,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,SAAS;CACT,YAAY;CACZ,kBAAkB;CAClB,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,0BAA0B;AAC3B;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;AACd;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;CAClB,cAAc;CACd,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,YAAY;CACZ,uBAAuB;CACvB,+BAA+B;CAC/B,qBAAqB;CACrB,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,aAAa;CACb,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;CAC3B,wBAAwB;CACxB,qBAAqB;CACrB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,0BAA0B;CAC1B,sBAAsB;CACtB,yBAAyB;CACzB,iCAAiC;CACjC,uBAAuB;CACvB,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,0BAA0B;AAC3B;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,WAAW;CACX,SAAS;CACT,iBAAiB;CACjB,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,6BAA6B;CAC7B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,gBAAgB;AACjB;;AAEA;;CAEC,6BAA6B;CAC7B,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ;AACD;;AAEA;CACC,WAAW;CACX,UAAU;CACV,WAAW;CACX,aAAa;CACb,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,oCAAoC;CACpC,4BAA4B;CAC5B,iCAAiC;CACjC,WAAW;CACX,SAAS;CACT,UAAU;CACV,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,oCAAoC;CACpC,8BAA8B;CAC9B,iCAAiC;CACjC,WAAW;CACX,SAAS;CACT,UAAU;CACV,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,QAAQ;AACT;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,WAAW;CACX,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,WAAW;CACX,WAAW;CACX,UAAU;CACV,mBAAmB;CACnB,kBAAkB;CAClB;AACD;;AAEA;CACC,WAAW;CACX,SAAS;CACT,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC;AACD;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,WAAW;CACX;AACD;;AAEA;CACC;AACD;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,OAAO;CACP,QAAQ;CACR,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,SAAS;CACT,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,UAAU;CACV,mBAAmB;CACnB,WAAW;CACX,WAAW;CACX,iBAAiB;CACjB,oCAAoC;CACpC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,YAAY;AACb;;AAEA;CACC,aAAa;CACb,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,0CAA0C;CAC1C,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,uBAAuB;CACvB,+BAA+B;CAC/B,qBAAqB;AACtB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,2BAA2B;CAC3B,UAAU;CACV,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,eAAe;CACf,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC;EACC;CACD;AACD;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,eAAe;CACf,uBAAuB;CACvB,+BAA+B;CAC/B,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,YAAY;CACZ,SAAS;CACT,UAAU;CACV,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,WAAW;AACZ;;;AAGA;;wBAEwB;;AAExB;CACC,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,eAAe;CACf,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,SAAS;CACT,eAAe;CACf,wBAAwB;CACxB,OAAO;CACP,SAAS;CACT,UAAU;CACV,UAAU;CACV,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,qCAAqC;AACtC;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;CACV,eAAe;CACf,WAAW;CACX,YAAY;CACZ,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,UAAU;CACV,QAAQ;CACR,uBAAuB;CACvB,+BAA+B;CAC/B,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;AACd;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,YAAY;CACZ,WAAW;CACX,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,uBAAuB;CACvB,+BAA+B;CAC/B,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,gBAAgB;CAChB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,oCAAoC;CACpC,WAAW;CACX,qBAAqB;CACrB,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;;AAGA;;wBAEwB;;AAExB;CACC,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iCAAiC;CACjC,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;;;CAKC,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,yBAAyB;AAC1B;;AAEA;;;;;;;CAOC,qBAAqB;AACtB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,cAAc;CACd,0BAA0B;CAC1B,2BAA2B;CAC3B,6BAA6B;CAC7B,wBAAwB;CACxB,4BAA4B;CAC5B,uBAAuB;AACxB;;AAEA;CACC,oBAAoB;CACpB,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;;CAGC,oCAAoC;CACpC,sBAAsB;CACtB,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,sBAAsB;CACtB,YAAY;CACZ,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,iCAAiC;AAClC;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,iCAAiC;AAClC;;AAEA;CACC,YAAY;AACb;;;AAGA;;wBAEwB;;AAExB;CACC,sBAAsB;CACtB,mBAAmB;CACnB,mBAAmB;CACnB,gBAAgB;CAChB,8CAA8C;AAC/C;;AAEA;CACC,gCAAgC;CAChC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,0BAA0B;AAC3B;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gCAAgC;CAChC,kBAAkB;AACnB;AACA;IACI,oBAAoB;IACpB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,sBAAsB;AAC1B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,cAAc;CACd,cAAc;CACd,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,2BAA2B;AAC5B;;;AAGA;;wBAEwB;;AAExB;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,YAAY;AACb;;;AAGA;;wBAEwB;;AAExB;CACC,sBAAsB;CACtB,gCAAgC;AACjC;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,YAAY;AACb;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;;AAGA;;wBAEwB;;AAExB;CACC,SAAS;AACV;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB,aAAa;AACd;;;AAGA;;wBAEwB;;AAExB;CACC,yBAAyB;CACzB,sBAAsB;CACtB,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,SAAS;CACT,OAAO;CACP,cAAc;CACd,uBAAuB;CACvB,oBAAoB;CACpB,kBAAkB;CAClB,QAAQ;CACR,MAAM;AACP;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,YAAY;CACZ,WAAW;CACX,UAAU;CACV,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,mBAAmB;CACnB,WAAW;CACX,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;CACtB,gCAAgC;CAChC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,SAAS;CACT,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,UAAU;AACX;;AAEA;;CAEC,6BAA6B;AAC9B;;AAEA;CACC,UAAU;CACV,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,0BAA0B;CAC1B,sBAAsB;CACtB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,uBAAuB;CACvB,+BAA+B;CAC/B,qBAAqB;CACrB,WAAW;CACX,OAAO;AACR;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,oCAAoC;CACpC,YAAY;CACZ,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,eAAe;CACf,kBAAkB;CAClB,OAAO;AACR;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,6BAA6B;CAC7B,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,mBAAmB;CACnB,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,SAAS;CACT,OAAO;CACP,cAAc;CACd,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,cAAc;CACd,cAAc;AACf;;AAEA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,cAAc;CACd,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,QAAQ;AACT;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,qBAAqB;CACrB,iBAAiB;CACjB,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,sBAAsB;CACtB,oCAAoC;AACrC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,oCAAoC;CACpC,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,aAAa;CACb,MAAM;CACN,6BAA6B;AAC9B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,WAAW;AACZ;;AAEA;;CAEC,cAAc;CACd,uBAAuB;CACvB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;;AAGA;;wBAEwB;;AAExB;CACC,YAAY;CACZ,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,SAAS;AACV;;AAEA;CACC,kBAAkB;AACnB;;;AAGA;;wBAEwB;;AAExB;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,6BAA6B;AAC9B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,uBAAuB;CACvB,+BAA+B;CAC/B,qBAAqB;AACtB;;AAEA;CACC,0CAA0C;CAC1C,6BAA6B;CAC7B,mBAAmB;CACnB,WAAW;CACX,cAAc;CACd,aAAa;CACb,aAAa;AACd;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,yBAAyB;CACzB,WAAW;CACX,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,yBAAyB;CACzB,WAAW;CACX,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;CAC5B,4BAA4B;AAC7B;;AAEA;CACC;EACC,8CAA8C;CAC/C;CACA;EACC,+CAA+C;CAChD;AACD;;AAEA;CACC;EACC,2CAA2C;EAC3C,sCAAsC;CACvC;CACA;EACC,4CAA4C;EAC5C,uCAAuC;CACxC;AACD;;;AAGA;;wBAEwB;;AAExB;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,2BAA2B;AAC5B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;;AAGA;;wBAEwB;;AAExB;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,eAAe;AAChB;;;AAGA;;wBAEwB;;AAExB;CACC,yBAAyB;CACzB,sBAAsB;CACtB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;CAGC,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,gCAAgC;CAChC,6BAA6B;CAC7B,wBAAwB;CACxB,4DAA4D;CAC5D,2DAA2D;CAC3D,0DAA0D;CAC1D,+DAA+D;CAC/D,uDAAuD;AACxD;;AAEA;CACC,8BAA8B;CAC9B,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,UAAU;CACV,cAAc;CACd,0BAA0B;CAC1B,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,iCAAiC;CACjC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,SAAS;CACT,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,SAAS;CACT,gBAAgB;AACjB;;AAEA;;;CAGC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,SAAS;CACT,UAAU;AACX;;AAEA;CACC,cAAc;CACd,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gCAAgC;CAChC,6BAA6B;CAC7B,wBAAwB;CACxB,4DAA4D;CAC5D,2DAA2D;CAC3D,0DAA0D;CAC1D,+DAA+D;CAC/D,uDAAuD;AACxD;;AAEA;CACC,8BAA8B;CAC9B,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;CACf,SAAS;AACV;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,uBAAuB;CACvB,eAAe;CACf,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;;AAGA;;wBAEwB;;AAExB;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,SAAS;CACT,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,qBAAqB;CACrB,eAAe;CACf,YAAY;CACZ,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,OAAO;CACP,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,iBAAiB;AAClB;;;AAGA;;wBAEwB;;AAExB;CACC,eAAe;CACf,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC;AACD;;;AAGA;;wBAEwB;;AAExB;CACC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,OAAO;CACP,QAAQ;CACR,MAAM;CACN,aAAa;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,YAAY;CACZ,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,QAAQ;CACR,UAAU;CACV,aAAa;AACd;;AAEA;CACC,SAAS;CACT,yBAAyB;IACtB,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;CACC,2BAA2B;CAC3B,WAAW;AACZ;;AAEA;CACC,uBAAuB;CACvB,UAAU;CACV,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,oBAAoB;CACpB,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;CACtB,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;CACd,aAAa;CACb,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,kBAAkB;CAClB,iBAAiB;CACjB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,mCAAmC;CACnC,gCAAgC;CAChC,8BAA8B;CAC9B,2BAA2B;CAC3B,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gCAAgC;CAChC,6BAA6B;CAC7B,wBAAwB;CACxB,4DAA4D;CAC5D,2DAA2D;CAC3D,0DAA0D;CAC1D,+DAA+D;CAC/D,uDAAuD;CACvD,WAAW;AACZ;;AAEA;CACC,8BAA8B;CAC9B,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,sBAAsB;CACtB,WAAW;CACX,YAAY;CACZ,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,uBAAuB;CACvB,+BAA+B;CAC/B,qBAAqB;CACrB,kBAAkB;CAClB,cAAc;CACd,0CAA0C;CAC1C,sCAAsC;CACtC,kCAAkC;CAClC,UAAU;CACV,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,mBAAmB;CACnB,uCAAuC;CACvC,mCAAmC;CACnC,+BAA+B;AAChC;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,YAAY;AACb;;AAEA;;CAEC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,WAAW;CACX,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,YAAY;AACb;;AAEA;;CAEC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,2CAA2C;CAC3C,gBAAgB;AACjB;;;AAGA;;wBAEwB;;AAExB;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,OAAO;IACP,uBAAuB;AAC3B;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;;wBAEwB;;AAExB;CACC;EACC,WAAW;EACX,YAAY;CACb;CACA;EACC,4BAA4B;CAC7B;CACA;EACC,8BAA8B;CAC/B;CACA;EACC,eAAe;CAChB;CACA;;;EAGC,iBAAiB;CAClB;AACD;;AAEA;;CAEC;EACC,iBAAiB;CAClB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,eAAe;CAChB;CACA;EACC,cAAc;EACd,kBAAkB;CACnB;CACA;EACC,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;CACZ;CACA;EACC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;EAClB,gBAAgB;CACjB;CACA;EACC,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;EACd,eAAe;EACf,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,gCAAgC;EAChC,wBAAwB;EACxB,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,aAAa;CACd;CACA;EACC,sBAAsB;EACtB,+CAA+C;EAC/C,gDAAgD;EAChD,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,6BAA6B;EAC7B,qBAAqB;EACrB,iCAAiC;EACjC,yBAAyB;CAC1B;CACA;EACC,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;CACzB;CACA;EACC,cAAc;CACf;CACA;EACC,cAAc;CACf;CACA;EACC,aAAa;CACd;CACA;EACC,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;CAChB;CACA;EACC,UAAU;EACV,MAAM;EACN,gBAAgB;CACjB;CACA;EACC,cAAc;EACd,qBAAqB;EACrB,kBAAkB;CACnB;CACA;EACC,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,+CAA+C;CAChD;CACA;EACC,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;CACzB;CACA;EACC,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,wBAAwB;EACxB,cAAc;EACd,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;CAC5B;CACA;EACC,iBAAiB;CAClB;CACA;EACC,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,oBAAoB;CACrB;AACD;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;CACC;;EAEC,gBAAgB;CACjB;CACA;EACC,iBAAiB;EACjB,kBAAkB;CACnB;CACA;EACC,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;CACA;;EAEC,gBAAgB;CACjB;CACA;EACC,iBAAiB;EACjB,aAAa;EACb,cAAc;CACf;CACA;EACC,iBAAiB;EACjB,aAAa;EACb,cAAc;CACf;CACA;EACC,iBAAiB;EACjB,aAAa;EACb,cAAc;CACf;CACA;EACC,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;CACnB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,kBAAkB;CACnB;CACA;EACC,kBAAkB;EAClB,cAAc;CACf;CACA;EACC,qBAAqB;CACtB;CACA;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,UAAU;EACV,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;CACA;EACC,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,eAAe;CAChB;CACA;EACC,gCAAgC;EAChC,cAAc;CACf;CACA;EACC,cAAc;CACf;CACA;EACC,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,gBAAgB;CACjB;CACA;EACC,YAAY;EACZ,eAAe;CAChB;CACA;EACC,aAAa;EACb,WAAW;EACX,4BAA4B;CAC7B;CACA;EACC,4BAA4B;CAC7B;CACA;EACC,gBAAgB;CACjB;CACA;EACC,cAAc;CACf;CACA;EACC,cAAc;CACf;CACA;EACC,aAAa;CACd;CACA;EACC,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;EACpB,yBAAyB;CAC1B;CACA;EACC,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;CACd;CACA;EACC,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;CACrB;CACA;EACC,qBAAqB;CACtB;CACA;EACC,aAAa;CACd;CACA;EACC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,YAAY;CACb;CACA;EACC,aAAa;CACd;CACA;EACC,oBAAoB;CACrB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,eAAe;CAChB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,eAAe;CAChB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,gBAAgB;CACjB;CACA;;EAEC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,+DAA+D;EAC/D,WAAW;CACZ;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,UAAU;EACV,kBAAkB;CACnB;CACA;EACC,sBAAsB;EACtB,8BAA8B;EAC9B,oBAAoB;CACrB;CACA;EACC,cAAc;CACf;CACA;EACC,iBAAiB;CAClB;CACA;EACC,WAAW;CACZ;CACA;EACC,QAAQ;EACR,UAAU;EACV,mBAAmB;CACpB;CACA;EACC,WAAW;CACZ;CACA;EACC,eAAe;CAChB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,cAAc;CACf;CACA;EACC,gBAAgB;CACjB;CACA;EACC,mBAAmB;EACnB,eAAe;EACf,YAAY;CACb;CACA;EACC,mBAAmB;CACpB;CACA;EACC,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,oBAAoB;CACrB;CACA;EACC,eAAe;CAChB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,aAAa;CACd;CACA;EACC,WAAW;CACZ;CACA;EACC,qBAAqB;EACrB,gBAAgB;CACjB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,2BAA2B;CAC5B;CACA;EACC,cAAc;CACf;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,kBAAkB;EAClB,SAAS;CACV;CACA;EACC,cAAc;CACf;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,WAAW;CACZ;CACA;EACC,oBAAoB;CACrB;CACA;EACC,qBAAqB;CACtB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,YAAY;CACb;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,cAAc;EACd,eAAe;CAChB;AACD;;AAEA;CACC;;EAEC,eAAe;CAChB;CACA;;EAEC,kBAAkB;CACnB;CACA;;EAEC,mBAAmB;CACpB;CACA;;EAEC,eAAe;CAChB;CACA;;EAEC,mBAAmB;CACpB;CACA;;EAEC,kBAAkB;CACnB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;;EAEC,kBAAkB;EAClB,cAAc;CACf;CACA;EACC,gBAAgB;CACjB;CACA;EACC,YAAY;CACb;CACA;EACC,cAAc;EACd,aAAa;CACd;CACA;;EAEC,gBAAgB;CACjB;CACA;EACC,aAAa;CACd;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,gBAAgB;EAChB,cAAc;CACf;CACA;EACC,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;CAC5B;CACA;EACC,kBAAkB;EAClB,cAAc;EACd,WAAW;CACZ;CACA;EACC,kBAAkB;EAClB,cAAc;EACd,WAAW;CACZ;CACA;EACC,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;CACZ;CACA;EACC,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;CAC1B;CACA;EACC,mBAAmB;CACpB;CACA;EACC,eAAe;EACf,qBAAqB;CACtB;CACA;EACC,cAAc;CACf;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;EACf,kBAAkB;CACnB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,gBAAgB;CACjB;CACA;;;EAGC,eAAe;CAChB;CACA;EACC,YAAY;CACb;CACA;EACC,WAAW;CACZ;CACA;EACC,kBAAkB;CACnB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;CACjB;CACA;EACC,gBAAgB;EAChB,gBAAgB;CACjB;CACA;EACC,WAAW;CACZ;CACA;EACC,YAAY;EACZ,WAAW;CACZ;CACA;EACC,mBAAmB;CACpB;CACA;EACC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,eAAe;CAChB;CACA;EACC,WAAW;CACZ;CACA;EACC,WAAW;CACZ;CACA;EACC,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;CACZ;CACA;EACC,eAAe;CAChB;CACA;EACC,aAAa;EACb,YAAY;CACb;CACA;EACC,kBAAkB;CACnB;CACA;EACC,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;CACpB;CACA;;;EAGC,sBAAsB;EACtB,cAAc;CACf;CACA;EACC,0BAA0B;EAC1B,sBAAsB;EACtB,kBAAkB;CACnB;CACA;EACC,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;CAChB;CACA;EACC,0BAA0B;EAC1B,sBAAsB;CACvB;CACA;EACC,aAAa;CACd;CACA;EACC,mBAAmB;CACpB;CACA;EACC,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;CACtB;CACA;EACC,iBAAiB;EACjB,aAAa;EACb,cAAc;CACf;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;;;EAGC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,2BAA2B;CAC5B;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,UAAU;CACX;CACA;EACC,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,oBAAoB;CACrB;CACA;;EAEC,kBAAkB;CACnB;CACA;;EAEC,iBAAiB;CAClB;CACA;;EAEC,kBAAkB;CACnB;CACA;;EAEC,eAAe;CAChB;CACA;;EAEC,mBAAmB;CACpB;CACA;;EAEC,kBAAkB;CACnB;CACA;EACC,wBAAwB;CACzB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,uBAAuB;CACxB;CACA;EACC,uBAAuB;CACxB;CACA;EACC,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,cAAc;CACf;CACA;EACC,WAAW;CACZ;CACA;EACC,OAAO;EACP,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,WAAW;CACZ;CACA;EACC,WAAW;EACX,kBAAkB;EAClB,eAAe;CAChB;CACA;EACC,YAAY;CACb;CACA;EACC,cAAc;CACf;CACA;EACC,WAAW;EACX,cAAc;EACd,UAAU;CACX;CACA;EACC,WAAW;EACX,cAAc;EACd,UAAU;CACX;CACA;EACC,eAAe;CAChB;CACA;EACC,UAAU;CACX;CACA;EACC,iBAAiB;CAClB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,YAAY;CACb;CACA;EACC,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;CACd;CACA;EACC,mBAAmB;EACnB,eAAe;EACf,YAAY;CACb;CACA;EACC,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;CACd;CACA;EACC,mBAAmB;EACnB,eAAe;EACf,YAAY;CACb;CACA;EACC,qBAAqB;CACtB;CACA;EACC,YAAY;CACb;CACA;EACC,WAAW;CACZ;CACA;EACC,YAAY;EACZ,WAAW;CACZ;CACA;EACC,YAAY;EACZ,WAAW;CACZ;CACA;EACC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;CAClB;CACA;EACC,gBAAgB;EAChB,iBAAiB;CAClB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,eAAe;EACf,wBAAwB;CACzB;CACA;EACC,kBAAkB;EAClB,cAAc;EACd,eAAe;CAChB;CACA;EACC,eAAe;EACf,eAAe;CAChB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,YAAY;EACZ,WAAW;CACZ;CACA;EACC,wBAAwB;CACzB;CACA;EACC,WAAW;CACZ;CACA;EACC,gBAAgB;CACjB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,YAAY;EACZ,WAAW;CACZ;CACA;EACC,iBAAiB;CAClB;CACA;EACC,mBAAmB;EACnB,YAAY;EACZ,WAAW;CACZ;CACA;EACC,sBAAsB;CACvB;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,iBAAiB;EACjB,kBAAkB;CACnB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,YAAY;EACZ,aAAa;CACd;CACA;EACC,WAAW;CACZ;CACA;EACC,WAAW;EACX,mBAAmB;CACpB;CACA;EACC,WAAW;CACZ;CACA;;EAEC,gBAAgB;CACjB;CACA;;;EAGC,sBAAsB;EACtB,eAAe;CAChB;CACA;EACC,gBAAgB;EAChB,aAAa;CACd;CACA;EACC,mBAAmB;EACnB,WAAW;EACX,aAAa;CACd;CACA;EACC,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;CACf;CACA;EACC,kBAAkB;CACnB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,0BAA0B;EAC1B,sBAAsB;CACvB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,kBAAkB;EAClB,aAAa;EACb,YAAY;CACb;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,kBAAkB;EAClB,cAAc;CACf;CACA;EACC,cAAc;EACd,mBAAmB;CACpB;CACA;EACC,cAAc;CACf;CACA;EACC,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;AACD;;;;AAIA;CACC,gBAAgB;CAChB,MAAM;CACN,mBAAmB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;CACC,yBAAyB;AAC1B;;AAEA;;wBAEwB;;AAExB;IACI,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;AACX;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/*\r\nAuthor       : Dreamguys\r\nTemplate Name: Pathivu - Bootstrap Template\r\nVersion      : 1.0\r\n*/\r\n\r\n\r\n/*============================\r\n [Table of CSS]\r\n\r\n1. General\r\n2. Table\r\n3. Bootstrap Classes\r\n4. Avatar\r\n5. Select2\r\n6. Nav Tabs\r\n7. Components\r\n8. Focus Label\r\n9. Login\r\n10. Header\r\n11. Home\r\n12. Footer\r\n13. Mobile Menu\r\n14. Search\r\n15. advisors Profile\r\n16. Booking\r\n17. Checkout\r\n18. Booking Success\r\n19. Invoice View\r\n20. Schedule Timings\r\n21. advisors Dashboard\r\n22. Customer Profile\r\n23. Chat\r\n24. advisors Profile Settings\r\n25. Calendar\r\n26. Customer Dashboard\r\n27. Profile Settings\r\n28. Appoitment List\r\n29. Reviews\r\n30. Voice call\r\n31. Video Call\r\n32. Outgoing Call\r\n33. Incoming Call\r\n34. Terms and Conditions\r\n35. Blog\r\n36. Blog Details\r\n37. Blog Grid\r\n38. Map List & Grid\r\n39. Responsive\r\n40. Custom\r\n\r\n========================================*/\r\n\r\n\r\n/*-----------------\r\n\t1. General\r\n-----------------------*/\r\n\r\n@import url('https://fonts.googleapis.com/css?family=Plus+Jakarta+Sans:300,400,500,700,900');\r\n@import url('https://fonts.googleapis.com/css2?family=Patua+One&display=swap');\r\n/* Material Symbols Outlined */\r\n@font-face {\r\n    font-family: 'Material Symbols Outlined';\r\n    font-style: normal;\r\n    font-weight: 100 700;\r\n    src: url('../fonts/material-icons-outlined.woff2') format('woff2');\r\n    font-display: block;\r\n}\r\n.material-symbols-outlined {\r\n    font-family: 'Material Symbols Outlined';\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-size: 24px;\r\n    line-height: 1;\r\n    letter-spacing: normal;\r\n    text-transform: none;\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    word-wrap: normal;\r\n    direction: ltr;\r\n    -moz-font-feature-settings: 'liga';\r\n    -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n/* Material Icons Outlined */\r\n@font-face {\r\n    font-family: 'Material Icons Outlined';\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    src: url('../fonts/material-icons-outlined.woff2') format('woff2');\r\n    font-display: block;\r\n}\r\n.material-icons-outlined {\r\n    font-family: 'Material Icons Outlined';\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-size: 24px;\r\n    line-height: 1;\r\n    letter-spacing: normal;\r\n    text-transform: none;\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    word-wrap: normal;\r\n    direction: ltr;\r\n    -moz-font-feature-settings: 'liga';\r\n    -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Material Icons';\r\n    font-style: normal;\r\n    font-weight: 100 700;\r\n    src: url('../fonts/material-icons.woff2') format('woff2');\r\n    font-display: block;\r\n}\r\n\r\n.material-icons {\r\n    font-family: 'Material Icons';\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-size: 24px;\r\n    line-height: 1;\r\n    letter-spacing: normal;\r\n    text-transform: none;\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    word-wrap: normal;\r\n    direction: ltr;\r\n    -moz-font-feature-settings: 'liga';\r\n    -moz-osx-font-smoothing: grayscale;\r\n} \r\n\r\nhtml {\r\n\theight: 100%;\r\n}\r\n\r\nbody {\r\n\tbackground-color: #fff;\r\n\tcolor: #505050;\r\n\tfont-family: \"Plus Jakarta Sans\", sans-serif;\r\n\t/* font-size: 0.9375rem; */\r\n\theight: 100%;\r\n\toverflow-x: hidden;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n\tcolor: #505050;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.h1,\r\nh1 {\r\n\tfont-size: 2.25rem;\r\n}\r\n\r\n.h2,\r\nh2 {\r\n\tfont-size: 1.875rem;\r\n}\r\n\r\n.h3,\r\nh3 {\r\n\tfont-size: 1.5rem;\r\n}\r\n\r\n.h4,\r\nh4 {\r\n\tfont-size: 1.125rem;\r\n}\r\n\r\n.h5,\r\nh5 {\r\n\tfont-size: 1rem;\r\n}\r\n\r\n.h6,\r\nh6 {\r\n\tfont-size: 0.875rem;\r\n}\r\n\r\na {\r\n\tcolor: #2E3842;\r\n}\r\n\r\na:hover {\r\n\tcolor: #e5bd54;\r\n}\r\na,\r\na:hover,\r\na:active,\r\na:focus {\r\n\toutline: none;\r\n\ttext-decoration: none;\r\n}\r\n\r\ninput:-webkit-autofill,\r\ninput:-webkit-autofill:hover,\r\ninput:-webkit-autofill:focus {\r\n\t-webkit-box-shadow: 0 0 0px 1000px white inset !important;\r\n}\r\n\r\ninput,\r\nbutton,\r\na {\r\n\ttransition: all 0.4s ease;\r\n\t-moz-transition: all 0.4s ease;\r\n\t-o-transition: all 0.4s ease;\r\n\t-ms-transition: all 0.4s ease;\r\n\t-webkit-transition: all 0.4s ease;\r\n}\r\n\r\nul {\r\n\tpadding: 0;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\np:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\nbutton:focus {\r\n\toutline: 0;\r\n}\r\n\r\ninput[type=text],\r\ninput[type=password] {\r\n\t-webkit-appearance: none;\r\n\t-moz-appearance: none;\r\n\tappearance: none;\r\n}\r\n\r\n.container-fluid {\r\n    padding-left: 30px;\r\n    padding-right: 30px;\r\n}\r\n\r\n.btn, .btn * {\r\n    cursor: pointer;\r\n}\r\n\r\n.btn.focus,\r\n.btn:focus {\r\n\tbox-shadow: inherit;\r\n}\r\n\r\n.btn.disabled, .btn.disabled *\r\n.btn:disabled, .btn:disabled * {\r\n\tcursor: default;\r\n}\r\n\r\n.form-control {\r\n\tborder-color: #dcdcdc;\r\n\tcolor: #333;\r\n\tfont-size: 15px;\r\n\tmin-height: 46px;\r\n\tpadding: 6px 15px;\r\n}\r\n\r\n.table .form-control {\r\n\tfont-size: 14px;\r\n\tmin-height: 38px;\r\n}\r\n\r\n.form-control::-webkit-input-placeholder {\r\n\tcolor: #858585;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.form-control::-moz-placeholder {\r\n\tcolor: #858585;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.form-control:-ms-input-placeholder {\r\n\tcolor: #858585;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.form-control::-ms-input-placeholder {\r\n\tcolor: #858585;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.form-control::placeholder {\r\n\tcolor: #858585;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.list-group-item {\r\n\tborder: 1px solid #f0f0f0;\r\n}\r\n\r\n.content {\r\n\tmin-height: 70vh;\r\n\tpadding: 40px 0 0;\r\n    margin-top: 6rem;\r\n}\r\n\r\nfigure {\r\n\tmargin: 0;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t2. Table\r\n-----------------------*/\r\n\r\n.table {\r\n\tcolor: #272b41;\r\n\tmax-width: 100%;\r\n\tmargin-bottom: 0;\r\n\twidth: 100%;\r\n}\r\n\r\n.table-striped > tbody > tr:nth-of-type(2n+1) {\r\n\tbackground-color: #f8f9fa;\r\n}\r\n\r\n.table.no-border > tbody > tr > td,\r\n.table > tbody > tr > th,\r\n.table.no-border > tfoot > tr > td,\r\n.table.no-border > tfoot > tr > th,\r\n.table.no-border > thead > tr > td,\r\n.table.no-border > thead > tr > th {\r\n\tborder-top: 0;\r\n\tpadding: 10px 8px;\r\n}\r\n\r\n.table-nowrap td,\r\n.table-nowrap th {\r\n\twhite-space: nowrap\r\n}\r\n\r\n.table.dataTable {\r\n\tborder-collapse: collapse !important;\r\n}\r\n\r\ntable.table td h2 {\r\n\tdisplay: inline-block;\r\n\tfont-size: inherit;\r\n\tfont-weight: 400;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tvertical-align: middle;\r\n}\r\n\r\ntable.table td h2.table-avatar {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\tfont-size: inherit;\r\n\tfont-weight: 400;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tvertical-align: middle;\r\n\twhite-space: nowrap;\r\n}\r\n\r\ntable.table td h2 a {\r\n\tcolor: #272b41;\r\n}\r\n\r\ntable.table td h2 a:hover {\r\n\tcolor: #e5bd54;\r\n}\r\n\r\ntable.table td h2 span {\r\n\tcolor: #888;\r\n\tdisplay: block;\r\n\tfont-size: 12px;\r\n\tmargin-top: 3px;\r\n}\r\n\r\n.table thead {\r\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.03);\r\n}\r\n\r\n.table thead tr th {\r\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.table tbody tr {\r\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.table tbody tr:last-child {\r\n\tborder-color: transparent;\r\n}\r\n\r\n.table.table-center td,\r\n.table.table-center th {\r\n\tvertical-align: middle;\r\n}\r\n\r\n.table-hover tbody tr:hover {\r\n\tbackground-color: #f7f7f7;\r\n}\r\n\r\n.table-hover tbody tr:hover td {\r\n\tcolor: #474648;\r\n}\r\n\r\n.table-striped thead tr {\r\n\tborder-color: transparent;\r\n}\r\n\r\n.table-striped tbody tr {\r\n\tborder-color: transparent;\r\n}\r\n\r\n.table-striped tbody tr:nth-of-type(even) {\r\n\tbackground-color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.table-striped tbody tr:nth-of-type(odd) {\r\n\tbackground-color: rgba(235, 235, 235, 0.4);\r\n}\r\n\r\n.table-bordered {\r\n\tborder: 1px solid rgba(0, 0, 0, 0.05) !important;\r\n}\r\n\r\n.table-bordered th,\r\n.table-bordered td {\r\n\tborder-color: rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.card-table .card-body {\r\n\tpadding: 0;\r\n}\r\n\r\n.card-table .card-body .table > thead > tr > th {\r\n\tborder-top: 0;\r\n}\r\n\r\n.card-table .table tr td:first-child,\r\n.card-table .table tr th:first-child {\r\n\tpadding-left: 1.5rem;\r\n}\r\n\r\n.card-table .table tr td:last-child,\r\n.card-table .table tr th:last-child {\r\n\tpadding-right: 1.5rem;\r\n}\r\n\r\n.card-table .table td,\r\n.card-table .table th {\r\n\tborder-top: 1px solid #e2e5e8;\r\n\tpadding: 1rem 0.75rem;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t3. Bootstrap Classes\r\n-----------------------*/\r\n\r\n.btn.focus,\r\n.btn:focus {\r\n\tbox-shadow: unset;\r\n}\r\n\r\n.btn-white {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #ccc;\r\n\tcolor: #272b41;\r\n}\r\n\r\n.btn.btn-rounded {\r\n\tborder-radius: 50px;\r\n}\r\n\r\n.bg-primary,\r\n.badge-primary {\r\n\tbackground-color: #e5bd54 !important;\r\n}\r\n\r\na.bg-primary:focus,\r\na.bg-primary:hover,\r\nbutton.bg-primary:focus,\r\nbutton.bg-primary:hover {\r\n\tbackground-color: #e5bd54 !important;\r\n}\r\n\r\n.bg-success,\r\n.badge-success {\r\n\tbackground-color: #00e65b !important;\r\n}\r\n\r\na.bg-success:focus,\r\na.bg-success:hover,\r\nbutton.bg-success:focus,\r\nbutton.bg-success:hover {\r\n\tbackground-color: #00cc52 !important;\r\n}\r\n\r\n.bg-info,\r\n.badge-info {\r\n\tbackground-color: #009efb !important;\r\n}\r\n\r\na.bg-info:focus,\r\na.bg-info:hover,\r\nbutton.bg-info:focus,\r\nbutton.bg-info:hover {\r\n\tbackground-color: #028ee1 !important;\r\n}\r\n\r\n.bg-warning,\r\n.badge-warning {\r\n\tbackground-color: #ffbc34 !important;\r\n}\r\n\r\na.bg-warning:focus,\r\na.bg-warning:hover,\r\nbutton.bg-warning:focus,\r\nbutton.bg-warning:hover {\r\n\tbackground-color: #e9ab2e !important;\r\n}\r\n\r\n.bg-danger,\r\n.badge-danger {\r\n\tbackground-color: #ff0100 !important;\r\n}\r\n\r\na.bg-danger:focus,\r\na.bg-danger:hover,\r\nbutton.bg-danger:focus,\r\nbutton.bg-danger:hover {\r\n\tbackground-color: #e63333 !important;\r\n}\r\n\r\n.bg-white {\r\n\tbackground-color: #fff;\r\n}\r\n\r\n.bg-purple,\r\n.badge-purple {\r\n\tbackground-color: #9368e9 !important;\r\n}\r\n\r\n.text-primary,\r\n.dropdown-menu > li > a.text-primary {\r\n\tcolor: #e5bd54 !important;\r\n}\r\n\r\n.text-success,\r\n.dropdown-menu > li > a.text-success {\r\n\tcolor: #00cc52 !important;\r\n}\r\n\r\n.text-danger,\r\n.dropdown-menu > li > a.text-danger {\r\n\tcolor: #ff0100 !important;\r\n}\r\n\r\n.text-info,\r\n.dropdown-menu > li > a.text-info {\r\n\tcolor: #009efb !important;\r\n}\r\n\r\n.text-warning,\r\n.dropdown-menu > li > a.text-warning {\r\n\tcolor: #ffbc34 !important;\r\n}\r\n\r\n.text-purple,\r\n.dropdown-menu > li > a.text-purple {\r\n\tcolor: #7460ee !important;\r\n}\r\n\r\n.text-muted {\r\n\tcolor: #757575 !important;\r\n}\r\n\r\n.text-light {\r\n    color: #edeeef\r\n}\r\n\r\na.text-light:focus,a.text-light:hover{color:#cbd3da}\r\n\r\n.btn-primary {\r\n\tbackground-color: #e5bd54;\r\n\tborder: 1px solid #e5bd54;\r\n}\r\n\r\n.btn-primary:hover,\r\n.btn-primary:focus,\r\n.btn-primary.active,\r\n.btn-primary:active,\r\n.open > .dropdown-toggle.btn-primary {\r\n\tbackground-color: #e6b230;\r\n\tborder: 1px solid #e6b230;\r\n}\r\n\r\n.btn-primary.active.focus,\r\n.btn-primary.active:focus,\r\n.btn-primary.active:hover,\r\n.btn-primary.focus:active,\r\n.btn-primary:active:focus,\r\n.btn-primary:active:hover,\r\n.open > .dropdown-toggle.btn-primary.focus,\r\n.open > .dropdown-toggle.btn-primary:focus,\r\n.open > .dropdown-toggle.btn-primary:hover {\r\n\tbackground-color: #e5bd54;\r\n\tborder: 1px solid #e5bd54;\r\n}\r\n\r\n.btn-primary.active:not(:disabled):not(.disabled),\r\n.btn-primary:active:not(:disabled):not(.disabled),\r\n.show > .btn-primary.dropdown-toggle {\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n\tcolor: #fff;\r\n}\r\n\r\n.btn-primary.active:focus:not(:disabled):not(.disabled),\r\n.btn-primary:active:focus:not(:disabled):not(.disabled),\r\n.show > .btn-primary.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n}\r\n\r\n.btn-primary.disabled,\r\n.btn-primary:disabled {\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n\tcolor: #fff;\r\n}\r\n\r\n/* .btn-secondary:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n}\r\n\r\n.btn-secondary.active:focus:not(:disabled):not(.disabled),\r\n.btn-secondary:active:focus:not(:disabled):not(.disabled),\r\n.show > .btn-secondary.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n} */\r\n\r\n/* .btn-success {\r\n\tbackground-color: #00e65b;\r\n\tborder: 1px solid #00e65b\r\n}\r\n\r\n.btn-success:hover,\r\n.btn-success:focus,\r\n.btn-success.active,\r\n.btn-success:active,\r\n.open > .dropdown-toggle.btn-success {\r\n\tbackground-color: #00cc52;\r\n\tborder: 1px solid #00cc52;\r\n\tcolor: #fff;\r\n}\r\n\r\n.btn-success.active.focus,\r\n.btn-success.active:focus,\r\n.btn-success.active:hover,\r\n.btn-success.focus:active,\r\n.btn-success:active:focus,\r\n.btn-success:active:hover,\r\n.open > .dropdown-toggle.btn-success.focus,\r\n.open > .dropdown-toggle.btn-success:focus,\r\n.open > .dropdown-toggle.btn-success:hover {\r\n\tbackground-color: #00cc52;\r\n\tborder: 1px solid #00cc52\r\n}\r\n\r\n.btn-success.active:not(:disabled):not(.disabled),\r\n.btn-success:active:not(:disabled):not(.disabled),\r\n.show > .btn-success.dropdown-toggle {\r\n\tbackground-color: #00cc52;\r\n\tborder-color: #00cc52;\r\n\tcolor: #fff;\r\n}\r\n\r\n.btn-success.active:focus:not(:disabled):not(.disabled),\r\n.btn-success:active:focus:not(:disabled):not(.disabled),\r\n.show > .btn-success.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n}\r\n\r\n.btn-success.disabled,\r\n.btn-success:disabled {\r\n\tbackground-color: #00e65b;\r\n\tborder-color: #00e65b;\r\n\tcolor: #fff;\r\n}\r\n\r\n.btn-info {\r\n\tbackground-color: #009efb;\r\n\tborder: 1px solid #009efb\r\n}\r\n\r\n.btn-info:hover,\r\n.btn-info:focus,\r\n.btn-info.active,\r\n.btn-info:active,\r\n.open > .dropdown-toggle.btn-info {\r\n\tbackground-color: #028ee1;\r\n\tborder: 1px solid #028ee1\r\n}\r\n\r\n.btn-info.active.focus,\r\n.btn-info.active:focus,\r\n.btn-info.active:hover,\r\n.btn-info.focus:active,\r\n.btn-info:active:focus,\r\n.btn-info:active:hover,\r\n.open > .dropdown-toggle.btn-info.focus,\r\n.open > .dropdown-toggle.btn-info:focus,\r\n.open > .dropdown-toggle.btn-info:hover {\r\n\tbackground-color: #028ee1;\r\n\tborder: 1px solid #028ee1\r\n}\r\n\r\n.btn-info.active:not(:disabled):not(.disabled),\r\n.btn-info:active:not(:disabled):not(.disabled),\r\n.show > .btn-info.dropdown-toggle {\r\n\tbackground-color: #028ee1;\r\n\tborder-color: #028ee1;\r\n\tcolor: #fff;\r\n}\r\n\r\n.btn-info.active:focus:not(:disabled):not(.disabled),\r\n.btn-info:active:focus:not(:disabled):not(.disabled),\r\n.show > .btn-info.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n}\r\n\r\n.btn-info.disabled,\r\n.btn-info:disabled {\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n\tcolor: #fff;\r\n}\r\n\r\n.btn-warning {\r\n\tbackground-color: #ffbc34;\r\n\tborder: 1px solid #ffbc34\r\n}\r\n\r\n.btn-warning:hover,\r\n.btn-warning:focus,\r\n.btn-warning.active,\r\n.btn-warning:active,\r\n.open > .dropdown-toggle.btn-warning {\r\n\tbackground-color: #e9ab2e;\r\n\tborder: 1px solid #e9ab2e\r\n}\r\n\r\n.btn-warning.active.focus,\r\n.btn-warning.active:focus,\r\n.btn-warning.active:hover,\r\n.btn-warning.focus:active,\r\n.btn-warning:active:focus,\r\n.btn-warning:active:hover,\r\n.open > .dropdown-toggle.btn-warning.focus,\r\n.open > .dropdown-toggle.btn-warning:focus,\r\n.open > .dropdown-toggle.btn-warning:hover {\r\n\tbackground-color: #e9ab2e;\r\n\tborder: 1px solid #e9ab2e\r\n}\r\n\r\n.btn-warning.active:not(:disabled):not(.disabled),\r\n.btn-warning:active:not(:disabled):not(.disabled),\r\n.show > .btn-warning.dropdown-toggle {\r\n\tbackground-color: #e9ab2e;\r\n\tborder-color: #e9ab2e;\r\n\tcolor: #fff;\r\n}\r\n\r\n.btn-warning.active:focus:not(:disabled):not(.disabled),\r\n.btn-warning:active:focus:not(:disabled):not(.disabled),\r\n.show > .btn-warning.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n}\r\n\r\n.btn-warning.disabled,\r\n.btn-warning:disabled {\r\n\tbackground-color: #ffbc34;\r\n\tborder-color: #ffbc34;\r\n\tcolor: #fff;\r\n}\r\n\r\n.btn-danger {\r\n\tbackground-color: #ff0100;\r\n\tborder: 1px solid #ff0100;\r\n}\r\n\r\n.btn-danger:hover,\r\n.btn-danger:focus,\r\n.btn-danger.active,\r\n.btn-danger:active,\r\n.open > .dropdown-toggle.btn-danger {\r\n\tbackground-color: #e63333;\r\n\tborder: 1px solid #e63333;\r\n}\r\n\r\n.btn-danger.active.focus,\r\n.btn-danger.active:focus,\r\n.btn-danger.active:hover,\r\n.btn-danger.focus:active,\r\n.btn-danger:active:focus,\r\n.btn-danger:active:hover,\r\n.open > .dropdown-toggle.btn-danger.focus,\r\n.open > .dropdown-toggle.btn-danger:focus,\r\n.open > .dropdown-toggle.btn-danger:hover {\r\n\tbackground-color: #e63333;\r\n\tborder: 1px solid #e63333;\r\n}\r\n\r\n.btn-danger.active:not(:disabled):not(.disabled),\r\n.btn-danger:active:not(:disabled):not(.disabled),\r\n.show > .btn-danger.dropdown-toggle {\r\n\tbackground-color: #e63333;\r\n\tborder-color: #e63333;\r\n\tcolor: #fff;\r\n}\r\n\r\n.btn-danger.active:focus:not(:disabled):not(.disabled),\r\n.btn-danger:active:focus:not(:disabled):not(.disabled),\r\n.show > .btn-danger.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n}\r\n\r\n.btn-danger.disabled,\r\n.btn-danger:disabled {\r\n\tbackground-color: #f62d51;\r\n\tborder-color: #f62d51;\r\n\tcolor: #fff;\r\n}\r\n\r\n.btn-light.active:focus:not(:disabled):not(.disabled),\r\n.btn-light:active:focus:not(:disabled):not(.disabled),\r\n.show > .btn-light.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n}\r\n\r\n.btn-dark.active:focus:not(:disabled):not(.disabled),\r\n.btn-dark:active:focus:not(:disabled):not(.disabled),\r\n.show > .btn-dark.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n}\r\n*/\r\n\r\n.btn-outline-primary {\r\n\tcolor: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n}\r\n\r\n.btn-outline-primary:hover {\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n}\r\n\r\n.btn-outline-primary:focus,\r\n.btn-outline-primary.focus {\r\n\tbox-shadow: none;\r\n}\r\n\r\n.btn-outline-primary.disabled,\r\n.btn-outline-primary:disabled {\r\n\tcolor: #e5bd54;\r\n\tbackground-color: transparent;\r\n}\r\n\r\n.btn-outline-primary:not(:disabled):not(.disabled):active,\r\n.btn-outline-primary:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-primary.dropdown-toggle {\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n}\r\n\r\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-primary:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-primary.dropdown-toggle:focus {\r\n\tbox-shadow: none;\r\n}\r\n\r\n/*\r\n.btn-outline-success {\r\n\tcolor: #00e65b;\r\n\tborder-color: #00e65b;\r\n}\r\n\r\n.btn-outline-success:hover {\r\n\tbackground-color: #00e65b;\r\n\tborder-color: #00e65b;\r\n}\r\n\r\n.btn-outline-success:focus,\r\n.btn-outline-success.focus {\r\n\tbox-shadow: none;\r\n}\r\n\r\n.btn-outline-success.disabled,\r\n.btn-outline-success:disabled {\r\n\tcolor: #00e65b;\r\n\tbackground-color: transparent;\r\n}\r\n\r\n.btn-outline-success:not(:disabled):not(.disabled):active,\r\n.btn-outline-success:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-success.dropdown-toggle {\r\n\tbackground-color: #00e65b;\r\n\tborder-color: #00e65b;\r\n}\r\n\r\n.btn-outline-success:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-success:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-success.dropdown-toggle:focus {\r\n\tbox-shadow: none;\r\n}\r\n\r\n.btn-outline-info {\r\n\tcolor: #009efb;\r\n\tborder-color: #009efb;\r\n}\r\n\r\n.btn-outline-info:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #009efb;\r\n\tborder-color: #009efb;\r\n}\r\n\r\n.btn-outline-info:focus,\r\n.btn-outline-info.focus {\r\n\tbox-shadow: none;\r\n}\r\n\r\n.btn-outline-info.disabled,\r\n.btn-outline-info:disabled {\r\n\tbackground-color: transparent;\r\n\tcolor: #009efb;\r\n}\r\n\r\n.btn-outline-info:not(:disabled):not(.disabled):active,\r\n.btn-outline-info:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-info.dropdown-toggle {\r\n\tbackground-color: #009efb;\r\n\tborder-color: #009efb;\r\n}\r\n\r\n.btn-outline-info:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-info:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-info.dropdown-toggle:focus {\r\n\tbox-shadow: none;\r\n}\r\n\r\n.btn-outline-warning {\r\n\tcolor: #ffbc34;\r\n\tborder-color: #ffbc34;\r\n}\r\n\r\n.btn-outline-warning:hover {\r\n\tcolor: #212529;\r\n\tbackground-color: #ffbc34;\r\n\tborder-color: #ffbc34;\r\n}\r\n\r\n.btn-outline-warning:focus,\r\n.btn-outline-warning.focus {\r\n\tbox-shadow: none;\r\n}\r\n\r\n.btn-outline-warning.disabled,\r\n.btn-outline-warning:disabled {\r\n\tbackground-color: transparent;\r\n\tcolor: #ffbc34;\r\n}\r\n\r\n.btn-outline-warning:not(:disabled):not(.disabled):active,\r\n.btn-outline-warning:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-warning.dropdown-toggle {\r\n\tcolor: #212529;\r\n\tbackground-color: #ffbc34;\r\n\tborder-color: #ffbc34;\r\n}\r\n\r\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-warning:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-warning.dropdown-toggle:focus {\r\n\tbox-shadow: none;\r\n}\r\n\r\n.btn-outline-danger {\r\n\tcolor: #ff0100;\r\n\tborder-color: #ff0100;\r\n}\r\n\r\n.btn-outline-danger:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #ff0100;\r\n\tborder-color: #ff0100;\r\n}\r\n\r\n.btn-outline-danger:focus,\r\n.btn-outline-danger.focus {\r\n\tbox-shadow: none;\r\n}\r\n\r\n.btn-outline-danger.disabled,\r\n.btn-outline-danger:disabled {\r\n\tbackground-color: transparent;\r\n\tcolor: #ff0100;\r\n}\r\n\r\n.btn-outline-danger:not(:disabled):not(.disabled):active,\r\n.btn-outline-danger:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-danger.dropdown-toggle {\r\n\tbackground-color: #ff0100;\r\n\tborder-color: #ff0100;\r\n}\r\n\r\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-danger:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-danger.dropdown-toggle:focus {\r\n\tbox-shadow: none;\r\n}\r\n\r\n.btn-outline-light {\r\n\tcolor: #ababab;\r\n\tborder-color: #e6e6e6;\r\n}\r\n\r\n.btn-outline-light.disabled,\r\n.btn-outline-light:disabled {\r\n\tcolor: #ababab;\r\n} */\r\n\r\n.pagination > .active > a,\r\n.pagination > .active > a:focus,\r\n.pagination > .active > a:hover,\r\n.pagination > .active > span,\r\n.pagination > .active > span:focus,\r\n.pagination > .active > span:hover {\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n}\r\n\r\n.pagination > li > a,\r\n.pagination > li > span {\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.page-link:hover {\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.page-link:focus {\r\n\tbox-shadow: unset;\r\n}\r\n\r\n.page-item.active .page-link {\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n}\r\n\r\n.dropdown-menu {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid rgba(0, 0, 0, 0.1);\r\n\tborder-radius: 3px;\r\n\tbox-shadow: inherit;\r\n\tfont-size: 14px;\r\n\ttransform-origin: left top 0;\r\n}\r\n\r\n.dropdown-item.active,\r\n.dropdown-item:active {\r\n\tbackground-color: #e8ba3f;\r\n}\r\n\r\n.dropdown-menu.show {\r\n    display: block;\r\n    z-index: 99999;\r\n}\r\n\r\n.navbar-nav .open .dropdown-menu {\r\n\tborder: 0;\r\n\tbox-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n\tbackground-color: #fff;\r\n}\r\n\r\n.card {\r\n\tbox-shadow: 0px 2px 8px rgb(183 183 183 / 25%);\r\n\tmargin-bottom: 1.875rem;\r\n\tborder: 0;\r\n}\r\n\r\n.card-body {\r\n\tpadding: 1.5rem;\r\n}\r\n\r\n.card-title {\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.card-header {\r\n\tborder-bottom: 1px solid #f0f0f0;\r\n\tpadding: 1rem 1.5rem;\r\n}\r\n\r\n.card-footer {\r\n\tbackground-color: #fff;\r\n\tborder-top: 1px solid #f0f0f0;\r\n\tpadding: 1rem 1.5rem;\r\n}\r\n\r\n.card .card-header {\r\n\tbackground-color: #fff;\r\n\tborder-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.card .card-header .card-title {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.btn-light {\r\n\tborder-color: #e6e6e6;\r\n\tcolor: #a6a6a6;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.active,\r\n.bootstrap-datetimepicker-widget table td.active:hover {\r\n\tbackground-color: #e5bd54;\r\n\ttext-shadow: unset;\r\n}\r\n\r\n.bootstrap-datetimepicker-widget table td.today::before {\r\n\tborder-bottom-color: #e5bd54;\r\n}\r\n\r\n.bg-secondary-light {\r\n\tbackground-color: rgba(129, 129, 129, 0.12) !important;\r\n\tcolor: #474747 !important;\r\n}\r\n\r\n.bg-info-light {\r\n\tbackground-color: rgba(2, 182, 179, 0.12) !important;\r\n\tcolor: #1db9aa !important;\r\n}\r\n\r\n.bg-primary-light {\r\n\tbackground-color: rgba(17, 148, 247, 0.12) !important;\r\n\tcolor: #2196f3 !important;\r\n}\r\n\r\n.bg-danger-light {\r\n\tbackground-color: rgba(242, 17, 54, 0.12) !important;\r\n\tcolor: #e63c3c !important;\r\n}\r\n\r\n.bg-warning-light {\r\n\tbackground-color: rgba(255, 152, 0, 0.12) !important;\r\n\tcolor: #f39c12 !important;\r\n}\r\n\r\n.bg-success-light {\r\n\tbackground-color: rgba(15, 183, 107, 0.12) !important;\r\n\tcolor: #26af48 !important;\r\n}\r\n\r\n.bg-purple-light {\r\n\tbackground-color: rgba(197, 128, 255, 0.12) !important;\r\n\tcolor: #c580ff !important;\r\n}\r\n\r\n.bg-default-light {\r\n\tbackground-color: rgba(40, 52, 71, 0.12) !important;\r\n\tcolor: #283447 !important;\r\n}\r\n\r\n.text-xs {\r\n\tfont-size: .75rem !important;\r\n}\r\n\r\n.text-sm {\r\n\tfont-size: .875rem !important;\r\n}\r\n\r\n.text-md {\r\n    font-size: 1rem !important;\r\n}\r\n\r\n.text-lg {\r\n\tfont-size: 1.25rem !important;\r\n}\r\n\r\n.text-xl {\r\n\tfont-size: 1.5rem !important;\r\n}\r\n\r\n.form-control:focus {\r\n\tborder-color: #bbb;\r\n\tbox-shadow: none;\r\n\toutline: 0 none;\r\n}\r\n\r\n.form-group {\r\n\tmargin-bottom: 1.25rem;\r\n}\r\n\r\n.custom-control-input:checked ~ .custom-control-label.custom-control-primary::before {\r\n    color: #fff;\r\n    border-color: #e6b230;\r\n    background-color: #e6b230;\r\n}\r\n\r\n.custom-control-input:focus ~ .custom-control-label.custom-control-primary::before {\r\n    box-shadow: 0 0 0 .2rem rgba(230,178,48,.25);\r\n}\r\n\r\n.custom-control-input:focus:not(:checked) ~ .custom-control-label.custom-control-primary::before {\r\n    border-color: #e5bd54;\r\n}\r\n\r\n.custom-control-input:not(:disabled):active ~ .custom-control-label.custom-control-primary::before {\r\n    color: #fff;\r\n    background-color: #ebd295;\r\n    border-color: #ebd295;\r\n}\r\n\r\n#alertModal {\r\n    z-index: 1060; /* higher so it stacks above */\r\n}\r\n\r\n.modal-backdrop + .modal-backdrop {\r\n    z-index: 1055; /* adjust backdrop layering */\r\n}\r\n\r\n/*-----------------\r\n\t4. Avatar\r\n-----------------------*/\r\n\r\n.avatar {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\twidth: 3rem;\r\n\theight: 3rem\r\n}\r\n\r\n.avatar > img {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\t-o-object-fit: cover;\r\n\tobject-fit: cover;\r\n}\r\n\r\n.avatar-title {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground-color: #e5bd54;\r\n\tcolor: #fff;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\t-ms-flex-pack: center;\r\n}\r\n\r\n.avatar-away::before,\r\n.avatar-offline::before,\r\n.avatar-online::before {\r\n\tposition: absolute;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\twidth: 25%;\r\n\theight: 25%;\r\n\tborder-radius: 50%;\r\n\tcontent: '';\r\n\tborder: 2px solid #fff;\r\n}\r\n\r\n.avatar-online::before {\r\n\tbackground-color: #00e65b;\r\n}\r\n\r\n.avatar-offline::before {\r\n\tbackground-color: #ff0100;\r\n}\r\n\r\n.avatar-away::before {\r\n\tbackground-color: #ffbc34;\r\n}\r\n\r\n.avatar .border {\r\n\tborder-width: 3px !important;\r\n}\r\n\r\n.avatar .rounded {\r\n\tborder-radius: 6px !important;\r\n}\r\n\r\n.avatar .avatar-title {\r\n\tfont-size: 18px;\r\n}\r\n\r\n.avatar-xs {\r\n\twidth: 1.65rem;\r\n\theight: 1.65rem;\r\n}\r\n\r\n.avatar-xs .border {\r\n\tborder-width: 2px !important;\r\n}\r\n\r\n.avatar-xs .rounded {\r\n\tborder-radius: 4px !important;\r\n}\r\n\r\n.avatar-xs .avatar-title {\r\n\tfont-size: 12px;\r\n}\r\n\r\n.avatar-xs.avatar-away::before,\r\n.avatar-xs.avatar-offline::before,\r\n.avatar-xs.avatar-online::before {\r\n\tborder-width: 1px;\r\n}\r\n\r\n.avatar-sm {\r\n\twidth: 2.5rem;\r\n\theight: 2.5rem;\r\n}\r\n\r\n.avatar-sm .border {\r\n\tborder-width: 3px !important;\r\n}\r\n\r\n.avatar-sm .rounded {\r\n\tborder-radius: 4px !important;\r\n}\r\n\r\n.avatar-sm .avatar-title {\r\n\tfont-size: 15px;\r\n}\r\n\r\n.avatar-sm.avatar-away::before,\r\n.avatar-sm.avatar-offline::before,\r\n.avatar-sm.avatar-online::before {\r\n\tborder-width: 2px;\r\n}\r\n\r\n.avatar-lg {\r\n\twidth: 3.75rem;\r\n\theight: 3.75rem;\r\n}\r\n\r\n.avatar-lg .border {\r\n\tborder-width: 3px !important;\r\n}\r\n\r\n.avatar-lg .rounded {\r\n\tborder-radius: 8px !important;\r\n}\r\n\r\n.avatar-lg .avatar-title {\r\n\tfont-size: 24px;\r\n}\r\n\r\n.avatar-lg.avatar-away::before,\r\n.avatar-lg.avatar-offline::before,\r\n.avatar-lg.avatar-online::before {\r\n\tborder-width: 3px;\r\n}\r\n\r\n.avatar-xl {\r\n\twidth: 5rem;\r\n\theight: 5rem;\r\n}\r\n\r\n.avatar-xl .border {\r\n\tborder-width: 4px !important;\r\n}\r\n\r\n.avatar-xl .rounded {\r\n\tborder-radius: 8px !important;\r\n}\r\n\r\n.avatar-xl .avatar-title {\r\n\tfont-size: 28px;\r\n}\r\n\r\n.avatar-xl.avatar-away::before,\r\n.avatar-xl.avatar-offline::before,\r\n.avatar-xl.avatar-online::before {\r\n\tborder-width: 4px;\r\n}\r\n\r\n.avatar-xxl {\r\n\twidth: 5.125rem;\r\n\theight: 5.125rem;\r\n}\r\n\r\n.avatar-xxl .border {\r\n\tborder-width: 6px !important;\r\n}\r\n\r\n.avatar-xxl .rounded {\r\n\tborder-radius: 8px !important;\r\n}\r\n\r\n.avatar-xxl .avatar-title {\r\n\tfont-size: 30px;\r\n}\r\n\r\n.avatar-xxl.avatar-away::before,\r\n.avatar-xxl.avatar-offline::before,\r\n.avatar-xxl.avatar-online::before {\r\n\tborder-width: 4px;\r\n}\r\n\r\n.avatar-group {\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n}\r\n\r\n.avatar-group .avatar+.avatar {\r\n\tmargin-left: -.75rem;\r\n}\r\n\r\n.avatar-group .avatar-xs+.avatar-xs {\r\n\tmargin-left: -.40625rem;\r\n}\r\n\r\n.avatar-group .avatar-sm+.avatar-sm {\r\n\tmargin-left: -.625rem;\r\n}\r\n\r\n.avatar-group .avatar-lg+.avatar-lg {\r\n\tmargin-left: -1rem;\r\n}\r\n\r\n.avatar-group .avatar-xl+.avatar-xl {\r\n\tmargin-left: -1.28125rem;\r\n}\r\n\r\n.avatar-group .avatar:hover {\r\n\tz-index: 1;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t5. Select2\r\n-----------------------*/\r\n\r\n.select2-results__option {\r\n\tpadding: 6px 15px;\r\n}\r\n\r\n.select2-container .select2-selection--single {\r\n\tborder: 1px solid #dcdcdc;\r\n\theight: 46px;\r\n}\r\n\r\n.select2-container--default .select2-selection--single .select2-selection__arrow {\r\n\theight: 44px;\r\n\tright: 7px;\r\n}\r\n\r\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\r\n\tborder-color: #dcdcdc transparent transparent;\r\n\tborder-style: solid;\r\n\tborder-width: 6px 6px 0;\r\n\theight: 0;\r\n\tleft: 50%;\r\n\tmargin-left: -10px;\r\n\tmargin-top: -2px;\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\twidth: 0;\r\n}\r\n\r\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\r\n\tborder-color: transparent transparent #dcdcdc;\r\n\tborder-width: 0 6px 6px;\r\n}\r\n\r\n.select2-container .select2-selection--single .select2-selection__rendered {\r\n\tpadding-right: 30px;\r\n\tpadding-left: 15px;\r\n}\r\n\r\n.select2-container--default .select2-selection--single .select2-selection__rendered {\r\n\tcolor: #272b41;\r\n\tfont-size: 15px;\r\n\tfont-weight: normal;\r\n\tline-height: 44px;\r\n}\r\n\r\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\r\n\tbackground-color: #e5bd54;\r\n}\r\n\r\n.select2-container--default .select2-selection--multiple {\r\n\tborder: 1px solid #dcdcdc;\r\n\tmin-height: 46px;\r\n}\r\n\r\n.select2-dropdown {\r\n\tborder-color: #dcdcdc;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t6. Nav Tabs\r\n-----------------------*/\r\n\r\n.nav-tabs {\r\n\tborder-bottom: none;\r\n}\r\n\r\n.card-header-tabs {\r\n\tborder-bottom: 0;\r\n}\r\n\r\n.nav-tabs > li > a {\r\n\tmargin-right: 0;\r\n\tcolor: #888;\r\n\tborder-radius: 0;\r\n}\r\n\r\n.nav-tabs > li > a:hover,\r\n.nav-tabs > li > a:focus {\r\n\tborder-color: transparent;\r\n\tcolor: #272b41;\r\n}\r\n\r\n.nav-tabs.nav-tabs-solid > li > a {\r\n\tcolor: #272b41;\r\n}\r\n\r\n.nav-tabs.nav-tabs-solid > .active > a,\r\n.nav-tabs.nav-tabs-solid > .active > a:hover,\r\n.nav-tabs.nav-tabs-solid > .active > a:focus {\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n\tcolor: #fff;\r\n}\r\n\r\n.tab-content {\r\n\tpadding-top: 20px;\r\n}\r\n\r\n.nav-tabs .nav-link {\r\n\tborder-radius: 0;\r\n}\r\n\r\n.nav-tabs .nav-link:focus,\r\n.nav-tabs .nav-link:hover {\r\n\tborder-color: transparent;\r\n    border-bottom: 2px solid #b8b8b8;\r\n\tcolor: #272b41;\r\n}\r\n\r\n.nav-tabs.nav-justified > li > a {\r\n\tborder-radius: 0;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.nav-tabs.nav-justified > li > a:hover,\r\n.nav-tabs.nav-justified > li > a:focus {\r\n\tborder-bottom-color: #b8b8b8;\r\n}\r\n\r\n.nav-tabs.nav-justified.nav-tabs-solid > li > a {\r\n\tborder-color: transparent;\r\n}\r\n\r\n.nav-tabs.nav-tabs-solid > li > a {\r\n\tcolor: #272b41;\r\n}\r\n\r\n.nav-tabs.nav-tabs-solid > li > a.active,\r\n.nav-tabs.nav-tabs-solid > li > a.active:hover,\r\n.nav-tabs.nav-tabs-solid > li > a.active:focus {\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n\tcolor: #fff;\r\n}\r\n\r\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded {\r\n\tborder-radius: 50px;\r\n}\r\n\r\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a {\r\n\tborder-radius: 50px;\r\n}\r\n\r\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,\r\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,\r\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {\r\n\tborder-radius: 5px;\r\n}\r\n\r\n.nav-tabs-justified > li > a {\r\n\tborder-radius: 0;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.nav-tabs-justified > li > a:hover,\r\n.nav-tabs-justified > li > a:focus {\r\n\tborder-bottom-color: #ddd;\r\n}\r\n\r\n.nav-tabs-justified.nav-tabs-solid > li > a {\r\n\tborder-color: transparent;\r\n}\r\n\r\n.nav-tabs.nav-justified.nav-tabs-top {\r\n\tborder-bottom: 1px solid #ddd;\r\n}\r\n\r\n.nav-tabs.nav-justified.nav-tabs-top > li > a,\r\n.nav-tabs.nav-justified.nav-tabs-top > li > a:hover,\r\n.nav-tabs.nav-justified.nav-tabs-top > li > a:focus {\r\n\tborder-width: 2px 0 0 0;\r\n}\r\n\r\n.nav-tabs.nav-tabs-top > li {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.nav-tabs.nav-tabs-top > li > a,\r\n.nav-tabs.nav-tabs-top > li > a:hover,\r\n.nav-tabs.nav-tabs-top > li > a:focus {\r\n\tborder-width: 2px 0 0 0;\r\n}\r\n\r\n.nav-tabs.nav-tabs-top > li.open > a,\r\n.nav-tabs.nav-tabs-top > li > a:hover,\r\n.nav-tabs.nav-tabs-top > li > a:focus {\r\n\tborder-top-color: #ddd;\r\n}\r\n\r\n.nav-tabs.nav-tabs-top > li+li > a {\r\n\tmargin-left: 1px;\r\n}\r\n\r\n.nav-tabs.nav-tabs-top > li > a.active,\r\n.nav-tabs.nav-tabs-top > li > a.active:hover,\r\n.nav-tabs.nav-tabs-top > li > a.active:focus {\r\n\tborder-top-color: #e5bd54;\r\n}\r\n\r\n.nav-tabs.nav-tabs-bottom > li > a.active,\r\n.nav-tabs.nav-tabs-bottom > li > a.active:hover,\r\n.nav-tabs.nav-tabs-bottom > li > a.active:focus {\r\n\tborder-bottom-width: 2px;\r\n\tborder-color: transparent;\r\n\tborder-bottom-color: #e5bd54;\r\n\tbackground-color: transparent;\r\n\ttransition: none 0s ease 0s;\r\n\t-moz-transition: none 0s ease 0s;\r\n\t-o-transition: none 0s ease 0s;\r\n\t-ms-transition: none 0s ease 0s;\r\n\t-webkit-transition: none 0s ease 0s;\r\n}\r\n\r\n.nav-tabs.nav-tabs-solid {\r\n\tbackground-color: #fafafa;\r\n\tborder: 0;\r\n}\r\n\r\n.nav-tabs.nav-tabs-solid > li {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.nav-tabs.nav-tabs-solid > li > a {\r\n\tborder-color: transparent;\r\n}\r\n\r\n.nav-tabs.nav-tabs-solid > li > a:hover,\r\n.nav-tabs.nav-tabs-solid > li > a:focus {\r\n\tbackground-color: #f5f5f5;\r\n}\r\n\r\n.nav-tabs.nav-tabs-solid > .open:not(.active) > a {\r\n\tbackground-color: #f5f5f5;\r\n\tborder-color: transparent;\r\n}\r\n\r\n.nav-tabs-justified.nav-tabs-top {\r\n\tborder-bottom: 1px solid #ddd;\r\n}\r\n\r\n.nav-tabs-justified.nav-tabs-top > li > a,\r\n.nav-tabs-justified.nav-tabs-top > li > a:hover,\r\n.nav-tabs-justified.nav-tabs-top > li > a:focus {\r\n\tborder-width: 2px 0 0 0;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t7. Components\r\n-----------------------*/\r\n\r\n.comp-header {\r\n\tmargin-bottom: 1.875rem;\r\n}\r\n\r\n.comp-header .comp-title {\r\n\tcolor: #272b41;\r\n}\r\n\r\n.line {\r\n\tbackground-color: #e5bd54;\r\n\theight: 2px;\r\n\tmargin: 0;\r\n\twidth: 60px;\r\n}\r\n\r\n.comp-buttons .btn {\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n.pagination-box .pagination {\r\n\tmargin-top: 0;\r\n}\r\n\r\n.comp-dropdowns .btn-group {\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n.progress-example .progress {\r\n\tmargin-bottom: 1.5rem;\r\n}\r\n\r\n.progress-xs {\r\n\theight: 4px;\r\n}\r\n\r\n.progress-sm {\r\n\theight: 15px;\r\n}\r\n\r\n.progress.progress-sm {\r\n\theight: 6px;\r\n}\r\n\r\n.progress.progress-md {\r\n\theight: 8px;\r\n}\r\n\r\n.progress.progress-lg {\r\n\theight: 18px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t8. Focus Label\r\n-----------------------*/\r\n\r\n.form-focus {\r\n\theight: 50px;\r\n\tposition: relative;\r\n}\r\n\r\n.form-focus .focus-label {\r\n\tfont-size: 14px;\r\n\tfont-weight: 400;\r\n\tpointer-events: none;\r\n\tposition: absolute;\r\n\t-webkit-transform: translate3d(0, 22px, 0) scale(1);\r\n\t-ms-transform: translate3d(0, 22px, 0) scale(1);\r\n\t-o-transform: translate3d(0, 22px, 0) scale(1);\r\n\ttransform: translate3d(0, 22px, 0) scale(1);\r\n\ttransform-origin: left top;\r\n\ttransition: 240ms;\r\n\tleft: 12px;\r\n\ttop: -8px;\r\n\tz-index: 1;\r\n\tcolor: #b8b8b8;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.form-focus.focused .focus-label {\r\n\topacity: 1;\r\n\ttop: -18px;\r\n\tfont-size: 12px;\r\n\tz-index: 1;\r\n}\r\n\r\n.form-focus .form-control:focus~.focus-label,\r\n.form-focus .form-control:-webkit-autofill~.focus-label {\r\n\topacity: 1;\r\n\tfont-weight: 400;\r\n\ttop: -18px;\r\n\tfont-size: 12px;\r\n\tz-index: 1;\r\n}\r\n\r\n.form-focus .form-control {\r\n\theight: 50px;\r\n\tpadding: 21px 12px 6px;\r\n}\r\n\r\n.form-focus .form-control::-webkit-input-placeholder {\r\n\tcolor: transparent;\r\n\ttransition: 240ms;\r\n}\r\n\r\n.form-focus .form-control:focus::-webkit-input-placeholder {\r\n\ttransition: none;\r\n}\r\n\r\n.form-focus.focused .form-control::-webkit-input-placeholder {\r\n\tcolor: #bbb;\r\n}\r\n\r\n.form-focus.select-focus .focus-label {\r\n\topacity: 1;\r\n\tfont-weight: 300;\r\n\ttop: -20px;\r\n\tfont-size: 12px;\r\n\tz-index: 1;\r\n}\r\n\r\n.form-focus .select2-container .select2-selection--single {\r\n\tborder: 1px solid #e3e3e3;\r\n\theight: 50px;\r\n}\r\n\r\n.form-focus .select2-container--default .select2-selection--single .select2-selection__arrow {\r\n\theight: 48px;\r\n\tright: 7px;\r\n}\r\n\r\n.form-focus .select2-container--default .select2-selection--single .select2-selection__arrow b {\r\n\tborder-color: #ccc transparent transparent;\r\n\tborder-style: solid;\r\n\tborder-width: 6px 6px 0;\r\n\theight: 0;\r\n\tleft: 50%;\r\n\tmargin-left: -10px;\r\n\tmargin-top: -2px;\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\twidth: 0;\r\n}\r\n\r\n.form-focus .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\r\n\tborder-color: transparent transparent #ccc;\r\n\tborder-width: 0 6px 6px;\r\n}\r\n\r\n.form-focus .select2-container .select2-selection--single .select2-selection__rendered {\r\n\tpadding-right: 30px;\r\n\tpadding-left: 12px;\r\n\tpadding-top: 10px;\r\n}\r\n\r\n.form-focus .select2-container--default .select2-selection--single .select2-selection__rendered {\r\n\tcolor: #676767;\r\n\tfont-size: 14px;\r\n\tfont-weight: normal;\r\n\tline-height: 38px;\r\n}\r\n\r\n.form-focus .select2-container--default .select2-results__option--highlighted[aria-selected] {\r\n\tbackground-color: #fc6075;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t9. Login\r\n-----------------------*/\r\n\r\n.account-page {\r\n\tbackground-color: #fff;\r\n}\r\n\r\n.account-page .content {\r\n\tpadding: 50px 0;\r\n}\r\n\r\n.login-right {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #f0f0f0;\r\n\tborder-radius: 4px;\r\n\tpadding: 25px;\r\n}\r\n\r\n.login-header {\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.login-header p {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.login-header h3 {\r\n\tfont-size: 18px;\r\n\tmargin-bottom: 3px;\r\n}\r\n\r\n.login-header h3 a {\r\n\tcolor: #e8ba3f;\r\n\tfloat: right;\r\n\tfont-size: 15px;\r\n\tmargin-top: 2px;\r\n}\r\n\r\n.login-right .dont-have {\r\n\tcolor: #3d3d3d;\r\n\tmargin-top: 20px;\r\n\tfont-size: 13px;\r\n}\r\n\r\n.login-right .dont-have a {\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.login-btn {\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.login-or {\r\n\tcolor: #c8c8c8;\r\n\tmargin-bottom: 20px;\r\n\tmargin-top: 20px;\r\n\tpadding-bottom: 10px;\r\n\tpadding-top: 10px;\r\n\tposition: relative;\r\n}\r\n\r\n.or-line {\r\n\tbackground-color: #ddd;\r\n\theight: 1px;\r\n\tmargin-bottom: 0;\r\n\tmargin-top: 0;\r\n\tdisplay: block;\r\n}\r\n\r\n.span-or {\r\n\tbackground-color: #fff;\r\n\tdisplay: block;\r\n\tleft: 50%;\r\n\tmargin-left: -20px;\r\n\tposition: absolute;\r\n\ttext-align: center;\r\n\ttop: -3px;\r\n\twidth: 42px;\r\n}\r\n\r\n.forgot-link {\r\n\tcolor: #3d3d3d;\r\n\tdisplay: inline-block;\r\n\tfont-size: 13px;\r\n\tmargin-bottom: 10px;\r\n\tfont-weight: 400;\r\n}\r\n\r\n.btn-facebook {\r\n\tbackground-color: #3a559f;\r\n\tcolor: #fff;\r\n\tfont-size: 13px;\r\n\tpadding: 8px 12px;\r\n}\r\n\r\n.btn-google {\r\n\tbackground-color: #dd4b39;\r\n\tcolor: #fff;\r\n\tfont-size: 13px;\r\n\tpadding: 8px 12px;\r\n}\r\n\r\n.social-login .btn:hover,\r\n.social-login .btn:focus {\r\n\tcolor: #fff;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t10. Header\r\n-----------------------*/\r\n\r\n.header-nav {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tbackground-color: #13563A;\r\n\tborder: 0;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\tjustify-content: space-between;\r\n\t-webkit-justify-content: space-between;\r\n\t-ms-flex-pack: space-between;\r\n\tposition: relative;\r\n\tpadding: 10px 30px;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.home .header-trans {\r\n\tposition: fixed !important;\r\n}\r\n\r\n.header-trans {\r\n\tdisplay: block;\r\n\twidth: 100%;\r\n    position: relative;\r\n\tz-index: 9999;\r\n\theight: 75px;\r\n\ttransition: all 0.5s ease;\r\n\t-webkit-transition: all 0.5s ease;\r\n\t-ms-transition: all 0.5s ease;\r\n}\r\n\r\n.header-trans .header-nav {\r\n\tbackground: #13563A;\r\n}\r\n.home .header-trans .header-nav {\r\n\tbackground: transparent;\r\n}\r\n\r\n.main-nav {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.main-nav > li.active > a {\r\n\tcolor: #E5BD54 !important;\r\n}\r\n\r\n.main-nav > li.active > a:before {\r\n    content: '';\r\n    position: absolute;\r\n    background: url(../img/active-menu.png);\r\n    bottom: 0;\r\n    top: 0;\r\n    left: 35%;\r\n    right: 0;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.main-nav > li .submenu li a {\r\n\tdisplay: block;\r\n\tpadding: 10px 15px;\r\n\tclear: both;\r\n\twhite-space: nowrap;\r\n\tfont-size: 14px;\r\n\tcolor: #2d3b48;\r\n\t-webkit-transition: all .35s ease;\r\n\ttransition: all .35s ease;\r\n\twidth: 100%;\r\n\tborder-top: 1px solid #f0f0f0;\r\n}\r\n\r\n.main-nav > li .submenu > li.has-submenu > a::after {\r\n\tcontent: \"\\f054\";\r\n\tfont-family: \"Font Awesome 5 Free\";\r\n\tfont-weight: 900;\r\n\tposition: absolute;\r\n\tright: 15px;\r\n\ttop: 12px;\r\n\tfont-size: 13px;\r\n}\r\n\r\n.vibrate {\r\n    display: inline-block;\r\n    animation: vibrate 0.5s ease infinite;\r\n}\r\n\r\n/* Vibration effect */\r\n@keyframes vibrate {\r\n    0% { transform: translateX(0); }\r\n    25% { transform: translateX(-1px); }\r\n    50% { transform: translateX(1px); }\r\n    75% { transform: translateX(-1px); }\r\n    100% { transform: translateX(1px); }\r\n}\r\n\r\n.main-nav > li .submenu li {\r\n\tposition: relative;\r\n}\r\n\r\n.main-nav li a {\r\n\tdisplay: block;\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.main-nav li .submenu::before {\r\n    display: none !important;\r\n}\r\n\r\n.main-nav.bg-trans li a {\r\n\tdisplay: block;\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n\tcolor: #ffffff;\r\n}\r\n\r\n.main-nav li.login-link {\r\n\tdisplay: none;\r\n}\r\n\r\n.logo {\r\n\tdisplay: inline-block;\r\n\tmargin-right: 30px;\r\n\tmax-width: 75px;\r\n}\r\n\r\n.main-menu-wrapper {\r\n\tmargin-left: auto;\r\n}\r\n\r\n.header-contact-img {\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.header-contact-img i {\r\n\tcolor: rgba(0, 0, 0, 0.5);\r\n\tfont-size: 30px;\r\n}\r\n\r\n.header-contact-detail {\r\n\tdisplay: inline-block;\r\n\tpadding-left: 10px;\r\n}\r\n\r\n.header-contact-detail p.contact-header {\r\n\tcolor: #484848;\r\n\tfont-size: 13px;\r\n\tfont-weight: 400;\r\n\tmargin-bottom: 2px;\r\n\ttext-align: left;\r\n}\r\n\r\n.header-contact-detail p.contact-info-header {\r\n\tcolor: #000;\r\n\tfont-weight: 500;\r\n\tfont-size: 14px;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.header-navbar-rht {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.header-navbar-rht li {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\t-ms-flex-pack: center;\r\n\tmargin-left: 15px;\r\n}\r\n\r\n.header-navbar-rht li:last-child {\r\n\tpadding-right: 0px;\r\n}\r\n\r\n.header-navbar-rht li .dropdown-menu {\r\n\tborder: 0;\r\n\tbox-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.header-navbar-rht .dropdown-toggle::after {\r\n\tdisplay: none;\r\n}\r\n\r\n.header-navbar-rht li .dropdown-menu::before {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\ttop: 2px;\r\n\tright: 0;\r\n\tborder: 7px solid #fff;\r\n\tborder-color: transparent transparent #ffffff #ffffff;\r\n\t-webkit-transform-origin: 0 0;\r\n\ttransform-origin: 0 0;\r\n\t-webkit-transform: rotate(135deg);\r\n\ttransform: rotate(135deg);\r\n\tbox-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.header-navbar-rht li .dropdown-menu .dropdown-item {\r\n\tborder-top: 1px solid #f0f0f0;\r\n\tpadding: 10px 15px;\r\n}\r\n\r\n.header-navbar-rht li .dropdown-menu .dropdown-item:first-child {\r\n\tborder-top: 0;\r\n\tborder-radius: 5px 5px 0 0;\r\n}\r\n\r\n.header-navbar-rht li .dropdown-menu .dropdown-item:last-child {\r\n\tborder-radius: 0 0 5px 5px;\r\n}\r\n\r\n.header-navbar-rht li a.header-login:hover {\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n\tcolor: #fff;\r\n}\r\n\r\n.header-navbar-rht li .dropdown-menu a:hover {\r\n\tcolor: #e5bd54;\r\n\tletter-spacing: 0.5px;\r\n\tpadding-left: 20px;\r\n\tbackground-color: #fff;\r\n}\r\n\r\n.header-navbar-rht li a.header-login {\r\n\tborder: 2px solid #e5bd54;\r\n\tborder-radius: 4px;\r\n\tpadding: 10px 15px !important;\r\n\ttext-align: center;\r\n\tfont-size: 15px;\r\n\tcolor: #e5bd54;\r\n\ttext-transform: uppercase;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.header .has-arrow .dropdown-toggle:after {\r\n\tborder-top: 0;\r\n\tborder-left: 0;\r\n\tborder-bottom: 2px solid #757575;\r\n\tborder-right: 2px solid #757575;\r\n\tcontent: '';\r\n\theight: 8px;\r\n\tdisplay: inline-block;\r\n\tpointer-events: none;\r\n\t-webkit-transform-origin: 66% 66%;\r\n\t-ms-transform-origin: 66% 66%;\r\n\ttransform-origin: 66% 66%;\r\n\t-webkit-transform: rotate(45deg);\r\n\t-ms-transform: rotate(45deg);\r\n\ttransform: rotate(45deg);\r\n\t-webkit-transition: all 0.15s ease-in-out;\r\n\ttransition: all 0.15s ease-in-out;\r\n\twidth: 8px;\r\n\tvertical-align: 2px;\r\n\tmargin-left: 10px;\r\n}\r\n\r\n.header .has-arrow .dropdown-toggle[aria-expanded=\"true\"]:after {\r\n\t-webkit-transform: rotate(-135deg);\r\n\t-ms-transform: rotate(-135deg);\r\n\ttransform: rotate(-135deg);\r\n}\r\n\r\n.user-menu {\r\n\tfloat: right;\r\n\tmargin: 0;\r\n\tposition: relative;\r\n\tz-index: 99;\r\n}\r\n\r\n.user-menu.nav > li > a {\r\n\tcolor: #fff;\r\n\tfont-size: 14px;\r\n\tline-height: 58px;\r\n\tpadding: 0 15px;\r\n\theight: 60px;\r\n}\r\n\r\n.user-menu.nav > li > a:hover,\r\n.user-menu.nav > li > a:focus {\r\n\tbackground-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.user-menu.nav > li > a:hover i,\r\n.user-menu.nav > li > a:focus i {\r\n\tcolor: #fff;\r\n}\r\n\r\n.user-img {\r\n\tdisplay: inline-block;\r\n\tposition: relative;\r\n}\r\n\r\n.user-img > img {\r\n\theight: 31px;\r\n\tobject-fit: cover;\r\n\twidth: 31px;\r\n}\r\n\r\n.user-menu.nav > li > a.mobile_btn {\r\n\tborder: 0;\r\n\tposition: relative;\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tcursor: pointer\r\n}\r\n\r\n.header-navbar-rht .dropdown-menu {\r\n\tmin-width: 200px;\r\n\tpadding: 0;\r\n}\r\n\r\n.header-navbar-rht .dropdown-menu .dropdown-item {\r\n\tpadding: 7px 15px;\r\n}\r\n\r\n.header-navbar-rht .dropdown-menu .dropdown-item {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tborder-top: 1px solid #e3e3e3;\r\n\tpadding: 10px 15px;\r\n}\r\n\r\n.header-navbar-rht .dropdown-menu .dropdown-item:hover {\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.user-header {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tpadding: 10px 15px;\r\n}\r\n\r\n.user-header .user-text {\r\n\tmargin-left: 10px;\r\n}\r\n\r\n.user-header .user-text h6 {\r\n\tfont-size: 15px;\r\n\tmargin-bottom: 2px;\r\n}\r\n\r\n.header-navbar-rht .logged-item .nav-link {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\tfont-size: 14px;\r\n\tline-height: 60px;\r\n\tpadding: 0 10px;\r\n}\r\n\r\n.togglesearch {\r\n\tposition: absolute;\r\n\ttop: 74px;\r\n\tright: 8%;\r\n\twidth: 280px;\r\n\tborder-top: 4px solid #e5bd54;\r\n\tdisplay: none;\r\n\tz-index: 999;\r\n\tbackground: #fff;\r\n\tpadding: 0 10px;\r\n\tborder-radius: 5px;\r\n\tbox-shadow: 0px 2px 8px rgb(183 183 183 / 25%);\r\n}\r\n\r\n.togglesearch:before {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\ttop: -30px;\r\n\tright: 13px;\r\n\tborder-left: 12px solid transparent;\r\n\tborder-right: 12px solid transparent;\r\n\tborder-top: 14px solid transparent;\r\n\tborder-bottom: 14px solid #e5bd54;\r\n}\r\n\r\n.togglesearch input[type=\"text\"] {\r\n\twidth: 182px;\r\n\tpadding: 5px 10px;\r\n\tborder: 1px solid #e5bd54;\r\n\toutline: none;\r\n\theight: 40px;\r\n\tborder-radius: 5px 0 0 5px;\r\n}\r\n\r\n.togglesearch button {\r\n\twidth: 80px;\r\n\tpadding: 5px 0;\r\n\tbackground: #e5bd54;\r\n\tcolor: #fff;\r\n\tmargin-left: -6px;\r\n\tborder: 1px solid #e5bd54;\r\n\toutline: none;\r\n\tcursor: pointer;\r\n\theight: 41px;\r\n\tborder-radius: 0 5px 5px 0;\r\n}\r\n\r\n.dropdown-item img {\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.nav-item > a {\r\n\tcolor: #fff;\r\n}\r\n\r\n.nav-book-content span {\r\n\tfont-weight: 500;\r\n\tcolor: #fff;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.nav-book-content p {\r\n\tcolor: #e5bd54;\r\n\tfont-weight: 500;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.nav-booking {\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tborder-radius: 50%;\r\n\tbackground: #e5bd54;\r\n\ttext-align: center;\r\n\tpadding: 3px;\r\n}\r\n\r\n.nav-item i {\r\n\tcolor: #fff;\r\n}\r\n\r\n.contact-item {\r\n\tbackground: #E5BD54;\r\n\tpadding: 0 15px !important;\r\n\tbox-shadow: -2px 2px 4px rgba(5, 90, 190, 0.1);\r\n\tborder-radius: 5px;\r\n\tfont-size: 12px;\r\n\theight: 45px;\r\n}\r\n\r\n.cart-item img {\r\n\tpadding: 10px 9px 8px 2px;\r\n}\r\n\r\n.cart-item {\r\n\twidth: 35px;\r\n    height: 35px;\r\n    background: #e5bd54;\r\n    border-radius: 50%;\r\n    margin: auto;\r\n    padding: 5px;\r\n}\r\n\r\n.header-top {\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\tbackground: #E5BD54;\r\n\tcolor: #fff;\r\n\tpadding: 8px 30px;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\tz-index: 999;\r\n\theight: 32px;\r\n}\r\n\r\n.header-top a:hover {\r\n\tcolor: #000;\r\n}\r\n\r\n.header-top ul {\r\n\tdisplay: flex;\r\n\tmargin: 0;\r\n\tlist-style: none;\r\n}\r\n\r\n.header-top .left-top ul li {\r\n\tfont-size: 12px;\r\n}\r\n\r\n.header-top .left-top ul li:last-child {\r\n\tpadding-right: 0;\r\n}\r\n\r\n.header-top .right-top ul li {\r\n\tpadding-left: 25px;\r\n\tfont-size: 13px;\r\n}\r\n\r\n.header-top .right-top ul li a {\r\n\tcolor: #fff;\r\n}\r\n\r\n.header-top .right-top {\r\n\tfloat: right;\r\n}\r\n\r\n.top-icon {\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.header-top .nav-link {\r\n\tpadding: 0;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t11. Home\r\n-----------------------*/\r\n\r\n.banner-section {\r\n\tposition: relative;\r\n\tbackground: url(../img/banner2.jpg);\r\n\tbackground-position: 50% 0;\r\n\tbackground-size: cover;\r\n\tbackground-repeat: no-repeat;\r\n\tz-index: 1;\r\n}\r\n\r\n.banner-top:after {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\tbackground: rgba(0, 0, 0, 0.6);\r\n\ttop: 0;\r\n\tright: 0;\r\n\tleft: 0;\r\n\tbottom: 0;\r\n\tz-index: -1;\r\n}\r\n\r\n.banner-content img {\r\n\tmargin-bottom: 25px;\r\n\twidth: 135px;\r\n}\r\n\r\n.banner-content {\r\n\tmax-width: 740px;\r\n\tmargin: auto;\r\n\tpadding: 185px 0 160px;\r\n\ttext-align: center;\r\n}\r\n\r\n.banner-content h4 {\r\n\tfont-size: 26px;\r\n\tfont-weight: 600;\r\n\tcolor: #fff;\r\n}\r\n\r\n.banner-content p {\r\n\tfont-size: 15px;\r\n\tcolor: #fff;\r\n\tmargin-bottom: 2rem;\r\n\tline-height: 30px;\r\n}\r\n\r\n.banner-content h2 {\r\n\tfont-size: 44px;\r\n\tfont-weight: 400;\r\n\tcolor: #FFCF53;\r\n\tfont-family: 'Patua One', cursive;\r\n}\r\n\r\n.banner-primary:hover {\r\n\tbackground: #13563A;\r\n\tcolor: #fff;\r\n\tborder: 1px solid #13563A;\r\n}\r\n\r\n.banner-primary {\r\n\tpadding: 15px 30px;\r\n\tbackground: #E5BD54;\r\n\tborder: 1px solid #E5BD54;\r\n\tborder-radius: 0;\r\n\tcolor: #fff;\r\n\tfont-weight: 400;\r\n\tfont-size: 15px;\r\n}\r\n\r\n/* .btn-secondary {\r\n\tpadding: 15px 30px;\r\n\tbackground: #13563A;\r\n\tborder: 1px solid #13563A;\r\n\tborder-radius: 0;\r\n\tcolor: #fff;\r\n\tfont-weight: 400;\r\n\tfont-size: 15px;\r\n}\r\n\r\n.btn-secondary:hover {\r\n\tbackground: #fff;\r\n\tborder: 1px solid #13563A;\r\n\tcolor: #13563A\r\n}\r\n\r\n.btn-secondary-outline {\r\n\tbackground: #F8F8F8;\r\n\tborder: 2px solid #D9B03E;\r\n\tpadding: 5px 10px;\r\n\tcolor: #13563A;\r\n\tborder-radius: 0;\r\n\twidth: 100%;\r\n\tfont-size: 16px;\r\n\tfont-family: 'Patua One', cursive;\r\n} */\r\n\r\n.banner-white-outline {\r\n\tpadding: 15px 30px;\r\n\tborder: 1px solid #FFFFFF;\r\n\tborder-radius: 0;\r\n\tcolor: #fff;\r\n\tfont-weight: 400;\r\n\tfont-size: 15px;\r\n}\r\n\r\n.banner-white-outline:hover {\r\n\tpadding: 15px 30px;\r\n\tborder: 1px solid #FFFFFF;\r\n\tbackground: #FFFFFF;\r\n\tborder-radius: 0;\r\n\tcolor: #212529;\r\n\tfont-weight: 400;\r\n\tfont-size: 15px;\r\n}\r\n\r\n.features-box {\r\n\tposition: relative;\r\n}\r\n\r\n.features-img {\r\n\tposition: relative;\r\n}\r\n\r\n.features-img:after, .feature-video:after {\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tbackground: rgba(25, 25, 25, 0.7);\r\n}\r\n\r\n.features-img:after {\r\n    background: rgba(0, 0, 0, 0.45)\r\n}\r\n\r\n.features-border {\r\n\tposition: absolute;\r\n\tborder: 1px solid #CC9400;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tmargin: 20px;\r\n}\r\n\r\n.features-text {\r\n\tbottom: 30px;\r\n\tleft: 10px;\r\n\tposition: absolute;\r\n}\r\n\r\n.features-text h2 {\r\n\tfont-size: 20px;\r\n\tfont-weight: 400;\r\n\tcolor: #FFCF53;\r\n\tfont-family: 'Patua One', cursive;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.features-text p {\r\n\tfont-size: 17px;\r\n\tcolor: #fff;\r\n}\r\n\r\n.features-arrow {\r\n\tbottom: 45px;\r\n\tright: 10px;\r\n\tposition: absolute;\r\n\tdisplay: none;\r\n}\r\n\r\n.features-border:hover .features-arrow {\r\n\tdisplay: block;\r\n}\r\n\r\n.features-arrow i {\r\n\tborder: 1px solid #ffffff;\r\n\tbackground: #ffffff;\r\n\tborder-radius: 50%;\r\n\twidth: 25px;\r\n\tcolor: #e5bd54;\r\n\theight: 25px;\r\n\tline-height: 23px;\r\n\tfont-size: 12px;\r\n\ttext-align: center;\r\n}\r\n\r\n.features-border:hover {\r\n\tbackground: #cc9400;\r\n}\r\n\r\n.features-border:hover h2 {\r\n\tcolor: #fff;\r\n}\r\n\r\n.section-heading {\r\n\tposition: relative;\r\n\tpadding-bottom: 50px;\r\n\twidth: 575px;\r\n\tmargin: auto;\r\n}\r\n\r\n.fields-section .section-heading {\r\n\tpadding-bottom: 8px;\r\n}\r\n\r\n.section-heading img {\r\n\twidth: 22px;\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n.section-heading h2 {\r\n\tcolor: #13563A;\r\n\tfont-family: 'Patua One', cursive;\r\n\tfont-size: 32px;\r\n\tfont-weight: 400;\r\n}\r\n\r\n.section-heading p {\r\n\tcolor: #545454;\r\n\tfont-size: 13px;\r\n}\r\n\r\n.coaching-section {\r\n\tpadding: 175px 0 50px;\r\n}\r\n\r\n.coaching-text h2 {\r\n\tcolor: #13563A;\r\n\tfont-family: 'Patua One', cursive;\r\n\tfont-size: 22px;\r\n\tfont-weight: 400;\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.coaching-text img {\r\n\twidth: 55px;\r\n}\r\n\r\n.coaching-text p {\r\n\tcolor: #232323;\r\n\tfont-size: 13px;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.golf-img-1 {\r\n\tmargin-top: -50px;\r\n}\r\n\r\n.feature-card {\r\n\tbox-shadow: 0px 2px 8px rgba(39, 39, 39, 0.25);\r\n\tborder-radius: 10px;\r\n\tpadding: 20px;\r\n\tbackground: #fff;\r\n}\r\n\r\n.feature-head p {\r\n\tcolor: rgba(19, 74, 86, 0.1);\r\n\tfont-family: 'Patua One', cursive;\r\n\tfont-size: 46px;\r\n}\r\n\r\n.feature-head img {\r\n\twidth: auto;\r\n\theight: 55px;\r\n}\r\n\r\n.feature-head {\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.feature-body h2 {\r\n\tfont-size: 20px;\r\n\tcolor: #000;\r\n\tmargin: 0;\r\n}\r\n\r\n.features-section {\r\n\tposition: relative;\r\n\tbackground: url(../img/bg.jpg);\r\n\tbackground-position: 50% 0;\r\n\tbackground-size: cover;\r\n\tbackground-repeat: no-repeat;\r\n\tpadding: 50px 0;\r\n\tbackground-blend-mode: multiply;\r\n\tz-index: 1;\r\n}\r\n\r\n.features-section:after {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\tbackground: rgba(224, 181, 65, 0.95);\r\n\ttop: 0;\r\n\tright: 0;\r\n\tleft: 0;\r\n\tbottom: 0;\r\n\tz-index: -1;\r\n}\r\n\r\n.field-body h2 {\r\n\tcolor: #CC9400;\r\n\tfont-size: 18px;\r\n}\r\n\r\n.field-body span {\r\n\tcolor: #13563A;\r\n\tfont-size: 16px;\r\n\tfont-family: 'Patua One', cursive;\r\n}\r\n\r\n.fields-section {\r\n\tpadding: 50px 0;\r\n\tbackground: rgba(255, 250, 236, 0.6)\r\n}\r\n\r\n.field-row {\r\n\t-ms-flex: 0 0 20%;\r\n\tflex: 0 0 20%;\r\n\tmax-width: 20%;\r\n\tpadding: 0 15px;\r\n}\r\n\r\n.text-view {\r\n\ttext-decoration: underline;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.golf-img img {\r\n\tborder-radius: 10px;\r\n}\r\n\r\n.golf-img-1 img {\r\n\tborder-radius: 10px;\r\n}\r\n\r\n.golf-bg {\r\n\tbackground: rgba(196, 196, 196, 0.1);\r\n\tborder: 1px solid #E5BD54;\r\n\tpadding: 40px;\r\n}\r\n\r\n.golf-bg h2 {\r\n\tcolor: #fff;\r\n\tfont-size: 38px;\r\n\tfont-family: 'Patua One', cursive;\r\n}\r\n\r\n.golf-bg p {\r\n\tcolor: #fff;\r\n}\r\n\r\n.golf-section {\r\n\tposition: relative;\r\n\tbackground: url(../img/golf-bg.jpg);\r\n\tbackground-position: bottom;\r\n\tbackground-size: cover;\r\n\tbackground-repeat: no-repeat;\r\n\tpadding: 50px 0;\r\n\tbackground-blend-mode: multiply;\r\n\tz-index: 1;\r\n}\r\n\r\n.golf-section:after {\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\tbackground: rgba(172, 209, 23, 0.3);\r\n\ttop: 0;\r\n\tright: 0;\r\n\tleft: 0;\r\n\tbottom: 0;\r\n\tz-index: -1;\r\n}\r\n\r\n.review-section {\r\n\tpadding: 50px 0;\r\n\tbackground: rgba(255, 250, 236, 0.6);\r\n}\r\n\r\n.clients {\r\n\twidth: 80px !important;\r\n\tborder-radius: 50%;\r\n}\r\n\r\n.review-card h6 {\r\n\tcolor: #13563A;\r\n\tfont-size: 18px;\r\n}\r\n\r\n.review-card span {\r\n    color: #4F4F4F;\r\n    font-size: 16px;\r\n    text-transform: uppercase;\r\n    font-weight: 500;\r\n}\r\n\r\n.review-rating li .checked {\r\n\tcolor: #FFAA00;\r\n}\r\n\r\n.review-rating li .not-checked {\r\n\tcolor: #C4C4C4;\r\n}\r\n\r\n.review-rating li {\r\n\tlist-style-type: none;\r\n\tdisplay: inline-block;\r\n\tfont-size: 10px;\r\n}\r\n\r\n.owl-nav-left {\r\n\tborder: 1px solid #13563A;\r\n\tbackground: #13563A;\r\n\tborder-radius: 50%;\r\n\twidth: 25px;\r\n\tcolor: #FFFFFF;\r\n\theight: 25px;\r\n\tline-height: 23px;\r\n\tfont-size: 12px;\r\n}\r\n\r\n.owl-nav-right {\r\n\tborder: 1px solid #13563A;\r\n\tbackground: #13563A;\r\n\tborder-radius: 50%;\r\n\twidth: 25px;\r\n\tcolor: #FFFFFF;\r\n\theight: 25px;\r\n\tline-height: 23px;\r\n\tfont-size: 12px;\r\n}\r\n\r\n.testimonial-slider {\r\n\tbackground: #fff;\r\n\tpadding: 25px;\r\n}\r\n\r\n.blog-text h5 a {\r\n\tcolor: #13563A;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.blog-text p {\r\n\tfont-size: 12px;\r\n\tmargin-bottom: 0.75rem;\r\n}\r\n\r\n.blog-text a {\r\n\tcolor: #E5BD54;\r\n\tfont-size: 13px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.blogs-date {\r\n\tbackground: #D9B03E;\r\n\tbox-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\r\n\tborder-radius: 4px;\r\n\ttext-align: center;\r\n\tpadding: 1px 10px;\r\n\twidth: 150px;\r\n\tposition: absolute;\r\n\tright: 10px;\r\n\ttop: 20px;\r\n}\r\n\r\n.blogs-date p {\r\n\tcolor: #fff;\r\n\tfont-size: 12px;\r\n}\r\n\r\n.our-blogs,\r\n.blog-img {\r\n\tposition: relative;\r\n}\r\n\r\n.blog-img img{\r\n\twidth: 100%;\r\n}\r\n\r\n.blog-section {\r\n\tpadding: 50px 0;\r\n}\r\n\r\n.banner-overlay {\r\n\tposition: absolute;\r\n\tbottom: -125px;\r\n}\r\n\r\n.vector-shapes {\r\n\tposition: absolute;\r\n\twidth: 100%;\r\n}\r\n\r\n.shape-1 {\r\n\tposition: absolute;\r\n    top: -270px;\r\n    right: 0;\r\n}\r\n\r\n.shape-3 {\r\n\tposition: absolute;\r\n    bottom: -520px;\r\n    left: -140px;\r\n}\r\n\r\n.shape-4 {\r\n\tposition: absolute;\r\n    top: -45px;\r\n    right: 15%;\r\n}\r\n\r\n.shape-5 {\r\n    position: absolute;\r\n    bottom: 0;\r\n}\r\n\r\n.shape-6 {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 130px;\r\n}\r\n\r\n.shape-7 {\r\n    position: absolute;\r\n    right: 110px;\r\n    top: 0;\r\n}\r\n\r\n.shape-8 {\r\n    position: absolute;\r\n    right: 0;\r\n    bottom: 0;\r\n}\r\n\r\n/*-----------------\r\n\t12. Footer\r\n-----------------------*/\r\n\r\n.footer {\r\n\tposition: relative;\r\n\tbackground: #13563A;\r\n}\r\n\r\n.footer .footer-top {\r\n\tpadding-top: 40px;\r\n\tposition: relative;\r\n\tz-index: 9;\r\n}\r\n\r\n.footer .footer-top .footer-about-content {\r\n\tmax-width: 315px;\r\n}\r\n\r\n.footer .footer-bottom {\r\n\tposition: relative;\r\n\tz-index: 9;\r\n}\r\n\r\n.footer-title {\r\n\tcolor: #fff;\r\n\tfont-size: 18px;\r\n\tfont-weight: 600;\r\n\tmargin-bottom: 20px;\r\n\ttext-transform: capitalize;\r\n\tposition: relative;\r\n}\r\n\r\nh2.footer-title:after {\r\n\tcontent: \"\";\r\n\twidth: 39px;\r\n\theight: 2px;\r\n\tbackground: #FF3115;\r\n\ttop: 32px;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tposition: absolute;\r\n}\r\n\r\n.footer .footer-widget.footer-menu ul {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\toutline: none;\r\n}\r\n\r\n.footer .footer-widget .footer-logo {\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.footer .footer-widget .footer-logo img {\r\n\tmax-height: 50px;\r\n\tmax-width: 100%;\r\n}\r\n\r\n.footer .footer-widget p {\r\n\tcolor: #fff;\r\n\tfont-size: 12px;\r\n}\r\n\r\n.footer .footer-widget h5 {\r\n\tcolor: #fff;\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.footer .footer-widget .footer-about-content p:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.footer .footer-menu ul li {\r\n\tmargin-bottom: 10px;\r\n\tposition: relative;\r\n}\r\n\r\n.footer .footer-menu ul li:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.footer .footer-menu ul li a {\r\n\tcolor: #fff;\r\n\ttransition: all 0.4s ease 0s;\r\n\tfont-size: 13px;\r\n}\r\n\r\n.footer .footer-menu ul li a i {\r\n\tmargin-right: 15px;\r\n\tfont-size: 13px;\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.footer .footer-widget.footer-menu ul li a:hover {\r\n\tcolor: #fff;\r\n}\r\n\r\n.footer-contact-info {\r\n\tcolor: #fff;\r\n}\r\n\r\n.footer-contact-info .footer-address {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}\r\n\r\n.footer-contact-info .footer-address span {\r\n\tmargin-right: 20px;\r\n}\r\n\r\n.footer-contact-info .footer-address span i.fa-map-marker-alt {\r\n\tfont-size: 20px;\r\n}\r\n\r\n.footer-contact-info p i {\r\n\tmargin-right: 15px;\r\n}\r\n\r\n.footer .footer-bottom .copyright {\r\n\tpadding: 40px 0;\r\n}\r\n\r\n.home-page .footer .footer-bottom .copyright {\r\n\tborder-top: 1px solid #eceff0;\r\n}\r\n\r\n.footer .footer-bottom .copyright-text p {\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.footer .footer-bottom .copyright-text p a {\r\n\tcolor: #09e5ab;\r\n\t-webkit-transition: all 0.4s ease 0s;\r\n\t-o-transition: all 0.4s ease 0s;\r\n\ttransition: all 0.4s ease 0s;\r\n}\r\n\r\n.footer .footer-bottom .copyright-text p a:hover {\r\n\tcolor: #fff;\r\n}\r\n\r\n.footer .footer-bottom .copyright-text p.title {\r\n\tfont-weight: 400;\r\n\tmargin: 10px 0 0;\r\n}\r\n\r\n.footer .social-icon ul {\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\tlist-style: none;\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n}\r\n\r\n.footer .social-icon ul li {\r\n\tmargin-right: 15px;\r\n}\r\n\r\n.footer .social-icon ul li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n\r\n.footer .social-icon ul li a {\r\n\tcolor: #fff;\r\n\tdisplay: block;\r\n\tfont-size: 14px;\r\n\ttransition: all 0.4s ease 0s;\r\n\theight: 26px;\r\n\twidth: 26px;\r\n\tbackground: rgba(255, 255, 255, 0.1);\r\n\tborder-radius: 50%;\r\n\ttext-align: center;\r\n\tpadding: 4px;\r\n}\r\n\r\n.footer .social-icon ul li a:hover {\r\n\tcolor: #ff3115;\r\n}\r\n\r\n.footer-newsletter input {\r\n\tbox-shadow: 0px 4px 4px rgb(194 194 194 / 25%);\r\n\tborder-radius: 200px !important;\r\n\theight: 43px;\r\n\twidth: 100%;\r\n\tpadding: 6px 15px;\r\n}\r\n\r\n.footer-newsletter input:focus {\r\n\toutline: none;\r\n}\r\n\r\n.btn-newsletter {\r\n\tbackground: #FF3115;\r\n\tborder-radius: 200px;\r\n\tposition: absolute;\r\n\theight: 43px;\r\n\tright: 0;\r\n\twidth: 83px;\r\n}\r\n\r\n.subsccribe-item {\r\n\tmargin-bottom: 40px;\r\n}\r\n\r\n.subscribe-item .section-title h2 {\r\n\tcolor: #E5BD54;\r\n}\r\n\r\n.subscribe-item .section-title p {\r\n\tcolor: #fff;\r\n}\r\n\r\n.subscribe-item .newsletter-form {\r\n\tposition: relative;\r\n}\r\n\r\n.subscribe-item .newsletter-form .form-control {\r\n\theight: 50px;\r\n\tpadding: 10px 15px 10px 30px;\r\n\tbackground-color: #fff;\r\n\tborder-radius: 0;\r\n\tfont-size: 16px;\r\n\tbox-shadow: 0px 4px 4px rgb(194 194 194 / 25%);\r\n\tborder: 0;\r\n}\r\n\r\n.subscribe-item .newsletter-form .cmn-btn {\r\n\topacity: 1;\r\n\tposition: absolute;\r\n\tright: 0;\r\n\ttop: 0;\r\n\tpadding: 12px 18px;\r\n\tbackground: #E5BD54;\r\n\tborder-radius: 0;\r\n\theight: 50px;\r\n\tcolor: #fff;\r\n}\r\n\r\n.footer-about {\r\n\tmax-width: 320px;\r\n\tmargin: auto;\r\n}\r\n\r\n.footer-about ul li {\r\n\tdisplay: inline-block;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t13. Mobile Menu\r\n-----------------------*/\r\n\r\n.sidebar-overlay {\r\n\tbackground-color: rgba(0, 0, 0, 0.6);\r\n\tdisplay: none;\r\n\theight: 100%;\r\n\tleft: 0;\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\twidth: 100%;\r\n\tz-index: 1029;\r\n}\r\n\r\n.menu-opened .main-menu-wrapper {\r\n\ttransform: translateX(0);\r\n}\r\n\r\n.menu-header {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tbackground-color: #13563A;\r\n\theight: 60px;\r\n\tpadding: 0 20px;\r\n\tjustify-content: space-between;\r\n\t-webkit-justify-content: space-between;\r\n\t-ms-flex-pack: space-between;\r\n\tborder-bottom: 1px solid #f0f0f0;\r\n\tdisplay: none;\r\n}\r\n\r\n.menu-logo img {\r\n\theight: 40px;\r\n}\r\n\r\n.menu-close {\r\n\tfont-size: 18px;\r\n\tcolor: #fff;\r\n}\r\n\r\n.bar-icon {\r\n\tdisplay: inline-block;\r\n\twidth: 31px;\r\n}\r\n\r\n.bar-icon span {\r\n\tbackground-color: #e8ba3f;\r\n\tdisplay: block;\r\n\tfloat: left;\r\n\theight: 3px;\r\n\tmargin-bottom: 7px;\r\n\twidth: 31px;\r\n\tborder-radius: 2px;\r\n}\r\n\r\n.bar-icon span:nth-child(2) {\r\n\twidth: 16px;\r\n}\r\n\r\n.bar-icon span:nth-child(3) {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n#mobile_btn {\r\n\tdisplay: none;\r\n\tmargin-right: 30px;\r\n}\r\n\r\nhtml.menu-opened body {\r\n\toverflow: hidden;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t14. Search\r\n-----------------------*/\r\n\r\n.breadcrumb-bar {\r\n    display: none;\r\n\tbackground-color: #f1f1f1;\r\n\tpadding: 15px 0;\r\n}\r\n\r\n.breadcrumb-bar .breadcrumb-title {\r\n\tcolor: #2d3952;\r\n\tfont-size: 22px;\r\n\tfont-weight: 700;\r\n\tmargin: 5px 0 0;\r\n}\r\n\r\n.page-breadcrumb ol {\r\n\tbackground-color: transparent;\r\n\tfont-size: 12px;\r\n\tmargin-bottom: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.page-breadcrumb ol li a {\r\n\tcolor: #2d3952;\r\n}\r\n\r\n.page-breadcrumb ol li.active {\r\n\tcolor: #2d3952;\r\n}\r\n\r\n.page-breadcrumb .breadcrumb-item+.breadcrumb-item:before {\r\n\tcolor: #2d3952;\r\n\tfont-size: 10px;\r\n}\r\n\r\n.sort-by {\r\n\tfloat: right;\r\n}\r\n\r\n.sort-title {\r\n\tcolor: #2d3952;\r\n\tfont-size: 14px;\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.sortby-fliter {\r\n\tdisplay: inline-block;\r\n\twidth: 120px;\r\n}\r\n\r\n.cal-icon {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n}\r\n\r\n.cal-icon:after {\r\n\tcolor: #979797;\r\n\tcontent: '\\f073';\r\n\tdisplay: block;\r\n\tfont-family: \"Font Awesome 5 Free\";\r\n\tfont-size: 16px;\r\n\tfont-weight: 400;\r\n\tmargin: auto;\r\n\tposition: absolute;\r\n\tright: 15px;\r\n\ttop: 10px;\r\n}\r\n\r\n.custom_check {\r\n\tcolor: #666;\r\n\tdisplay: inline-block;\r\n\tposition: relative;\r\n\tfont-size: 14px;\r\n\tfont-size: .9375rem;\r\n\tpadding-left: 30px;\r\n\tmargin-bottom: 10px;\r\n\tcursor: pointer;\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none\r\n}\r\n\r\n.custom_check input {\r\n\tposition: absolute;\r\n\topacity: 0;\r\n\tcursor: pointer\r\n}\r\n\r\n.custom_check input:checked~.checkmark {\r\n\tbackground-color: #fff;\r\n}\r\n\r\n.custom_check .checkmark {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\theight: 20px;\r\n\twidth: 20px;\r\n\tborder: 1px solid #dcdcdc;\r\n\tbackground-color: #fff;\r\n\tborder-radius: 3px;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-ms-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out\r\n}\r\n\r\n.custom_check .checkmark::after {\r\n\tcontent: \"\\f00c\";\r\n\tfont-family: \"Font Awesome 5 Free\";\r\n\tfont-weight: 900;\r\n\tposition: absolute;\r\n\tdisplay: none;\r\n\tleft: 4px;\r\n\ttop: 0;\r\n\tcolor: #f1c85f;\r\n\tfont-size: 11px;\r\n}\r\n\r\n.custom_check input:checked~.checkmark:after {\r\n\tdisplay: block\r\n}\r\n\r\n.custom_radio {\r\n\tcolor: #555;\r\n\tdisplay: inline-block;\r\n\tposition: relative;\r\n\tfont-size: 14px;\r\n\tfont-size: 0.9375rem;\r\n\tpadding-left: 30px;\r\n\tmargin-bottom: 10px;\r\n\tcursor: pointer;\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none\r\n}\r\n\r\n.radio_input .custom_radio+.custom_radio {\r\n\tmargin-left: 15px;\r\n}\r\n\r\n.custom_radio input {\r\n\tposition: absolute;\r\n\topacity: 0\r\n}\r\n\r\n.custom_radio input:checked~.checkmark:after {\r\n\topacity: 1\r\n}\r\n\r\n.custom_radio .checkmark {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\theight: 20px;\r\n\twidth: 20px;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #ccc;\r\n\tborder-radius: 50%\r\n}\r\n\r\n.custom_radio .checkmark:after {\r\n\tdisplay: block;\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\topacity: 0;\r\n\ttop: 3px;\r\n\tleft: 3px;\r\n\twidth: 12px;\r\n\theight: 12px;\r\n\tborder-radius: 50%;\r\n\tbackground: #ff9b44;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-ms-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out\r\n}\r\n\r\n.filter-widget {\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.filter-widget h4 {\r\n\tfont-size: 1rem;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.filter-widget .custom_check {\r\n\tline-height: 18px;\r\n}\r\n\r\n.btn-search .btn {\r\n\tbackground-color: #f1c85f;\r\n\tborder: 1px solid #f1c85f;\r\n\tcolor: #fff;\r\n\theight: 46px;\r\n\tfont-weight: 500;\r\n\tfont-size: 16px;\r\n}\r\n\r\n.sender-widget {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}\r\n\r\n.doc-info-left {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}\r\n\r\n.doc-info-right {\r\n\tmargin-left: auto;\r\n\t-ms-flex: 0 0 25%;\r\n\tflex: 0 0 25%;\r\n\tmax-width: 200px;\r\n}\r\n\r\n.sender-img {\r\n\t-ms-flex: 0 0 150px;\r\n\tflex: 0 0 150px;\r\n\tmargin-right: 20px;\r\n\twidth: 150px;\r\n}\r\n\r\n.sender-img img {\r\n\t/* border-radius: 5px; */\r\n}\r\n\r\n.doc-department {\r\n\tcolor: #e5bd54;\r\n\tfont-size: 14px;\r\n\tmargin-bottom: 8px;\r\n}\r\n\r\n.doc-department img {\r\n\twidth: 19px;\r\n\tdisplay: inline-block;\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.doc-location {\r\n\tcolor: #757575;\r\n\tfont-size: 14px;\r\n\tmargin-bottom: 25px;\r\n}\r\n\r\n.doc-location a {\r\n\tcolor: #13563A;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.sender-widget .doc-name {\r\n\tfont-size: 20px;\r\n\tfont-weight: 500;\r\n\tmargin-bottom: 3px;\r\n}\r\n\r\n.doc-speciality {\r\n\tfont-size: 14px;\r\n\tcolor: #757575;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.sender-widget .rating i {\r\n\tfont-size: 14px;\r\n}\r\n\r\n.sender-widget .average-rating {\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.shop-details {\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.shop-details h5 {\r\n\tfont-weight: normal;\r\n\tcolor: #757575;\r\n\tmargin-bottom: 25px;\r\n}\r\n\r\n.shop-details ul {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.shop-details ul li {\r\n\tdisplay: inline-block;\r\n\tpadding-right: 9px;\r\n}\r\n\r\n.shop-details ul li:last-child {\r\n\tpadding-right: 0;\r\n}\r\n\r\n.shop-details ul li a {\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.shop-details ul li a img {\r\n\tborder-radius: 5px;\r\n\twidth: 40px;\r\n}\r\n\r\n.shop-services {\r\n\tcolor: #272b41;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tfont-size: 13px;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.shop-services span {\r\n\tborder: 1px solid #ccc;\r\n\tborder-radius: 4px;\r\n\tdisplay: inline-block;\r\n\tfont-size: 12px;\r\n\tpadding: 3px 10px;\r\n}\r\n\r\n.shop-services span+span {\r\n\tmargin-left: 5px;\r\n}\r\n\r\n.clini-infos {\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.clini-infos ul {\r\n\tfont-size: 14px;\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.clini-infos ul li {\r\n\tdisplay: block;\r\n\tline-height: 30px;\r\n\tcolor: #4E4852;\r\n}\r\n\r\n.clini-infos ul li i {\r\n\tfont-size: 15px;\r\n\tmin-width: 30px;\r\n}\r\n\r\n.shop-booking a+a {\r\n\tmargin-top: 15px;\r\n}\r\n\r\n.shop-booking a {\r\n\tbackground-color: #fff;\r\n\tborder: 2px solid #e5bd54;\r\n\tborder-radius: 4px;\r\n\tcolor: #e5bd54;\r\n\tdisplay: block;\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n\tletter-spacing: 1px;\r\n\tpadding: 10px 15px;\r\n\ttext-align: center;\r\n\ttext-transform: uppercase;\r\n\twidth: 100%;\r\n}\r\n\r\n.shop-booking a.view-pro-btn:hover,\r\n.shop-booking a.view-pro-btn:focus {\r\n\tbackground: #e5bd54;\r\n\tcolor: #fff;\r\n}\r\n\r\n.shop-booking a.apt-btn {\r\n\tbackground-color: #e5bd54;\r\n\tcolor: #fff;\r\n}\r\n\r\n.shop-booking a.apt-btn:hover,\r\n.shop-booking a.apt-btn:focus {\r\n\tbackground-color: #e2b745;\r\n\tborder-color: #e2b745;\r\n\tcolor: #fff;\r\n}\r\n\r\n.load-more {\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t15. advisors Profile\r\n-----------------------*/\r\n\r\n.shop-direction {\r\n\tcolor: #757575;\r\n\tfont-size: 14px;\r\n\tmargin-bottom: 25px;\r\n}\r\n\r\n.shop-direction a {\r\n\tcolor: #09e5ab;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.sender-action {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.sender-action a+a {\r\n\tmargin-left: 8px;\r\n}\r\n\r\n.sender-action .fav-btn:hover {\r\n\tbackground-color: #fb1612;\r\n\tborder-color: #fb1612;\r\n\tcolor: #fff;\r\n}\r\n\r\n.msg-btn:hover,\r\n.msg-btn:focus {\r\n\tbackground-color: #efc75e;\r\n\tborder-color: #efc75e;\r\n\tcolor: #fff;\r\n}\r\n\r\n.call-btn:hover,\r\n.call-btn:focus {\r\n\tbackground-color: #efc75e;\r\n\tborder-color: #efc75e;\r\n\tcolor: #fff;\r\n}\r\n\r\n.user-tabs .nav-tabs > li > a {\r\n\tborder: 0;\r\n\tborder-bottom: 3px solid transparent;\r\n\tcolor: #3e3e3e;\r\n\tfont-weight: 600;\r\n\tpadding: 20px;\r\n}\r\n\r\n.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active,\r\n.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:hover,\r\n.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:focus {\r\n\tborder-bottom-width: 3px;\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.user-tabs .med-records {\r\n\tdisplay: inline-block;\r\n\tmin-width: 130px;\r\n}\r\n\r\n.user-tabs .nav-tabs > li > a:hover {\r\n\tbackground-color: unset;\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.widget {\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n.widget-title {\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.experience-box {\r\n\tposition: relative;\r\n}\r\n\r\n.experience-list {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tposition: relative;\r\n}\r\n\r\n.experience-list::before {\r\n\tbackground: #ddd;\r\n\tbottom: 0;\r\n\tcontent: \"\";\r\n\tleft: 8px;\r\n\tposition: absolute;\r\n\ttop: 8px;\r\n\twidth: 2px;\r\n}\r\n\r\n.experience-list > li {\r\n\tposition: relative;\r\n}\r\n\r\n.experience-list > li:last-child .experience-content {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.experience-user .avatar {\r\n\theight: 32px;\r\n\tline-height: 32px;\r\n\tmargin: 0;\r\n\twidth: 32px;\r\n}\r\n\r\n.experience-list > li .experience-user {\r\n\tbackground: #fff;\r\n\theight: 10px;\r\n\tleft: 4px;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tposition: absolute;\r\n\ttop: 4px;\r\n\twidth: 10px;\r\n}\r\n\r\n.experience-list > li .experience-content {\r\n\tbackground-color: #fff;\r\n\tmargin: 0 0 20px 40px;\r\n\tpadding: 0;\r\n\tposition: relative;\r\n}\r\n\r\n.experience-list > li .experience-content .timeline-content {\r\n\tcolor: #757575;\r\n}\r\n\r\n.experience-list > li .experience-content .timeline-content a.name {\r\n\tfont-weight: 500;\r\n}\r\n\r\n.experience-list > li .time {\r\n\tcolor: #757575;\r\n\tdisplay: block;\r\n\tfont-size: 13px;\r\n}\r\n\r\n.before-circle {\r\n\tbackground-color: rgb(229 189 84 / 25%);\r\n\tborder-radius: 50%;\r\n\theight: 12px;\r\n\twidth: 12px;\r\n\tborder: 2px solid #e5bd54;\r\n}\r\n\r\n.exp-year {\r\n\tcolor: #e5bd54;\r\n\tmargin-bottom: 2px;\r\n}\r\n\r\n.exp-title {\r\n\tfont-size: 16px;\r\n}\r\n\r\n.awards-widget .experience-list > li:last-child p {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.service-list {\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n.service-list:last-child {\r\n\tborder-bottom: 0;\r\n\tmargin-bottom: 0;\r\n\tpadding-bottom: 0;\r\n}\r\n\r\n.service-list ul {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.service-list ul li {\r\n\tfloat: left;\r\n\tmargin: 6px 0;\r\n\tpadding-left: 25px;\r\n\tposition: relative;\r\n\twidth: 33%;\r\n}\r\n\r\n.service-list ul li::before {\r\n\tcolor: #ccc;\r\n\tcontent: '\\f30b';\r\n\tfont-family: \"Font Awesome 5 Free\";\r\n\tfont-weight: 900;\r\n\tleft: 0;\r\n\tposition: absolute;\r\n}\r\n\r\n.location-list {\r\n\tborder: 1px solid #f0f0f0;\r\n\tborder-radius: 4px;\r\n\tpadding: 20px;\r\n}\r\n\r\n.location-list+.location-list {\r\n\tmargin-top: 20px;\r\n}\r\n\r\n.shop-content .shop-name {\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n\tmargin-bottom: 3px;\r\n}\r\n\r\n.shop-content .shop-direction a {\r\n\tdisplay: inline-block;\r\n\tmargin-top: 8px;\r\n}\r\n\r\n.timings-days {\r\n\tfont-weight: bold;\r\n\tcolor: #272b41;\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n.timings-times span {\r\n\tdisplay: block;\r\n}\r\n\r\n.location-list .consult-price {\r\n\tfont-size: 20px;\r\n\tfont-weight: 500;\r\n\tcolor: #272b41;\r\n}\r\n\r\n.review-listing {\r\n\tborder-bottom: 1px solid #f5f7fc;\r\n\tmargin-top: 20px;\r\n\tpadding-bottom: 30px;\r\n}\r\n\r\n.review-listing > ul {\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tlist-style: none;\r\n}\r\n\r\n.review-listing > ul li+li {\r\n\tmargin-top: 20px;\r\n\tborder-top: 1px dashed #f0f0f0;\r\n\tpadding-top: 20px;\r\n}\r\n\r\n.review-listing > ul li .comment {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n.review-listing > ul li .comment:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.review-listing > ul li .comment .comment-body {\r\n\tmargin-left: 16px;\r\n}\r\n\r\n.review-listing > ul li .comment .comment-body .meta-data {\r\n\tposition: relative;\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.review-listing > ul li .comment .comment-body .meta-data span {\r\n\tdisplay: block;\r\n\tfont-size: 16px;\r\n\tcolor: #757575;\r\n}\r\n\r\n.review-listing > ul li .comment .comment-body .meta-data span.comment-author {\r\n\tfont-weight: 600;\r\n\tcolor: #272b41;\r\n\ttext-transform: capitalize;\r\n}\r\n\r\n.review-listing > ul li .comment .comment-body .meta-data span.comment-date {\r\n\tfont-size: 14px;\r\n}\r\n\r\n.review-listing > ul li .comment .comment-body .meta-data .review-count {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tposition: absolute;\r\n\ttop: 3px;\r\n\tright: 0;\r\n\twidth: auto;\r\n}\r\n\r\n.review-listing > ul li .comment .comment-body .comment-content {\r\n\tcolor: #757575;\r\n\tmargin-top: 15px;\r\n\tmargin-bottom: 15px;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.review-listing > ul li .comment .comment-body .comment-reply .comment-btn {\r\n\tcolor: #e5bd54;\r\n\tdisplay: inline-block;\r\n\tfont-weight: 500;\r\n\tfont-size: 15px;\r\n}\r\n\r\n.review-listing .recommend-btn {\r\n\tfloat: right;\r\n\tcolor: #757575;\r\n\tfont-size: 14px;\r\n\tpadding: 5px 0;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.review-listing .recommend-btn a {\r\n\tborder: 1px solid rgba(128, 137, 150, 0.4);\r\n\tborder-radius: 4px;\r\n\tdisplay: inline-block;\r\n\tpadding: 4px 12px;\r\n\tcolor: #757575;\r\n\tmargin-left: 3px;\r\n\tmargin-right: 3px;\r\n\ttransition: all .3s;\r\n}\r\n\r\n.review-listing .recommend-btn a.like-btn:hover {\r\n\tbackground-color: #28a745;\r\n\tborder: 1px solid #28a745;\r\n\tcolor: #fff;\r\n}\r\n\r\n.review-listing .recommend-btn a.dislike-btn:hover {\r\n\tbackground-color: #dc3545;\r\n\tborder: 1px solid #dc3545;\r\n\tcolor: #fff;\r\n}\r\n\r\n.review-listing .recommend-btn a i {\r\n\tfont-size: 16px;\r\n}\r\n\r\n.review-listing > ul li .comments-reply {\r\n\tlist-style: none;\r\n\tmargin-left: 65px;\r\n\tpadding: 0;\r\n}\r\n\r\n.recommended {\r\n\tcolor: #28a745;\r\n\tfont-size: 15px;\r\n\tfont-weight: 500;\r\n\tmargin: 0;\r\n}\r\n\r\n.all-feedback {\r\n\tmargin-top: 20px;\r\n}\r\n\r\n.star-rating {\r\n\tdirection: rtl;\r\n}\r\n\r\n.star-rating input[type=radio] {\r\n\tdisplay: none\r\n}\r\n\r\n.star-rating label {\r\n\tcolor: #dedfe0;\r\n\tcursor: pointer;\r\n\tfont-size: 18px;\r\n\tpadding: 0;\r\n\t-webkit-transition: all .3s ease-in-out;\r\n\ttransition: all .3s ease-in-out;\r\n    direction: ltr;\r\n    line-height: 1;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.star-rating label i {\r\n    min-width: auto !important;\r\n}\r\n\r\n.star-rating label:hover,\r\n.star-rating label:hover~label,\r\n.star-rating input[type=radio]:checked~label {\r\n\tcolor: #f2b600\r\n}\r\n\r\n.terms-accept a {\r\n\tcolor: #e5bd54;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.business-widget {\r\n\tbackground-color: #fcfcfc;\r\n\tborder: 1px solid #f0f0f0;\r\n\tpadding: 20px;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.listing-day {\r\n\t-webkit-box-align: flex-start;\r\n\t-ms-flex-align: flex-start;\r\n\talign-items: flex-start;\r\n\tcolor: #000;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\tjustify-content: space-between;\r\n\t-webkit-justify-content: space-between;\r\n\t-ms-flex-pack: space-between;\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.listing-day:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.listing-day.current {\r\n\tborder-bottom: 1px solid #ddd;\r\n\tpadding-bottom: 13px;\r\n\tmargin-bottom: 13px;\r\n}\r\n\r\n.listing-day .day {\r\n\tfont-weight: 500;\r\n}\r\n\r\n.listing-day.current .day {\r\n\tfont-weight: bold;\r\n}\r\n\r\n.listing-day.current .day span {\r\n\tdisplay: block;\r\n\tfont-weight: normal;\r\n}\r\n\r\n.time-items {\r\n\tcolor: #757575;\r\n}\r\n\r\n.time-items > span {\r\n\tdisplay: block;\r\n\ttext-align: right;\r\n}\r\n\r\n.time-items > span.open-status {\r\n\tmargin-bottom: 3px;\r\n}\r\n\r\n.dropzone .dz-preview.dz-error:hover .dz-error-message {\r\n\tdisplay: none;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t16. Booking\r\n-----------------------*/\r\n\r\n.booking-doc-info {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}\r\n\r\n.booking-doc-info .booking-doc-img {\r\n\twidth: 80px;\r\n\tmargin-right: 15px;\r\n}\r\n\r\n.booking-doc-info .booking-doc-img img {\r\n\tborder-radius: 4px;\r\n\theight: 80px;\r\n\twidth: 80px;\r\n\tobject-fit: cover;\r\n}\r\n\r\n.schedule-widget {\r\n\tborder-radius: 4px;\r\n\tmin-height: 100px;\r\n}\r\n\r\n.schedule-header h4 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 600;\r\n\tmargin: 3px 0 0;\r\n}\r\n\r\n.schedule-header {\r\n\tborder-bottom: 1px solid #f0f0f0;\r\n\tborder-radius: 4px 4px 0 0;\r\n\tpadding: 10px 20px;\r\n}\r\n\r\n.day-slot ul {\r\n\tfloat: left;\r\n\tlist-style: none;\r\n\tmargin-bottom: 0;\r\n\tmargin-left: -5px;\r\n\tmargin-right: -5px;\r\n\tpadding: 0;\r\n\tposition: relative;\r\n\twidth: 100%;\r\n}\r\n\r\n.day-slot li {\r\n\tfloat: left;\r\n\tpadding-left: 5px;\r\n\tpadding-right: 5px;\r\n\ttext-align: center;\r\n\twidth: 14.28%;\r\n}\r\n\r\n.day-slot li span {\r\n\tdisplay: block;\r\n\tfont-size: 18px;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.day-slot li span.slot-date {\r\n\tdisplay: block;\r\n\tcolor: #757575;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.day-slot li small.slot-year {\r\n\tcolor: #757575;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.day-slot li.left-arrow {\r\n\tleft: 0;\r\n\tpadding: 0;\r\n\tposition: absolute;\r\n\ttext-align: center;\r\n\ttop: 50%;\r\n\twidth: 20px !important;\r\n\ttransform: translateY(-50%);\r\n}\r\n\r\n.day-slot li.right-arrow {\r\n\tright: -11px;\r\n\tpadding: 0;\r\n\tposition: absolute;\r\n\ttext-align: center;\r\n\ttop: 50%;\r\n\twidth: 20px !important;\r\n\ttransform: translateY(-50%);\r\n}\r\n\r\n.schedule-cont {\r\n\tpadding: 20px;\r\n}\r\n\r\n.time-slot ul {\r\n\tlist-style: none;\r\n\tmargin-right: -5px;\r\n\tmargin-left: -5px;\r\n\tmargin-bottom: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.time-slot li {\r\n\tfloat: left;\r\n\tpadding-left: 5px;\r\n\tpadding-right: 5px;\r\n\twidth: 14.28%;\r\n}\r\n\r\n.time-slot li .timing {\r\n\tbackground-color: #e9e9e9;\r\n\tborder: 1px solid #e9e9e9;\r\n\tborder-radius: 3px;\r\n\tcolor: #757575;\r\n\tdisplay: block;\r\n\tfont-size: 14px;\r\n\tmargin-bottom: 10px;\r\n\tpadding: 5px 5px;\r\n\ttext-align: center;\r\n\tposition: relative;\r\n}\r\n\r\n.time-slot li .timing:hover {\r\n\tbackground-color: #fff;\r\n}\r\n\r\n.time-slot li .timing:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.time-slot li .timing.selected {\r\n\tbackground-color: #13563A;\r\n\tborder: 1px solid #13563A;\r\n\tcolor: #fff;\r\n}\r\n\r\n.time-slot li .timing.selected::before {\r\n\tcolor: #fff;\r\n\tcontent: \"\\f00c\";\r\n\tfont-family: \"Font Awesome 5 Free\";\r\n\tfont-size: 12px;\r\n\tfont-weight: 900;\r\n\tposition: absolute;\r\n\tright: 6px;\r\n\ttop: 6px;\r\n}\r\n\r\n.schedule-list {\r\n\tborder-bottom: 1px solid #cfcfcf;\r\n\tmargin-bottom: 50px;\r\n\tpadding-bottom: 50px;\r\n}\r\n\r\n.schedule-list:last-child {\r\n\tborder-bottom: 0;\r\n\tmargin-bottom: 0;\r\n\tpadding-bottom: 0;\r\n}\r\n\r\n.submit-section.proceed-btn {\r\n\tmargin: 0 0 30px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t17. Checkout\r\n-----------------------*/\r\n\r\n.info-widget {\r\n\tborder-bottom: 1px solid #f0f0f0;\r\n\tpadding-bottom: 30px;\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n.card-label > label {\r\n    position: relative;\r\n    z-index: 900;\r\n\tbackground-color: #fff;\r\n\tcolor: #959595;\r\n\tdisplay: inline-block;\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n\tmargin: 6px auto auto 8px;\r\n\tpadding: 0 7px;\r\n    border-radius: 4px;\r\n}\r\n\r\n.card-label > input, .card-label > .input, .card-label > select, .card-label > textarea {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #ebebeb;\r\n\tborder-radius: 4px;\r\n\tbox-shadow: 0 1px 3px 0 rgba(0, 0, 0, .05);\r\n\tdisplay: block;\r\n\theight: 50px;\r\n\tmargin-top: -11px;\r\n\tpadding: 0 15px;\r\n\ttransition: border-color .3s;\r\n\twidth: 100%;\r\n}\r\n\r\n.card-label > textarea {\r\n    height: inherit;\r\n    padding-top: 8px;\r\n}\r\n\r\n.card-label > span.input {\r\n    padding-top: 13px;\r\n    border: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.exist-customer a {\r\n\tcolor: #e5bd54;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.payment-widget .payment-list+.payment-list {\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.payment-radio {\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\tpadding-left: 35px;\r\n\tmargin-bottom: 12px;\r\n\tcursor: pointer;\r\n\tfont-size: 16px;\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none;\r\n\tfont-weight: 600;\r\n\tcolor: #272b41;\r\n\ttext-transform: capitalize;\r\n}\r\n\r\n.payment-radio input {\r\n\tposition: absolute;\r\n\topacity: 0;\r\n\tcursor: pointer;\r\n\theight: 0;\r\n\twidth: 0;\r\n}\r\n\r\n.payment-radio .checkmark {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 19px;\r\n\theight: 19px;\r\n\tmargin: 3px 0 0 0;\r\n\tborder: 2px solid #ddd;\r\n\tborder-top-color: rgb(221, 221, 221);\r\n\tborder-right-color: rgb(221, 221, 221);\r\n\tborder-bottom-color: rgb(221, 221, 221);\r\n\tborder-left-color: rgb(221, 221, 221);\r\n\t-webkit-border-radius: 50%;\r\n\t-moz-border-radius: 50%;\r\n\tborder-radius: 50%;\r\n\t-webkit-transition: all .3s;\r\n\t-moz-transition: all .3s;\r\n\t-ms-transition: all .3s;\r\n\t-o-transition: all .3s;\r\n\ttransition: all .3s;\r\n}\r\n\r\n.payment-radio input:checked~.checkmark {\r\n\tborder-color: #e5bd54;\r\n}\r\n\r\n.payment-radio .checkmark::after {\r\n\tposition: absolute;\r\n\tleft: 3px;\r\n\ttop: 3px;\r\n\tcontent: '';\r\n\twidth: 9px;\r\n\theight: 9px;\r\n\tbackground-color: #e5bd54;\r\n\topacity: 0;\r\n\tvisibility: hidden;\r\n\t-webkit-transform: scale(0.1);\r\n\t-moz-transform: scale(0.1);\r\n\t-ms-transform: scale(0.1);\r\n\t-o-transform: scale(0.1);\r\n\ttransform: scale(0.1);\r\n\t-webkit-border-radius: 50%;\r\n\t-moz-border-radius: 50%;\r\n\tborder-radius: 50%;\r\n\t-webkit-transition: all .3s;\r\n\t-moz-transition: all .3s;\r\n\t-ms-transition: all .3s;\r\n\t-o-transition: all .3s;\r\n\ttransition: all .3s;\r\n}\r\n\r\n.payment-radio input:checked~.checkmark::after {\r\n\t-webkit-transform: scale(1);\r\n\t-moz-transform: scale(1);\r\n\t-ms-transform: scale(1);\r\n\t-o-transform: scale(1);\r\n\ttransform: scale(1);\r\n\topacity: 1;\r\n\tvisibility: visible;\r\n}\r\n\r\n.booking-date {\r\n\tpadding: 0;\r\n\tlist-style: none;\r\n}\r\n\r\n.booking-date li {\r\n\tposition: relative;\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n\tcolor: #272b41;\r\n\ttext-transform: capitalize;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.booking-date li span {\r\n\tfloat: right;\r\n\tcolor: #757575;\r\n\tfont-weight: 400;\r\n\tfont-size: 15px;\r\n}\r\n\r\n.booking-fee {\r\n\tpadding: 0;\r\n\tlist-style: none;\r\n}\r\n\r\n.booking-fee li {\r\n\tposition: relative;\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n\tcolor: #272b41;\r\n\ttext-transform: capitalize;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.booking-fee li span {\r\n\tfloat: right;\r\n\tcolor: #757575;\r\n\tfont-weight: 400;\r\n\tfont-size: 15px;\r\n}\r\n\r\n.booking-total {\r\n\tborder-top: 1px solid #e4e4e4;\r\n\tmargin-top: 20px;\r\n\tpadding-top: 20px;\r\n}\r\n\r\n.booking-total ul {\r\n\tpadding: 0;\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n}\r\n\r\n.booking-total ul li span {\r\n\tfont-size: 18px;\r\n\tfont-weight: 600;\r\n\tcolor: #272b41;\r\n}\r\n\r\n.booking-total ul li .total-cost {\r\n\tcolor: #e5bd54;\r\n\tfont-size: 16px;\r\n\tfloat: right;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t18. Booking Success\r\n-----------------------*/\r\n\r\n.success-page-cont {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tdisplay: flex;\r\n}\r\n\r\n.success-card .card-body {\r\n\tpadding: 50px 20px;\r\n}\r\n\r\n.success-cont {\r\n\ttext-align: center;\r\n}\r\n\r\n.success-cont i {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tcolor: #fff;\r\n\twidth: 60px;\r\n\theight: 60px;\r\n\tborder: 2px solid #e5bd54;\r\n\tborder-radius: 50%;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\t-ms-flex-pack: center;\r\n\tfont-size: 30px;\r\n\tmargin-bottom: 30px;\r\n\tbackground-color: #e5bd54;\r\n}\r\n\r\n.success-cont h3 {\r\n\tfont-size: 24px;\r\n}\r\n\r\n.success-cont p {\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n.success-cont strong {\r\n\tfont-weight: 600;\r\n}\r\n\r\n.view-inv-btn {\r\n\tfont-size: 16px;\r\n\tfont-weight: 600;\r\n\tpadding: 12px 30px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t19. Invoice View\r\n-----------------------*/\r\n\r\n.invoice-content {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #f0f0f0;\r\n\tborder-radius: 4px;\r\n\tmargin-bottom: 30px;\r\n\tpadding: 30px;\r\n}\r\n\r\n.invoice-item .invoice-logo {\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n.invoice-item .invoice-logo img {\r\n\twidth: auto;\r\n\tmax-height: 52px;\r\n}\r\n\r\n.invoice-item .invoice-text h2 {\r\n\tcolor: #272b41;\r\n\tfont-size: 36px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.invoice-item .invoice-details {\r\n\ttext-align: right;\r\n\tcolor: #757575;\r\n\tfont-weight: 500\r\n}\r\n\r\n.invoice-item .invoice-details strong {\r\n\tcolor: #272b41\r\n}\r\n\r\n.invoice-item .invoice-details-two {\r\n\ttext-align: left\r\n}\r\n\r\n.invoice-item .invoice-text {\r\n\tpadding-top: 42px;\r\n\tpadding-bottom: 36px\r\n}\r\n\r\n.invoice-item .invoice-text h2 {\r\n\tfont-weight: 400\r\n}\r\n\r\n.invoice-info {\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n.invoice-info p {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.invoice-info.invoice-info2 {\r\n\ttext-align: right;\r\n}\r\n\r\n.invoice-item .customer-text {\r\n\tfont-size: 18px;\r\n\tcolor: #272b41;\r\n\tfont-weight: 600;\r\n\tmargin-bottom: 8px;\r\n\tdisplay: block\r\n}\r\n\r\n.invoice-table tr th,\r\n.invoice-table tr td,\r\n.invoice-table-two tr th,\r\n.invoice-table-two tr td {\r\n\tcolor: #272b41;\r\n\tfont-weight: 600;\r\n\tpadding: 10px 20px;\r\n\tline-height: inherit\r\n}\r\n\r\n.invoice-table tr td,\r\n.invoice-table-two tr td {\r\n\tcolor: #757575;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.invoice-table-two {\r\n\tmargin-bottom: 0\r\n}\r\n\r\n.invoice-table-two tr th,\r\n.invoice-table-two tr td {\r\n\tborder-top: 0;\r\n}\r\n\r\n.invoice-table-two tr td {\r\n\ttext-align: right\r\n}\r\n\r\n.invoice-info h5 {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.other-info {\r\n\tmargin-top: 10px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t20. Schedule Timings\r\n-----------------------*/\r\n\r\n.tab-content.schedule-cont .card-title {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.doc-times {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.doc-slot-list {\r\n\tbackground-color: #d9534f;\r\n\tborder: 1px solid #d43f3a;\r\n\tborder-radius: 4px;\r\n\tcolor: #fff;\r\n\tfont-size: 14px;\r\n\tmargin: 10px 10px 0 0;\r\n\tpadding: 6px 15px;\r\n}\r\n\r\n.doc-slot-list a {\r\n\tcolor: #e48784;\r\n\tdisplay: inline-block;\r\n\tmargin-left: 5px;\r\n}\r\n\r\n.doc-slot-list a:hover {\r\n\tcolor: #fff;\r\n}\r\n\r\n.schedule-nav .nav-tabs {\r\n\tborder: 0 !important;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.schedule-nav .nav-tabs li {\r\n\tmargin: 5px 15px 5px 0;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.schedule-nav .nav-tabs li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n\r\n.schedule-nav .nav-tabs > li > a {\r\n\tborder: 1px solid #dcddea;\r\n\tborder-radius: 4px;\r\n\tpadding: 6px 15px;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.schedule-nav .nav-tabs li a.active {\r\n\tbackground: #ff4877;\r\n\tborder: 1px solid #ff4877 !important;\r\n\tcolor: #fff;\r\n}\r\n\r\n.hours-info .form-control {\r\n\tmin-height: auto;\r\n}\r\n\r\n.hours-info .btn.btn-danger.trash {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\theight: 38px;\r\n\twidth: 100%;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\t-ms-flex-pack: center;\r\n}\r\n\r\n.edit-link {\r\n\tcolor: #e5bd54;\r\n\tfont-size: 16px;\r\n\tmargin-top: 4px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t21. advisors Dashboard\r\n-----------------------*/\r\n\r\n.dash-widget {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}\r\n\r\n.circle-bar {\r\n\tmargin-right: 15px;\r\n}\r\n\r\n.dct-border-rht {\r\n\tborder-right: 1px solid #f0f0f0;\r\n}\r\n\r\n.dash-widget h6 {\r\n\tfont-size: 16px;\r\n\tfont-weight: 400;\r\n}\r\n\r\n.dash-widget h3 {\r\n\tfont-size: 24px;\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n.dash-widget p {\r\n\tcolor: #757575;\r\n\tfont-size: 14px;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.circle-bar > div {\r\n\tdisplay: inline-block;\r\n    position: relative;\r\n    text-align: center;\r\n    padding: 10px;\r\n    background: #e5bd54;\r\n    border-radius: 50px;\r\n    border: 1px dashed;\r\n}\r\n\r\n.circle-bar > div img {\r\n\tposition: relative;\r\n\ttext-align: center;\r\n\tmargin: 0 auto;\r\n\r\n}\r\n\r\n.circle-bar > div canvas {\r\n\twidth: 90px !important;\r\n\theight: 90px !important;\r\n}\r\n\r\n.dash-card .row {\r\n\tmargin-left: -10px;\r\n\tmargin-right: -10px;\r\n}\r\n\r\n.dash-card .row > div {\r\n\tpadding-left: 10px;\r\n\tpadding-right: 10px;\r\n}\r\n\r\n.appointment-tab {\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n.appointment-tab .nav-tabs {\r\n\tbackground-color: #fff;\r\n\tpadding: 1.5rem;\r\n\tborder: 1px solid #f0f0f0;\r\n\tborder-radius: .25rem 0.25rem 0 0 !important;\r\n\tborder-bottom: 0;\r\n}\r\n\r\n.appointment-tab .tab-content {\r\n\tpadding-top: 0;\r\n}\r\n\r\n.appointment-tab .card {\r\n\tborder-radius: 0;\r\n}\r\n\r\n.submit-btn-bottom {\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t22. Customer Profile\r\n-----------------------*/\r\n\r\n.add-new-btn {\r\n\tbackground-color: #e8ba3f;\r\n\tborder-radius: 30px;\r\n\tcolor: #fff;\r\n\tdisplay: inline-block;\r\n\tfont-weight: 500;\r\n\tmargin-bottom: 20px;\r\n\tpadding: 10px 20px;\r\n}\r\n\r\n.add-new-btn:focus,\r\n.add-new-btn:hover,\r\n.add-new-btn:active {\r\n\tbackground-color: #e8ba3f;\r\n\tcolor: #fff;\r\n}\r\n\r\n.receiver-info {\r\n\tmargin-top: 15px;\r\n}\r\n\r\n.receiver-info ul {\r\n\tpadding: 0;\r\n\tlist-style: none;\r\n\tfont-size: .875rem;\r\n\tmargin: 0;\r\n}\r\n\r\n.receiver-info ul li {\r\n\tposition: relative;\r\n\tfont-size: .875rem;\r\n\tfont-weight: 500;\r\n\tcolor: #272b41;\r\n\ttext-transform: capitalize;\r\n}\r\n\r\n.receiver-info ul li+li {\r\n\tmargin-top: 15px;\r\n}\r\n\r\n.receiver-info ul li i {\r\n\twidth: 18px;\r\n}\r\n\r\n.receiver-info ul li span {\r\n\tcolor: #757575;\r\n\tfloat: right;\r\n\tfont-weight: 400;\r\n}\r\n\r\n.dependent {\r\n\tmargin: auto;\r\n}\r\n\r\n.dependent h2 {\r\n\tfont-size: 32px;\r\n\tfont-weight: 500;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t23. Chat\r\n-----------------------*/\r\n\r\n.chat-page .footer {\r\n\tdisplay: none;\r\n}\r\n\r\n.chat-window {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\tposition: relative;\r\n}\r\n\r\n.chat-cont-left {\r\n\tborder-right: 1px solid #f0f0f0;\r\n\t-ms-flex: 0 0 35%;\r\n\tflex: 0 0 35%;\r\n\tleft: 0;\r\n\tmax-width: 35%;\r\n\tposition: relative;\r\n\tz-index: 4;\r\n}\r\n\r\n.chat-page .content {\r\n    padding: 0;\r\n}\r\n\r\n.chat-page .content > .container-fluid {\r\n    padding: 0;\r\n}\r\n\r\n.chat-cont-left .chat-header {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tbackground-color: #fff;\r\n\tborder-bottom: 1px solid #f0f0f0;\r\n\tcolor: #272b41;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\theight: 72px;\r\n\tjustify-content: space-between;\r\n\t-webkit-justify-content: space-between;\r\n\t-ms-flex-pack: space-between;\r\n\tpadding: 0 15px;\r\n}\r\n\r\n.chat-cont-left .chat-header span {\r\n\tfont-size: 20px;\r\n\tfont-weight: 500;\r\n\ttext-transform: capitalize;\r\n}\r\n\r\n.chat-cont-left .chat-header .chat-compose {\r\n\tcolor: #8a8a8a;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n}\r\n\r\n.chat-cont-left .chat-search {\r\n\tbackground-color: #f5f5f6;\r\n\tborder-bottom: 1px solid #e5e5e5;\r\n\tpadding: 10px 15px;\r\n\twidth: 100%;\r\n}\r\n\r\n.chat-cont-left .chat-search .input-group {\r\n\twidth: 100%;\r\n}\r\n\r\n.chat-cont-left .chat-search .input-group .form-control {\r\n\tbackground-color: #fff;\r\n\tborder-radius: 50px !important;\r\n\tpadding-left: 36px;\r\n}\r\n\r\n.chat-cont-left .chat-search .input-group .form-control:focus {\r\n\tborder-color: #ccc;\r\n\tbox-shadow: none;\r\n}\r\n\r\n.chat-cont-left .chat-search .input-group .input-group-prepend {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tbottom: 0;\r\n\tcolor: #666;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tleft: 15px;\r\n\tpointer-events: none;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tz-index: 4;\r\n}\r\n\r\n.chat-window .chat-scroll {\r\n\tmin-height: 300px;\r\n\tmax-height: calc(100vh - 260px);\r\n\toverflow-y: auto;\r\n}\r\n\r\n.chat-cont-left .chat-users-list {\r\n\tbackground-color: #fff;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media {\r\n\tborder-bottom: 1px solid #f0f0f0;\r\n\tpadding: 10px 15px;\r\n\ttransition: all 0.2s ease 0s;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media:last-child {\r\n\tborder-bottom: 0;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media .media-img-wrap {\r\n\tmargin-right: 15px;\r\n\tposition: relative;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media .media-img-wrap .avatar {\r\n\theight: 45px;\r\n\twidth: 45px;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media .media-img-wrap .status {\r\n\tbottom: 7px;\r\n\theight: 10px;\r\n\tright: 4px;\r\n\tposition: absolute;\r\n\twidth: 10px;\r\n\tborder: 2px solid #fff;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media .media-body {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\t-webkit-justify-content: space-between;\r\n\t-ms-flex-pack: space-between;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name,\r\n.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {\r\n\tmax-width: 250px;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {\r\n\tcolor: #272b41;\r\n\ttext-transform: capitalize;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {\r\n\tcolor: #8a8a8a;\r\n\tfont-size: 14px;\r\n\tline-height: 24px;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media .media-body > div:last-child {\r\n\ttext-align: right;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media .media-body > div:last-child .last-chat-time {\r\n\tcolor: #8a8a8a;\r\n\tfont-size: 13px;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media:hover {\r\n\tbackground-color: #f5f5f6;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media.read-chat .media-body > div:last-child .last-chat-time {\r\n\tcolor: #8a8a8a;\r\n}\r\n\r\n.chat-cont-left .chat-users-list a.media.active {\r\n\tbackground-color: #f5f5f6;\r\n}\r\n\r\n.chat-cont-right {\r\n\t-ms-flex: 0 0 65%;\r\n\tflex: 0 0 65%;\r\n\tmax-width: 65%;\r\n}\r\n\r\n.chat-cont-right .chat-header {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tbackground-color: #fff;\r\n\tborder-bottom: 1px solid #f0f0f0;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\theight: 72px;\r\n\tjustify-content: space-between;\r\n\t-webkit-justify-content: space-between;\r\n\t-ms-flex-pack: space-between;\r\n\tpadding: 0 15px;\r\n}\r\n\r\n.chat-cont-right .chat-header .back-user-list {\r\n\tdisplay: none;\r\n\tmargin-right: 5px;\r\n\tmargin-left: -7px;\r\n}\r\n\r\n.chat-cont-right .chat-header .media {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n}\r\n\r\n.chat-cont-right .chat-header .media .media-img-wrap {\r\n\tposition: relative;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tmargin-right: 15px;\r\n}\r\n\r\n.chat-cont-right .chat-header .media .media-img-wrap .avatar {\r\n\theight: 50px;\r\n\twidth: 50px;\r\n}\r\n\r\n.chat-cont-right .chat-header .media .media-img-wrap .status {\r\n\tborder: 2px solid #fff;\r\n\tbottom: 0;\r\n\theight: 10px;\r\n\tposition: absolute;\r\n\tright: 3px;\r\n\twidth: 10px;\r\n}\r\n\r\n.chat-cont-right .chat-header .media .media-body .user-name {\r\n\tcolor: #272b41;\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\ttext-transform: capitalize;\r\n}\r\n\r\n.chat-cont-right .chat-header .media .media-body .user-status {\r\n\tcolor: #666;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.chat-cont-right .chat-header .chat-options {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}\r\n\r\n.chat-cont-right .chat-header .chat-options > a {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tborder-radius: 50%;\r\n\tcolor: #8a8a8a;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\theight: 30px;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\t-ms-flex-pack: center;\r\n\tmargin-left: 10px;\r\n\twidth: 30px;\r\n}\r\n\r\n.chat-cont-right .chat-body {\r\n\tbackground-color: #f5f5f6;\r\n}\r\n\r\n.chat-cont-right .chat-body ul.list-unstyled {\r\n\tmargin: 0 auto;\r\n\tpadding: 15px;\r\n\twidth: 100%;\r\n}\r\n\r\n.chat-cont-right .chat-body .media .avatar {\r\n\theight: 30px;\r\n\twidth: 30px;\r\n}\r\n\r\n.chat-cont-right .chat-body .media .media-body {\r\n\tmargin-left: 20px;\r\n}\r\n\r\n.chat-cont-right .chat-body .media .media-body .msg-box > div {\r\n\tpadding: 10px 15px;\r\n\tborder-radius: .25rem;\r\n\tdisplay: inline-block;\r\n\tposition: relative;\r\n}\r\n\r\n.chat-cont-right .chat-body .media .media-body .msg-box > div p {\r\n\tcolor: #272b41;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.chat-cont-right .chat-body .media .media-body .msg-box+.msg-box {\r\n\tmargin-top: 5px;\r\n}\r\n\r\n.chat-cont-right .chat-body .media.received {\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.chat-cont-right .chat-body .media:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.chat-cont-right .chat-body .media.received .media-body .msg-box > div {\r\n\tbackground-color: #fff;\r\n}\r\n\r\n.chat-cont-right .chat-body .media.sent {\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.chat-cont-right .chat-body .media.sent .media-body {\r\n\t-webkit-box-align: flex-end;\r\n\t-ms-flex-align: flex-end;\r\n\talign-items: flex-end;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column;\r\n\tjustify-content: flex-end;\r\n\t-webkit-justify-content: flex-end;\r\n\t-ms-flex-pack: flex-end;\r\n\tmargin-left: 0;\r\n}\r\n\r\n.chat-cont-right .chat-body .media.sent .media-body .msg-box > div {\r\n\tbackground-color: #e3e3e3;\r\n}\r\n\r\n.chat-cont-right .chat-body .media.sent .media-body .msg-box > div p {\r\n\tcolor: #272b41;\r\n}\r\n\r\n.chat-cont-right .chat-body .chat-date {\r\n\tfont-size: 14px;\r\n\tmargin: 1.875rem 0;\r\n\toverflow: hidden;\r\n\tposition: relative;\r\n\ttext-align: center;\r\n\ttext-transform: capitalize;\r\n}\r\n\r\n.chat-cont-right .chat-body .chat-date:before {\r\n\tbackground-color: #e0e3e4;\r\n\tcontent: \"\";\r\n\theight: 1px;\r\n\tmargin-right: 28px;\r\n\tposition: absolute;\r\n\tright: 50%;\r\n\ttop: 50%;\r\n\twidth: 100%;\r\n}\r\n\r\n.chat-cont-right .chat-body .chat-date:after {\r\n\tbackground-color: #e0e3e4;\r\n\tcontent: \"\";\r\n\theight: 1px;\r\n\tleft: 50%;\r\n\tmargin-left: 28px;\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\twidth: 100%;\r\n}\r\n\r\n.chat-cont-right .chat-footer {\r\n\tbackground-color: #fff;\r\n\tborder-top: 1px solid #f0f0f0;\r\n\tpadding: 10px 15px;\r\n\tposition: relative;\r\n}\r\n\r\n.chat-cont-right .chat-footer .input-group {\r\n\twidth: 100%;\r\n}\r\n\r\n.chat-cont-right .chat-footer .input-group .form-control {\r\n\tbackground-color: #f5f5f6;\r\n\tborder: none;\r\n\tborder-radius: 50px;\r\n}\r\n\r\n.chat-cont-right .chat-footer .input-group .form-control:focus {\r\n\tbackground-color: #f5f5f6;\r\n\tborder: none;\r\n\tbox-shadow: none;\r\n}\r\n\r\n.chat-cont-right .chat-footer .input-group .input-group-prepend .btn,\r\n.chat-cont-right .chat-footer .input-group .input-group-append .btn {\r\n\tbackground-color: transparent;\r\n\tborder: none;\r\n\tcolor: #9f9f9f;\r\n}\r\n\r\n.chat-cont-right .chat-footer .input-group .input-group-append .btn.msg-send-btn {\r\n\tbackground-color: #e8ba3f;\r\n\tborder-color: #e8ba3f;\r\n\tborder-radius: 50%;\r\n\tcolor: #fff;\r\n\tmargin-left: 10px;\r\n\tmin-width: 46px;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.msg-typing {\r\n\twidth: auto;\r\n\theight: 24px;\r\n\tpadding-top: 8px\r\n}\r\n\r\n.msg-typing span {\r\n\theight: 8px;\r\n\twidth: 8px;\r\n\tfloat: left;\r\n\tmargin: 0 1px;\r\n\tbackground-color: #a0a0a0;\r\n\tdisplay: block;\r\n\tborder-radius: 50%;\r\n\topacity: .4\r\n}\r\n\r\n.msg-typing span:nth-of-type(1) {\r\n\tanimation: 1s blink infinite .33333s\r\n}\r\n\r\n.msg-typing span:nth-of-type(2) {\r\n\tanimation: 1s blink infinite .66666s\r\n}\r\n\r\n.msg-typing span:nth-of-type(3) {\r\n\tanimation: 1s blink infinite .99999s\r\n}\r\n\r\n.chat-cont-right .chat-body .media.received .media-body .msg-box {\r\n\tposition: relative;\r\n}\r\n\r\n.chat-cont-right .chat-body .media.received .media-body .msg-box:first-child:before {\r\n\tborder-bottom: 6px solid transparent;\r\n\tborder-right: 6px solid #fff;\r\n\tborder-top: 6px solid transparent;\r\n\tcontent: \"\";\r\n\theight: 0;\r\n\tleft: -6px;\r\n\tposition: absolute;\r\n\tright: auto;\r\n\ttop: 8px;\r\n\twidth: 0;\r\n}\r\n\r\n.chat-cont-right .chat-body .media.sent .media-body .msg-box {\r\n\tpadding-left: 50px;\r\n\tposition: relative;\r\n}\r\n\r\n.chat-cont-right .chat-body .media.sent .media-body .msg-box:first-child:before {\r\n\tborder-bottom: 6px solid transparent;\r\n\tborder-left: 6px solid #e3e3e3;\r\n\tborder-top: 6px solid transparent;\r\n\tcontent: \"\";\r\n\theight: 0;\r\n\tleft: auto;\r\n\tposition: absolute;\r\n\tright: -6px;\r\n\ttop: 8px;\r\n\twidth: 0;\r\n}\r\n\r\n.chat-msg-info {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tclear: both;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\tlist-style: none;\r\n\tpadding: 0;\r\n\tmargin: 5px 0 0;\r\n}\r\n\r\n.chat-msg-info li {\r\n\tfont-size: 13px;\r\n\tpadding-right: 16px;\r\n\tposition: relative;\r\n}\r\n\r\n.chat-msg-info li:not(:last-child):after {\r\n\tposition: absolute;\r\n\tright: 8px;\r\n\ttop: 50%;\r\n\tcontent: '';\r\n\theight: 4px;\r\n\twidth: 4px;\r\n\tbackground: #d2dde9;\r\n\tborder-radius: 50%;\r\n\ttransform: translate(50%, -50%)\r\n}\r\n\r\n.chat-cont-right .chat-body .media.sent .media-body .msg-box .chat-msg-info li:not(:last-child)::after {\r\n\tright: auto;\r\n\tleft: 8px;\r\n\ttransform: translate(-50%, -50%);\r\n\tbackground: #aaa;\r\n}\r\n\r\n.chat-cont-right .chat-body .media.received .media-body .msg-box > div .chat-time {\r\n\tcolor: rgba(50, 65, 72, 0.4);\r\n}\r\n\r\n.chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-time {\r\n\tcolor: rgba(50, 65, 72, 0.4);\r\n}\r\n\r\n.chat-msg-info li a {\r\n\tcolor: #777;\r\n}\r\n\r\n.chat-msg-info li a:hover {\r\n\tcolor: #2c80ff\r\n}\r\n\r\n.chat-seen i {\r\n\tcolor: #00d285;\r\n\tfont-size: 16px;\r\n}\r\n\r\n.chat-msg-attachments {\r\n\tpadding: 4px 0;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\twidth: 100%;\r\n\tmargin: 0 -1px\r\n}\r\n\r\n.chat-msg-attachments > div {\r\n\tmargin: 0 1px\r\n}\r\n\r\n.chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info {\r\n\tflex-direction: row-reverse;\r\n}\r\n\r\n.chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-attachments {\r\n\tflex-direction: row-reverse\r\n}\r\n\r\n.chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info li {\r\n\tpadding-left: 16px;\r\n\tpadding-right: 0;\r\n\tposition: relative;\r\n}\r\n\r\n.chat-attachment img {\r\n\tmax-width: 100%;\r\n}\r\n\r\n.chat-attachment {\r\n\tposition: relative;\r\n\tmax-width: 130px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.chat-attachment {\r\n\tborder-radius: .25rem;\r\n}\r\n\r\n.chat-attachment:before {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tbackground: #000;\r\n\tcontent: \"\";\r\n\topacity: 0.4;\r\n\ttransition: all .4s;\r\n}\r\n\r\n.chat-attachment:hover:before {\r\n\topacity: 0.6;\r\n}\r\n\r\n.chat-attach-caption {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tcolor: #fff;\r\n\tpadding: 7px 15px;\r\n\tfont-size: 13px;\r\n\topacity: 1;\r\n\ttransition: all .4s;\r\n}\r\n\r\n.chat-attach-download {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n\topacity: 0;\r\n\ttransition: all .4s;\r\n\tcolor: #fff;\r\n\twidth: 32px;\r\n\tline-height: 32px;\r\n\tbackground: rgba(255, 255, 255, 0.2);\r\n\ttext-align: center;\r\n}\r\n\r\n.chat-attach-download:hover {\r\n\tcolor: #495463;\r\n\tbackground: #fff;\r\n}\r\n\r\n.chat-attachment:hover .chat-attach-caption {\r\n\topacity: 0;\r\n}\r\n\r\n.chat-attachment:hover .chat-attach-download {\r\n\topacity: 1;\r\n}\r\n\r\n.chat-attachment-list {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tmargin: -5px;\r\n}\r\n\r\n.chat-attachment-list li {\r\n\twidth: 33.33%;\r\n\tpadding: 5px;\r\n}\r\n\r\n.chat-attachment-item {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tborder: 5px solid rgba(230, 239, 251, 0.5);\r\n\theight: 100%;\r\n\tmin-height: 60px;\r\n\ttext-align: center;\r\n\tfont-size: 30px;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\t-ms-flex-pack: center;\r\n}\r\n\r\n.chat-cont-right .chat-body .media.sent .media-body .msg-box > div:hover .chat-msg-actions {\r\n\topacity: 1;\r\n}\r\n\r\n.chat-msg-actions {\r\n\tposition: absolute;\r\n\tleft: -30px;\r\n\ttop: 50%;\r\n\ttransform: translateY(-50%);\r\n\topacity: 0;\r\n\ttransition: all .4s;\r\n\tz-index: 2;\r\n}\r\n\r\n.chat-msg-actions > a {\r\n\tpadding: 0 10px;\r\n\tcolor: #495463;\r\n\tfont-size: 24px;\r\n}\r\n\r\n.chat-msg-actions > a:hover {\r\n\tcolor: #2c80ff;\r\n}\r\n\r\n@keyframes blink {\r\n\t50% {\r\n\t\topacity: 1\r\n\t}\r\n}\r\n\r\n.btn-file {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\tfont-size: 20px;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\t-ms-flex-pack: center;\r\n\toverflow: hidden;\r\n\tpadding: 0 0.75rem;\r\n\tposition: relative;\r\n\tvertical-align: middle;\r\n}\r\n\r\n.btn-file input {\r\n\tcursor: pointer;\r\n\tfilter: alpha(opacity=0);\r\n\tfont-size: 23px;\r\n\theight: 100%;\r\n\tmargin: 0;\r\n\topacity: 0;\r\n\tposition: absolute;\r\n\tright: 0;\r\n\ttop: 0;\r\n\twidth: 100%;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t24. advisors Profile Settings\r\n-----------------------*/\r\n\r\n.profile-image img {\r\n\tmargin-bottom: 1.5rem;\r\n}\r\n\r\n.change-photo-btn {\r\n\tbackground-color: #e8b145;\r\n\tborder-radius: 50px;\r\n\tcolor: #fff;\r\n\tcursor: pointer;\r\n\tdisplay: block;\r\n\tfont-size: 13px;\r\n\tfont-weight: 600;\r\n\tmargin: 0 auto;\r\n\tpadding: 10px 15px;\r\n\tposition: relative;\r\n\ttransition: .3s;\r\n\ttext-align: center;\r\n\twidth: 220px;\r\n}\r\n\r\n.change-photo-btn input.upload {\r\n\tbottom: 0;\r\n\tcursor: pointer;\r\n\tfilter: alpha(opacity=0);\r\n\tleft: 0;\r\n\tmargin: 0;\r\n\topacity: 0;\r\n\tpadding: 0;\r\n\tposition: absolute;\r\n\tright: 0;\r\n\ttop: 0;\r\n\twidth: 220px;\r\n}\r\n\r\n.dropzone {\r\n\tbackground-color: #fbfbfb;\r\n\tborder: 2px dashed rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.btn-icon {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\ttext-align: center;\r\n\tposition: absolute;\r\n\tpadding: 0;\r\n\tfont-size: 10px;\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\tright: 3px;\r\n\ttop: 3px;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\t-ms-flex-pack: center;\r\n}\r\n\r\n.upload-images {\r\n\tposition: relative;\r\n\twidth: 80px;\r\n}\r\n\r\n.upload-images img {\r\n\tborder-radius: 4px;\r\n\theight: 80px;\r\n\twidth: auto;\r\n}\r\n\r\n.upload-wrap {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}\r\n\r\n.upload-wrap .upload-images+.upload-images {\r\n\tmargin-left: 20px;\r\n}\r\n\r\n.contact-card .card-body {\r\n\tpadding-bottom: 0.625rem;\r\n}\r\n\r\n.custom_price_cont {\r\n\tmargin-top: 20px;\r\n}\r\n\r\n.btn.btn-danger.trash {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\theight: 46px;\r\n\twidth: 46px;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\t-ms-flex-pack: center;\r\n}\r\n\r\n.add-more a {\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.bootstrap-tagsinput {\r\n\tborder-color: #dcdcdc;\r\n\tbox-shadow: inherit;\r\n\tmin-height: 46px;\r\n\twidth: 100%;\r\n\tborder-radius: 0;\r\n}\r\n\r\n.bootstrap-tagsinput.focus {\r\n\tborder-color: #bbb;\r\n}\r\n\r\n.bootstrap-tagsinput .tag {\r\n\tbackground-color: #e5bd54 !important;\r\n\tcolor: #fff;\r\n\tdisplay: inline-block;\r\n\tfont-size: 14px;\r\n\tfont-weight: normal;\r\n\tmargin-right: 2px;\r\n\tpadding: 11px 15px;\r\n\tborder-radius: 0;\r\n}\r\n\r\n.services-card .bootstrap-tagsinput input {\r\n\twidth: 160px;\r\n}\r\n\r\n.submit-section .submit-btn {\r\n\tpadding: 12px 30px;\r\n\tfont-weight: 600;\r\n\tfont-size: 16px;\r\n\tmin-width: 120px;\r\n}\r\n\r\n.submit-section .submit-btn+.submit-btn {\r\n\tmargin-left: 15px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t25. Calendar\r\n-----------------------*/\r\n\r\n#calendar-events {\r\n\tbackground-color: #fcfcfc;\r\n}\r\n\r\n.calendar-events {\r\n\tborder: 1px solid transparent;\r\n\tcursor: move;\r\n\tpadding: 10px 15px;\r\n}\r\n\r\n.calendar-events:hover {\r\n\tborder-color: #e9e9e9;\r\n\tbackground-color: #fff;\r\n}\r\n\r\n.calendar-events i {\r\n\tmargin-right: 8px;\r\n}\r\n\r\n.calendar {\r\n\tfloat: left;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.fc-toolbar.fc-header-toolbar {\r\n\tmargin-bottom: 1.5rem;\r\n}\r\n\r\n.none-border .modal-footer {\r\n\tborder-top: none;\r\n}\r\n\r\n.fc-toolbar h2 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 600;\r\n\tfont-family: 'Roboto', sans-serif;\r\n\tline-height: 30px;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.fc-day-grid-event .fc-time {\r\n\tfont-family: 'Roboto', sans-serif;\r\n}\r\n\r\n.fc-day {\r\n\tbackground: #fff;\r\n}\r\n\r\n.fc-toolbar .fc-state-active,\r\n.fc-toolbar .ui-state-active,\r\n.fc-toolbar button:focus,\r\n.fc-toolbar button:hover,\r\n.fc-toolbar .ui-state-hover {\r\n\tz-index: 0;\r\n}\r\n\r\n.fc th.fc-widget-header {\r\n\tbackground: #eeeeee;\r\n\tfont-size: 14px;\r\n\tline-height: 20px;\r\n\tpadding: 10px 0;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.fc-unthemed th,\r\n.fc-unthemed td,\r\n.fc-unthemed thead,\r\n.fc-unthemed tbody,\r\n.fc-unthemed .fc-divider,\r\n.fc-unthemed .fc-row,\r\n.fc-unthemed .fc-popover {\r\n\tborder-color: #f3f3f3;\r\n}\r\n\r\n.fc-basic-view .fc-day-number,\r\n.fc-basic-view .fc-week-number {\r\n\tpadding: 2px 5px;\r\n}\r\n\r\n.fc-button {\r\n\tbackground: #f1f1f1;\r\n\tborder: none;\r\n\tcolor: #797979;\r\n\ttext-transform: capitalize;\r\n\tbox-shadow: none !important;\r\n\tborder-radius: 3px !important;\r\n\tmargin: 0 3px !important;\r\n\tpadding: 6px 12px !important;\r\n\theight: auto !important;\r\n}\r\n\r\n.fc-text-arrow {\r\n\tfont-family: inherit;\r\n\tfont-size: 16px;\r\n}\r\n\r\n.fc-state-hover {\r\n\tbackground: #f3f3f3;\r\n}\r\n\r\n.fc-state-highlight {\r\n\tbackground: #f0f0f0;\r\n}\r\n\r\n.fc-state-down,\r\n.fc-state-active,\r\n.fc-state-disabled {\r\n\tbackground-color: #e5bd54 !important;\r\n\tcolor: #fff !important;\r\n\ttext-shadow: none !important;\r\n}\r\n\r\n.fc-cell-overlay {\r\n\tbackground: #f0f0f0;\r\n}\r\n\r\n.fc-unthemed .fc-today {\r\n\tbackground: #fff;\r\n}\r\n\r\n.fc-event {\r\n\tborder-radius: 2px;\r\n\tborder: none;\r\n\tcolor: #fff !important;\r\n\tcursor: move;\r\n\tfont-size: 13px;\r\n\tmargin: 1px 7px;\r\n\tpadding: 5px 5px;\r\n\ttext-align: center;\r\n}\r\n\r\n.fc-basic-view td.fc-week-number span {\r\n\tpadding-right: 8px;\r\n\tfont-weight: 700;\r\n\tfont-family: 'Roboto', sans-serif;\r\n}\r\n\r\n.fc-basic-view td.fc-day-number {\r\n\tpadding-right: 8px;\r\n\tfont-weight: 700;\r\n\tfont-family: 'Roboto', sans-serif;\r\n}\r\n\r\n.event-form .input-group .form-control {\r\n\theight: 40px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t26. Customer Dashboard\r\n-----------------------*/\r\n\r\n.profile-sidebar {\r\n\tbackground-color: #fff;\r\n\tborder-radius: 10px;\r\n\tmargin-bottom: 30px;\r\n\toverflow: hidden;\r\n\tbox-shadow: 0px 2px 8px rgb(183 183 183 / 25%);\r\n}\r\n\r\n.pro-widget-content {\r\n\tborder-bottom: 1px solid #f0f0f0;\r\n\tpadding: 20px;\r\n\ttext-align: center;\r\n}\r\n\r\n.profile-info-widget {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\ttext-align: left;\r\n}\r\n\r\n.profile-info-widget .booking-doc-img {\r\n\tmargin-right: 15px;\r\n}\r\n\r\n.profile-info-widget .booking-doc-img img {\r\n\tborder-radius: 4px;\r\n\theight: 90px;\r\n\twidth: 90px;\r\n\tobject-fit: cover;\r\n}\r\n\r\n.profile-det-info {\r\n\toverflow: hidden;\r\n}\r\n\r\n.profile-det-info h3 {\r\n\tfont-size: 17px;\r\n\ttext-overflow: ellipsis;\r\n\twhite-space: nowrap;\r\n\toverflow: hidden;\r\n}\r\n\r\n.receiver-details h5 {\r\n\tcolor: #757575;\r\n\tfont-size: 13px;\r\n\tfont-weight: normal;\r\n\tmargin-bottom: 8px;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.receiver-details h5 i {\r\n\twidth: 18px;\r\n}\r\n\r\n.dashboard-menu ul {\r\n\tcolor: #757575;\r\n\tfont-size: 14px;\r\n\tline-height: 17px;\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\ttext-transform: capitalize;\r\n}\r\n\r\n.dashboard-menu ul li {\r\n\tline-height: inherit;\r\n}\r\n\r\n.dashboard-menu > ul > li {\r\n\tborder-bottom: 1px solid #f0f0f0;\r\n\tposition: relative;\r\n}\r\n.media {\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-align: start;\r\n    align-items: flex-start;\r\n}\r\n.media-img-wrap {\r\n    flex-shrink: 0!important;\r\n}\r\n.media-body {\r\n    flex-grow: 1!important;\r\n}\r\n\r\n.dashboard-menu > ul > li:last-child {\r\n\tborder-bottom: 0;\r\n}\r\n\r\n.dashboard-menu ul li a span,\r\n.dashboard-menu ul li a i {\r\n\tdisplay: inline-block;\r\n\tvertical-align: middle;\r\n}\r\n\r\n.dashboard-menu > ul > li > a {\r\n\tcolor: #757575;\r\n\tdisplay: block;\r\n\tpadding: 16px 20px;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.dashboard-menu > ul > li:hover > a,\r\n.dashboard-menu > ul > li.active > a {\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.dashboard-menu ul li a i {\r\n\tfont-size: 16px;\r\n\tmargin-right: 10px;\r\n\twidth: 16px;\r\n}\r\n\r\n.unread-msg {\r\n\tbackground-color: #e5bd54;\r\n\tborder-radius: 2px;\r\n\tcolor: #ffffff;\r\n\tfont-size: 10px;\r\n\tfont-style: normal;\r\n\tpadding: 0 5px;\r\n\tposition: absolute;\r\n\tright: 20px;\r\n\ttext-align: center;\r\n\ttop: 50%;\r\n\ttransform: translateY(-50%);\r\n}\r\n\r\n\r\n/*-----------------\r\n\t27. Profile Settings\r\n-----------------------*/\r\n\r\n.change-avatar {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}\r\n\r\n.change-avatar .profile-img {\r\n\tmargin-right: 15px;\r\n}\r\n\r\n.change-avatar .profile-img img {\r\n\tborder-radius: 4px;\r\n\theight: 100px;\r\n\twidth: 100px;\r\n\tobject-fit: cover;\r\n}\r\n\r\n.change-avatar .change-photo-btn {\r\n\tmargin: 0 0 10px;\r\n\twidth: 150px;\r\n}\r\n\r\n.widget-profile.pat-widget-profile .profile-info-widget .booking-doc-img {\r\n\tpadding: 0;\r\n}\r\n\r\n.widget-profile.pat-widget-profile .profile-info-widget .booking-doc-img img {\r\n\tborder-radius: 50%;\r\n\theight: 100px;\r\n\twidth: 100px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t28. Appoitment List\r\n-----------------------*/\r\n\r\n.widget-profile {\r\n\tbackground-color: #fff;\r\n\tborder-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.widget-profile .profile-info-widget {\r\n\tdisplay: block;\r\n\ttext-align: center;\r\n}\r\n\r\n.widget-profile .profile-info-widget .booking-doc-img {\r\n\tdisplay: inline-block;\r\n\tmargin: 0 0 15px;\r\n\twidth: auto;\r\n\tpadding: 8px;\r\n\tbackground-color: #f7f7f7;\r\n\tborder-radius: 50%;\r\n}\r\n\r\n.widget-profile .profile-info-widget .booking-doc-img img {\r\n\tborder-radius: 50%;\r\n\theight: 120px;\r\n\twidth: 120px;\r\n}\r\n\r\n.appointment-list .profile-info-widget {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tmargin-right: auto;\r\n\ttext-align: left;\r\n}\r\n\r\n.appointment-list .profile-info-widget .booking-doc-img img {\r\n\tborder-radius: 4px;\r\n\theight: 120px;\r\n\tobject-fit: cover;\r\n\twidth: 120px;\r\n}\r\n\r\n.batch .appointment-list {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #f0f0f0;\r\n\tborder-radius: 4px;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-wrap: wrap;\r\n\tflex-wrap: wrap;\r\n\tmargin-bottom: 20px;\r\n\tpadding: 20px;\r\n}\r\n\r\n.batch .appointment-list:last-child {\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n.batch .appointment-action {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n}\r\n\r\n.appointment-action a+a {\r\n\tmargin-left: 5px;\r\n}\r\n\r\n.appointment-action a {\r\n\tfont-size: 13px;\r\n}\r\n\r\n.info-details {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.info-details li .title {\r\n\tcolor: #272b41;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.info-details li .text {\r\n\tcolor: #757575;\r\n\tdisplay: block;\r\n\tfont-size: 16px;\r\n\toverflow: hidden;\r\n}\r\n\r\n.info-details li {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.info-details li:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t29. Reviews\r\n-----------------------*/\r\n\r\n.doc-review.review-listing {\r\n\tmargin: 0;\r\n}\r\n\r\n.review-listing.doc-review > ul > li {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #f0f0f0;\r\n\tpadding: 20px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t30. Voice call\r\n-----------------------*/\r\n\r\n.modal-open .main-wrapper {\r\n\t-webkit-filter: blur(1px);\r\n\t-moz-filter: blur(1px);\r\n\t-o-filter: blur(1px);\r\n\t-ms-filter: blur(1px);\r\n\tfilter: blur(1px);\r\n}\r\n\r\n.call-main-row {\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\toverflow: auto;\r\n\tpadding-bottom: inherit;\r\n\tpadding-top: inherit;\r\n\tposition: absolute;\r\n\tright: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.call-main-wrapper {\r\n\tdisplay: table;\r\n\theight: 100%;\r\n\ttable-layout: fixed;\r\n\twidth: 100%;\r\n}\r\n\r\n.call-view {\r\n\tdisplay: table-cell;\r\n\theight: 100%;\r\n\tfloat: none;\r\n\tpadding: 0;\r\n\tposition: static;\r\n\tvertical-align: top;\r\n\twidth: 75%;\r\n}\r\n\r\n.call-window {\r\n\tdisplay: table;\r\n\theight: 100%;\r\n\ttable-layout: fixed;\r\n\twidth: 100%;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #f0f0f0;\r\n}\r\n\r\n.fixed-header {\r\n\tbackground-color: #fff;\r\n\tborder-bottom: 1px solid #f0f0f0;\r\n\tpadding: 10px 15px;\r\n}\r\n\r\n.fixed-header .navbar {\r\n\tborder: 0 none;\r\n\tmargin: 0;\r\n\tmin-height: auto;\r\n\tpadding: 0;\r\n}\r\n\r\n.fixed-header .user-info a {\r\n\tcolor: #272b41;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.typing-text {\r\n\tcolor: #e5bd54;\r\n\tfont-size: 12px;\r\n\ttext-transform: lowercase;\r\n}\r\n\r\n.last-seen {\r\n\tcolor: #888;\r\n\tdisplay: block;\r\n\tfont-size: 12px;\r\n}\r\n\r\n.custom-menu {\r\n\tmargin-top: 6px;\r\n}\r\n\r\n.fixed-header .custom-menu {\r\n\tmargin: 0 0 1px;\r\n}\r\n\r\n.custom-menu.nav > li > a {\r\n\tcolor: #bbb;\r\n\tfont-size: 26px;\r\n\tline-height: 32px;\r\n\tmargin-left: 15px;\r\n\tpadding: 0;\r\n}\r\n\r\n.custom-menu.navbar-nav > li > a:hover,\r\n.custom-menu.navbar-nav > li > a:focus {\r\n\tbackground-color: transparent;\r\n}\r\n\r\n.custom-menu .dropdown-menu {\r\n\tleft: auto;\r\n\tright: 0;\r\n}\r\n\r\n.call-contents {\r\n\tdisplay: table-row;\r\n\theight: 100%;\r\n}\r\n\r\n.call-content-wrap {\r\n\theight: 100%;\r\n\tposition: relative;\r\n\twidth: 100%;\r\n}\r\n\r\n.voice-call-avatar {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\t-ms-flex-pack: center;\r\n\t-ms-flex: 2;\r\n\tflex: 2;\r\n}\r\n\r\n.voice-call-avatar .call-avatar {\r\n\tmargin: 15px;\r\n\twidth: 150px;\r\n\theight: 150px;\r\n\tborder-radius: 100%;\r\n\tborder: 1px solid rgba(0, 0, 0, 0.1);\r\n\tpadding: 3px;\r\n\tbackground-color: #fff;\r\n}\r\n\r\n.call-duration {\r\n\tdisplay: inline-block;\r\n\tfont-size: 30px;\r\n\tmargin-top: 4px;\r\n\tposition: absolute;\r\n\tleft: 0;\r\n}\r\n\r\n.voice-call-avatar .call-timing-count {\r\n\tpadding: 5px;\r\n}\r\n\r\n.voice-call-avatar .username {\r\n\tfont-size: 20px;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.call-footer {\r\n\tbackground-color: #fff;\r\n\tborder-top: 1px solid #f0f0f0;\r\n\tpadding: 15px;\r\n}\r\n\r\n.call-icons {\r\n\ttext-align: center;\r\n\tposition: relative;\r\n}\r\n\r\n.call-icons .call-items {\r\n\tborder-radius: 5px;\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tlist-style: none;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.call-icons .call-items .call-item {\r\n\tdisplay: inline-block;\r\n\ttext-align: center;\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.call-icons .call-items .call-item:last-child {\r\n\tmargin-right: 0;\r\n}\r\n\r\n.call-icons .call-items .call-item a {\r\n\tcolor: #777;\r\n\tborder: 1px solid #ddd;\r\n\twidth: 50px;\r\n\theight: 50px;\r\n\tline-height: 50px;\r\n\tborder-radius: 50px;\r\n\tdisplay: inline-block;\r\n\tfont-size: 20px;\r\n}\r\n\r\n.call-icons .call-items .call-item a i {\r\n\twidth: 18px;\r\n\theight: 18px;\r\n}\r\n\r\n.user-video {\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\toverflow: auto;\r\n\tposition: absolute;\r\n\tright: 0;\r\n\ttop: 0;\r\n\tz-index: 10;\r\n}\r\n\r\n.user-video img {\r\n\twidth: auto;\r\n\tmax-width: 100%;\r\n\theight: auto;\r\n\tmax-height: 100%;\r\n\tdisplay: block;\r\n\tmargin: 0 auto;\r\n}\r\n\r\n.user-video video {\r\n\twidth: auto;\r\n\tmax-width: 100%;\r\n\theight: auto;\r\n\tmax-height: 100%;\r\n\tdisplay: block;\r\n\tmargin: 0 auto;\r\n}\r\n\r\n.my-video {\r\n\tposition: absolute;\r\n\tz-index: 99;\r\n\tbottom: 20px;\r\n\tright: 20px;\r\n}\r\n\r\n.my-video ul {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tlist-style: none;\r\n}\r\n\r\n.my-video ul li {\r\n\tfloat: left;\r\n\twidth: 120px;\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.my-video ul li img {\r\n\tborder: 3px solid #fff;\r\n\tborder-radius: 6px;\r\n}\r\n\r\n.end-call {\r\n\tposition: absolute;\r\n\ttop: 7px;\r\n\tright: 0;\r\n}\r\n\r\n.end-call a {\r\n\tbackground-color: #f06060;\r\n\tborder-radius: 50px;\r\n\tcolor: #fff;\r\n\tdisplay: inline-block;\r\n\tline-height: 10px;\r\n\tpadding: 8px 25px;\r\n\ttext-transform: uppercase;\r\n}\r\n\r\n.call-users {\r\n\tposition: absolute;\r\n\tz-index: 99;\r\n\tbottom: 20px;\r\n\tright: 20px;\r\n}\r\n\r\n.call-users ul {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tlist-style: none;\r\n}\r\n\r\n.call-users ul li {\r\n\tfloat: left;\r\n\twidth: 80px;\r\n\tmargin-left: 10px;\r\n}\r\n\r\n.call-users ul li img {\r\n\tborder-radius: 6px;\r\n\tpadding: 2px;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.call-mute {\r\n\twidth: 80px;\r\n\theight: 80px;\r\n\tbackground-color: rgba(0, 0, 0, 0.5);\r\n\tposition: absolute;\r\n\ttext-align: center;\r\n\tline-height: 80px;\r\n\tborder-radius: 6px;\r\n\tfont-size: 30px;\r\n\tcolor: #fff;\r\n\tdisplay: none;\r\n\ttop: 0;\r\n\tborder: 3px solid transparent;\r\n}\r\n\r\n.call-users ul li a:hover .call-mute {\r\n\tdisplay: block;\r\n}\r\n\r\n.call-details {\r\n\tmargin: 10px 0 0;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n}\r\n\r\n.call-info {\r\n\tmargin-left: 10px;\r\n\twidth: 100%;\r\n}\r\n\r\n.call-user-details,\r\n.call-timing {\r\n\tdisplay: block;\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.call-description {\r\n\twhite-space: nowrap;\r\n\tvertical-align: bottom;\r\n}\r\n\r\n.call-timing {\r\n\tcolor: #727272;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tfont-size: 14px;\r\n\tmargin-top: 1px;\r\n\toverflow: hidden;\r\n\twhite-space: pre;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t31. Video Call\r\n-----------------------*/\r\n\r\n.content-full {\r\n\theight: 100%;\r\n\tposition: relative;\r\n\twidth: 100%;\r\n}\r\n\r\n.video-window .fixed-header {\r\n\tpadding: 0;\r\n\tborder: 0;\r\n}\r\n\r\n.video-window .fixed-header .nav > li > a {\r\n\tpadding: 18px 15px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t32. Outgoing Call\r\n-----------------------*/\r\n\r\n.call-box .call-wrapper {\r\n\theight: auto;\r\n\ttext-align: center;\r\n}\r\n\r\n.call-box .call-wrapper .call-avatar {\r\n\tmargin-bottom: 30px;\r\n\tcursor: pointer;\r\n\tanimation: ripple 2s infinite;\r\n}\r\n\r\n.call-box .call-wrapper .call-user {\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n.call-box .call-wrapper .call-user span {\r\n\tdisplay: block;\r\n\tfont-weight: 500;\r\n\ttext-align: center;\r\n}\r\n\r\n.call-box .call-wrapper .call-items {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\t-ms-flex-pack: center;\r\n}\r\n\r\n.call-box .call-wrapper .call-items .call-item {\r\n\tbackground-color: rgba(255, 255, 255, 0.2);\r\n\tborder: 1px solid transparent;\r\n\tborder-radius: 100%;\r\n\tcolor: #fff;\r\n\tline-height: 0;\r\n\tmargin: 0 5px;\r\n\tpadding: 15px;\r\n}\r\n\r\n.call-box .call-wrapper .call-items .call-item:hover {\r\n\topacity: 0.9;\r\n}\r\n\r\n.call-box .call-wrapper .call-items .call-item:first-child {\r\n\tmargin-top: -30px;\r\n}\r\n\r\n.call-box .call-wrapper .call-items .call-item:last-child {\r\n\tmargin-top: -30px;\r\n}\r\n\r\n.call-box .call-wrapper .call-items .call-item.call-end {\r\n\tpadding: 20px;\r\n\tmargin: 30px 20px 0;\r\n\tbackground: #f06060;\r\n\tborder: 1px solid #f06060;\r\n\tcolor: #fff;\r\n\tline-height: 0;\r\n\tborder-radius: 100%;\r\n}\r\n\r\n.call-box .call-wrapper .call-items .call-item.call-start {\r\n\tpadding: 20px;\r\n\tmargin: 30px 20px 0;\r\n\tbackground: #55ce63;\r\n\tborder: 1px solid #55ce63;\r\n\tcolor: #fff;\r\n\tline-height: 0;\r\n\tborder-radius: 100%;\r\n}\r\n\r\n.call-box.incoming-box .call-wrapper .call-items .call-item.call-start {\r\n\tmargin: 0 10px;\r\n}\r\n\r\n.call-box.incoming-box .call-wrapper .call-items .call-item.call-end {\r\n\tmargin: 0 10px;\r\n}\r\n\r\n.call-box .call-avatar {\r\n\tborder-radius: 100%;\r\n\theight: 140px;\r\n\tmax-width: 140px;\r\n\tmin-width: 140px;\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\tborder: 10px solid #fafafa;\r\n}\r\n\r\n.call-box .btn {\r\n\tbackground: rgba(0, 0, 0, 0);\r\n\ttransition: all 0.3s ease 0s;\r\n}\r\n\r\n@-webkit-keyframes ripple {\r\n\t0% {\r\n\t\t-webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);\r\n\t}\r\n\t100% {\r\n\t\t-webkit-box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);\r\n\t}\r\n}\r\n\r\n@keyframes ripple {\r\n\t0% {\r\n\t\t-moz-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);\r\n\t\tbox-shadow: 0 0 0 0 rgba(0, 0, 0, 0.1);\r\n\t}\r\n\t100% {\r\n\t\t-moz-box-shadow: 0 0 0 30px rgba(0, 0, 0, 0);\r\n\t\tbox-shadow: 0 0 0 30px rgba(0, 0, 0, 0);\r\n\t}\r\n}\r\n\r\n\r\n/*-----------------\r\n\t33. Incoming Call\r\n-----------------------*/\r\n\r\n.incoming-btns {\r\n\tmargin-top: 20px;\r\n}\r\n\r\n.call-wrapper {\r\n\tposition: relative;\r\n\theight: calc(100vh - 145px);\r\n}\r\n\r\n.call-page .footer {\r\n\tdisplay: none;\r\n}\r\n\r\n.dropdown-action .dropdown-toggle::after {\r\n\tdisplay: none;\r\n}\r\n\r\n.call-modal .modal-body {\r\n\tpadding: 40px;\r\n}\r\n\r\n.call-modal .modal-content {\r\n\tborder: 0;\r\n\tborder-radius: 10px;\r\n}\r\n\r\n.call-box .call-wrapper .call-user h4 {\r\n\tfont-size: 24px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t34. Terms and Conditions\r\n-----------------------*/\r\n\r\n.terms-text {\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.terms-text h4 {\r\n\tfont-size: 24px;\r\n\tfont-weight: 500;\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.terms-text p {\r\n\tcolor: #666;\r\n\tdisplay: inline-block;\r\n\tfont-size: 16px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t35. Blog\r\n-----------------------*/\r\n\r\n.blog {\r\n\tborder: 1px solid #f0f0f0;\r\n\tbackground-color: #fff;\r\n\tborder-radius: 4px;\r\n\tmargin-bottom: 30px;\r\n\tpadding: 1.5rem;\r\n\tposition: relative;\r\n}\r\n\r\n.blog-image {\r\n\toverflow: hidden;\r\n}\r\n\r\n.blog-image,\r\n.blog-image > a,\r\n.blog-image img {\r\n\tdisplay: block;\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\theight: auto;\r\n}\r\n\r\n.blog-image img {\r\n\t-webkit-transform: translateZ(0);\r\n\t-moz-transform: translateZ(0);\r\n\ttransform: translateZ(0);\r\n\t-moz-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n\t-ms-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n\t-o-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n\t-webkit-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n\ttransition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n}\r\n\r\n.blog-image a:hover img {\r\n\t-webkit-transform: scale(1.15);\r\n\t-moz-transform: scale(1.15);\r\n\ttransform: scale(1.15);\r\n}\r\n\r\n.blog-image {\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n.blog-content {\r\n\tposition: relative;\r\n}\r\n\r\n.blog-title {\r\n\tfont-size: 22px;\r\n\tmargin: 0 0 10px;\r\n}\r\n\r\n.blog-title a {\r\n\tcolor: #272b41;\r\n}\r\n\r\n.blog-title a:hover {\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.blog-content p {\r\n\tcolor: #666;\r\n\tfont-size: 14px;\r\n\tmargin: 0 0 30px;\r\n}\r\n\r\n.read-more {\r\n\tdisplay: inline-block;\r\n\tfont-size: 16px;\r\n\tpadding: 0;\r\n\tcolor: #e5bd54;\r\n\ttext-decoration: underline;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.blog-info {\r\n\tcolor: #757575;\r\n\tfont-size: 14px;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.blog-info a {\r\n\tcolor: #757575;\r\n}\r\n\r\n.blog-info a:hover {\r\n\tcolor: #757575;\r\n}\r\n\r\n.blog-info i {\r\n\tcolor: #e5bd54;\r\n\tfont-size: 14px;\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.entry-meta {\r\n\tcolor: #757575;\r\n\tfont-size: 14px;\r\n\tlist-style: none;\r\n\tmargin-bottom: 15px;\r\n\tpadding: 0;\r\n}\r\n\r\n.entry-meta li {\r\n\tdisplay: inline-block;\r\n\tmargin-right: 15px;\r\n}\r\n\r\n.entry-meta li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n\r\n.blog-pagination .pagination {\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n.blog-pagination .pagination li a {\r\n\tpadding: 12px 20px;\r\n\tfont-weight: 600;\r\n\tcolor: #2E3842;\r\n\tmargin-right: 10px;\r\n\tborder-radius: inherit !important;\r\n\tborder-color: #f0f0f0;\r\n}\r\n\r\n.blog-pagination .pagination li.disabled a {\r\n\tborder-color: #f0f0f0;\r\n}\r\n\r\n.blog-pagination .pagination li.active a {\r\n\tbackground: #e5bd54;\r\n\tborder-color: transparent;\r\n\tcolor: #ffffff;\r\n}\r\n\r\n.post-left ul {\r\n\tmargin: 0;\r\n\tpadding-left: 0;\r\n\tlist-style: none;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tflex-wrap: wrap;\r\n}\r\n\r\n.post-left ul li {\r\n\tmargin-bottom: 5px;\r\n\tmargin-right: 20px;\r\n}\r\n\r\n.post-left ul li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n\r\n.post-author a {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n}\r\n\r\n.video {\r\n\tposition: relative;\r\n\tpadding-bottom: 56%;\r\n\theight: 0;\r\n\toverflow: hidden;\r\n}\r\n\r\n.video iframe,\r\n.video object,\r\n.video embed {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tborder: none;\r\n}\r\n\r\n.latest-posts {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.latest-posts li {\r\n\tdisplay: table;\r\n\twidth: 100%;\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.latest-posts li:last-child {\r\n\tpadding-bottom: 0px;\r\n\tmargin-bottom: 0px;\r\n\tborder-bottom: none;\r\n}\r\n\r\n.post-thumb {\r\n\tborder-radius: 4px;\r\n\twidth: 80px;\r\n\tfloat: left;\r\n\toverflow: hidden;\r\n}\r\n\r\n.post-thumb a img {\r\n\tborder-radius: 4px;\r\n\t-webkit-transform: translateZ(0);\r\n\t-moz-transform: translateZ(0);\r\n\ttransform: translateZ(0);\r\n\t-moz-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n\t-ms-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n\t-o-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n\t-webkit-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n\ttransition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n}\r\n\r\n.post-thumb a:hover img {\r\n\t-webkit-transform: scale(1.15);\r\n\t-moz-transform: scale(1.15);\r\n\ttransform: scale(1.15);\r\n}\r\n\r\n.post-info {\r\n\tmargin-left: 95px;\r\n}\r\n\r\n.post-info h4 {\r\n\tfont-size: 15px;\r\n\tmargin: 0 0 5px;\r\n}\r\n\r\n.post-info h4 a {\r\n\tcolor: #272b41;\r\n}\r\n\r\n.post-info h4 a:hover {\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.post-info p {\r\n\tcolor: #757575;\r\n\tfont-size: 12px;\r\n\tmargin: 0;\r\n}\r\n\r\n.post-info p i {\r\n\tcolor: #e5bd54;\r\n\tfont-size: 14px;\r\n\tmargin-right: 4px;\r\n}\r\n\r\n.category-widget .categories {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.category-widget .categories li {\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.category-widget .categories li:last-child {\r\n\tborder-bottom: none;\r\n\tmargin-bottom: 0;\r\n\tpadding-bottom: 0;\r\n}\r\n\r\n.category-widget .categories li a {\r\n\tcolor: #2E3842;\r\n\tfont-size: 15px;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.category-widget .categories li a span {\r\n\tfloat: right;\r\n\tcolor: #757575;\r\n}\r\n\r\n.category-widget .categories li a:hover {\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.category-widget .categories > li > a > i {\r\n\tcolor: #e5bd54;\r\n\tfont-size: 18px;\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.tags-widget .card-body {\r\n\tpadding-bottom: 1rem;\r\n}\r\n\r\n.tags {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\toverflow: hidden;\r\n\tpadding: 0;\r\n}\r\n\r\n.tags li {\r\n\tfloat: left;\r\n}\r\n\r\n.tag {\r\n\tbackground-color: #fff;\r\n\tborder-radius: 4px;\r\n\tcolor: #272b41;\r\n\tpadding: 5px 10px;\r\n\tposition: relative;\r\n\tmargin: 0 .5rem .5rem 0;\r\n\tfont-size: 14px;\r\n\tborder: 1px solid #ccc;\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.tag:hover {\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n\tcolor: #fff;\r\n}\r\n\r\n.comment-by {\r\n\tdisplay: block;\r\n\tfont-size: 14px;\r\n\tline-height: 21px;\r\n\tmargin: 0 0 10px;\r\n}\r\n\r\n.comments-list .comment-block p {\r\n\tfont-size: 14px;\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t36. Blog Details\r\n-----------------------*/\r\n\r\n.blog-view .blog-title {\r\n\tfont-size: 24px;\r\n}\r\n\r\n.blog-content p:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.blog-view .blog-info {\r\n\tborder: 0;\r\n\tmargin-bottom: 20px;\r\n\tpadding: 0;\r\n}\r\n\r\n.social-share {\r\n\tfloat: left;\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.social-share > li {\r\n\tdisplay: inline-block;\r\n\tfloat: left;\r\n\tmargin-left: 10px;\r\n\ttext-align: center;\r\n}\r\n\r\n.social-share > li:first-child {\r\n\tmargin-left: 0;\r\n}\r\n\r\n.social-share > li > a {\r\n\tborder: 1px solid #dfdfdf;\r\n\tcolor: #666;\r\n\tdisplay: inline-block;\r\n\tfont-size: 22px;\r\n\theight: 40px;\r\n\tline-height: 40px;\r\n\twidth: 40px;\r\n}\r\n\r\n.social-share > li > a:hover {\r\n\tbackground-color: #e5bd54;\r\n\tcolor: #fff;\r\n\tborder-color: #e5bd54;\r\n}\r\n\r\n.blog-reply > a {\r\n\tcolor: #999;\r\n\tfont-size: 12px;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.blog-date {\r\n\tcolor: #999;\r\n\tfont-size: 12px;\r\n}\r\n\r\n.blog-comments .comments-list {\r\n\tlist-style: none;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tposition: relative;\r\n}\r\n\r\n.blog-comments .comments-list li {\r\n\tclear: both;\r\n\tpadding-left: 80px;\r\n}\r\n\r\n.blog-comments .comments-list li .comment {\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.blog-comments .comments-list li .comment-author {\r\n\tleft: 0;\r\n\tposition: absolute;\r\n}\r\n\r\n.blog-comments .comments-list li img.avatar {\r\n\theight: 58px;\r\n\twidth: 58px;\r\n\tborder-radius: 58px;\r\n}\r\n\r\n.blog-comments .comment-btn {\r\n\tcolor: #e5bd54;\r\n\tdisplay: inline-block;\r\n\tfont-weight: 500;\r\n\tfont-size: 15px;\r\n}\r\n\r\n.blog-author-name {\r\n\tcolor: #272b41;\r\n\tfont-size: 16px;\r\n\tfont-weight: 600;\r\n}\r\n\r\n.new-comment label {\r\n\tfont-weight: 500;\r\n}\r\n\r\n.comment-submit .btn {\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n\tborder-radius: 0;\r\n\tfont-size: 18px;\r\n\tpadding: 8px 26px;\r\n\tcolor: #fff;\r\n}\r\n\r\n.about-author-img {\r\n\tbackground-color: #fff;\r\n\theight: 100px;\r\n\toverflow: hidden;\r\n\tposition: absolute;\r\n\twidth: 100px;\r\n}\r\n\r\n.author-details {\r\n\tmargin-left: 120px;\r\n}\r\n\r\n.about-author {\r\n\tmin-height: 100px;\r\n}\r\n\r\n.author-details .blog-author-name {\r\n\tdisplay: inline-block;\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.post-author img {\r\n\tborder-radius: 100%;\r\n\twidth: 28px;\r\n\tmargin-right: 5px;\r\n}\r\n\r\n\r\n/*-----------------\r\n\t37. Blog Grid\r\n-----------------------*/\r\n\r\n.grid-blog .blog-title {\r\n\tfont-size: 18px;\r\n\tmargin: 0 0 5px;\r\n\tmin-height: 43px;\r\n}\r\n\r\n.grid-blog .blog-content p {\r\n\tmargin: 0 0 15px;\r\n}\r\n\r\n.grid-blog .blog-info {\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.grid-blog .blog-image {\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.blog.grid-blog {\r\n\tpadding: 20px;\r\n}\r\n\r\n.grid-blog .entry-meta {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tflex-wrap: wrap;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.grid-blog .entry-meta li {\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.grid-blog .entry-meta li:last-child {\r\n\tflex: 0 0 100px;\r\n\tmax-width: 100px;\r\n}\r\n\r\n.grid-blog .post-author {\r\n\twidth: 189px;\r\n\toverflow: hidden;\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n}\r\n\r\n.grid-blog .post-author a:hover {\r\n\tcolor: #e5bd54\r\n}\r\n\r\n\r\n/*-----------------\r\n\t38. Map List & Grid\r\n-----------------------*/\r\n\r\n.map-page .footer {\r\n\tdisplay: none;\r\n}\r\n\r\n.map-page .map-header {\r\n\tposition: fixed;\r\n\tleft: 0;\r\n\tright: 0;\r\n\ttop: 0;\r\n\tz-index: 1030;\r\n}\r\n\r\n.map-page .bootstrap-datetimepicker-widget {\r\n  z-index: 1030 !important;\r\n}\r\n\r\n.fixed {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    z-index: 99;\r\n}\r\n\r\n.map-page .content {\r\n\tpadding-top: 140px;\r\n}\r\n\r\n.map-right {\r\n\tbottom: 0;\r\n\theight: 100%;\r\n\tmin-height: 100%;\r\n\tpadding-right: 30px;\r\n\tposition: fixed;\r\n\tright: 0;\r\n\ttop: 140px;\r\n\tz-index: 1029;\r\n}\r\n\r\nbody.map-up .map-right {\r\n\ttop: 80px;\r\n\ttransition: ease all 0.5s;\r\n    -webkit-transition: ease all 0.5s;\r\n    -ms-transition: ease all 0.5s;\r\n}\r\n\r\n.map-listing {\r\n\theight: calc(100vh - 145px);\r\n\twidth: 100%;\r\n}\r\n\r\n.map-listing .profile-widget {\r\n\twidth: 200px !important;\r\n\tpadding: 0;\r\n\tborder: 0;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.map-right .available-info {\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.blank-page .content {\r\n\tmin-height: 200px !important;\r\n}\r\n\r\n.view-icons {\r\n\tdisplay: inline-flex;\r\n\tfloat: right;\r\n}\r\n\r\n.view-icons a {\r\n\talign-items: center;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #ddd;\r\n\tborder-radius: 4px;\r\n\tcolor: #212529;\r\n\tdisplay: flex;\r\n\tfont-size: 20px;\r\n\tjustify-content: center;\r\n\tpadding: 4px 10px;\r\n\ttext-align: center;\r\n\tmargin-left: 10px;\r\n\twidth: 44px;\r\n\theight: 44px;\r\n}\r\n\r\n.view-icons a:hover {\r\n\tborder-color: #e5bd54;\r\n\tcolor: #e5bd54;\r\n}\r\n\r\n.view-icons a.active {\r\n\tbackground-color: #e5bd54;\r\n\tborder-color: #e5bd54;\r\n\tcolor: #fff;\r\n}\r\n\r\n.profile-widget {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #f0f0f0;\r\n\tborder-radius: 4px;\r\n\tmargin-bottom: 30px;\r\n\tposition: relative;\r\n\t-webkit-transition: all .3s ease 0s;\r\n\t-moz-transition: all .3s ease 0s;\r\n\t-o-transition: all .3s ease 0s;\r\n\ttransition: all .3s ease 0s;\r\n\tpadding: 15px;\r\n}\r\n\r\n.doc-img {\r\n\tposition: relative;\r\n\toverflow: hidden;\r\n\tz-index: 1;\r\n\tborder-radius: 4px;\r\n}\r\n\r\n.doc-img img {\r\n\tborder-radius: 4px;\r\n\t-webkit-transform: translateZ(0);\r\n\t-moz-transform: translateZ(0);\r\n\ttransform: translateZ(0);\r\n\t-moz-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n\t-ms-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n\t-o-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n\t-webkit-transition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n\ttransition: all 2000ms cubic-bezier(.19, 1, .22, 1) 0ms;\r\n\twidth: 100%;\r\n}\r\n\r\n.doc-img:hover img {\r\n\t-webkit-transform: scale(1.15);\r\n\t-moz-transform: scale(1.15);\r\n\ttransform: scale(1.15);\r\n}\r\n\r\n.profile-widget .fav-btn {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tposition: absolute;\r\n\ttop: 5px;\r\n\tright: 5px;\r\n\tbackground-color: #fff;\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\t-ms-flex-pack: center;\r\n\tborder-radius: 3px;\r\n\tcolor: #2E3842;\r\n\t-webkit-transform: translate3d(100%, 0, 0);\r\n\t-ms-transform: translate3d(100%, 0, 0);\r\n\ttransform: translate3d(100%, 0, 0);\r\n\topacity: 0;\r\n\tvisibility: hidden;\r\n\tz-index: 99;\r\n}\r\n\r\n.profile-widget:hover .fav-btn {\r\n\topacity: 1;\r\n\tvisibility: visible;\r\n\t-webkit-transform: translate3d(0, 0, 0);\r\n\t-ms-transform: translate3d(0, 0, 0);\r\n\ttransform: translate3d(0, 0, 0);\r\n}\r\n\r\n.profile-widget .fav-btn:hover {\r\n\tbackground-color: #fb1612;\r\n\tcolor: #fff;\r\n}\r\n\r\n.pro-content {\r\n\tpadding: 15px 0 0;\r\n}\r\n\r\n.pro-content .title {\r\n\tfont-size: 17px;\r\n\tfont-weight: 500;\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n.profile-widget .pro-content .title a {\r\n\tdisplay: inline-block;\r\n}\r\n\r\n.profile-widget .verified {\r\n\tcolor: #28a745;\r\n\tmargin-left: 3px;\r\n}\r\n\r\n.profile-widget p.speciality {\r\n\tfont-size: 13px;\r\n\tcolor: #757575;\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.rating {\r\n\tlist-style: none;\r\n\tmargin: 0 0 7px;\r\n\tpadding: 0;\r\n\twidth: 100%;\r\n}\r\n\r\n.rating i {\r\n\tcolor: #dedfe0;\r\n}\r\n\r\n.rating i.filled {\r\n\tcolor: #f4c150;\r\n}\r\n\r\n.profile-widget .rating {\r\n\tcolor: #757575;\r\n\tfont-size: 14px;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.profile-widget .rating i {\r\n\tfont-size: 14px;\r\n}\r\n\r\n.available-info {\r\n\tfont-size: 13px;\r\n\tcolor: #757575;\r\n\tfont-weight: 400;\r\n\tlist-style: none;\r\n\tpadding: 0;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n.available-info li+li {\r\n\tmargin-top: 5px;\r\n}\r\n\r\n.available-info li i {\r\n\twidth: 22px;\r\n}\r\n\r\n.row.row-sm {\r\n\tmargin-left: -3px;\r\n\tmargin-right: -3px;\r\n}\r\n\r\n.row.row-sm > div {\r\n\tpadding-left: 3px;\r\n\tpadding-right: 3px;\r\n}\r\n\r\n.view-btn {\r\n\tcolor: #f1c144;\r\n\tfont-size: 13px;\r\n\tborder: 2px solid #f1c144;\r\n\ttext-align: center;\r\n\tdisplay: block;\r\n\tfont-weight: 500;\r\n\tpadding: 6px;\r\n}\r\n\r\n.view-btn:hover,\r\n.view-btn:focus {\r\n\tbackground-color: #f1c144;\r\n\tcolor: #fff;\r\n}\r\n\r\n.book-btn {\r\n\tbackground-color: #f1c144;\r\n\tborder: 2px solid #f1c144;\r\n\tcolor: #fff;\r\n\tfont-size: 13px;\r\n\ttext-align: center;\r\n\tdisplay: block;\r\n\tfont-weight: 500;\r\n\tpadding: 6px;\r\n}\r\n\r\n.book-btn:hover,\r\n.book-btn:focus {\r\n\tbackground-color: #ecba37;\r\n\tborder-color: #ecba37;\r\n\tcolor: #fff;\r\n}\r\n\r\n.section-sender .profile-widget {\r\n\tbox-shadow: 2px 2px 13px rgba(0, 0, 0, 0.1);\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n\r\n/*-----------------\r\n\tCarousel\r\n-----------------------*/\r\n\r\n.carousel {\r\n    height: 95px;\r\n    width: 560px;\r\n    position: relative;\r\n    overflow-x: scroll;\r\n    margin: auto 0;\r\n    padding: 0;\r\n    list-style: none;\r\n    /* width: 100%; */\r\n    display: flex;\r\n    left: 0;\r\n    transition: all 1s ease;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .carousel {\r\n        width: 320px;\r\n    }\r\n}\r\n\r\n.carousel-card {\r\n    min-width: 70px;\r\n    height: 80px;\r\n    margin: 0 5px;\r\n    background-color: #f2f2f2;\r\n}\r\n\r\n.carousel-card a {\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.carousel-card a:hover {\r\n    background-color: #d0d0d0;\r\n    border-color: #d0d0d0;\r\n}\r\n\r\n.carousel-card a.active-card, .carousel-card a.active-card:hover {\r\n    background-color: #e5bd54;\r\n    border-color: #e5bd54;\r\n}\r\n\r\n.carousel-card a.active-card * {\r\n    color: #fff;\r\n}\r\n  \r\n.carousel-arrow {\r\n    height: fit-content;\r\n    align-self: center;\r\n    cursor: pointer;\r\n}  \r\n\r\n\r\n/*-----------------\r\n\t39. Responsive\r\n-----------------------*/\r\n\r\n@media only screen and (min-width:768px) {\r\n\t.avatar-xxl {\r\n\t\twidth: 8rem;\r\n\t\theight: 8rem;\r\n\t}\r\n\t.avatar-xxl .border {\r\n\t\tborder-width: 4px !important;\r\n\t}\r\n\t.avatar-xxl .rounded {\r\n\t\tborder-radius: 12px !important;\r\n\t}\r\n\t.avatar-xxl .avatar-title {\r\n\t\tfont-size: 42px;\r\n\t}\r\n\t.avatar-xxl.avatar-away:before,\r\n\t.avatar-xxl.avatar-offline:before,\r\n\t.avatar-xxl.avatar-online:before {\r\n\t\tborder-width: 4px;\r\n\t}\r\n}\r\n\r\n@media (min-width: 992px) {\r\n\r\n\t.container {\r\n\t\tmax-width: 1440px;\r\n\t}\r\n\t.main-nav > li {\r\n\t\tmargin-right: 30px;\r\n\t}\r\n\t.main-nav > li:last-child {\r\n\t\tmargin-right: 0;\r\n\t}\r\n\t.main-nav li {\r\n\t\tdisplay: block;\r\n\t\tposition: relative;\r\n\t}\r\n\t.main-nav > li > a {\r\n\t\tline-height: 60px;\r\n\t\tpadding: 0 !important;\r\n\t\tcolor: #fff;\r\n\t}\r\n\t.main-nav > li > i {\r\n\t\twidth: 30px;\r\n\t\theight: 30px;\r\n\t\tbackground: #FFFFFF;\r\n\t\tborder: 1px solid #F8F8F8;\r\n\t\tpadding: 8px;\r\n\t\tborder-radius: 50%;\r\n\t\tfont-size: 12px;\r\n\t}\r\n\t.main-nav > li > i:hover {\r\n\t\tcursor: pointer;\r\n\t}\r\n\t.main-nav > li > a > i {\r\n\t\tfont-size: initial;\r\n\t\tmargin-left: 3px;\r\n\t}\r\n\t.main-nav li > ul {\r\n\t\tbackground-color: #fff;\r\n\t\tborder-radius: 5px;\r\n\t\tbox-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\r\n\t\tdisplay: block;\r\n\t\tfont-size: 14px;\r\n\t\tleft: 0;\r\n\t\tmargin: 0;\r\n\t\tmin-width: 200px;\r\n\t\topacity: 0;\r\n\t\tpadding: 0;\r\n\t\tposition: absolute;\r\n\t\t-webkit-transition: all .2s ease;\r\n\t\ttransition: all .2s ease;\r\n\t\t-webkit-transform: translateY(20px);\r\n\t\t-ms-transform: translateY(20px);\r\n\t\ttransform: translateY(20px);\r\n\t\ttop: 100%;\r\n\t\tvisibility: hidden;\r\n\t\tz-index: 1000;\r\n\t}\r\n\t.main-nav li .submenu::before {\r\n\t\tborder: 7px solid #fff;\r\n\t\tborder-color: transparent transparent #fff #fff;\r\n\t\tbox-shadow: -2px 2px 2px -1px rgba(0, 0, 0, 0.1);\r\n\t\tcontent: \"\";\r\n\t\tleft: 45px;\r\n\t\tposition: absolute;\r\n\t\ttop: 2px;\r\n\t\t-webkit-transform-origin: 0 0;\r\n\t\ttransform-origin: 0 0;\r\n\t\t-webkit-transform: rotate(135deg);\r\n\t\ttransform: rotate(135deg);\r\n\t}\r\n\t.main-nav li.has-submenu:hover > .submenu {\r\n\t\tvisibility: visible;\r\n\t\topacity: 1;\r\n\t\tmargin-top: 0;\r\n\t\t-webkit-transform: translateY(0);\r\n\t\t-ms-transform: translateY(0);\r\n\t\ttransform: translateY(0);\r\n\t}\r\n\t.main-nav .has-submenu.active > a {\r\n\t\tcolor: #e5bd54;\r\n\t}\r\n\t.main-nav .has-submenu.active .submenu li.active > a {\r\n\t\tcolor: #e5bd54;\r\n\t}\r\n\t.main-nav > li .submenu li:first-child a {\r\n\t\tborder-top: 0;\r\n\t}\r\n\t.main-nav > li.has-submenu:hover > .submenu > li.has-submenu:hover > .submenu {\r\n\t\tvisibility: visible;\r\n\t\topacity: 1;\r\n\t\tmargin-top: -1px;\r\n\t\tmargin-right: 0;\r\n\t}\r\n\t.main-nav > li .submenu > li .submenu {\r\n\t\tleft: 100%;\r\n\t\ttop: 0;\r\n\t\tmargin-top: 10px;\r\n\t}\r\n\t.main-nav li .submenu a:hover {\r\n\t\tcolor: #e5bd54;\r\n\t\tletter-spacing: 0.5px;\r\n\t\tpadding-left: 20px;\r\n\t}\r\n\t.main-nav > .has-submenu > .submenu > .has-submenu > .submenu::before {\r\n\t\ttop: 20px;\r\n\t\tmargin-left: -35px;\r\n\t\tbox-shadow: 1px 1px 0 0 rgba(0, 0, 0, .15);\r\n\t\tborder-color: transparent #fff #fff transparent;\r\n\t}\r\n\t.header-navbar-rht li.show > .dropdown-menu {\r\n\t\tvisibility: visible;\r\n\t\topacity: 1;\r\n\t\tmargin-top: 0;\r\n\t\t-webkit-transform: translateY(0);\r\n\t\t-ms-transform: translateY(0);\r\n\t\ttransform: translateY(0);\r\n\t}\r\n\t.header-navbar-rht li .dropdown-menu {\r\n\t\tborder-radius: 5px;\r\n\t\tpadding: 0;\r\n\t\tmargin: 0;\r\n\t\tmin-width: 200px;\r\n\t\tvisibility: hidden;\r\n\t\topacity: 0;\r\n\t\t-webkit-transition: all .2s ease;\r\n\t\ttransition: all .2s ease;\r\n\t\tdisplay: block;\r\n\t\t-webkit-transform: translateY(20px);\r\n\t\t-ms-transform: translateY(20px);\r\n\t\ttransform: translateY(20px);\r\n\t}\r\n\t.searchbar {\r\n\t\tline-height: 60px;\r\n\t}\r\n\t.banner-section .container-fluid {\r\n\t\tpadding-left: 60px;\r\n\t\tpadding-right: 60px;\r\n\t}\r\n\t.banner-white-outline {\r\n\t\tmargin-right: 1.5rem;\r\n\t}\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    body.map-up .map-right .map-listing {\r\n        height: calc(100vh - 80px);\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 1399px) {\r\n\t.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name,\r\n\t.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {\r\n\t\tmax-width: 180px;\r\n\t}\r\n\t.row.row-grid {\r\n\t\tmargin-left: -8px;\r\n\t\tmargin-right: -8px;\r\n\t}\r\n\t.row.row-grid > div {\r\n\t\tpadding-right: 8px;\r\n\t\tpadding-left: 8px;\r\n\t\t-ms-flex: 0 0 33.333333%;\r\n\t\tflex: 0 0 33.333333%;\r\n\t\tmax-width: 33.333333%;\r\n\t}\r\n}\r\n\r\n@media only screen and (max-width: 1199px) {\r\n\t.header-nav {\r\n\t\tpadding-left: 20px;\r\n\t\tpadding-right: 20px;\r\n\t}\r\n\t.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name,\r\n\t.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {\r\n\t\tmax-width: 150px;\r\n\t}\r\n\t.chat-cont-left {\r\n\t\t-ms-flex: 0 0 40%;\r\n\t\tflex: 0 0 40%;\r\n\t\tmax-width: 40%;\r\n\t}\r\n\t.chat-cont-right {\r\n\t\t-ms-flex: 0 0 60%;\r\n\t\tflex: 0 0 60%;\r\n\t\tmax-width: 60%;\r\n\t}\r\n\t.row.row-grid > div {\r\n\t\t-ms-flex: 0 0 50%;\r\n\t\tflex: 0 0 50%;\r\n\t\tmax-width: 50%;\r\n\t}\r\n\t.dash-widget {\r\n\t\t-ms-flex-direction: column;\r\n\t\tflex-direction: column;\r\n\t\ttext-align: center;\r\n\t}\r\n\t.circle-bar {\r\n\t\tmargin: 0 0 15px;\r\n\t}\r\n\t.header-navbar-rht li.contact-item {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.map-right {\r\n\t\theight: 450px;\r\n\t\tposition: static;\r\n\t\tmin-height: inherit;\r\n\t\tmargin-bottom: 30px;\r\n\t\tpadding-right: 15px;\r\n\t}\r\n\t.map-listing {\r\n\t\theight: 450px;\r\n\t}\r\n\t.map-page .content {\r\n\t\tpadding-top: 100px;\r\n\t}\r\n\t.banner-overlay {\r\n\t\tposition: absolute;\r\n\t\tbottom: -100px;\r\n\t}\r\n\t.coaching-section {\r\n\t\tpadding: 150px 0 40px;\r\n\t}\r\n\t.golf-img-1 {\r\n\t\tmargin-top: -25px;\r\n\t}\r\n}\r\n\r\n@media only screen and (max-width: 991.98px) {\r\n\t.main-nav {\r\n\t\tpadding: 0;\r\n\t\t-ms-flex-direction: column;\r\n\t\tflex-direction: column;\r\n\t\tpadding-left: 0;\r\n\t\tmargin-bottom: 0;\r\n\t\tlist-style: none;\r\n\t}\r\n\t.main-nav ul {\r\n\t\tbackground-color: #25525c;\r\n\t\tdisplay: none;\r\n\t\tlist-style: none;\r\n\t\tmargin: 0;\r\n\t\tpadding-left: 0;\r\n\t}\r\n\t.main-nav > li {\r\n\t\tborder-bottom: 1px solid #4b8997;\r\n\t\tmargin-left: 0;\r\n\t}\r\n\t.main-nav li+li {\r\n\t\tmargin-left: 0;\r\n\t}\r\n\t.main-nav > li > a {\r\n\t\tline-height: 1.5;\r\n\t\tpadding: 15px 20px !important;\r\n\t\tcolor: #fff;\r\n\t\tfont-size: 14px;\r\n\t\tfont-weight: 500;\r\n\t}\r\n\t.main-nav > li > a > i {\r\n\t\tfloat: right;\r\n\t\tmargin-top: 5px;\r\n\t}\r\n\t.main-nav > li .submenu li a {\r\n\t\tborder-top: 0;\r\n\t\tcolor: #fff;\r\n\t\tpadding: 10px 15px 10px 35px;\r\n\t}\r\n\t.main-nav > li .submenu ul li a {\r\n\t\tpadding: 10px 15px 10px 45px;\r\n\t}\r\n\t.main-nav > li .submenu > li.has-submenu > a::after {\r\n\t\tcontent: \"\\f078\";\r\n\t}\r\n\t.main-nav .has-submenu.active > a {\r\n\t\tcolor: #e5bd54;\r\n\t}\r\n\t.main-nav .has-submenu.active .submenu li.active > a {\r\n\t\tcolor: #e5bd54;\r\n\t}\r\n\t.login-left {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.main-menu-wrapper {\r\n\t\torder: 3;\r\n\t\twidth: 260px;\r\n\t\tposition: fixed;\r\n\t\ttop: 0;\r\n\t\tbottom: 0;\r\n\t\tleft: 0;\r\n\t\toverflow-x: hidden;\r\n\t\toverflow-y: auto;\r\n\t\tz-index: 1060;\r\n\t\ttransform: translateX(-260px);\r\n\t\ttransition: all 0.4s;\r\n\t\tbackground-color: #13563A;\r\n\t}\r\n\t.menu-header {\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t}\r\n\t.navbar-header {\r\n\t\t-webkit-box-align: center;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\tdisplay: -webkit-inline-box;\r\n\t\tdisplay: -ms-inline-flexbox;\r\n\t\tdisplay: inline-flex;\r\n\t}\r\n\t#mobile_btn {\r\n\t\tdisplay: inline-block;\r\n\t}\r\n\t.searchbar {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.libraries-row {\r\n\t\t-ms-flex: 0 0 33.3%;\r\n\t\tflex: 0 0 33.3%;\r\n\t\tmax-width: 33.3%;\r\n\t\tpadding: 0 15px;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.advisors-row {\r\n\t\t-ms-flex: 0 0 33.3%;\r\n\t\tflex: 0 0 33.3%;\r\n\t\tmax-width: 33.3%;\r\n\t\tpadding: 0 15px;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.collection-row {\r\n\t\t-ms-flex: 0 0 33.3%;\r\n\t\tflex: 0 0 33.3%;\r\n\t\tmax-width: 33.3%;\r\n\t\tpadding: 0 15px;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.counter {\r\n\t\ttext-align: center;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.top-books {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.course-section {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.reviews {\r\n\t\tmargin-bottom: 50px;\r\n\t}\r\n\t.sc-btn {\r\n\t\tmargin-top: 0;\r\n\t}\r\n\t.review-bot:after {\r\n\t\tbottom: 15px;\r\n\t}\r\n\t.counter-overlay {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.counter-section {\r\n\t\tpadding: 40px 0 20px;\r\n\t}\r\n\t.reviews-section {\r\n\t\tpadding: 60px 0 30px;\r\n\t}\r\n\t.popular-course-section {\r\n\t\tpadding: 60px 0 40px;\r\n\t}\r\n\t.advisors-section {\r\n\t\tpadding: 60px 0 30px;\r\n\t}\r\n\t.top-books-section {\r\n\t\tpadding: 60px 0 30px;\r\n\t}\r\n\t.libraries-section {\r\n\t\tpadding: 30px 0;\r\n\t}\r\n\t.ourblog-section {\r\n\t\tpadding: 60px 0 30px;\r\n\t}\r\n\t.footer .footer-bottom .copyright {\r\n\t\tpadding: 15px 0;\r\n\t}\r\n\t.footer .footer-top {\r\n\t\tpadding: 30px 0 10px;\r\n\t}\r\n\t.section-search {\r\n\t\tmin-height: 330px;\r\n\t}\r\n\t.section-specialities {\r\n\t\tpadding: 50px 0;\r\n\t}\r\n\t.footer-widget {\r\n\t\tmargin: 0 0 20px;;\r\n\t}\r\n\t.chat-cont-left,\r\n\t.chat-cont-right {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmax-width: 100%;\r\n\t\ttransition: left 0.3s ease-in-out 0s, right 0.3s ease-in-out 0s;\r\n\t\twidth: 100%;\r\n\t}\r\n\t.chat-cont-left {\r\n\t\tborder-right: 0;\r\n\t}\r\n\t.chat-cont-right {\r\n\t\tposition: absolute;\r\n\t\tright: -100%;\r\n\t\ttop: 0;\r\n\t\topacity: 0;\r\n\t\tvisibility: hidden;\r\n\t}\r\n\t.chat-cont-right .chat-header {\r\n\t\tjustify-content: start;\r\n\t\t-webkit-justify-content: start;\r\n\t\t-ms-flex-pack: start;\r\n\t}\r\n\t.chat-cont-right .chat-header .back-user-list {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.chat-cont-right .chat-header .chat-options {\r\n\t\tmargin-left: auto;\r\n\t}\r\n\t.chat-window.chat-slide .chat-cont-left {\r\n\t\tleft: -100%;\r\n\t}\r\n\t.chat-window.chat-slide .chat-cont-right {\r\n\t\tright: 0;\r\n\t\topacity: 1;\r\n\t\tvisibility: visible;\r\n\t}\r\n\t.day-slot li.left-arrow {\r\n\t\tleft: -10px;\r\n\t}\r\n\t.container {\r\n\t\tmax-width: 100%;\r\n\t}\r\n\t.batch .appointment-action {\r\n\t\tmargin-top: 10px;\r\n\t}\r\n\t.batch .appointment-list {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.banner-wrapper {\r\n\t\tmax-width: 720px;\r\n\t}\r\n\t.search-box .search-info {\r\n\t\t-ms-flex: 0 0 410px;\r\n\t\tflex: 0 0 410px;\r\n\t\twidth: 410px;\r\n\t}\r\n\t.banner-wrapper .banner-header h1 {\r\n\t\tfont-size: 2.125rem;\r\n\t}\r\n\t.dct-border-rht {\r\n\t\tborder-bottom: 1px solid #f0f0f0;\r\n\t\tborder-right: 0;\r\n\t\tmargin-bottom: 20px;\r\n\t\tpadding-bottom: 15px;\r\n\t}\r\n\t.card-label > label {\r\n\t\tfont-size: 12px;\r\n\t}\r\n\t.footer .footer-top {\r\n\t\tpadding-bottom: 0;\r\n\t}\r\n\t.time-slot li .timing.selected::before {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.review-listing .recommend-btn {\r\n\t\tfloat: none;\r\n\t}\r\n\t.dash-widget {\r\n\t\tflex-direction: unset;\r\n\t\ttext-align: left;\r\n\t}\r\n\t.circle-bar {\r\n\t\tmargin: 0 15px 0 0;\r\n\t}\r\n\t.call-wrapper {\r\n\t\theight: calc(100vh - 140px);\r\n\t}\r\n\t.sidebar-overlay.opened {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.about-content {\r\n\t\tmargin-bottom: 30px;\r\n\t}\r\n\t.header-top {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.banner-overlay {\r\n\t\tposition: relative;\r\n\t\tbottom: 0;\r\n\t}\r\n\t.banner-btns {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.banner-white-outline {\r\n\t\tfont-size: 12px;\r\n\t}\r\n\t.features-box {\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\t.section-heading {\r\n\t\twidth: auto;\r\n\t}\r\n\t.coaching-section {\r\n\t\tpadding: 30px 0 10px;\r\n\t}\r\n\t.banner-content {\r\n\t\tpadding: 120px 0 60px;\r\n\t}\r\n\t.coaching-text {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.golf-img-1 {\r\n\t\tmargin-top: 0;\r\n\t}\r\n\t.coaching-info {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.feature-card {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.features-section {\r\n\t\tpadding: 30px 0 20px;\r\n\t}\r\n\t.field-row {\r\n\t\t-ms-flex: 0 0 33%;\r\n\t\tflex: 0 0 33%;\r\n\t\tmax-width: 33%;\r\n\t\tpadding: 0 15px;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.field-body h2 {\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.fields-section {\r\n\t\tpadding: 30px 0 10px;\r\n\t}\r\n\t.golf-bg h2 {\r\n\t\tfont-size: 28px;\r\n\t}\r\n\t.golf-section, .review-section {\r\n\t\tpadding: 30px 0;\r\n\t}\r\n\t.banner-primary {\r\n\t\tfont-size: 12px;\r\n\t}\r\n\t.blog-section {\r\n\t\tpadding: 30px 0 10px;\r\n\t}\r\n\t.our-blogs {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.subscribe-item .newsletter-form .cmn-btn {\r\n\t\tpadding: 5px 8px;\r\n\t}\r\n\t.subscribe-item .newsletter-form .form-control {\r\n\t\tpadding: 5px;\r\n\t}\r\n\t.subscribe-item .section-title p {\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\t.subsccribe-item {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.vector-shapes {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.main-nav > li.active > a:before {\r\n\t\tdisplay: none;\r\n\t}\r\n}\r\n\r\n@media only screen and (max-width: 849.98px) {\r\n\t.row.row-grid > div {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmax-width: 100%;\r\n\t}\r\n}\r\n\r\n@media only screen and (max-width: 767.98px) {\r\n\th1,\r\n\t.h1 {\r\n\t\tfont-size: 2rem;\r\n\t}\r\n\th2,\r\n\t.h2 {\r\n\t\tfont-size: 1.75rem;\r\n\t}\r\n\th3,\r\n\t.h3 {\r\n\t\tfont-size: 1.375rem;\r\n\t}\r\n\th4,\r\n\t.h4 {\r\n\t\tfont-size: 1rem;\r\n\t}\r\n\th5,\r\n\t.h5 {\r\n\t\tfont-size: 0.875rem;\r\n\t}\r\n\th6,\r\n\t.h6 {\r\n\t\tfont-size: 0.75rem;\r\n\t}\r\n\t.content {\r\n\t\tpadding: 15px 0 0;\r\n\t}\r\n\t.account-page .content {\r\n\t\tpadding: 15px 0;\r\n\t}\r\n\t.container-fluid {\r\n\t\tpadding-left: 15px;\r\n\t\tpadding-right: 15px;\r\n\t}\r\n\t.card {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.profile-sidebar {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.appointment-tab {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.features-slider .slick-dots,\r\n\t.features-img img {\r\n\t\ttext-align: center;\r\n\t\tmargin: 0 auto;\r\n\t}\r\n\t.sender-slider {\r\n\t\tmargin-top: 25px;\r\n\t}\r\n\t.breadcrumb-bar {\r\n\t\theight: auto;\r\n\t}\r\n\t.login-right {\r\n\t\tmargin: 0 15px;\r\n\t\tpadding: 15px;\r\n\t}\r\n\t.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name,\r\n\t.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {\r\n\t\tmax-width: 250px;\r\n\t}\r\n\t.chat-window .chat-cont-right .chat-header .media .media-body {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.banner-wrapper .banner-header h1 {\r\n\t\tfont-size: 2rem;\r\n\t}\r\n\t.banner-wrapper .banner-header p {\r\n\t\tfont-size: 1rem;\r\n\t}\r\n\t.section-header h2 {\r\n\t\tfont-size: 1.875rem;\r\n\t}\r\n\t.section-header .sub-title {\r\n\t\tfont-size: 0.875rem;\r\n\t}\r\n\t.speicality-item p {\r\n\t\tfont-size: 0.875rem;\r\n\t}\r\n\t.section-header p {\r\n\t\tfont-size: 0.9375rem;\r\n\t}\r\n\t.footer-title {\r\n\t\tfont-size: 1.125rem;\r\n\t}\r\n\t.search-box {\r\n\t\tmax-width: 535px;\r\n\t\tmargin: 0 auto;\r\n\t}\r\n\t.search-box form {\r\n\t\t-ms-flex-direction: column;\r\n\t\tflex-direction: column;\r\n\t\tword-wrap: break-word;\r\n\t\tbackground-clip: border-box;\r\n\t}\r\n\t.search-box .search-location {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\twidth: 100%;\r\n\t}\r\n\t.search-box .search-info {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\twidth: 100%;\r\n\t}\r\n\t.search-box .search-btn {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmin-height: 46px;\r\n\t\twidth: 100%;\r\n\t}\r\n\t.search-box .search-btn span {\r\n\t\tdisplay: inline-block;\r\n\t\tmargin-left: 5px;\r\n\t\ttext-transform: uppercase;\r\n\t}\r\n\t.section-search {\r\n\t\tbackground: #f9f9f9;\r\n\t}\r\n\t.day-slot li span {\r\n\t\tfont-size: 16px;\r\n\t\ttext-transform: unset;\r\n\t}\r\n\t.time-slot li .timing span {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.submit-section.proceed-btn {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.day-slot li small.slot-year {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.success-cont h3 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.view-inv-btn {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 10px 30px;\r\n\t}\r\n\t.invoice-info.invoice-info2 {\r\n\t\ttext-align: left;\r\n\t}\r\n\t.invoice-item .invoice-details {\r\n\t\ttext-align: left;\r\n\t}\r\n\t.section-search,\r\n\t.section-sender,\r\n\t.section-features {\r\n\t\tpadding: 50px 0;\r\n\t}\r\n\t.slick-next {\r\n\t\tright: -10px;\r\n\t}\r\n\t.slick-prev {\r\n\t\tleft: -10px;\r\n\t}\r\n\t.specialities-slider .slick-slide {\r\n\t\tmargin-right: 15px;\r\n\t}\r\n\t.about-content a {\r\n\t\tpadding: 12px 20px;\r\n\t}\r\n\t.submit-section .submit-btn {\r\n\t\tpadding: 10px 20px;\r\n\t\tfont-size: 15px;\r\n\t\tmin-width: 105px;\r\n\t}\r\n\t.policy-menu {\r\n\t\tmargin-top: 10px;\r\n\t\ttext-align: left;\r\n\t}\r\n\t.booking-doc-info .booking-doc-img {\r\n\t\twidth: 75px;\r\n\t}\r\n\t.booking-doc-info .booking-doc-img img {\r\n\t\theight: 75px;\r\n\t\twidth: 75px;\r\n\t}\r\n\t.btn.btn-danger.trash {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.libraries-row {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmax-width: 100%;\r\n\t\tpadding: 0 15px;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.advisors-row {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmax-width: 100%;\r\n\t\tpadding: 0 15px;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.collection-row {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmax-width: 100%;\r\n\t\tpadding: 0 15px;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.banner-content h2 {\r\n\t\tfont-size: 32px;\r\n\t}\r\n\t.banner-content p {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\tbody {\r\n\t\tfont-size: .75rem;\r\n\t}\r\n\t.section-heading {\r\n\t\tpadding-bottom: 15px;\r\n\t}\r\n\t.section-heading h2 {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.section-heading.section-bg h2 {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.advisors-author h2 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.advisors-author span {\r\n\t\tfont-size: .75rem;\r\n\t}\r\n\t.advisors-author p {\r\n\t\tfont-size: .75rem;\r\n\t}\r\n\t.course-bot h2 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.course-content h2 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.review-listing > ul li .comment .comment-body .meta-data span.comment-date {\r\n\t\tmargin-bottom: 5px;\r\n\t}\r\n\t.review-listing > ul li .comment .comment-body .meta-data .review-count {\r\n\t\tposition: unset;\r\n\t}\r\n\t.my-video ul li {\r\n\t\twidth: 50px;\r\n\t}\r\n\t.call-users ul li {\r\n\t\twidth: 50px;\r\n\t}\r\n\t.call-mute {\r\n\t\tfont-size: 20px;\r\n\t\theight: 50px;\r\n\t\tline-height: 50px;\r\n\t\twidth: 50px;\r\n\t}\r\n\t.call-duration {\r\n\t\tfont-size: 24px;\r\n\t}\r\n\t.voice-call-avatar .call-avatar {\r\n\t\theight: 100px;\r\n\t\twidth: 100px;\r\n\t}\r\n\t.user-tabs {\r\n\t\tmargin-top: 1.5rem;\r\n\t}\r\n\t.user-tabs .nav-tabs > li > a {\r\n\t\tborder-left: 2px solid transparent;\r\n\t\tborder-bottom: 0;\r\n\t\tpadding: .5rem 1rem;\r\n\t}\r\n\t.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active,\r\n\t.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:hover,\r\n\t.user-tabs .nav-tabs.nav-tabs-bottom > li > a.active:focus {\r\n\t\tborder-left-width: 2px;\r\n\t\tcolor: #20c0f3;\r\n\t}\r\n\t.sender-widget {\r\n\t\t-ms-flex-direction: column;\r\n\t\tflex-direction: column;\r\n\t\ttext-align: center;\r\n\t}\r\n\t.doc-info-right {\r\n\t\tmargin-left: 0;\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmax-width: 100%;\r\n\t}\r\n\t.doc-info-left {\r\n\t\t-ms-flex-direction: column;\r\n\t\tflex-direction: column;\r\n\t}\r\n\t.shop-services {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.sender-img {\r\n\t\tmargin: 0 auto 20px;\r\n\t}\r\n\t.sender-action {\r\n\t\tjustify-content: center;\r\n\t\t-webkit-justify-content: center;\r\n\t\t-ms-flex-pack: center;\r\n\t}\r\n\t.row.row-grid > div {\r\n\t\t-ms-flex: 0 0 50%;\r\n\t\tflex: 0 0 50%;\r\n\t\tmax-width: 50%;\r\n\t}\r\n\t.breadcrumb-bar .breadcrumb-title {\r\n\t\tfont-size: 18px;\r\n\t}\r\n\t.dash-widget h6 {\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.dash-widget h3 {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.dash-widget p {\r\n\t\tfont-size: 13px;\r\n\t}\r\n\t.sender-widget .doc-name {\r\n\t\tfont-size: 18px;\r\n\t}\r\n\t.exp-title,\r\n\t.booking-total ul li span,\r\n\t.booking-total ul li .total-cost {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.invoice-item .customer-text {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t.call-wrapper {\r\n\t\theight: calc(100vh - 115px);\r\n\t}\r\n\t.appointment-tab .nav-tabs {\r\n\t\tpadding: 1.5rem;\r\n\t}\r\n\t.submit-btn-bottom {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.service-list ul li {\r\n\t\twidth: 50%;\r\n\t}\r\n\t.grid-blog .blog-title {\r\n\t\tmin-height: inherit;\r\n\t}\r\n\t.blog-title {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.blog-view .blog-title {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.field-row {\r\n\t\t-ms-flex: 0 0 50%;\r\n\t\tflex: 0 0 50%;\r\n\t\tmax-width: 50%;\r\n\t\tpadding: 0 15px;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.golf-bg {\r\n\t\tpadding: 20px;\r\n\t}\r\n}\r\n\r\n@media only screen and (max-width: 575.98px) {\r\n\tbody {\r\n\t\tfont-size: 0.8125rem;\r\n\t}\r\n\th1,\r\n\t.h1 {\r\n\t\tfont-size: 1.75rem;\r\n\t}\r\n\th2,\r\n\t.h2 {\r\n\t\tfont-size: 1.5rem;\r\n\t}\r\n\th3,\r\n\t.h3 {\r\n\t\tfont-size: 1.25rem;\r\n\t}\r\n\th4,\r\n\t.h4 {\r\n\t\tfont-size: 1rem;\r\n\t}\r\n\th5,\r\n\t.h5 {\r\n\t\tfont-size: 0.875rem;\r\n\t}\r\n\th6,\r\n\t.h6 {\r\n\t\tfont-size: 0.75rem;\r\n\t}\r\n\t.card {\r\n\t\tmargin-bottom: 0.9375rem;\r\n\t}\r\n\t.card-body {\r\n\t\tpadding: 1.25rem;\r\n\t}\r\n\t.card-header {\r\n\t\tpadding: .75rem 1.25rem;\r\n\t}\r\n\t.card-footer {\r\n\t\tpadding: .75rem 1.25rem;\r\n\t}\r\n\t.header-nav {\r\n\t\tpadding-left: 15px;\r\n\t\tpadding-right: 15px;\r\n\t}\r\n\t.header-navbar-rht {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.main-nav li.login-link {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.navbar-header {\r\n\t\twidth: 100%;\r\n\t}\r\n\t#mobile_btn {\r\n\t\tleft: 0;\r\n\t\tmargin-right: 0;\r\n\t\tpadding: 0 15px;\r\n\t\tposition: absolute;\r\n\t\tz-index: 99;\r\n\t}\r\n\t.navbar-brand.logo {\r\n\t\twidth: 100%;\r\n\t\ttext-align: center;\r\n\t\tmargin-right: 0;\r\n\t}\r\n\t.navbar-brand.logo img {\r\n\t\theight: 40px;\r\n\t}\r\n\t.search-box form {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.search-box .search-location {\r\n\t\twidth: 100%;\r\n\t\t-ms-flex: none;\r\n\t\tflex: none;\r\n\t}\r\n\t.search-box .search-info {\r\n\t\twidth: 100%;\r\n\t\t-ms-flex: none;\r\n\t\tflex: none;\r\n\t}\r\n\t.banner-wrapper .banner-header h1 {\r\n\t\tfont-size: 28px;\r\n\t}\r\n\t.slick-next {\r\n\t\tright: 0px;\r\n\t}\r\n\t.section-header h2 {\r\n\t\tfont-size: 1.5rem;\r\n\t}\r\n\t.section-header .sub-title {\r\n\t\tfont-size: 0.875rem;\r\n\t}\r\n\t.speicality-item p {\r\n\t\tfont-size: 0.875rem;\r\n\t}\r\n\t.section-header p {\r\n\t\tfont-size: 0.9375rem;\r\n\t}\r\n\t.footer-title {\r\n\t\tfont-size: 1.125rem;\r\n\t}\r\n\t.booking-schedule.schedule-widget {\r\n\t\toverflow-x: auto;\r\n\t}\r\n\t.booking-schedule.schedule-widget > div {\r\n\t\twidth: 730px;\r\n\t}\r\n\t.booking-schedule .day-slot ul {\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t}\r\n\t.booking-schedule .day-slot li {\r\n\t\t-ms-flex: 0 0 100px;\r\n\t\tflex: 0 0 100px;\r\n\t\twidth: 100px;\r\n\t}\r\n\t.booking-schedule .time-slot ul {\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t}\r\n\t.booking-schedule .time-slot li {\r\n\t\t-ms-flex: 0 0 100px;\r\n\t\tflex: 0 0 100px;\r\n\t\twidth: 100px;\r\n\t}\r\n\t.booking-schedule .time-slot li .timing span {\r\n\t\tdisplay: inline-block;\r\n\t}\r\n\t.booking-schedule .day-slot li.right-arrow {\r\n\t\tright: -20px;\r\n\t}\r\n\t.booking-doc-info .booking-doc-img {\r\n\t\twidth: 70px;\r\n\t}\r\n\t.booking-doc-info .booking-doc-img img {\r\n\t\theight: 70px;\r\n\t\twidth: 70px;\r\n\t}\r\n\t.voice-call-avatar .call-avatar {\r\n\t\theight: 80px;\r\n\t\twidth: 80px;\r\n\t}\r\n\t.call-duration {\r\n\t\tdisplay: block;\r\n\t\tmargin-top: 0;\r\n\t\tmargin-bottom: 10px;\r\n\t\tposition: inherit;\r\n\t}\r\n\t.end-call {\r\n\t\tmargin-top: 10px;\r\n\t\tposition: inherit;\r\n\t}\r\n\t.user-tabs .med-records {\r\n\t\tmin-width: 110px;\r\n\t}\r\n\t.pagination-lg .page-link {\r\n\t\tfont-size: 1rem;\r\n\t\tpadding: 0.5rem 0.625rem;\r\n\t}\r\n\t.row.row-grid > div {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmax-width: 100%;\r\n\t}\r\n\t.edit-link {\r\n\t\tfont-size: 14px;\r\n\t\tmargin-top: 2px;\r\n\t}\r\n\t.invoice-content {\r\n\t\tpadding: 1.25rem;\r\n\t}\r\n\t.change-avatar .profile-img img {\r\n\t\theight: 80px;\r\n\t\twidth: 80px;\r\n\t}\r\n\t.submit-btn-bottom {\r\n\t\tmargin-bottom: 0.9375rem;\r\n\t}\r\n\t.service-list ul li {\r\n\t\twidth: 100%;\r\n\t}\r\n\t.blog {\r\n\t\tpadding: 1.25rem;\r\n\t}\r\n\t.blog-title {\r\n\t\tfont-size: 18px;\r\n\t}\r\n\t.blog-view .blog-title {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.blog-info i {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.post-left ul li {\r\n\t\tmargin-right: 10px;\r\n\t}\r\n\t.post-left ul li:last-child {\r\n\t\tmargin-right: 10px;\r\n\t}\r\n\t.about-author-img {\r\n\t\theight: 60px;\r\n\t\twidth: 60px;\r\n\t}\r\n\t.author-details {\r\n\t\tmargin-left: 80px;\r\n\t}\r\n\t.blog-comments .comments-list li img.avatar {\r\n\t\tborder-radius: 40px;\r\n\t\theight: 40px;\r\n\t\twidth: 40px;\r\n\t}\r\n\t.blog-comments .comments-list li {\r\n\t\tpadding: 10px 0 0 50px;\r\n\t}\r\n\t.read-more {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.field-row {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmax-width: 100%;\r\n\t\tpadding: 0 15px;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n}\r\n\r\n@media only screen and (max-width:479px) {\r\n\t.section-search {\r\n\t\tmin-height: 410px;\r\n\t\tpadding: 30px 15px;\r\n\t}\r\n\t.specialities-slider .slick-slide {\r\n\t\tmargin-right: 10px;\r\n\t}\r\n\t.speicality-img {\r\n\t\twidth: 120px;\r\n\t\theight: 120px;\r\n\t}\r\n\t.speicality-img img {\r\n\t\twidth: 50px;\r\n\t}\r\n\t.shop-booking a.view-pro-btn {\r\n\t\twidth: 100%;\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\t.shop-booking a.apt-btn {\r\n\t\twidth: 100%;\r\n\t}\r\n\t.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name,\r\n\t.chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {\r\n\t\tmax-width: 160px;\r\n\t}\r\n\t.section-features,\r\n\t.section-features,\r\n\t.section-specialities {\r\n\t\tbackground-color: #fff;\r\n\t\tpadding: 30px 0;\r\n\t}\t\r\n\t.banner-btns {\r\n\t\tmax-width: 200px;\r\n\t\tmargin:0 auto;\r\n\t}\r\n\t.banner-btns button {\r\n\t\tmargin-bottom: 10px;\r\n\t\twidth: 100%;\r\n\t\tpadding: 10px;\r\n\t}\r\n\t.login-header h3 a {\r\n\t\tcolor: #0de0fe;\r\n\t\tfloat: none;\r\n\t\tfont-size: 15px;\r\n\t\tmargin-top: 10px;\r\n\t\ttext-align: center;\r\n\t\tdisplay: block;\r\n\t}\r\n\t.login-header h3 {\r\n\t\ttext-align: center;\r\n\t}\r\n\t.batch .appointment-list {\r\n\t\ttext-align: center;\r\n\t}\r\n\t.appointment-list .profile-info-widget {\r\n\t\t-ms-flex-direction: column;\r\n\t\tflex-direction: column;\r\n\t}\r\n\t.appointment-list .profile-info-widget {\r\n\t\ttext-align: center;\r\n\t}\r\n\t.appointment-list .profile-info-widget .booking-doc-img {\r\n\t\tmargin: 0 0 15px;\r\n\t}\r\n\t.appointment-list .profile-info-widget .booking-doc-img img {\r\n\t\tborder-radius: 50%;\r\n\t\theight: 100px;\r\n\t\twidth: 100px;\r\n\t}\r\n\t.appointment-list .profile-det-info {\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\t.batch .appointment-action {\r\n\t\tmargin-top: 0;\r\n\t}\r\n\t.user-tabs .nav-tabs .nav-item {\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t}\r\n\t.review-listing .recommend-btn span {\r\n\t\tdisplay: block;\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n\t.review-listing > ul li .comments-reply {\r\n\t\tmargin-left: 0;\r\n\t}\r\n\t.schedule-nav .nav-tabs li {\r\n\t\tdisplay: block;\r\n\t\t-ms-flex: 0 0 100%;\r\n\t\tflex: 0 0 100%;\r\n\t\tmargin-right: 0;\r\n\t}\r\n\t.fc-header-toolbar .fc-left {\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n\t.fc-header-toolbar .fc-right {\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n}\r\n\r\n\r\n\r\n.stickyside {\r\n\tposition: sticky;\r\n\ttop: 0;\r\n\tpadding-bottom: 1px;\r\n}\r\n.mapgridrating1 i:not(:last-child) {\r\n    margin-right: 4px;\r\n}\r\n.fancystyle {\r\n\tdisplay: unset !important;\r\n}\r\n\r\n/*-----------------\r\n\t40. Custom Elements\r\n-----------------------*/\r\n\r\n.form-control:disabled, .form-control[readonly] {\r\n    background-color: transparent;\r\n    border: none;\r\n    box-shadow: none;\r\n}\r\n\r\ninput:focus:not(.form-control) {\r\n    outline: none;\r\n    border: none;\r\n}\r\n\r\n.min-h-40 {\r\n    min-height: 40rem;\r\n}\r\n\r\n.inset-0 {\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n}\r\n\r\n.inset-top-left {\r\n    top: 5px;\r\n    left: 5px;\r\n}\r\n\r\n.object-contain {\r\n    object-fit: cover;\r\n}\r\n\r\n.object-cover {\r\n    object-fit: cover;\r\n}\r\n\r\n.bg-cover {\r\n    background-size: cover;\r\n}\r\n\r\n.bg-contain {\r\n    background-size: contain;\r\n}\r\n\r\n.bg-no-repeat {\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.bg-light {\r\n    background-color: var(--light);\r\n}\r\n\r\n.bgc-gray {\r\n    background-color: #fafafa !important;\r\n}\r\n\r\n.bg-light-hover:hover {\r\n    background-color: var(--gray);\r\n}\r\n\r\n.bg-white-hover:hover {\r\n    background-color: var(--light);\r\n}\r\n\r\n.display-1 {\r\n    font-size: 13vmin;\r\n}\r\n\r\n.display-2 {\r\n    font-size: 11vmin;\r\n}\r\n\r\n.display-3 {\r\n    font-size: 7.5vmin;\r\n}\r\n\r\n.font-weight-200 {\r\n    font-weight: 200;\r\n}\r\n\r\n.font-weight-300 {\r\n    font-weight: 300;\r\n}\r\n\r\n.font-weight-500 {\r\n    font-weight: 500;\r\n}\r\n\r\n.font-weight-600 {\r\n    font-weight: 600;\r\n}\r\n\r\n@media (min-width: 40rem) {\r\n    .min-vh-md-100 {\r\n        min-height: 100vh;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
